import { meaningIcon } from '../meaning-icon'
import { countsAsDayVisit } from '../day-visits'
import { phoneWeekRows, weekName, weekNameDrag } from '../diary-week-phone'
import { dueDragTeach, playDueDragDemo } from '../due-drag-demo'
import { closedDiaryDay, visitColour } from '../day-state'
import { beginDiaryColours, colourDay, diaryColourKey, resetDiaryColours, stateMark, usedDiaryWeek } from '../diary-colours'
import { pinFoot } from '../pin-foot'
import { extraBadges } from '../extras'
import { flyDrag } from '../drag-fly'
import { agreeOnDay, askAgreedFirst, openTheyReplied, type RepliedOptions } from '../they-replied'
import { invoicesForVisits, invoicesHere, invoiceVisit, openInvoice, STATE_WORDS } from '../invoices'
import { currencySymbol, monthFirst, postcodeWords, roundClock, screenLocale, shownTime } from '../round-config'
import { paidLook, paidMoment } from '../paid-moment'
import { setTimesOn, visibleTime } from '../business-settings'
import { inverseDayOrder } from '../diary-order'
import { diaryDesk, diaryDayFacts, diaryEstimate, diaryLandOn, diaryMoreMenu, diaryMotion, diaryPreferenceKey, diaryPage, finishDiary, diaryFeedback, diaryDayTotals, diaryDayProgress, diaryDayFooter, diaryHeading, diaryOrderCapture, diaryOrderSettle, diaryCompletion, type DiaryOrderEffect, diaryMoveCapture, diaryMoveSettle, type DiaryMoveEffect } from '../diary-layout'
import { priceButton } from '../price-edit'
import { partBadge, priceWords } from '../inside-price'
import { priceFor } from '../pricing'
import { getMe, ownerDoesJobs, pricesHidden, worksAlone } from '../me'
import { alsoBookedText } from '../also-booked'
import { holdToDrag } from '../hold-drag'
import { leadIsOpen } from '../new-jobs'
import { jobTimesLine } from '../job-times'
import { downloadLines, phoneOf, reachesPhone } from '../download-status'
import { noteNode, noteText } from '../note-lines'
import { api, dismiss, getQueue, mutate, onQueueChange, readCache, type Ack, type QueuedMutation, isLocalOnly } from '../api'
import { openBooking } from '../booking'
import { nowWhose, otherThanOwner } from '../booking-days'
import { dismissUndo, offerUndo, undoPatch } from '../undo'
import { cancelVisitWithUndo, markAgreed, markDayAgreed, markTimeAgreed } from '../visit-actions'
import { AREA_RENAMED, areaRenameLink, areaWord } from '../area-rename'
import { rowMenu } from '../row-menu'
import { cycleRisk, renderAttention, riskNote, setNeedsExtras, setNeedsOnly, setNeedsWatch, setNoDateOpener, setWaitingLine, takeNoDateGlow, type NeedsExtra, type NeedsLine, type RoundCustomer, type WaitingLine } from '../attention'
import { renderWelcome } from '../welcome'
import { lastWhatsNextCard, renderWhatsNext, whatsNextStale } from '../whats-next'
import { knownWorkers, renderDayLedger, visitWorker, type FinishedDay } from '../closeout'
import { closeOutEntry } from '../close-out-entry'
import { finishedDaysArea, pencilledIn, sheet } from '../day-close'
import { pinsOf, spreadWords, unmappable } from '../day-map'
import { contactButton, contactLines, type ContactCustomer } from '../contact-tile'
import { confirmNeed, dueDate, fromTheSheet, isContact, isSuggestion, isUnplaced, nextMondayAfter, standingOf, workload } from '../planning'
import { standingFields } from '../customer-context'
import { cancelAfter } from '../leftover-visit'
import { askWords, diaryCustomer, movedUntold, offeredDaysText, offersWaiting, paymentWords, visitWords } from '../visit-words'
import { dayHeading, weekDates, weekHeading } from '../diary-heading'
import { countPencilled, pencilledStep, PENCILLED_STEPS, STEP_NOTES, STEP_TITLES, type PencilledCount, type PencilledStep } from '../pencilled'
import { findCustomerMatches } from '../lead-conversion'
import { ENQUIRY_FRESH_DAYS, enquiryEmailHref, enquiryFirstMessage, enquiryMessagedToday, enquiryMessages, enquiryNoteLine } from '../enquiry-message'
import { agreedTimeKey, appendNote, messagesThisCycle, onAPhone, timeIsAgreed } from '../rebook-message'
import { countedWords, isSendPress, leadPhoneLink, type NoteChannel } from '../contact'
import { bindEmailSend } from '../email-send'
import { wayIcon } from '../contact-ui'
import { timeWheel } from '../time-wheel'
import { openTimePicker as openSharedTimePicker, saveVisitTime, timeOnly, type VisitTimeHooks } from '../visit-time'
import { addressLine } from '../address-words'
import { directionsHref } from '../../functions/lib/maps-link'
import { spotButton } from '../exact-spot'
import { autoScrollSpeed, bandOf, canReorder, clockOf, draggedTo, dropSide, dropTargetId, minutesOfDay, orderDay, pencilTime, pressOnControl, rowIdAt, shouldGrab, strictMinutes, AUTO_SCROLL_EDGE_PX, LONG_PRESS_MS } from '../day-order'
import { diaryDayGroups, diaryDayOrder, openingDay, OPEN_AHEAD_DAYS } from '../diary-stops'
import { enoughPostcode, missingDetails, openAddDetails, takesNoMessages } from '../add-details'
import { askAgainLater, isFollowupDue, notNowPatch } from '../followup'
import { acceptDayFromDiary, askAboutDay, awaitingReplies, mailIcon, openMessagesFor, openReplyDialog, openSecondMessage, keepDayDone, showDayDone, type AwaitingReply, type Placement } from './rebook'
import { GONE_DAY_WORDS, leaveMonth, monthComeBack, monthOnDataChanged, monthRedraw, monthVisitsShown, mountMonth, threeViewSwitch } from './month'
import { areaOfClean } from '../month-view'
import { cashTakenBadge, paymentBadge, paymentLabel } from '../payment'
import { openMoveSheet, type MoveDay } from '../move-sheet'
import { initialsOf, lineDrawing, reasonDrawing, type Drawing } from '../picture-tiles'
import { captureStops, settleStops } from '../stop-motion'
import { moveDays } from '../missed-visit'
import { parkingHeadline, parkingRules } from '../parking-rules'
import { attachPhotos } from '../photo-note'
import { nextWeekFrom, weekMoveSet, type WeekMove } from '../week-move'
import { routeGen } from '../route-state'
import { bookedAhead, cleansBehind, collectedFilter, dueCarrier as dueCarrierOf, dueEntries, dueFrom, dueGroups, dueKey, missedCleanFor as missedCleanOf, noCycleSet, reviewVisits, setCycleDays, visitKey, DUE_BAR_MAX, type DueEntry, type DueGroups } from '../diary-sets'
import { bottomSheet, dueBar, dueBarOpen, rememberDueBarOpen, dueDragLive, popDueCount, showWaiting, swallowNextTap, swipeToPush, whenDueDragEnds, type BarCard, type Sheet } from '../due-bar'
import { loadRoundJobs, noteJobOneNames, severalJobsOn, visitJobLabel } from '../job-names'
import { gutterAsk, houseOrder, visitJobId, windowsDayBefore, type CustomerJob } from '../jobs'
import type { Clean, Customer, DayNote, Lead, RoundDay, SchedulePayload } from '../types'
import '../attention.css'
import '../schedule-days.css'
import '../diary-due-col.css'
import '../diary-redesign.css'
import '../diary-day-phone.css'
import '../diary-desk-day.css'
import { toCollect, visitReceived } from '../brought'
import { askParking, type ParkingCustomer } from '../parking-ask'
import {
  BLOCKED_CHOICES,
  blockedSaveOf,
  addDaysISO,
  blockedBadgeText,
  blockedChoiceOf,
  blockedNoteText,
  blockedWords,
  clear,
  dayLabel,
  el,
  loadError,
  mondayOf,
  money,
  splitAccessWarning,
  shortDate,
  telHref,
  toast,
  todayISO,
  shownVisitTime,
  noteDate,
  cycleLabel,
  cycleOptions,
  nearestCycleChoice,
} from '../ui'

// The schedule — replaces the Current Scheduled tab AND the Day Totals
// habit: booked cleans grouped by day (time slots, durations, worker,
// confirmed), per-day notes, and the day close-out (day_ledger) for days
// that have happened. The van lives on this screen. The close-out forms and
// the worker list live in ../closeout; the round summary lives in
// ../attention.

const WINDOW_DAYS = 7 // one week, Monday to Sunday; Previous / Next week move by seven days (Liam 2026-09-11: two weeks was too long a scroll on the phone)

// The diary opens on Monday of THIS week, not on today: what got done earlier
// in the week (and whether it was paid) is read back all week, and it was
// falling off the top the morning after. One week is shown; Next week is a tap.
export function defaultFrom(today: string = todayISO()): string {
  return mondayOf(today)
}

let payload: SchedulePayload | null = null
let fromDate = defaultFrom()
// Opening the diary on particular visits, glowing (29 Sep): the first visit booked through the welcome's guide
// ("Here it is"), and the "What's next" card's Show me / Open it (whats-next.ts). The diary goes to that week,
// past or future, opens the week panel on "No day yet" when the visits are there, and once a read started
// after the request is drawn, the visits glow with a line saying what to do.
// The first job's landing (first-job.ts, 19 Oct 2026) adds its own words, a next step and Book another.
type LandingAction = { label: string; act: () => void }
let focusReq: { ids: number[]; date: string; after: number; tip: string | null; title?: string; action?: LandingAction | null; another?: boolean } | null = null
// Kept for one mount, so opening the diary does not snap a requested past week back to this one (P12).
let holdWindow = false
// The owner's own panel and filter choices, put back on their next ordinary visit to the diary (Codex).
let restoreChoices: { workerFilter: string; areaFilter: string } | null = null
// "Give them a day" from What's next: the diary walks the owner through placing each week-panel visit (Liam,
// 29 Sep: the hint sat under the first customer, and tapping one jumped the page away). Until the week panel has
// none left, or the next ordinary visit.
let placingGuide = false
// "Show me" opens a folded Due bar once; Hide after it is the owner's word (Sol's review, 19 Oct 2026).
let guideOpensBar = false
export function focusDiary(ids: number[], date: string, tip: string | null, tray: boolean): void {
  // "Show me" points at rows on the week view, so it always opens the week.
  setDiaryView('week')
  leaveMonth()
  placingGuide = tray
  guideOpensBar = tray
  focusReq = { ids, date, after: requestSequence, tip: tray ? null : tip }
  selectedDate = date; selectedIdentity = diaryPreferenceKey('selection')
  // The visits shown are on a day: Day, where the Diary is already open too (the Diary opens on Week otherwise).
  setWeekMode('day')
  if (tray) { planningExpanded = true; planningTab = 'place'; deskIdentity = diaryPreferenceKey('selection'); deskPlanOpen = true; deskPlanBody = 'place'; deskDueFor(); deskDueTab = 'due'; deskDueOpen = true; deskPencilOpen = false; deskNeedsOpen = false }
  fromDate = defaultFrom(date)
  restoreChoices ??= { workerFilter, areaFilter }
  // Nothing may hide the visits being shown: every worker and area.
  workerFilter = ''
  areaFilter = ''
  if (window.location.hash.startsWith('#/schedule')) void load()
  else { holdWindow = true; window.location.hash = '#/schedule' }
}
window.addEventListener('roundly:first-visit', (e) => {
  const d = (e as CustomEvent<{ id: number; date: string; title?: string; tip?: string; action?: LandingAction | null; another?: boolean }>).detail
  if (!d?.id || !d.date) return
  setDiaryView('week')
  leaveMonth()
  const inWindow = d.date >= fromDate && d.date <= addDaysISO(fromDate, WINDOW_DAYS - 1)
  focusReq = { ids: [d.id], date: d.date, after: requestSequence, tip: d.tip ?? 'On the day, open Today and tap it to start the job.', title: d.title, action: d.action ?? null, another: d.another }
  setWeekMode('day')
  selectedDate = d.date; selectedIdentity = diaryPreferenceKey('selection')
  if (!inWindow) fromDate = defaultFrom(d.date)
  if (!window.location.hash.startsWith('#/schedule')) { holdWindow = true; window.location.hash = '#/schedule' }
})
function showFocus(root: HTMLElement, sequence: number): void {
  if (!focusReq || sequence <= focusReq.after) return
  const req = focusReq
  // Called on a fresh read of the week: visits it does not hold will not turn up later, so let the request go.
  focusReq = null
  const rows = req.ids.map((id) => root.querySelector<HTMLElement>(`.clean-row[data-clean-id="${id}"]`)).filter((r): r is HTMLElement => !!r)
  if (!rows.length) return
  // A done visit sits in the folded "Completed" (Owed's "Open diary", 8 Oct 2026): open the fold so it shows.
  for (const r of rows) { const fold = r.closest('details'); if (fold && !fold.open) fold.open = true }
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  for (const r of rows) r.classList.add('first-visit-glow')
  const row = rows[0]
  if (req.tip) {
    const tip = el('div', { class: 'first-visit-tip', role: 'status' }, el('strong', {}, req.title ?? 'Here it is.'), ` ${req.tip}`)
    const ok = el('button', { type: 'button', class: 'link-button' }, 'Got it')
    const done = (): void => { tip.remove(); for (const r of rows) r.classList.remove('first-visit-glow') }
    ok.addEventListener('click', done)
    // The first job (first-job.ts): its next step (Message them about the day) in lemon, and Book another.
    if (req.action || req.another) {
      tip.classList.add('first-visit-tip-actions')
      const buttons = el('div', { class: 'first-visit-tip-buttons' })
      if (req.action) {
        const act = req.action
        const go = el('button', { type: 'button', class: 'btn-primary' }, act.label)
        go.addEventListener('click', () => { done(); act.act() })
        buttons.append(go)
      }
      if (req.another) {
        const more = el('button', { type: 'button', class: 'btn-secondary' }, 'Book another')
        more.addEventListener('click', () => { done(); openBooking({}) })
        buttons.append(more)
      }
      buttons.append(ok)
      tip.append(buttons)
    } else tip.append(' ', ok)
    row.after(tip)
  }
  // Brought into the part of the screen that can be read: under the bar and the dates that stay at the top, above a
  // phone's tab bar. Again once the boxes that load on their own have drawn (Needs you, What's next), which move the
  // page (Owed's "Open diary", bug hunt 8 Oct 2026: the visit glowed off the screen, or behind the dates on an iPhone).
  const id = row.dataset.cleanId ?? ''
  const gen = routeGen
  const bring = (smooth: boolean): void => {
    if (gen !== routeGen) return
    const now = [...root.querySelectorAll<HTMLElement>(`.clean-row[data-clean-id="${id}"]`)].find(r => r.getBoundingClientRect().height > 0)
    if (!now) return
    const band = readableBand(), at = now.getBoundingClientRect()
    // Its note under it is read too (the first job's "Andy's first job is in the diary", 19 Oct 2026: it sat behind
    // the phone's Due bar).
    const note = now.nextElementSibling?.classList.contains('first-visit-tip') ? now.nextElementSibling.getBoundingClientRect() : null
    const bottom = note ? note.bottom : at.bottom
    if (at.top >= band.top + 8 && bottom <= band.bottom - 8) return
    window.scrollTo({ top: Math.max(0, window.scrollY + at.top - band.top - 16), behavior: smooth && !reduced ? 'smooth' : 'auto' })
  }
  requestAnimationFrame(() => bring(true))
  for (const wait of [700, 1600]) window.setTimeout(() => bring(false), wait)
}

// The part of the screen a visit can be read in: below what stays at the top (the app's bar, the diary's dates when
// they stick) and above a phone's tab bar.
function readableBand(): { top: number; bottom: number } {
  let top = Math.max(0, document.querySelector<HTMLElement>('header.topbar, header')?.getBoundingClientRect().bottom ?? 0)
  const strip = document.querySelector<HTMLElement>('.diary-desk-strip, .diary-week-strip')
  if (strip && getComputedStyle(strip).position === 'sticky') top = Math.max(top, (parseFloat(getComputedStyle(strip).top) || 0) + strip.offsetHeight)
  const tabs = [...document.querySelectorAll<HTMLElement>('nav')].find(n => getComputedStyle(n).position === 'fixed' && n.getBoundingClientRect().top > window.innerHeight / 2)
  // The phone's Due bar sits on the tabs (round 2): a visit is read above it. With nothing on it, it is not there.
  const due = document.querySelector<HTMLElement>('.diary-due-bar:not([hidden])')
  return { top, bottom: due ? due.getBoundingClientRect().top : tabs ? tabs.getBoundingClientRect().top : window.innerHeight }
}
// The calendar day this module last believed it was. The diary is a
// single-page app that lives on a phone for days at a time: fromDate was set
// once when the tab first loaded, so after paging back through history — or
// simply leaving the app open overnight — coming back to the diary reopened
// last week, or yesterday, with no sign that it was not today.
let mountedDay = todayISO()
let editing = false
let refreshPending = false
let workerFilter = ''
let areaFilter = ''
// A renamed area keeps its filter, under its new name (area-rename.ts), here and in the choices kept for later.
window.addEventListener(AREA_RENAMED, (e) => {
  const { from, to } = (e as CustomEvent<{ from: string; to: string }>).detail
  if (areaFilter === from) areaFilter = to
  if (restoreChoices?.areaFilter === from) restoreChoices.areaFilter = to
})
let reviewOpen = false
// The customer page's Not done on a past visit to review ("#/schedule?notdone=<visit id>", customer page redesign,
// Liam 9 Oct 2026): the Diary opens with that visit's own Not done question, so the answers and their saves are the
// Diary's own.
let askNotDone: number | null = null
// Today's jobs and their states at the last drawing, so Day done shows only when the last one has just been marked done.
let diaryTodayStates: { draw: number; states: Map<number, string> } | null = null
let diaryDraws = 0
// Which days' Completed lists are open (New), by account and day: they stay open while payments are recorded in them,
// as reviewOpen does for the review box (bug hunt, 8 Oct 2026: the list shut after every Paid).
const completedOpen = new Set<string>()
// The computer's Done fold, closed only when you closed it (this phone or computer remembers).
const DONE_FOLDED = 'roundly:diary-done-folded'
function doneFolded(): boolean { try { return localStorage.getItem(DONE_FOLDED) === '1' } catch { return false } }
function setDoneFolded(on: boolean): void { try { if (on) localStorage.setItem(DONE_FOLDED, '1'); else localStorage.removeItem(DONE_FOLDED) } catch { /* kept for this visit only */ } }
// The phone's magnifier (search, worker and area) remembers being open while the diary is on screen.
let filtersOpen = false
let diarySearch = ''
let selectedDate = ''
let selectedIdentity = ''
// The day the Diary chooses itself (Liam, 20 Oct 2026: "i wonder if it should open here in day view of diary only to the
// next day with any work on ... we can save a touch here"; Sonnet's edge cases as the lead settled them, 20 Oct 2026;
// diary-stops.ts openingDay). The Diary still arrives on Week; the day it chooses, the one Day shows, is today while
// today has a visit still to do, else the next day with visits still to do within 14 days. A selection still equal to
// chosenDay is the Diary's own, which an opening may move; any other was picked (a tap, the arrows, Today, Jump to a date,
// a link, a move or a booking) and stays.
let chosenDay = ''
// Set as the Diary opens (from another tab, or the app opening); the next read chooses the day before it draws.
let choosing = false
// The chosen day when it lies beyond the week read (next week): Day goes there, the way the arrows do, when it is shown
// with the Diary's own choice. Week stays on this week.
let chosenAhead: string | null = null
// The screen the Diary was reached from (main.ts): back from a customer page or a day's map keeps its day, week and view.
let cameFrom = ''
export function noteScreenBeforeDiary(screen: string): void { cameFrom = screen }
let weekEntry: { from: string; gen: number; who: string; label: string } | null = null
let planningExpanded = false
let planningTab: 'place' | 'review' | 'round' = 'place'
const dayViewChoices = new Map<string,'day' | 'week' | null>()
function weekMode(): 'day' | 'week' {
  const key = diaryPreferenceKey('day-view')
  if (!dayViewChoices.has(key)) {
    let saved: 'day' | 'week' | null = null
    try { const value = localStorage.getItem(key); if (value === 'day' || value === 'week') saved = value } catch { /* Session memory works without storage. */ }
    dayViewChoices.set(key,saved)
  }
  // Day · Week · Month (Liam, 8 Oct 2026): Day (the dates and one day) is where the diary opens on any screen.
  return dayViewChoices.get(key) ?? 'day'
}
function setWeekMode(mode: 'day' | 'week'): void {
  // Another view arrives with its lists closed and no tile lit (Astra's final check: switching is explicit); a way in
  // that wants Due open (Give them a day, Show me) opens it after this.
  if (weekMode() !== mode) { deskDueOpen = false; deskPencilOpen = false; deskNeedsOpen = false; deskWeekLens = null }
  const key = diaryPreferenceKey('day-view'); dayViewChoices.set(key,mode)
  try { localStorage.setItem(key,mode) } catch { /* Current visit still remembers the choice. */ }
}
// The Day · Week · Month switch's choice, from the week diary (Month answers through its own hooks).
function pickView(view: 'day' | 'week' | 'month', p: SchedulePayload, root: HTMLElement): void {
  if (!diaryNavigationReady()) return
  if (phoneWeekActive()) closePhoneSheet()
  if (view === 'month') { root.classList.remove('diary-phone-week-view'); showMonth(); return }
  setWeekMode(view)
  if (view === 'day' && goAhead()) return
  render(p, root)
  ;[...root.querySelectorAll<HTMLButtonElement>('.diary-views button')].find(b => b.textContent === (view === 'day' ? 'Day' : 'Week'))?.focus({preventScroll:true})
}
function diaryNavigationReady(): boolean {
  if (editing || rowDrag || reorderInFlight || movesInFlight.size || [...document.querySelectorAll<HTMLDialogElement>('dialog')].some(d => d.open && !d.classList.contains('diary-week-tray') && !d.classList.contains('visit-card-side'))) {
    toast('Finish editing or moving this visit before changing the diary.'); return false
  }
  return true
}
function selectInitialDay(p: SchedulePayload): void {
  const who = diaryPreferenceKey('selection')
  if (selectedIdentity !== who) { selectedIdentity = who; selectedDate = ''; chosenDay = ''; chosenAhead = null; planningExpanded = false; filtersOpen = false }
  if (!selectedDate || selectedDate < p.from || selectedDate > p.to) {
    const own = !selectedDate || selectedDate === chosenDay
    selectedDate = todayISO() >= p.from && todayISO() <= p.to ? todayISO() : p.from
    if (own) chosenDay = selectedDate
  }
}

// ---- the day the Diary chooses (above, chosenDay) ----
// A day's visits as the rule counts them, whatever the filters (E3): no contacts, none held in a week, no suggestions,
// none cancelled.
const ruleRows = (cleans: readonly Clean[], iso: string): Clean[] => cleans.filter(c => c.date === iso && !isContact(c) && !isUnplaced(c, c.date, c.date) && !isSuggestion(c) && c.state !== 'cancelled')
const stillToDo = (c: Clean): boolean => c.state === 'booked' && !c.blocked_reason
// Today's Finish my day card would show (day-close.ts finishDayCard): the person signed in has visits of their own today,
// not only pencilled in, every one dealt with, and the day not finished. Not known (the copy on the phone): as if it
// would (E2).
function finishWouldShow(p: SchedulePayload, today: string, fresh: boolean): boolean {
  const name = getMe()?.workerName?.trim().toLowerCase()
  if (!name) return false
  const roster = p.round_days ?? []
  const mine = ruleRows(p.cleans, today).filter(c => (worksAlone() || visitWorker(c, roster).trim().toLowerCase() === name) && !pencilledIn(c))
  if (!mine.length || mine.some(stillToDo)) return false
  if (!fresh || !('finished_days' in p)) return true
  return !finishedDays(p).some(f => f.date === today && f.worker.trim().toLowerCase() === name)
}
// The day, from the week read and (`ahead`) the days after it; null when it may lie beyond the days read.
function chooseDay(p: SchedulePayload, fresh: boolean, ahead: SchedulePayload | null): string | null {
  const today = todayISO()
  if (today < p.from || today > p.to) return today
  const cleans = ahead ? [...p.cleans, ...ahead.cleans] : p.cleans
  return openingDay(today, ahead?.to ?? p.to,
    iso => ruleRows(cleans, iso).some(stillToDo) || (iso === today && finishWouldShow(p, today, fresh)),
    iso => ruleRows(cleans, iso).some(c => c.state === 'booked'))
}
// The days after the week up to 14 days ahead, read without touching the week's read or its saved copy (E4), given a
// moment before the Diary draws today instead (E5).
const AHEAD_WAIT_MS = 2500
function readAhead(p: SchedulePayload): Promise<SchedulePayload | null> {
  const to = addDaysISO(todayISO(), OPEN_AHEAD_DAYS)
  if (to <= p.to) return Promise.resolve(null)
  return Promise.race([
    api<SchedulePayload>(`/api/schedule?from=${addDaysISO(p.to, 1)}&to=${to}`).catch(() => null),
    new Promise<null>(done => window.setTimeout(() => done(null), AHEAD_WAIT_MS)),
  ])
}
function setChosen(p: SchedulePayload, day: string): void {
  const today = todayISO(), inWeek = day >= p.from && day <= p.to
  chosenAhead = inWeek ? null : day
  selectedDate = chosenDay = inWeek ? day : today >= p.from && today <= p.to ? today : p.from
  selectedIdentity = diaryPreferenceKey('selection')
}
// Day shown with the Diary's own choice, and that choice in a later week: go there, the way the arrows do.
function goAhead(): boolean {
  if (weekMode() !== 'day' || !chosenAhead || selectedDate !== chosenDay) return false
  selectedDate = chosenDay = chosenAhead; chosenAhead = null
  fromDate = defaultFrom(selectedDate)
  void load()
  return true
}
const diaryPhoneMedia = typeof matchMedia === 'function' ? matchMedia('(max-width: 760px)') : null
let widthRedrawWaiting = false
function redrawForWidth(): void {
  // Adapt the default at the phone breakpoint; an explicit choice is kept. New diary also changes arrangement here
  // (desktop strip and column, or the phone's), so it redraws whatever the choice, once nothing is in progress.
  widthRedrawWaiting = false
  const root = document.querySelector<HTMLElement>('#screen')
  if (!root) return
  // Month keeps its arrangement until it is next drawn (its old bar, the only thing this redrew, was Original's).
  if (diaryView() === 'month') return
  if (!payload || !root.querySelector('.diary-week-strip, .diary-desk-head')) return
  if (editing || rowDrag || reorderInFlight || movesInFlight.size || document.querySelector('dialog[open]')) { widthRedrawWaiting = true; window.setTimeout(redrawForWidth, 400); return }
  render(payload,root)
}
diaryPhoneMedia?.addEventListener?.('change',()=>{ if (!widthRedrawWaiting) redrawForWidth() })
// The tray row tapped for a move: every day card then offers Move here until
// the row is tapped again or Escape is pressed. Module state on purpose, and
// mountSchedule resets it — a selection must not survive navigation (kimi S-5).
let movingId: number | null = null
// The row being dragged to a new place in its day — one at a time, whole app,
// finger or mouse alike. Null while no press is watching. The decisions the
// gesture makes — whether a press becomes a grab, which row a drop lands on,
// how the page auto-scrolls — live in src/day-order.ts and are tested there;
// everything below is the plumbing that feeds them. Reset like the
// selections around it.
type RowDrag = {
  row: HTMLElement
  cleanId: number
  date: string
  day: HTMLElement
  inDayOrder: readonly Clean[]
  pointerId: number
  pointerType: string
  startX: number
  startY: number
  lastY: number
  lastX: number
  startedAt: number
  fingerDy: number // where in the row the pointer took hold
  rowTopPage: number // the row's top in page coordinates at the grab
  phase: 'press' | 'held'
  timer: number | null
  frame: number | null
}
let rowDrag: RowDrag | null = null
// The customers read (GET /api/customers) that feeds the panel's "Due this
// week" group. Null until one answers: a failed read drops the group and the
// diary stays up — the panel is a bonus, the diary is the work.
let customers: Customer[] | null = null
// Several jobs (step 2): every extra job on the round with its own dates (GET /api/customer-jobs). Empty while the
// round's switch is off, so every set below is the customer-wide one it always was.
let roundJobList: CustomerJob[] = []
// The due-group row tapped for a booking: every day then offers Book here
// until the row is tapped again or Escape is pressed. Kept apart from
// movingId on purpose — a due customer is not a visit yet, so the two
// selections can never share an id space. Keyed by job (diary-sets dueKey):
// a customer's windows and gutters are two rows.
let movingDueId: string | null = null
// "Do the gutters that day, first?" answered No for these visits (several jobs, Liam Q1), while the app is open.
const gutterAskDeclined = new Set<string>()
// The enquiry row tapped for placement — same pattern, third id space (a
// lead is not a customer and not a visit).
let movingEnqId: number | null = null
// The leads read (GET /api/leads, the same cache key Messages uses) that
// feeds the panel's "New enquiries" group. Same survival rule as customers:
// a failed read drops the tab, the diary carries on.
let leads: Lead[] | null = null
let requestSequence = 0

function dataChanged(): void {
  if (editing) refreshPending = true
  else void load()
}

function afterEdit(): void {
  editing = false
  if (diaryView() === 'month') { refreshPending = false; monthOnDataChanged(); return }
  if (refreshPending) {
    refreshPending = false
    void load()
  }
}

// The 4xx terminal case for fire-and-forget mutations (codex CRITICAL-2):
// mutate() drops invalid edits from the queue and returns the ack — if the
// caller ignores it, a rejection vanishes silently.
function alert4xx(ack: Ack): void {
  if (!ack.ok && ack.status >= 400 && ack.status < 500) window.alert(ack.error ?? 'rejected')
}

// ---- cleans ---------------------------------------------------------------

// `extra` is one caller-supplied action placed FIRST in the row's action
// list. Only the diary's review box passes one ("Move to Due this week"; New's Not done, moved beside Done),
// which has no meaning on a day card — a visit sitting on its own day is not
// waiting to be triaged.
function renderClean(cl: Clean, container: HTMLElement, extra?: HTMLElement, day?: Clean[]): void {
  clear(container)
  container.classList.remove('cell-pending', 'clean-paid', 'clean-owed')
  // The tile itself says paid or owed, not just a badge inside it: a day is
  // read at a glance for "who still owes".
  if (cl.state === 'done') container.classList.add(cl.payment_status === 'paid' ? 'clean-paid' : 'clean-owed')
  const main = el('a', { href: `#/customer/${cl.customer_id}`, class: 'sched-clean-main' })
  const line = el('span', { class: 'sched-clean-line' })
  if (shownVisitTime(cl)) line.append(el('span', { class: 'clean-time' }, shownVisitTime(cl)!))
  line.append(el('strong', {}, cl.customer_name ?? `#${cl.customer_id}`))
  if (cl.customer_address) {
    // Access constraints are buried INSIDE imported address strings — e.g.
    // "58 Eastern Road - DO NOT BOOK BETWEEN 11-1PM". Rendered whole in grey
    // .sched-addr, the hard constraint was the least prominent text on the
    // row, so Lewis could read the address and miss the instruction. Split it
    // out and give the warning its own weight.
    const { addr, warn } = splitAccessWarning(cl.customer_address)
    line.append(el('span', { class: 'sched-addr' }, ` ${addr}`))
    if (warn) line.append(el('span', { class: 'access-warn' }, warn))
  }
  main.append(line)
  const sub = el('span', { class: 'clean-badges' })
  // The job's name once the customer has more than one job (several jobs); the trade's word otherwise.
  sub.append(el('span', { class: 'badge' }, visitJobLabel(cl)))
  // Part done (0070): "Fronts only", or "Backs (the rest)" on the visit booked for the rest.
  const partTag = partBadge(cl)
  if (partTag) sub.append(partTag)
  // Tap the price to change it for this visit only (Liam 2026-09-28).
  if (cl.amount_pence !== null) sub.append(priceButton(cl, { className: 'badge', after: () => window.dispatchEvent(new CustomEvent('dropby:data-changed')) }))
  // The extras by name, as Today's card shows them ("+ Conservatory roof £60"; the computer check, 26 Oct 2026).
  if (cl.extras_json) sub.append(...extraBadges(cl.extras_json))
  // "booked ?" / "booked ✓" carried the whole confirmation signal in a glyph
  // nothing on screen explained — and every imported job reads unconfirmed.
  // A machine-proposed date is a THIRD thing and must not read as either: the
  // van must never drive to a suggestion believing it is a commitment.
  if (cl.state === 'booked') {
    sub.append(agreementBadge(cl))
    const also = alsoBookedText(cl, payload?.also_booked, todayISO())
    if (also) sub.append(el('span', { class: 'badge badge-also-booked' }, also))
    // The door outcome the owner reads at a glance (step 4): the visit is
    // still booked — this badge is WHY it did not happen. The review queue
    // and the day rows share this renderer, so one change shows both.
    if (cl.blocked_reason) {
      sub.append(el('span', { class: 'badge badge-blocked' }, blockedBadgeText(cl)))
      const blockedNote = blockedNoteText(cl.blocked_reason, cl.blocked_note)
      if (blockedNote) sub.append(el('span', { class: 'clean-note' }, blockedNote))
    }
  }
  // One payment badge for the whole app (src/payment.ts). The diary used to
  // build its own, which had no wording for a clean that has been chased — so
  // the row Lewis is standing in front of said plain "unpaid" while Owed and
  // the customer screen both said "Chased · unpaid", and he chased it twice.
  if (cl.state === 'done') sub.append(paymentBadge(cl))
  const cashTaken = cl.state === 'done' ? cashTakenBadge(cl) : null
  if (cashTaken) sub.append(cashTaken)
  if (cl.state === 'cancelled') sub.append(el('span', { class: 'badge badge-cancelled' }, 'cancelled'))
  // A one-person round: only a name that is not the owner's (Liam, 19 Oct 2026).
  const shownWorker = worksAlone() ? otherName(cl.worker) : cl.worker
  if (shownWorker) sub.append(el('span', { class: 'badge badge-worker' }, shownWorker))
  // Job times (0020): when the worker got there and how long it took.
  const jobTimes = jobTimesLine(cl)
  if (jobTimes) sub.append(el('span', { class: 'badge badge-job-times' }, jobTimes))
  if (cl.duration_minutes) sub.append(el('span', { class: 'badge' }, `${cl.duration_minutes}m`))
  if (cl.note) sub.append(noteNode(cl.note))
  main.append(sub)
  // Has the worker's phone got this day as it is now? (download-status.ts; release 3 of "Roundly opens with no
  // signal", docs/plans/offline/PLAN-v3-changes.md §6.) Only on the days a phone keeps, for workers who sign in.
  if (payload?.downloads && reachesPhone(cl)) {
    const dayWorker = payload.round_days?.find((d) => d.date === cl.date)?.worker
    for (const line of downloadLines(phoneOf(cl.worker, dayWorker), cl.date, payload.downloads)) main.append(el('span', { class: 'download-line' }, line))
  }

  const actions = el('div', { class: 'clean-actions' })
  // The API already selects cu.phone as customer_phone and the type declares
  // it — it was fetched and thrown away. Calling from the row saves Lewis a
  // navigation, a load, and the trip back, at the door where he needs it.
  const tel = telHref(cl.customer_phone)
  if (tel) actions.append(el('a', { href: tel, class: 'maps-link call-link' }, 'Call'))
  if (cl.state === 'booked') {
    // Done only exists once the day has arrived. On a future row it recorded
    // a clean that never took place. Future unconfirmed real visits get the
    // other truth instead: the customer agreed on WhatsApp, and someone
    // records that by hand (Liam: "we manually click that").
    const future = cl.date > todayISO()
    if (!future && !isContact(cl)) {
      const done = el('button', { class: 'btn-primary' }, 'Done')
      done.addEventListener('click', (e) => {
        e.preventDefault()
        const gen = routeGen, who = diaryPreferenceKey('completion')
        const anchor = container.getBoundingClientRect()
        const tick = (): void => {
          if (gen === routeGen && who === diaryPreferenceKey('completion')) {
            const current = document.querySelector<HTMLElement>(`.day-card [data-clean-id="${cl.id}"]`)
            diaryCompletion(current?.getBoundingClientRect() ?? anchor,cl.id,() => gen === routeGen && who === diaryPreferenceKey('completion'))
          }
        }
        // The same "How was it paid?" pop-up as Owed (Liam, 9 Oct 2026: one way to mark a visit done everywhere); the full
        // form is behind its link.
        void import('./owed').then(({ openDonePopup }) => openDonePopup(cl, { onSaved: tick }))
      })
      actions.append(done)
    }
    // A passed day nobody answered is not a plan. Removing the visit (not
    // moving it, not cancelling it) puts the truth back: the customer is
    // still due, so the "Due this week" group brings them back on its own
    // next week with the asked badge intact — a visit pinned to another
    // unagreed day would be a second wrong date, and a cancelled one would
    // pile a cancelled badge on the day. A recorded door outcome
    // (blocked_reason) stays put: that visit has an answer, just no clean.
    // Only once the day has passed (bug hunt, 8 Oct 2026: it was offered on today's visit too, talking of next week).
    const moveOn = nobodyRepliedButton(cl)
    if (moveOn) actions.append(moveOn)
    // A visit to check (paused, stopped, Taken off, Needs a visit customer) is decided about, not agreed, so it offers no
    // Mark confirmed (Release 2, roundly-bugs' cross-check).
    const toCheck = confirmNeed(cl, visitCustomer(cl)) === 'check'
    // Release 2 (JOINT-PLAN 4e): the day agreed and a time set but not agreed: one tap agrees that exact time, the same
    // save as the booking form's "Time agreed" tick, with Undo.
    const timeKey = agreedTimeKey(cl.date, visibleTime(cl))
    if (future && cl.confirmed && timeKey && !timeIsAgreed(cl) && !isContact(cl) && !toCheck) {
      // "Agree 9am": what the tap does, with the time it agrees (Liam, 4 Nov 2026: "9am agreed i think this wording is
      // better"; design 2B, https://claude.ai/artifact/DpcjLYprs8VHSudWRdxJkZ). Phone and computer.
      const agree = el('button', { class: 'btn-primary diary-time-agreed', 'aria-label': `Agree ${shownTime(timeKey.split('|')[1] ?? '')} with ${cl.customer_name ?? 'them'}` }, `Agree ${shownTime(timeKey.split('|')[1] ?? '')}`)
      // The same save and Undo as the customer page's Time agreed (visit-actions.ts).
      agree.addEventListener('click', (e) => { e.preventDefault(); markTimeAgreed(cl, agree, () => void load()) })
      actions.append(agree)
    }
    if (future && !cl.confirmed && !isContact(cl) && !isSuggestion(cl) && !toCheck) {
      const confirm = el('button', { class: 'btn-primary' }, 'Mark confirmed') // an action, not a state (Astra review 2026-09-25)
      confirm.addEventListener('click', (e) => { e.preventDefault(); markDayAgreed(cl, confirm, () => void load()) })
      actions.append(confirm)
      // Several jobs on: the customer's other jobs waiting on the same day, by name. "Mark confirmed" agrees this
      // visit only; this agrees exactly the visits it names, and its Undo puts back exactly those (Astra r1, 7).
      const group = severalJobsOn() ? houseGroup(cl) : []
      // Offered once, on the house's first row.
      if (group.length > 1 && group[0]!.id === cl.id) {
        const both = el('button', {}, `Confirm ${group.map((v) => visitJobLabel(v)).join(' and ')}`)
        both.addEventListener('click', (e) => {
          e.preventDefault()
          both.setAttribute('disabled', 'disabled')
          confirmGroup(group)
        })
        actions.append(both)
      }
    }
    // A contact reminder is not a visit and has no ⋯ — it is a prompt with two
    // answers, so both stay on the face. Everything a real visit can have done
    // to it moved into the ⋯ (see jobMenu): the face keeps `call` and the ONE
    // act the day needs of it.
    if (isContact(cl)) {
      const plan = el('button', {}, 'Plan visit')
      plan.addEventListener('click', () => openBooking({ customerId: cl.customer_id, cleanId: cl.id }))
      const dismiss = el('button', { class: 'btn-danger' }, 'Dismiss reminder')
      // The same save as Cancel visit, with its Undo.
      dismiss.addEventListener('click', () => cancelVisit(cl, () => { dismiss.disabled = true }, {
        ask: `Cancel the ${dayLabel(cl.date)} reminder for ${cl.customer_name}?`,
        undoText: `Dismissed the ${dayLabel(cl.date)} reminder for ${cl.customer_name ?? 'them'}`,
      }))
      actions.append(plan, dismiss)
    }
  }
  // A cancelled visit had no control at all, so a visit put on the wrong day
  // stayed on that day for good — and kept counting against the customer on
  // their Reliability line, which is meant to mean THEY called it off. Remove
  // takes it off the day and off that count; the app's history keeps the row,
  // with who cancelled it and when. Deleting a cancelled visit pulls nothing
  // else with it (removeGeneratedBooking only acts on a done visit).
  // Any done clean that isn't settled needs the control — including 'unknown',
  // which previously had none.
  if (cl.state === 'done' && cl.payment_status !== 'paid') {
    // Two taps at the point of payment, instead of typing "cash"/"bank" into a
    // window.prompt one-handed in a van.
    for (const m of ['cash', 'bank'] as const) {
      const paid = el('button', { class: 'btn-primary', 'data-paid-way': m }, m)
      paid.addEventListener('click', (e) => {
        e.preventDefault()
        paid.setAttribute('disabled', 'disabled')
        // The paid moment, as on Owed (paid-moment.ts): green from the tap across the visit, a tick, the buzz.
        const takeBack = paidMoment({ host: container, from: paid, way: m })
        void mutate({
          label: `Mark paid: ${cl.customer_name ?? ''} ${cl.date}`,
          method: 'PATCH',
          path: `/api/cleans/${cl.id}`,
          body: { version: cl.version, payment_status: 'paid', payment_method: m, chased: 0 },
          onAck: () => void load(),
          onConflict: () => void load(),
        }).then((ack) => {
          if (!ack.ok && ack.status >= 400 && ack.status < 500) { paid.removeAttribute('disabled'); takeBack() }
          alert4xx(ack)
          undoPatch({ text: `Marked ${cl.customer_name ?? 'visit'} paid by ${m}`, label: `Undo paid: ${cl.customer_name ?? ''} ${cl.date}`, path: `/api/cleans/${cl.id}`, ack, version: cl.version,
            body: { payment_status: cl.payment_status, payment_method: cl.payment_method ?? null, chased: cl.chased }, after: () => void load() })
        })
      })
      actions.append(paid)
    }
    actions.prepend(el('span', { class: 'paid-label' }, 'paid:'))
  }
  // The ⋯ (see jobMenu): one menu, the same one the Due this week rows and the
  // week tray carry, so moving a job is the same gesture wherever it sits.
  // Contact reminders answer for themselves on the face and get none.
  if (day && !isContact(cl)) actions.append(jobMenu({ kind: 'day', clean: cl, day }))
  // Photos (step 2): diary rows show the strip only — 48px thumbnails, no
  // button; photos are added from the Today card or the customer page.
  // Cancelled visits carry none, the same rule as note controls.
  if (extra) actions.insertBefore(extra, actions.firstChild)
  if (cl.state !== 'cancelled') {
    const photosBox = el('div', { class: 'card-photos' })
    container.append(main, actions, photosBox)
    compactClean(cl, container, day)
    return
  }
  container.append(main, actions)
  compactClean(cl, container, day)
}

// Compact rows are the approved design. Their details reuse every real control
// from the original row; no second booking/payment implementation is introduced.
function compactClean(cl: Clean, container: HTMLElement, day?: Clean[]): void {
  const main = container.querySelector<HTMLElement>('.sched-clean-main')
  const actions = container.querySelector<HTMLElement>('.clean-actions')
  if (!main || !actions) return
  const photos = container.querySelector<HTMLElement>('.card-photos')
  const stash = el('div', {class:'diary-visit-details', hidden:''}, main, actions)
  if (photos) stash.append(photos)
  const face = el('button', {type:'button', class:'diary-row-summary', 'aria-label':`Details for ${cl.customer_name ?? 'visit'}`})
  const street = splitAccessWarning(cl.customer_address ?? '').addr.split(',')[0]?.trim()
  // The time can be tapped on a Day row, phone and computer (tidy-up 2 item 1, Liam, 20 Oct 2026: "Times arent tappable
  // how do i easily change that"): inside the title's <small>, so every rule keyed to it still holds; "+ Time" with none.
  // The computer's Day shows its own time button instead (deskRowParts), one time control a row; the computer's Week
  // grid and Month stay as they were (docs/plans/tidy-up-2/AGREED.md 1).
  const tapTime = timeEditable(cl) && diaryView() === 'week' && weekMode() === 'day' && !diaryDesk()
  const timeWords = shownVisitTime(cl)
  // Who is doing it, on the phone a tag beside the time (design B, 23 Oct 2026); the computer keeps it in its own line.
  const doer = diaryDesk() ? '' : (worksAlone() ? otherName(cl.worker) : cl.worker?.trim()) ?? ''
  face.append(el('span', {class:'diary-row-title'}, el('strong', {}, cl.customer_name ?? 'Visit'),
    ...(tapTime ? [el('small', {}, el('span', {class:`diary-row-time-tap${timeWords ? '' : ' is-empty'}`, title: timeWords ? 'Change the time' : 'Set a time'}, timeWords ?? '+ Time'))] : timeWords ? [el('small', {}, timeWords)] : []),
    // On a phone's Day the name keeps the line: who is doing it goes under it, before the street (Liam's Day in Today's
    // look, 4 Nov 2026; Astra: the name was cut to a few letters).
    ...(doer && !(diaryView() === 'week' && weekMode() === 'day') ? [el('span', {class:'diary-row-worker'}, doer)] : [])),
    // The phone's list reads like a round sheet: the street, then which job when there are several, then who (round 2).
    // A one-person round says no name but someone else's (Liam, 19 Oct 2026).
    // No street on file says so (tidy-up item 8, build-today.md 2.2: "No address yet"), unless the owner said the
    // postcode is enough: then the postcode (tidy-up 2 item 3, Liam, 20 Oct 2026; add-details.ts enoughPostcode).
    el('span', {class:'diary-row-meta'}, ...(doer && diaryView() === 'week' && weekMode() === 'day' ? [el('span', {class:'diary-row-worker'}, doer)] : []), (diaryDesk() ? [visitJobLabel(cl), areaOf(cl), worksAlone() ? otherName(cl.worker) : cl.worker, cl.duration_minutes ? `${cl.duration_minutes}m` : 'No estimate', street || postcodeEnough(cl) ? '' : 'No address yet']
      : [street || postcodeEnough(cl) || 'No address yet', severalJobsOn() ? visitJobLabel(cl) : '']).filter(Boolean).join(' · ')))
  // The shared words for the day and the time (visit-words.ts), the same line Messages shows for this visit.
  const words = diaryWords(cl)
  const state = el('span', {class:`diary-row-status diary-words-${words.tone}${words.tone === 'ok' ? ' agreed' : ''}`}, agreeTimeTag(cl, words.text, true))
  // Words that only say what the box and the time already show (Liam's phone Day A, 4 Nov 2026: "Day agreed · time
  // agreed" under every stop): marked, so the phone's Day can leave them out; "Asked yesterday" and the rest stay.
  // Today and earlier keep "time to confirm" and "Not asked yet": the words are the tap that agrees today's time, and a
  // past visit has no dashed box to say it instead (Astra, 4 Nov 2026).
  if (words.text === 'Day agreed · time agreed' || (cl.date > todayISO() && /^(Day agreed|Not asked yet)( · (time to confirm|no set time))?$/.test(words.text))) state.dataset.plain = '1'
  state.append(el('span', {class:'diary-details-cue'}, ' · Details', chevronIcon('diary-details-chev'))); face.append(state)
  const quick = el('div', {class:'diary-row-quick'})
  // The row's price is the visit's own price button, found by its class (never by its words), lent out of the details
  // with its empty holder taken away; it opens the price sheet wherever it sits (tidy-up 2 item 2, docs/plans/tidy-up-2/
  // AGREED.md 2: the box used to open inside the hidden details). Still a button straight inside .diary-row-quick, so the
  // phone's 44px target and the computer's placement rules hold (diary-new.css:40, :190, :306, :330, :566, :713). A visit
  // with no price gets one too, "Add price" (Sonnet F13).
  const price = main.querySelector<HTMLElement>('.price-edit-btn')
  if (price) {
    const holder = price.closest('.price-edit'); quick.append(price); holder?.remove()
    // Whole pounds on a phone's Day, as on Today (pence stay when there are any).
    if (!diaryDesk() && diaryView() === 'week' && weekMode() === 'day') for (const t of [price, ...Array.from(price.querySelectorAll<HTMLElement>('span'))]) if (!t.children.length && t.textContent) t.textContent = t.textContent.replace(/([£$€][\d,]+)\.00(?!\d)/g, '$1')
  }
  else if (cl.amount_pence !== undefined) quick.append(priceButton(cl, {className:'diary-price', after:() => window.dispatchEvent(new CustomEvent('dropby:data-changed'))}))
  else quick.append(el('span', {class:'diary-price'}, 'No price'))
  const quickActions = el('div', {class:'diary-quick-actions'})
  const done = [...actions.querySelectorAll<HTMLButtonElement>(':scope > button')].find(b => b.textContent === 'Done')
  // Design B (Liam, 8 Oct 2026: "a bit intimidating"): one main button per visit, the one thing it needs next. Move,
  // Call and the rest are in its ⋯ and its details; a visit is moved by dragging it onto a date.
  const next = visitNextStep(cl)
  if (done && next === 'done') { done.classList.add('diary-done'); quickActions.append(done) }
  // Nobody has asked them yet: the main button asks, in Messages' own pop-up for this one day (its send, "I messaged
  // them myself" and "They already said yes"). Mark confirmed stays in the ⋯ and the details for a day agreed another way.
  // No way to reach them: the add button in its place (tidy-up item 8); an agreed visit ahead with no address, too.
  const add = addDetailsStep(cl, next)
  if (add) {
    const b = el('button', {type:'button', class:'btn-primary diary-add-details'}, add.words)
    b.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); add.open() })
    quickActions.append(b)
  } else if (next === 'ask') {
    const first = (cl.customer_name ?? '').trim().split(/\s+/)[0]
    const ask = el('button', {type:'button', class:'btn-primary diary-desk-confirm diary-ask'}, first ? `Message ${first}` : 'Message them')
    ask.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); askAboutDay(cl.customer_id, cl.date, { visitId: cl.id, onDone: () => void load() }) })
    quickActions.append(ask)
  }
  if (next === 'replied') {
    const replied = el('button', {type:'button', class:'btn-primary diary-desk-confirm diary-replied'}, 'They replied')
    replied.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); if (diaryNavigationReady()) openTheyReplied(cl, repliedOptions(cl)) })
    quickActions.append(replied)
  }
  const own = [...actions.children] as HTMLElement[]
  if (next === 'confirm' || next === 'time') {
    for (const b of own.filter((n): n is HTMLButtonElement => n.tagName === 'BUTTON' && (n.textContent === 'Mark confirmed' || n.classList.contains('diary-time-agreed') || (n.textContent ?? '').startsWith('Confirm ')))) { b.classList.add('diary-desk-confirm'); quickActions.append(b) }
  }
  const deskWeek = diaryDesk() && diaryView() === 'week' && weekMode() === 'day'
  let payTag: HTMLElement | null = null
  if (next === 'paid') {
    const paidButtons = own.filter((n): n is HTMLButtonElement => n.tagName === 'BUTTON' && (n.dataset.paidWay === 'cash' || n.dataset.paidWay === 'bank'))
    if (paidButtons.length) {
      const group = el('span', {class:'diary-desk-paid', role:'group', 'aria-label':`Paid by, for ${cl.customer_name ?? 'visit'}`}, el('span', {}, 'Paid:'))
      // In their own colours, as everywhere a payment is marked (paid-moment.ts).
      for (const b of paidButtons) { const way = b.dataset.paidWay as 'cash' | 'bank'; b.textContent = way === 'cash' ? 'Cash' : 'Bank'; paidLook(b, way); group.append(b) }
      own.find(n => n.classList.contains('paid-label'))?.remove()
      // The computer week (Liam picked A, 15 Oct 2026: https://claude.ai/artifact/9En31D1mDsYU6JyaLQrFQQ): a finished job is
      // one line, and Cash and Bank wait behind one small "Not paid ›" until tapped. Elsewhere the pill is not shown.
      const pill = el('button', {type:'button', class:'diary-week-pill', 'aria-expanded':'false', 'aria-label':`Not paid: mark how ${cl.customer_name ?? 'this visit'} paid`}, 'Not paid', el('span', {'aria-hidden':'true'}, ' ›'))
      pill.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation()
        const open = !container.classList.contains('diary-paid-open')
        container.classList.toggle('diary-paid-open', open); pill.setAttribute('aria-expanded', String(open))
      })
      // The phone (docs/plans/diary-tidy/PLAN.md v2, Liam's drawings): one pill in the payment's own words and colour
      // (paymentLabel: Unpaid, Chased · unpaid, "£15.00 to pay", Payment not recorded), a drawn chevron; tapped, Cash and
      // Bank open in place with "Open in Owed" under them. The computer week keeps its own pill.
      // The words Messages and Owed use (visit-words.ts paymentWords: Not paid, Chased · not paid, "£15.00 to pay"), the
      // colour from paymentLabel's own class (badge-unpaid, badge-chased, badge-part, badge-unknown).
      const words = paymentWords(cl)
      const tone = paymentLabel(cl).className.replace('badge-', '')
      // On the computer's Day it opens Owed, and says so to a screen reader (Sonnet's review, 23 Oct 2026).
      const phonePill = el('button', {type:'button', class:`diary-pay-pill diary-pay-${tone}`, ...(deskWeek ? {'aria-label':`${words}: open ${cl.customer_name ?? 'this visit'} in Owed`} : {'aria-expanded':'false', 'aria-label':`${words}: mark how ${cl.customer_name ?? 'this visit'} paid`})}, el('span', {}, words), chevronIcon('diary-pay-chevron'))
      phonePill.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation()
        // The computer's Day shows Cash and Bank beside it (Liam's pick 1C), so there the tag opens Owed, as its words did.
        if (container.closest('.diary-desk-agenda')) { openInOwed(cl); return }
        const open = !container.classList.contains('diary-paid-open')
        container.classList.toggle('diary-paid-open', open); phonePill.setAttribute('aria-expanded', String(open)); pill.setAttribute('aria-expanded', String(open))
      })
      const owed = el('button', {type:'button', class:'diary-pay-owed'}, el('span', {}, 'Open in Owed'), chevronIcon('diary-pay-chevron'))
      owed.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); openInOwed(cl) })
      group.append(owed)
      quickActions.append(phonePill, pill, group); payTag = phonePill
    }
  }
  // Owed's "Didn't happen" (#/schedule?notdone=<id>&from=<day>) for a visit not in the review box (today's): its
  // Not done choices open on its row once drawn.
  if (askNotDone === cl.id) { askNotDone = null; setTimeout(() => { if (face.isConnected) openNotDone(cl, false, face) }, 0) }
  // Move, on a phone, for a job still to do (Liam, 22 Oct 2026: "make it easier to move to new day if a job isnt completed
  // we have to click the dots"; PLAN.md v2): never once started (its times would go) or for a reminder. The Diary's own
  // move, staying on this day; the six days say how full they are and which you don't work.
  if (mayMoveHere(cl)) {
    const move = el('button', {type:'button', class:'btn-secondary diary-move-btn'}, 'Move')
    move.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); openMoveFor(cl) })
    quickActions.append(move)
  }
  const show = (): void => {
    // The computer's Day (Liam picked B, 28 Oct 2026: https://claude.ai/artifact/2L2WokSyRTFptQ6Zymti1h): the visit opens
    // on the right, over the map, and the list stays usable; another visit's click swaps it, "Back to the map" closes it.
    const side = !!container.closest('.diary-desk-agenda')
    if (side && container.classList.contains('is-open-side')) return
    if (side) for (const other of Array.from(document.querySelectorAll<HTMLDialogElement>('dialog.diary-detail-side[open]'))) other.close()
    const dialog = el('dialog', {class:'booking-dialog diary-detail-dialog', 'aria-label':`Visit details for ${cl.customer_name ?? 'visit'}`})
    const close = el('button', {type:'button', 'aria-label':'Close visit details'}, 'Close')
    const content = el('div', {class:'diary-detail-content'})
    const order = container.querySelector<HTMLElement>('.diary-order-buttons')
    // The desktop agenda's agreement and payment labels lead its details too, so the time is never read as agreed.
    // Drawn afresh, not copied, so "time to confirm" still agrees the time from here (a copy loses its tap).
    if (container.closest('.diary-desk-agenda')) content.append(deskRowParts(cl).chips)
    // Laid out as the rest of Roundly lays out a card (Liam, 11 Oct 2026: "this has not been designed per brand
    // guidelines and universals used in the rest of the app"): who and where, then the one thing the visit needs next
    // as the lemon button, then the other ways on in equal buttons two by two, then the price and its order in the day.
    // The visit's own buttons are lent to the sheet and go back to it when the sheet closes.
    const lent = [...actions.children] as HTMLElement[]
    const callLink = lent.find((n) => n.matches('a.call-link'))
    const menu = lent.find((n) => n.classList.contains('row-menu'))
    const menuFace = menu?.querySelector(':scope > summary')
    const menuWas = menuFace?.textContent ?? null
    const primary = el('div', {class:'diary-detail-primary'})
    const grid = el('div', {class:'diary-detail-grid'})
    const nextStep = visitNextStep(cl)
    // Tidy-up item 8: the same rule as the row's button; with the main button something else, the add sits in the grid.
    const addNow = addDetailsStep(cl, nextStep)
    const addAside = addNow ? null : addDetailsAside(cl)
    if (addNow) {
      const b = el('button', {type:'button', class:'btn-primary diary-add-details'}, addNow.words)
      b.addEventListener('click', () => { dialog.close(); addNow.open() })
      primary.append(b)
    } else if (nextStep === 'ask') {
      const first = (cl.customer_name ?? '').trim().split(/\s+/)[0]
      const ask = el('button', {type:'button', class:'btn-primary'}, first ? `Message ${first}` : 'Message them')
      ask.addEventListener('click', () => { dialog.close(); askAboutDay(cl.customer_id, cl.date, { visitId: cl.id, onDone: () => void load() }) })
      primary.append(ask)
    } else if (nextStep === 'replied') {
      const replied = el('button', {type:'button', class:'btn-primary'}, 'They replied')
      replied.addEventListener('click', () => { dialog.close(); openTheyReplied(cl, repliedOptions(cl)) })
      primary.append(replied)
    } else if (nextStep === 'confirm' || nextStep === 'time') {
      // The visit's own Mark confirmed / Time agreed, on its face: the sheet's lemon button presses it (review: they had
      // left the buttons the sheet borrows, so the sheet showed none).
      for (const own of [...container.querySelectorAll<HTMLButtonElement>('button.diary-desk-confirm')].filter((n) => !n.classList.contains('diary-ask'))) {
        const b = el('button', {type:'button', class:'btn-primary'}, own.textContent ?? 'Mark confirmed')
        b.addEventListener('click', () => { dialog.close(); own.click() })
        primary.append(b)
      }
    } else if (done && nextStep === 'done') {
      // "Done", the row's own word (Liam's pick 11A, 22 Oct 2026).
      const finish = el('button', {type:'button', class:'btn-primary'}, 'Done'); finish.addEventListener('click', () => { dialog.close(); done.click() }); primary.append(finish)
    }
    // Design B (Liam, 27 Oct 2026: "Needs a redesign also not clear i can click customer here"; picked B,
    // https://claude.ai/artifact/JazPk5KEq5dttDN9iwETN4, Astra's check): who it is as a card on top with its own lemon
    // "Open <name>'s page" (the name block below no longer pretends to be a link), Cash and Bank as two big tiles when a
    // done visit is waiting to be paid, and the other ways on as picture tiles two by two. Everything the sheet did
    // before stays: the same lent buttons, the same order of what the visit needs next.
    // Since 28 Oct 2026 the name itself is the link to their page, underlined in lemon like every link, and the lemon
    // "Open <name>'s page" is gone (Liam: "there name should be underlined and that takes to customer page then we can drop
    // the bit about customer page"; src/links.css).
    const who = cl.customer_name ?? 'Visit'
    const first = (cl.customer_name ?? '').trim().split(/\s+/)[0]
    const card = el('div', {class:'diary-detail-who'},
      el('span', {class:'diary-detail-who-top'}, el('span', {class:'diary-detail-initials', 'aria-hidden':'true'}, initialsOf(who)),
        el('span', {class:'diary-detail-who-words'}, el('a', {href:`#/customer/${cl.customer_id}`, class:'diary-detail-name', 'aria-label':`Open ${who}'s page`}, who), ...(street ? [el('span', {}, street)] : []),
          // Its own button, never inside the page link: pin the door Google Maps gets wrong (exact-spot.ts).
          ...(isContact(cl) || cl.state === 'cancelled' ? [] : [spotButton({ id: cl.customer_id, name: who, link: cl.customer_maps_link ?? null }, () => void load(), () => dialog.close())]))))
    const mainHref = main.getAttribute('href')
    main.removeAttribute('href'); main.classList.add('diary-detail-main')
    // Cash and Bank live in the row's payment group (its pill opens them); lent here as tiles and put back on close.
    const paidHome: { b: HTMLElement; parent: HTMLElement; next: Element | null }[] = []
    const paidRow = el('div', {class:'diary-detail-paid', role:'group', 'aria-label':`How ${first || 'they'} paid`})
    if (cl.state === 'done' && nextStep === 'paid') {
      for (const b of container.querySelectorAll<HTMLElement>('.diary-desk-paid button[data-paid-way]')) {
        if (!b.parentElement) continue
        paidHome.push({ b, parent: b.parentElement, next: b.nextElementSibling })
        paidRow.append(b)
      }
      // The tap's own save runs first (its Undo, its paid moment on the row); then the sheet steps aside.
      paidRow.addEventListener('click', (e) => { if ((e.target as Element).closest('button')) dialog.close() })
    }
    const tileUp = (n: Element | null | undefined, drawing: Drawing | null): void => {
      if (!n) return
      n.classList.add('diary-tile')
      if (drawing) n.prepend(el('span', {class:'diary-tile-ring', 'aria-hidden':'true'}, lineDrawing(drawing, 20)))
    }
    if (addAside) {
      const b = el('button', {type:'button', class:'btn-secondary diary-add-details'}, addAside.words)
      b.addEventListener('click', () => { dialog.close(); addAside.open() })
      tileUp(b, 'personPlus')
      grid.append(b)
    }
    // Contact where Call was, the whole width, its choices opening under it: Call and the ways to message them, a chat
    // that Roundly does not record (Liam, 21 Oct 2026, after rearranging Lyndsey: "there was no easy way to text her or
    // message her"; contact-tile.ts). Asking about a day stays the Messages button below, where it is kept. Only Call
    // reaching them: Call, as before. One set of details for all of it (visitReach), so the sheet never offers two
    // different numbers; a cancelled visit or a contact reminder keeps the visit's own Call.
    if (cl.state === 'cancelled' || isContact(cl)) { if (callLink) { callLink.classList.add('btn-secondary'); tileUp(callLink, 'phone'); grid.append(callLink) } }
    else {
      callLink?.remove()
      const contact = contactButton(visitReach(cl), 'btn-secondary', () => dialog.close())
      if (contact) { tileUp(contact.button, contact.button.classList.contains('contact-open') || contact.button.classList.contains('call-link') ? 'phone' : 'bubble'); grid.append(contact.button, ...(contact.choices ? [contact.choices] : [])) }
      // Directions from where the phone is, as Today's (Liam, 27 Oct 2026: "There is no way to take a google link").
      // To their exact spot when one is pinned, else the address.
      const goTo = directionsHref(cl.customer_maps_link, addressLine(splitAccessWarning(cl.customer_address ?? '').addr, cl.customer_postcode ?? null, ', '))
      if (goTo) {
        const go = el('a', {href:goTo, target:'_blank', rel:'noopener', class:'btn-secondary diary-directions'}, 'Directions')
        tileUp(go, 'navigate')
        grid.append(go)
      }
      // Add a note and Parking as tiles (Liam, 28 Oct 2026: "an easy way to add a note from the manager diary"; drawn
      // https://claude.ai/artifact/XQi9oo4a1WkuSe3wKqzYCK): the note's This visit / Next visit / Every visit (diary-note.ts),
      // and the parking pop-up the ⋯ already had.
      const note = el('button', {type:'button', class:'btn-secondary diary-add-note'}, 'Add a note')
      note.addEventListener('click', () => {
        dialog.close()
        void import('../diary-note').then(({ openVisitNote }) => openVisitNote({ id: cl.id, version: cl.version, customer_id: cl.customer_id, customer_name: cl.customer_name ?? 'them', state: cl.state, note: cl.note ?? null, date: cl.date }, () => void load()))
      })
      tileUp(note, 'note')
      grid.append(note)
      const parking = el('button', {type:'button', class:'btn-secondary diary-parking'}, 'Parking')
      parking.addEventListener('click', () => { dialog.close(); openParkingFromDiary(cl) })
      tileUp(parking, 'car')
      grid.append(parking)
    }
    // Asking happens in Messages (Diary and Messages as one, Liam 8 Oct 2026): their card there, one tap away, while
    // the day still needs agreeing. Once it is agreed Messages has nothing to send them, so the button would land nowhere.
    if (confirmNeed(cl, visitCustomer(cl)) === 'day' && nextStep !== 'ask' && !noMessages(cl)) {
      const message = el('button', {type:'button', class:'btn-secondary diary-message-them'}, 'Message them')
      message.addEventListener('click', () => { dialog.close(); openMessagesFor({ id: cl.customer_id, name: cl.customer_name ?? 'Customer' }, 'customer', { jobId: cl.job_id ?? null }) })
      tileUp(message, 'bubble')
      grid.append(message)
    }
    // Design B: Move left the visit's face; in its details it is one tap, the same day chooser as before.
    if (cl.state === 'booked' && !isContact(cl) && diaryView() === 'week') {
      // "Move", and the row's own six-day pop-up wherever the row has one (Liam's pick 11A; Astra: two different pickers).
      const move = el('button', {type:'button', class:'btn-secondary diary-move'}, 'Move')
      move.addEventListener('click', () => { dialog.close(); if (!diaryNavigationReady()) return; if (mayMoveHere(cl)) openMoveFor(cl); else openMovePicker(cl, face) })
      tileUp(move, 'calendarMove')
      grid.append(move)
      // Back to Due beside Move, for anyone who doesn't drag (Liam, 4 Nov 2026).
      if (mayGoBackToDue(cl) && !pricesHidden()) {
        const due = el('button', {type:'button', class:'btn-secondary diary-back-due'}, 'Back to Due')
        due.addEventListener('click', () => { dialog.close(); backToDue(cl) })
        tileUp(due, 'list')
        grid.append(due)
      }
    }
    // Invoices (0065): a done visit's Invoice, or the invoice it is already on.
    if (cl.state === 'done' && invoicesHere()) {
      // Its words in their own span, so the invoice's number and state can take their place under the drawing.
      const invoiceWords = el('span', {}, 'Invoice')
      const invoiceButton = el('button', {type:'button', class:'btn-secondary diary-invoice'}, invoiceWords)
      tileUp(invoiceButton, 'invoice')
      let onInvoice: { id: number } | null = null
      invoiceButton.addEventListener('click', () => {
        dialog.close()
        if (onInvoice) openInvoice(onInvoice.id, { phone: cl.customer_phone ?? null, done: () => void load() })
        else invoiceVisit({ id: cl.id, customer_id: cl.customer_id, version: cl.version, payment_status: cl.payment_status, customer_phone: cl.customer_phone ?? null }, () => void load())
      })
      grid.append(invoiceButton)
      void invoicesForVisits([cl.id]).then((on) => { const o = on[String(cl.id)]; if (o && invoiceButton.isConnected) { onInvoice = o; invoiceWords.textContent = `${o.number} · ${STATE_WORDS[o.state]}` } })
    }
    if (menu && menuFace) { menuFace.textContent = 'More'; tileUp(menuFace, 'dots'); menu.classList.add('diary-detail-more'); grid.append(menu) }
    // Anything else the visit carries (a payment button) stays in a row of its own. A day not asked about yet is not
    // confirmed from here: that stays in More ("they agreed another way").
    const confirmWords = (n: HTMLElement): boolean => n.tagName === 'BUTTON' && (n.textContent === 'Mark confirmed' || n.classList.contains('diary-time-agreed') || (n.textContent ?? '').startsWith('Confirm '))
    for (const n of lent) if (n.parentElement === actions && (nextStep === 'ask' || nextStep === 'replied') && confirmWords(n)) n.remove()
    const rest = lent.filter((n) => n.parentElement === actions)
    // The time, for every way of using the app (the row's time sits inside its button): the details close first, so
    // nothing of them is left under the sheet (Astra's review, F15).
    const timeRow = timeEditable(cl) ? el('div', {class:'diary-detail-price diary-detail-time'}, el('span', {}, 'Time')) : null
    if (timeRow) {
      const t = el('button', {type:'button', class:`diary-row-time-tap${visibleTime(cl) ? '' : ' is-empty'}`}, shownVisitTime(cl) ?? '+ Time')
      t.addEventListener('click', () => { dialog.close(); openTimePicker(cl, face) })
      timeRow.append(t)
    }
    const priceRow = el('div', {class:'diary-detail-price'}, el('span', {}, 'Price'))
    // A visit with no price can be given one here too (tidy-up 2 item 2, Sonnet F13).
    if (cl.amount_pence !== undefined) priceRow.append(priceButton(cl, {after:()=>window.dispatchEvent(new CustomEvent('dropby:data-changed'))}))
    else priceRow.append(el('span', {class:'muted'}, 'No price'))
    if (order) {
      order.classList.add('diary-detail-order')
      for (const b of order.querySelectorAll<HTMLButtonElement>('button')) { b.classList.add('btn-secondary'); b.textContent = (b.getAttribute('aria-label') ?? '').endsWith(' up') ? '↑ Earlier' : '↓ Later' }
    }
    content.prepend(card)
    content.append(main, ...(primary.children.length ? [primary] : []), ...(paidHome.length ? [el('p', {class:'diary-detail-paid-q'}, `How did ${first || 'they'} pay?`), paidRow] : []), ...(grid.children.length ? [grid] : []), ...(rest.length ? [actions] : []), ...(timeRow ? [timeRow] : []), priceRow)
    if (order) content.append(order); if (photos) content.append(photos)
    if (photos && !photos.dataset.loaded) { photos.dataset.loaded='true'; attachPhotos(photos, {clean:{id:cl.id},small:true}) }
    // The sheet is the visit: its day and time on top, who it is in the card under it.
    dialog.append(el('header', {class:'booking-head'}, el('h2', {}, [dayLabel(cl.date), shownVisitTime(cl)].filter(Boolean).join(' · ')), close), content)
    document.body.append(dialog)
    const closeAction = (e: MouseEvent): void => { if (!(e.target as Element).closest('.row-menu') && (e.target as Element).closest('button')) dialog.close() }
    actions.addEventListener('click', closeAction)
    dialog.addEventListener('close', () => actions.removeEventListener('click',closeAction), {once:true})
    close.addEventListener('click', () => dialog.close())
    dialog.addEventListener('close', () => {
      // The visit's own buttons go back to it as they were.
      if (menuFace && menuWas !== null) menuFace.textContent = menuWas
      menuFace?.classList.remove('diary-tile'); callLink?.classList.remove('diary-tile'); callLink?.querySelector(':scope > .diary-tile-ring')?.remove()
      if (mainHref) main.setAttribute('href', mainHref)
      main.classList.remove('diary-detail-main')
      for (const { b, parent, next } of [...paidHome].reverse()) parent.insertBefore(b, next && next.parentElement === parent ? next : null)
      menu?.classList.remove('diary-detail-more'); callLink?.classList.remove('btn-secondary')
      actions.replaceChildren(...lent)
      if (order) { order.classList.remove('diary-detail-order'); for (const b of order.querySelectorAll<HTMLButtonElement>('button')) { b.classList.remove('btn-secondary'); b.textContent = (b.getAttribute('aria-label') ?? '').endsWith(' up') ? '↑' : '↓' } }
      stash.append(main, actions); if (order) stash.append(order); if (photos) stash.append(photos); dialog.remove(); face.focus({preventScroll:true})
    })
    // Finish this context before opening a real editor or navigating. Menu
    // choices that reveal an inline form keep this dialog open.
    content.addEventListener('click', e => {
      const target = (e.target as Element).closest('a, button')
      if (target?.matches('a[href]') || target?.textContent === 'Change price, worker or note…' || target?.textContent === 'Change price or note…' || target?.matches('.diary-agree-time-tap')) dialog.close()
    })
    if (side) {
      dialog.classList.add('diary-detail-side'); container.classList.add('is-open-side')
      // Over the map: where the right-hand column is, from the top of its first box down (never over the Diary's buttons).
      const rail = document.querySelector<HTMLElement>('.diary-rail')?.getBoundingClientRect()
      if (rail && rail.width > 200) {
        const top = Math.max(rail.top, 12) + window.scrollY
        Object.assign(dialog.style, { position: 'absolute', top: `${top}px`, left: `${rail.left + window.scrollX}px`, right: 'auto', width: `${rail.width}px`, maxHeight: `${window.innerHeight - Math.max(rail.top, 12) - 16}px` })
      }
      close.textContent = 'Back to the map'
      const esc = (e: KeyboardEvent): void => { if (e.key === 'Escape') dialog.close() }
      document.addEventListener('keydown', esc)
      dialog.addEventListener('close', () => { container.classList.remove('is-open-side'); document.removeEventListener('keydown', esc) }, {once:true})
      // Not modal, so the list beside it stays usable (a page with no non-modal dialog falls back to the modal one).
      if (typeof (dialog as HTMLDialogElement).show === 'function') (dialog as HTMLDialogElement).show(); else dialog.showModal()
    } else dialog.showModal()
    // The sheet takes the focus as it opens, not its Close (whose ring drew a heavy box round it); Tab still reaches it.
    dialog.setAttribute('tabindex', '-1'); dialog.focus({ preventScroll: true })
  }
  face.addEventListener('click', (e) => {
    // A tap on the time opens the time sheet: judged by where the tap landed, not by which element a browser names for a
    // click inside a button (build-diary.md 3). A tap anywhere else opens the details; a held press became a drag.
    const tap = face.querySelector<HTMLElement>('.diary-row-time-tap')
    const r = tap?.getBoundingClientRect()
    const onTime = !!tap && ((e.target as Element | null)?.closest?.('.diary-row-time-tap') === tap ||
      (!!r && r.width > 0 && r.height > 0 && e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom))
    // A tap on the time: the time sheet with Move to another day, Message and Whose job under it (Liam, 4 Nov 2026, Plan
    // folded into the Day: "1 and 2 A"; planSheet), as Today's.
    if (onTime) { e.preventDefault(); e.stopPropagation(); if (cl.state === 'booked' && !isSuggestion(cl) && !isContact(cl)) planSheet(cl, face, show); else openTimePicker(cl, face); return }
    // The same for "Day agreed · time to confirm" (agreeTimeTag): a tap on those words agrees the time.
    const agree = face.querySelector<HTMLElement>('.diary-agree-time-tap')
    const a = agree?.getBoundingClientRect()
    const onAgree = !!agree && !agree.hasAttribute('disabled') && ((e.target as Element | null)?.closest?.('.diary-agree-time-tap') === agree ||
      (!!a && a.width > 0 && a.height > 0 && e.clientX >= a.left && e.clientX <= a.right && e.clientY >= a.top - 6 && e.clientY <= a.bottom + 6))
    if (onAgree) { e.preventDefault(); e.stopPropagation(); markTimeAgreed(cl, agree, () => void load()); return }
    show()
  })
  // The computer's Day: a click anywhere on the visit that is not one of its own buttons or links opens it (design B).
  container.addEventListener('click', (e) => {
    if (!container.closest('.diary-desk-agenda')) return
    // Only the visit's own controls count: a finished visit sits inside Done's fold, which is no reason to stay shut (Liam,
    // 28 Oct 2026: clicking Sarah, done, opened nothing).
    const own = (e.target as Element).closest('a, button, input, select, textarea, summary, details, label, .diary-row-time-tap, .diary-agree-time-tap')
    if (own && container.contains(own)) return
    // Layout 1A (Liam, 4 Nov 2026): the visit's details open over the map column, "Back to the map" (design B's window).
    show()
  })
  if (cl.state !== 'booked' || isContact(cl)) {
    const more = el('button', {type:'button', class:'diary-more-dots', 'aria-label':`Actions for ${cl.customer_name ?? 'visit'}`}, '•••')
    more.addEventListener('click', show); quickActions.append(more)
  }
  // The desktop agenda's columns (approved Opus design): when, who and what, each agreement on its own, and
  // whether it is paid. Shown only inside that agenda; phone rows and Month keep the line above unchanged.
  const desk = deskRowParts(cl)
  // Design B: no Details button; tapping the visit opens its details, as on a phone.
  // Liam, 8 Oct: as in Original, the editing menu sits on the visit itself (move, week, time, price/worker/note,
  // cancel) and the name opens the customer. The same jobMenu and customer page, shown only on the desktop agenda.
  if (deskWeek && day && !isContact(cl)) { const menu = jobMenu({ kind: 'day', clean: cl, day }); menu.classList.add('diary-desk-menu'); quickActions.append(menu) }
  let extras: HTMLElement | null = null
  if (deskWeek) {
    // Liam, 8 Oct ("do it"): the everyday actions Original kept on the visit come back onto it, the same buttons and
    // handlers moved out of Details: call, Mark confirmed (and the several-jobs confirm), and Paid cash / bank.
    // ...and the small notes Original showed under it: also booked, the worker's times, cash taken, the phone's list.
    const dayWorker = payload?.round_days?.find(d => d.date === cl.date)?.worker
    const lines = [
      cl.state === 'booked' ? alsoBookedText(cl, payload?.also_booked, todayISO()) : null,
      jobTimesLine(cl),
      cl.state === 'done' ? cashTakenBadge(cl)?.textContent ?? null : null,
      ...(payload?.downloads && reachesPhone(cl) ? downloadLines(phoneOf(cl.worker, dayWorker), cl.date, payload.downloads) : []),
    ].filter((line): line is string => !!line)
    if (lines.length) extras = el('span', {class:'diary-row-extras'}, lines.join(' · '))
  }
  quick.append(desk.paid, quickActions)
  // The computer's Day: the tag sits under the price, as the phone's card has it, with Cash and Bank beside (D1, 1C).
  if (deskWeek && payTag) quick.insertBefore(payTag, quickActions)
  const name = deskWeek ? el('a', {href:`#/customer/${cl.customer_id}`, class:'diary-row-name', ...(cl.state === 'done' && timeWords ? {'data-time': timeWords} : {})}, cl.customer_name ?? 'Visit') : null
  const grip = el('span', {class:'diary-grip', 'aria-hidden':'true',title:'Drag to move this visit'}, '⠿')
  // The computer's Day, design A (Liam, 23 Oct 2026: "I like A"): a job still to do reads as the phone's stop, its name,
  // time and who as one line of tags, numbered on a line by the day (deskDay). Done work keeps its own short line.
  if (deskWeek && name && cl.state === 'booked') {
    container.classList.add('diary-stop')
    container.replaceChildren(grip, el('div', {class:'diary-row-line'}, name, desk.when, ...(desk.who ? [desk.who] : [])), face, desk.place, desk.chips, ...(extras ? [extras] : []), quick, stash)
  } else container.replaceChildren(grip, desk.when, face, ...(name ? [name] : []), desk.meta, desk.chips, ...(extras ? [extras] : []), quick, stash)
  const warning = splitAccessWarning(cl.customer_address ?? '').warn
  if (warning) container.append(el('div', {class:'diary-row-warning'}, warning))
  // Couldn't do it in Today's red words, its note under it (Liam's pick 7A, 22 Oct 2026, agreed with Astra); the row's own
  // Move is the way on, never a second one.
  if (cl.blocked_reason) {
    const note = blockedNoteText(cl.blocked_reason, cl.blocked_note)
    container.append(el('div', {class:'diary-row-blocked blocked-line'}, blockedBadgeText(cl), ...(note ? [el('span', {class:'blocked-line-note'}, note)] : [])))
  }
  // Parking hours read from their Parking note, as a small tag on a job still to do (Liam, 22 Oct 2026: "The wording
  // should just say parking restrictions 11am-1pm").
  // Since parking design B (27 Oct 2026): every time with its days, or Permit only / Pay and display, and a tap opens the
  // Parking pop-up (src/parking-sheet.ts).
  const parkingRule = cl.state === 'booked' ? parkingRules(cl.customer_parking) : null
  if (parkingRule && (parkingRule.ranges.length || parkingRule.permit || parkingRule.pay)) {
    const tag = el('button', {type:'button', class:'diary-row-parking', 'aria-label': `Parking at ${cl.customer_name ?? 'theirs'}: change it`}, `Parking: ${parkingHeadline(parkingRule)}`)
    tag.addEventListener('click', (e) => { e.stopPropagation(); openParkingFromDiary(cl) })
    container.append(tag)
  }
  // The computer's Day view (Liam, 14 Oct 2026, approved design): a job's note in the lemon shape of a worker note, headed
  // with who wrote it and when, voice notes as their lines, and the job's photos under it (a tap opens one big). Other
  // views keep the plain note line.
  // A finished job's note is one plain line on the computer too, as on the phone (Liam said yes to D1, 22 Oct 2026: it
  // replaces the big note box).
  if (cl.note) container.append(el('div', {class:'diary-row-note'}, cl.note.split('\n').map(noteText).join('\n')))
  if (deskWeek && (cl.state === 'done' || cl.started_at)) {
    const photos = el('div', {class:'diary-row-photos'})
    attachPhotos(photos, { clean: { id: cl.id }, small: true })
    container.append(photos)
  }
}

// Plan work > Offers & follow-ups (Diary and Messages as one, Liam 8 Oct 2026): the people waiting on days they were
// offered, in Messages' words, each one tap from their Messages card. From the customers list the Diary already reads.
const OFFERS_SHOWN = 8
function offersList(people: Customer[] | null = customers): HTMLElement {
  const box = el('div', {class:'diary-offers', role:'group', 'aria-label':'Dates offered, waiting'})
  if (!people) return box
  const waiting = people.map(c => ({ c, dates: [...new Set(offersWaiting(c).flatMap(o => o.dates))].sort() })).filter(w => w.dates.length)
    .sort((a, b) => a.dates[0].localeCompare(b.dates[0]) || a.c.name.localeCompare(b.c.name))
  box.append(el('p', {class:'diary-offers-head'}, waiting.length ? `Dates offered, waiting · ${waiting.length}` : 'Nobody is waiting on dates you offered.'))
  if (waiting.length) box.append(el('p', {class:'diary-offers-hint'}, 'When they pick a day, tap They replied.'))
  for (const w of waiting.slice(0, OFFERS_SHOWN)) {
    // The job whose days they were offered (several jobs: the first one waiting), for their reply.
    const jobId = offersWaiting(w.c)[0]?.jobId ?? null
    const open = el('button', {type:'button', class:'diary-offer', 'aria-label':`Message ${w.c.name}: dates offered ${offeredDaysText(w.dates)}, waiting`},
      el('strong', {}, w.c.name), el('span', {}, `Dates offered: ${offeredDaysText(w.dates)}, waiting`))
    open.addEventListener('click', () => openMessagesFor({ id: w.c.id, name: w.c.name }, 'customer'))
    const replied = el('button', {type:'button', class:'btn-secondary diary-offer-replied', 'aria-label':`They replied: ${w.c.name}`}, 'They replied')
    replied.addEventListener('click', () => openReplyDialog(w.c.id, jobId))
    const card = el('div', {class:'diary-offer-card', draggable:'true', 'data-customer-id':String(w.c.id)},
      el('span', {class:'diary-grip', 'aria-hidden':'true', title:'Drag onto the day they picked'}, '⠿'), open, replied)
    offerDrag(card, w.c.id, jobId)
    box.append(card)
  }
  if (waiting.length > OFFERS_SHOWN) box.append(el('p', {class:'diary-offers-more'}, `${waiting.length - OFFERS_SHOWN} more in Messages.`))
  return box
}

// A "Dates offered, waiting" card onto the day they picked (Liam, 9 Oct 2026): dragged on a computer, held and dragged on
// a phone (hold-drag.ts, as To place). That is their answer, so Messages' "They accepted a date" opens on that day
// (acceptDayFromDiary): the booking with the day filled in and agreed. A day that has gone takes nobody.
function offerDrag(card: HTMLElement, customerId: number, jobId: number | null, startsOn = '.diary-offer'): void {
  card.addEventListener('dragstart', (e) => {
    if (!e.dataTransfer) return
    window.getSelection()?.removeAllRanges()
    e.dataTransfer.setData('text/plain', `offer:${customerId}:${jobId ?? ''}`)
    e.dataTransfer.effectAllowed = 'move'
    dragPicture(e, card)
    card.classList.add('tray-row-moving')
  })
  card.addEventListener('dragend', () => {
    card.classList.remove('tray-row-moving')
    for (const d of document.querySelectorAll<HTMLElement>('.drop-ready')) d.classList.remove('drop-ready')
  })
  if (typeof matchMedia === 'function' && matchMedia('(pointer: coarse)').matches) holdToDrag(card, {
    dayAt: (x, y) => dayToDropOn(document.elementFromPoint(x, y)),
    days: daysToDropOn,
    drop: (iso) => acceptDayFromDiary(customerId, jobId, iso),
    startsOn,
  })
}
// The day under a held card, on the strip or its card, from today on; and the strip's days a held card can go to.
function dayToDropOn(node: Element | null): { el: HTMLElement; iso: string } | null {
  const day = node?.closest<HTMLElement>('.diary-week-strip button[data-date], .day-card[data-date]')
  const iso = day?.dataset.date
  return day && iso && iso >= todayISO() ? { el: day, iso } : null
}
function daysToDropOn(): HTMLElement[] {
  return [...document.querySelectorAll<HTMLElement>('.diary-week-strip button[data-date]')].filter(b => (b.dataset.date ?? '') >= todayISO())
}

// Needs you > Waiting for a reply (Liam, 9 Oct 2026): everyone messaged who has not answered, by Messages' own rule and
// in its words (rebook.ts awaitingReplies), each with "They replied" (Messages' reply, over the Diary) and, once it is
// due, "Send second message". Someone waiting on days offered is under "Dates offered, waiting" instead, where they can
// be dragged onto the day they pick. The people here leave Slipping, Going cold and No date yet (attention.ts).
const WAITING_SHOWN = 8
function waitingLineOf(list: RoundCustomer[]): WaitingLine {
  const byId = new Map(list.map(c => [c.id, c]))
  const rows = awaitingReplies(list).filter(a => !offersWaiting(byId.get(a.customer.id) ?? a.customer).length)
  const ids = new Set(rows.map(a => a.customer.id))
  if (!rows.length) return { ids, line: null }
  return { ids, line: { key: 'awaiting', label: 'Waiting for a reply', count: rows.length, tone: rows.some(a => a.stage !== 'waiting') ? 'amber' : 'slate', fill: (into) => {
    for (const a of rows.slice(0, WAITING_SHOWN)) into.append(waitingRow(a))
    if (rows.length > WAITING_SHOWN) into.append(el('a', {class:'needs-all', href:'#/rebook'}, `${rows.length - WAITING_SHOWN} more in Messages →`))
  } } }
}
function waitingRow(a: AwaitingReply): HTMLElement {
  const c = a.customer
  const replied = el('button', {type:'button', class:'btn-secondary needs-replied', 'aria-label':`They replied: ${c.name}`}, 'They replied')
  replied.addEventListener('click', () => openReplyDialog(c.id))
  const actions = el('div', {class:'needs-waiting-actions'}, replied)
  if (a.stage === 'second') {
    const send = el('button', {type:'button', class:'btn-primary needs-second', 'aria-label':`Send second message: ${c.name}`}, 'Send second message')
    send.addEventListener('click', () => openSecondMessage(c.id))
    actions.append(send)
  }
  const late = cycleRisk(c) ? riskNote(c) : ''
  return el('div', {class:'needs-person needs-waiting', 'data-customer-id':String(c.id)},
    el('a', {href:`#/customer/${c.id}`, class:'name-link'}, c.name),
    el('span', {class:'needs-waiting-words'}, a.words),
    ...(late ? [el('span', {}, late)] : []),
    actions)
}

// A visit's customer facts for the shared words: what the Diary read carries, plus the contact note from the customers
// list (days offered in a first message live there). Looked up once per list.
let customerIndex: { list: Customer[] | null; byId: Map<number, Customer> } | null = null
function customerOf(id: number): Customer | undefined {
  if (!customerIndex || customerIndex.list !== customers) customerIndex = { list: customers, byId: new Map((customers ?? []).map(c => [c.id, c])) }
  return customerIndex.byId.get(id)
}
function visitCustomer(cl: Clean): ReturnType<typeof diaryCustomer> { return diaryCustomer(cl, customerOf(cl.customer_id)) }

// The one thing a visit needs next, for its main button (Design B): Done on its day or after, Mark confirmed or Time
// agreed before it (planning.ts confirmNeed), Paid for done work not paid; nothing for an agreed future visit, a visit
// to check, a suggestion or a contact reminder.
function visitNextStep(cl: Clean): 'done' | 'ask' | 'replied' | 'confirm' | 'time' | 'paid' | null {
  if (isContact(cl) || isSuggestion(cl)) return null
  if (cl.state === 'done') return cl.payment_status !== 'paid' ? 'paid' : null
  if (cl.state !== 'booked') return null
  if (cl.date <= todayISO()) return 'done'
  const need = confirmNeed(cl, visitCustomer(cl))
  // Set to Don't message (option A): nobody is going to message them, so the day is agreed another way and the visit
  // offers Mark confirmed; asked before, They replied stays (tidy-up 2 AGREED.md section 3).
  return need === 'day' ? notAskedYet(cl) ? noMessages(cl) ? 'confirm' : 'ask' : askedNoReply(cl) ? 'replied' : 'confirm' : need === 'time' ? 'time' : null
}

// Set to Don't message (tidy-up 2 item 3, option A; Liam, 20 Oct 2026; Astra's review F11, GPT-6.1's R12, R13): their way
// from the customers list when it is read, else the visit's own (GET /api/schedule customer_message_by, in the phone's
// saved copy too), with a choice still waiting on this phone laid over (add-details.ts takesNoMessages).
function noMessages(cl: Clean): boolean {
  const known = customerOf(cl.customer_id)
  return takesNoMessages({ id: cl.customer_id, message_by: known ? known.message_by ?? null : cl.customer_message_by ?? null })
}
// How to reach a visit's customer, for Contact (contact-tile.ts): the customers list when it is read (the newer
// details), else the visit's own (GET /api/schedule: phone and way, no email), Don't message laid over as noMessages.
function visitReach(cl: Clean): ContactCustomer {
  const known = customerOf(cl.customer_id)
  return { name: cl.customer_name ?? known?.name ?? '', phone: known ? known.phone : cl.customer_phone, email: known ? known.email : cl.customer_email,
    message_by: noMessages(cl) ? 'none' : known ? known.message_by ?? null : cl.customer_message_by ?? null }
}
// The Diary's words for a visit: the shared ones (visit-words.ts), with "Not asked yet" read as "Not messaged" for a
// Don't message customer. The Diary's only: Messages keeps its words this round (AGREED.md section 3).
function diaryWords(cl: Clean): ReturnType<typeof visitWords> {
  const words = visitWords(cl, visitCustomer(cl))
  if (words.day !== 'Not asked yet' || !noMessages(cl)) return words
  return { ...words, day: 'Not messaged', text: words.text.replace(/^Not asked yet/, 'Not messaged') }
}
// The postcode a row shows instead of "No address yet" once the owner said it is enough (add-details.ts).
function postcodeEnough(cl: Clean): string | null {
  const known = customerOf(cl.customer_id)
  return known ? enoughPostcode(known) : null
}

// A missing number or address, added there and then (tidy-up item 8; Liam, 20 Oct 2026; AGREED.md section 8 and
// build-today.md 2.2; the box is src/add-details.ts). A visit whose next step is asking them, with no way to reach them,
// gets the add button where "Message X" would be ("+ Add details" with the address missing too); "Save and message"
// opens their message for this visit. An agreed visit ahead with no address and nothing else to do gets "+ Add an
// address". Never in place of Done, Paid, Mark confirmed, Time agreed or They replied: those keep the button, and the
// add sits in the visit's details. The customer is the customers list's (email and their way are only there); with that
// list not read, nothing is guessed and "Message X" stays.
function addDetailsStep(cl: Clean, next: ReturnType<typeof visitNextStep>): { words: string; open: () => void } | null {
  const c = customerOf(cl.customer_id)
  if (!c) return null
  const missing = missingDetails(c)
  if (next === 'ask' && missing.number && missing.words) {
    return { words: missing.words, open: () => openAddDetails(c, { message: true, onSaved: (r) => {
      void load()
      // With no signal the message is written from the customer as just saved on this phone (AGREED.md section 8, G E07).
      if (r.message) askAboutDay(cl.customer_id, cl.date, { visitId: cl.id, onDone: () => void load(), customer: r.customer as RoundCustomer })
    } }) }
  }
  if (next === null && cl.state === 'booked' && !isContact(cl) && !isSuggestion(cl) && cl.date > todayISO() && missing.address) {
    return { words: '+ Add an address', open: () => openAddDetails(c, { need: { address: true }, onSaved: () => void load() }) }
  }
  return null
}
// The same box from the visit's details when its main button is something else (build-today.md 2.2, edge cases 11, 12).
function addDetailsAside(cl: Clean): { words: string; open: () => void } | null {
  const c = customerOf(cl.customer_id)
  const words = c ? missingDetails(c).words : null
  return c && words ? { words, open: () => openAddDetails(c, { onSaved: () => void load() }) } : null
}

// Asked about this visit's day and no reply recorded yet ("Asked 9 Oct, no reply"): its main button is "They replied"
// (Liam, 12 Oct 2026, Sarah and Ian: "they couldn't do it ... not sure what the flow is"), which asks what they said:
// yes to that day, another day, or not now (they-replied.ts). Their first job's visits, as Messages asks about it.
function askedNoReply(cl: Clean): boolean {
  if (visitJobId(cl) !== null) return false
  const day = visitWords(cl, visitCustomer(cl)).day
  return /^Asked\b.*, no reply$/.test(day) && !day.includes('about another day')
}
// What "They replied" needs from the Diary: its redraw, Messages' reply card for Not now, who is out on the days this
// week has read, and Messages for a confirmation beside the Undo.
function repliedOptions(cl: Clean): RepliedOptions {
  return {
    changed: () => void load(),
    // The Diary goes where the visit went (as a move does), and back with its Undo.
    follow: (iso) => { selectedDate = iso; if (iso < fromDate || iso > addDaysISO(fromDate, WINDOW_DAYS - 1)) fromDate = defaultFrom(iso) },
    notNow: () => openReplyDialog(cl.customer_id, visitJobId(cl)),
    dayInfo: (iso) => {
      const p = payload
      if (!p || iso < p.from || iso > p.to) return null
      const out = (p.round_days ?? []).find((r) => r.date === iso)?.worker?.trim()
      // A one-person round (Liam, 19 Oct 2026): the day is one of theirs or a day off, never a name.
      if (worksAlone()) return out ? 'Working' : 'Day off'
      return out ? `${out} out` : 'Nobody out'
    },
    // The agreed visit's own confirmation: Book agreed visit, then its message to review and send (Astra: Messages had
    // nothing to send someone already agreed).
    tellThem: { act: () => openBooking({ customerId: cl.customer_id, cleanId: cl.id, replyConfirmation: true }), label: 'Send a confirmation' },
  }
}

// Nobody has asked them about this visit yet (Liam, 9 Oct 2026: "she hasnt been messaged so how could we confirm
// her?"), in the shared words: its main button is "Message <name>", not Mark confirmed. Their first job's visits: an
// extra job's visit keeps Mark confirmed, as Messages asks about the first job.
function notAskedYet(cl: Clean): boolean {
  const day = visitJobId(cl) === null ? visitWords(cl, visitCustomer(cl)).day : ''
  return day === 'Not asked yet' || day.endsWith('about another day, no reply')
}

// With someone picked in To place, tapping a date places them on it (render sets this; Design B).
let placePicked: (date: string) => boolean = () => false

// Design B (Liam, 8 Oct 2026): a customer just placed on a day from To place gets their message straight away, the
// Messages card's own message and send controls for that one day (roundly-bugs' askAboutDay), so the send records
// exactly what a Messages send records. Cancel there takes the visit off the day again.
// placement: the visit as saved, so the message's own Undo (and a later "Didn't send it") also takes it back off the
// day, or back to where it was, with the version checked (bug hunt server-data#9; Messages keeps it with the send).
function askAfterPlacing(due: Pick<DueEntry, 'id' | 'name'>, date: string, visitId: number, takeOff: () => void, backTo: string | null = null, placement?: Placement): void {
  const first = due.name.trim().split(/\s+/)[0] || due.name
  const weekday = new Date(`${date}T12:00:00`).toLocaleDateString('en-GB', { weekday: 'long' })
  void import('./rebook').then(({ askAboutDay }) => askAboutDay(due.id, date, {
    visitId,
    placement,
    dayNote: dayNoteFor(date),
    dayOut: dayOutFor(date),
    cancelLabel: backTo ? `Cancel: move ${first} back to ${dayLabel(backTo)}` : `Cancel: take ${first} off ${weekday}`,
    // Cancel: the visit just placed comes off the day again, exactly as its Undo would, and that Undo goes.
    onCancel: () => { dismissUndo(); takeOff() },
    onDone: () => void load(),
    // Put away without an answer: they wait as "Message N" (round 4).
    onLater: () => queueMessage({ id: due.id, name: due.name, date, visitId }),
  }))
}

// What the Diary knows of a day, said in the message that opens after a drop (round 4 of docs/plans/diary-due/PLAN.md):
// a day with somebody else out is theirs ("the visit is on Dave's list"); a day nobody is out on is not offered without
// saying so, as Messages offers only days with someone out. Only for the week the Diary has read.
// A date in Month outside that week is read from the month (Astra's final check, 24 Oct 2026).
let monthAsk: SchedulePayload | null = null
function knownFor(date: string): SchedulePayload | null {
  // In Month, the month's own read first: it is the newer one.
  if (diaryView() === 'month' && monthAsk && date >= monthAsk.from && date <= monthAsk.to) return monthAsk
  if (payload && date >= payload.from && date <= payload.to) return payload
  return null
}
function dayNoteFor(date: string): string | null {
  const p = knownFor(date)
  if (!p) return null
  const weekday = new Date(`${date}T12:00:00`).toLocaleDateString(screenLocale(), { weekday: 'long' })
  const out = (p.round_days ?? []).find((r) => r.date === date)?.worker?.trim()
  // A one-person round (Liam, 19 Oct 2026): nothing to say on a working day; any other day says why Messages leaves it
  // out, and the pop-up links to My working days (no names to choose: working days are set there, never here).
  if (worksAlone()) return out ? null : `${weekday} isn't one of your working days, so Messages won't offer it.`
  if (!out) return `Nobody is out on ${weekday} yet. Messages offers only days someone works: ${knownWorkers(p).length ? 'choose who is out' : "put someone on it in the day's details"}, or pick another day.`
  const me = getMe()?.workerName?.trim()
  return me && me.toLowerCase() === out.toLowerCase() ? null : `${weekday} is ${out}'s day: the visit goes on ${out}'s list.`
}

// A day nobody is out on: who is out is chosen in the pop-up itself, one tap (Liam, 11 Oct 2026: "book the worker in
// that day under less taps"), saved as the day's chooser saves it, with its Undo.
function dayOutFor(date: string): { names: string[]; choose: (name: string) => void } | null {
  const p = knownFor(date)
  // Never in a one-person round (Liam, 19 Oct 2026): nothing on the Diary sets a working day.
  if (worksAlone()) return null
  if (!p || (p.round_days ?? []).some((r) => r.date === date && r.worker?.trim())) return null
  const names = knownWorkers(p)
  return names.length ? { names, choose: (name) => addRoster(date, name) } : null
}

// "Message N" (Liam: "i'd want both somehow"): people placed whose message was put away, sent later in turn from the Due
// bar or column. Kept while the app is open. What is true is read again when one is sent: one taken off, moved or agreed
// since has nothing to ask, and says so (round 4 review).
const messageLater: { id: number; name: string; date: string; visitId: number }[] = []
// Drawn again only while the Diary is the screen: a pop-up closed by leaving for another page (Change wording, Back) puts
// its message away after that page is drawn, and the Diary must not draw over it (round 4 review).
function redrawForQueue(): void {
  const root = document.querySelector<HTMLElement>('#screen')
  if (payload && root && window.location.hash.startsWith('#/schedule') && !document.querySelector('dialog[open]')) render(payload, root)
}
function queueMessage(m: { id: number; name: string; date: string; visitId: number }): void {
  const at = messageLater.findIndex((x) => x.id === m.id)
  if (at >= 0) messageLater.splice(at, 1)
  messageLater.push(m)
  redrawForQueue()
}
// A visit moved since its message was put away is not asked about its old day.
function forgetQueued(visitId: number): void {
  const at = messageLater.findIndex((x) => x.visitId === visitId)
  if (at >= 0) messageLater.splice(at, 1)
}
async function sendNextQueued(): Promise<void> {
  const m = messageLater.shift()
  if (!m) return
  redrawForQueue()
  let visit: Clean | undefined
  try {
    const day = await api<SchedulePayload>(`/api/schedule?from=${m.date}&to=${m.date}`)
    visit = day.cleans.find((c) => c.customer_id === m.id && c.date === m.date && c.state === 'booked' && !isSuggestion(c) && (!m.visitId || c.id === m.visitId))
  } catch {
    messageLater.unshift(m); redrawForQueue()
    toast(`Sending ${m.name}'s message needs signal. It is still waiting beside Due.`)
    return
  }
  if (!visit) { toast(`${m.name} is no longer on ${dayLabel(m.date)}, so there is nothing to ask.`); return }
  if (visit.confirmed) { toast(`${m.name} has agreed ${dayLabel(m.date)} already, so there is nothing to ask.`); return }
  const placed = visit
  const { askAboutDay } = await import('./rebook')
  askAboutDay(m.id, m.date, {
    visitId: placed.id,
    dayNote: dayNoteFor(m.date),
    dayOut: dayOutFor(m.date),
    onDone: () => void load(),
    onLater: () => queueMessage({ ...m, visitId: placed.id }),
  })
}
function messageLaterChip(): HTMLElement | null {
  if (!messageLater.length) return null
  const chip = el('button', {type:'button', class:'diary-due-waiting diary-message-later', 'aria-label':`Message ${messageLater.length}: placed, message not sent yet. Send the next`}, `Message ${messageLater.length}`)
  chip.addEventListener('click', () => { if (!document.querySelector('dialog[open]')) void sendNextQueued() })
  return chip
}

// "Message them" beside Undo after an agreed visit is moved (Release 2, JOINT-PLAN 4c), in the Diary and in Month.
function messageThemLink(cl: Pick<Clean, 'customer_id' | 'customer_name' | 'job_id'>): { act: () => void; label: string } {
  return { label: 'Message them', act: () => openMessagesFor({ id: cl.customer_id, name: cl.customer_name ?? 'Customer' }, 'customer', { jobId: cl.job_id ?? null }) }
}

// Days offered to someone in Messages and still waiting on their choice (Release 2, JOINT-PLAN 4a; Liam: a note only,
// nothing booked and the day not held for others). From the customers list the Diary reads, worked out once per list.
let offeredFor: { list: Customer[] | null; days: Map<string, Customer[]> } | null = null
function offeredOn(date: string): Customer[] {
  if (!offeredFor || offeredFor.list !== customers) {
    const days = new Map<string, Customer[]>()
    for (const c of customers ?? []) for (const d of new Set(offersWaiting(c).flatMap(o => o.dates))) days.set(d, [...(days.get(d) ?? []), c])
    offeredFor = { list: customers, days }
  }
  return offeredFor.days.get(date) ?? []
}
// What a day still needs, in the words its date shows: "3 to confirm (1 time)" until the day and any set time are agreed,
// "all agreed" once they are, "1 to check" for a visit whose customer is paused, stopped, taken off or needs a visit,
// and "2 offered". By the rule Needs you counts with (planning.ts confirmNeed). A past day says neither: Review owns its
// visits. One answer for the computer's dates and week and the phone's dates and days (bug hunt, 8 Oct 2026: the phone
// showed none of it, and Week said "2 to confirm" where Day said "2 to confirm (1 time)").
function dayNeeds(rows: readonly Clean[], day: string): { confirm: string; check: string; offered: string } {
  const open = rows.filter(c => c.state === 'booked' && !isSuggestion(c) && !isContact(c))
  const need = { day: 0, time: 0, check: 0 }
  for (const c of open) { const n = confirmNeed(c, visitCustomer(c)); if (n) need[n]++ }
  const toConfirm = need.day + need.time
  const offered = offeredOn(day).length
  return {
    confirm: day < todayISO() || !open.length ? '' : toConfirm ? `${toConfirm} to confirm${need.time ? ` (${need.time} time)` : ''}` : need.check ? '' : 'all agreed',
    check: need.check ? `${need.check} to check` : '',
    offered: offered ? `${offered} offered` : '',
  }
}

// "Offered to Sage Mills and Ann Lee, waiting": each name opens that person in Messages, and drags onto the day they
// pick, this one or another, exactly as a "Dates offered, waiting" card does (Liam, 9 Oct 2026: "what if the customers in
// the offered to could be dragged onto the day").
function offeredNote(people: Customer[], date: string): HTMLElement {
  const note = el('p', {class:'diary-offered-day'}, 'Offered to ')
  people.forEach((c, i) => {
    if (i) note.append(i === people.length - 1 ? ' and ' : ', ')
    const open = el('button', {type:'button', class:'diary-offered-name', draggable:'true', title:'Tap to open Messages, or drag onto the day they picked', 'aria-label':`Message ${c.name}: offered this day, waiting`}, c.name)
    open.addEventListener('click', () => openMessagesFor({ id: c.id, name: c.name }, 'customer'))
    // The job whose offer names this day (several jobs).
    offerDrag(open, c.id, offersWaiting(c).find(o => o.dates.includes(date))?.jobId ?? null, '.diary-offered-name')
    note.append(open)
  })
  note.append(', waiting')
  return note
}

// "Day agreed · time to confirm" agrees the time when tapped (Liam, 27 Oct 2026, of Juliette's amber words on the phone's
// Day: "surely the orange pill should allow us to click it and mark a time?"): the same save and Undo as the Time agreed
// button (visit-actions.ts), for a visit today or later whose day is agreed and whose time is not. Anything else keeps
// its words as plain text.
function canAgreeTime(cl: Clean): boolean {
  return cl.state === 'booked' && cl.date >= todayISO() && !!cl.confirmed && !!agreedTimeKey(cl.date, visibleTime(cl)) && !timeIsAgreed(cl)
    && !isContact(cl) && confirmNeed(cl, visitCustomer(cl)) !== 'check'
}
// A visit that couldn't be done, moved: "Message them" opens the missed message ("Sorry, we ran out of time today. Could
// we come on Friday instead?") with the move to put right if they say no. One builder for Week, Day, the Move pop-up and
// Month (Month's moves had no message: the review of 27 Oct 2026).
type MissedMove = { from: string; reason: ReturnType<typeof blockedChoiceOf> }
function missedOf(cl: Clean): MissedMove | null {
  return cl.state === 'booked' && cl.blocked_reason && cl.blocked_reason !== 'customer_cancelled' && cl.date <= todayISO()
    ? { from: cl.date, reason: blockedChoiceOf(cl.blocked_reason, cl.blocked_note) } : null
}
function missedMessageLink(cl: Clean, date: string, missed: MissedMove, savedVersion: number, before: { date: string; confirmed: number; time_agreed_for?: string | null }): { label: string; act: () => void } {
  return { label: 'Message them', act: () => askAboutDay(cl.customer_id, date, { visitId: cl.id, onDone: () => void load(),
    missed: { ...missed, jobIds: [cl.job_id ?? null], placements: [{ kind: 'move' as const, id: cl.id, version: savedVersion, before }] } }) }
}

// inRow: the words sit inside the row's face, itself a button: a span there, and the face's own click handler agrees the
// time when the tap lands on it (judged by position, as the time tap is: build-diary.md 3). Elsewhere a real button.
function agreeTimeTag(cl: Clean, text: string, inRow = false): HTMLElement | string {
  if (!canAgreeTime(cl)) return text
  // In the round's own time words ("2pm" in the UK and US, never "14:00").
  const time = shownTime(visibleTime(cl) ?? '')
  if (inRow) return el('span', { class: 'diary-agree-time-tap', title: `Tap when ${time} is agreed` }, text)
  const tag = el('button', { type: 'button', class: 'diary-agree-time-tap', title: `Tap when ${time} is agreed`,
    'aria-label': `${text}. Mark ${time} agreed with ${cl.customer_name ?? 'them'}` }, text)
  tag.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); markTimeAgreed(cl, tag, () => void load()) })
  return tag
}

// A booked visit's agreement badge: the shared words (visit-words.ts), the same words Messages shows.
function agreementBadge(cl: Clean): HTMLElement {
  const words = diaryWords(cl)
  return el('span', { class: `badge diary-words-${words.tone} ${words.tone === 'ok' ? 'badge-booked' : 'badge-unconfirmed'}` }, words.text)
}

// The time a visit is proposed for is never shown as agreed: the day (confirmed) and the time (time_agreed_for, set
// by the booking form's "Time confirmed" tick, which Messages' Book agreed visit also uses) are agreed separately, and
// only that exact record makes the time agreed. A done visit is not a paid one.
function deskRowParts(cl: Clean): { when: HTMLElement; meta: HTMLElement; chips: HTMLElement; paid: HTMLElement; who: HTMLElement | null; place: HTMLElement } {
  const suggestion = isSuggestion(cl), contact = isContact(cl), agreedTime = timeIsAgreed(cl)
  const timeClass = `diary-row-time${cl.time_slot && !agreedTime && cl.state === 'booked' ? ' is-unagreed' : ''}`
  // A booked visit's time is its own button (Liam, 9 Oct 2026: "it would be useful if i could click the time directly so
  // i could change it? aswell as being able to click the dots"): the same time box and save as the ⋯ menu's "Change the
  // time…" (setVisitTime, with its Undo), the ⋯ unchanged.
  const editable = cl.state === 'booked' && !suggestion && !contact
  // No set times (Your business): no time column; a booked visit shows its place in the day instead (1, 2, 3: a CSS
  // counter on the day, so it follows the drag order exactly as drawn).
  if (!setTimesOn()) return deskRowRest(cl, el('span', {class:'diary-row-when'}, editable ? el('span', {class:'diary-row-place', 'aria-hidden':'true'}) : ''))
  // "+ Time" with none, as on the phone (tidy-up 2 item 1).
  const time = editable
    ? el('button', {type:'button', class:`${timeClass} diary-row-time-edit${cl.time_slot ? '' : ' is-empty'}`, 'aria-label':`${cl.time_slot ? `Change the time, ${shownTime(cl.time_slot)},` : 'Set a time'} for ${cl.customer_name ?? 'this visit'}`}, cl.time_slot ? shownTime(cl.time_slot) : '+ Time')
    : el('span', {class:timeClass}, cl.time_slot ? shownTime(cl.time_slot) : 'No time')
  // While its day is being planned the click goes on to the row, which opens the planning sheet (Sonnet, 4 Nov 2026).
  if (editable) time.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); if (cl.state === 'booked' && !isSuggestion(cl) && !isContact(cl)) planSheet(cl, time as HTMLButtonElement); else openTimePicker(cl, time as HTMLButtonElement) })
  return deskRowRest(cl, el('span', {class:'diary-row-when'}, time))
}
function deskRowRest(cl: Clean, when: HTMLElement): { when: HTMLElement; meta: HTMLElement; chips: HTMLElement; paid: HTMLElement; who: HTMLElement | null; place: HTMLElement } {
  const suggestion = isSuggestion(cl), contact = isContact(cl)
  const dayWorker = payload?.round_days?.find(d => d.date === cl.date)?.worker?.trim()
  const estimate = cl.state !== 'booked' || suggestion || contact ? '' : cl.duration_minutes && cl.duration_minutes > 0 ? ` · Est. ${cl.duration_minutes}m` : ' · Time not estimated'
  // A finished job names who did it, or nobody, as the phone's card (D1); a job still to do says who is out or Unassigned.
  const who = cl.worker?.trim() ? el('span', {}, cl.worker.trim()) : cl.state === 'done' ? '' : dayWorker ? el('span', {}, `${dayWorker} (out that day)`) : el('span', {class:'diary-unassigned'}, 'Unassigned')
  // A one-person round (Liam, 19 Oct 2026): no "Unassigned" or "(out that day)"; only a name that is not the owner's is
  // said, so a visit left in someone else's name can still be seen.
  const other = worksAlone() ? otherName(cl.worker) : ''
  // A finished job reads as the phone's card: the street, the job, who (Liam said yes to D1, 22 Oct 2026).
  const street = cl.state === 'done' ? splitAccessWarning(cl.customer_address ?? '').addr.split(',')[0]?.trim() : ''
  // The area on a computer's job line is its own word: a tap renames the area (area-rename.ts; Liam's pick A, 27 Oct 2026).
  const place = (): Array<string | HTMLElement> => street ? [`${street} · ${visitJobLabel(cl)}`]
    : [`${visitJobLabel(cl)} · `, getMe()?.role === 'owner' ? areaWord(areaOf(cl)) : areaOf(cl)]
  const meta = worksAlone()
    ? el('span', {class:'diary-row-meta-desk'}, ...place(), ...(other ? [' · ', el('span', {}, other)] : []), estimate)
    : el('span', {class:'diary-row-meta-desk'}, ...place(), who ? ' · ' : '', who, estimate)
  // Liam, 8 Oct: one plain line for the agreement instead of separate boxes, in the words Messages uses for the same
  // visit (visit-words.ts): the day, then the time, then where the customer stands. ✓ marks an agreed day or done work.
  const words = diaryWords(cl)
  // Plain coloured words, as the phone shows them: no box, no tick (Liam's pick 10A, 22 Oct 2026).
  const chips = el('span', {class:'diary-row-chips'}, el('span', {class:`diary-agree diary-agree-${words.tone}`}, agreeTimeTag(cl, words.text)))
  // The computer's Day leaves out words that only repeat the box and the time (Liam's 1A, 4 Nov 2026), on the same rule as
  // the phone (renderClean's data-plain): today and earlier keep "time to confirm" and "Not asked yet".
  if (words.text === 'Day agreed · time agreed' || (cl.date > todayISO() && /^(Day agreed|Not asked yet)( · (time to confirm|no set time))?$/.test(words.text))) chips.dataset.plain = '1'
  // A done visit says how it was paid in Owed's words (visit-words.ts paymentWords); while it is not paid the words open
  // that visit on Owed (docs/DIARY-AND-MESSAGES.md, Owed; Liam 8 Oct 2026). The price beside it stays its own button.
  // A visit not done yet owes nothing, so it says nothing about payment, unless a payment is really recorded on it (bug
  // hunt, 8 Oct 2026: every booked visit said "Not paid", the words of a done visit nobody has paid for).
  const paidWords = cl.state === 'cancelled' ? 'Not counted' : suggestion || contact ? 'Not booked' : cl.state === 'done' ? paymentWords(cl) : cl.payment_status === 'paid' ? 'Paid' : ''
  let paid: HTMLElement = el('span', {class:'diary-row-paid'}, paidWords)
  if (cl.state === 'done' && cl.payment_status !== 'paid') {
    paid = el('button', {type:'button', class:'diary-row-paid diary-row-owed', 'aria-label':`${paidWords}: open ${cl.customer_name ?? 'this visit'} in Owed`}, paidWords, el('span', {'aria-hidden':'true'}, ' ›'))
    paid.addEventListener('click', e => { e.stopPropagation(); openInOwed(cl) })
  }
  // Design A (Liam, 23 Oct 2026): a job still to do says who as a tag beside its name and time, and its line keeps the
  // job, the area and the estimate.
  const whoName = worksAlone() ? other : cl.worker?.trim() ? cl.worker.trim() : dayWorker ? `${dayWorker} (out that day)` : ''
  const whoTag = whoName ? el('span', {class:'diary-row-who'}, whoName) : worksAlone() ? null : el('span', {class:'diary-row-who diary-unassigned'}, 'Unassigned')
  const placeLine = el('span', {class:'diary-row-meta-desk'}, ...place(), estimate)
  return { when, meta, chips, paid, who: whoTag, place: placeLine }
}

// A visit whose time can be changed: booked, not Roundly's suggestion or a contact reminder, on a round with set times.
function timeEditable(cl: Clean): boolean {
  return setTimesOn() && cl.state === 'booked' && !isSuggestion(cl) && !isContact(cl)
}

// The time sheet is shared with Today (visit-time.ts openTimePicker; Liam, 4 Nov 2026, design H's tap a time).
const openTimePicker = (cl: Clean, opener: HTMLElement): void => openSharedTimePicker(cl, opener, diaryTimeHooks())

// The Diary's way into Owed: that visit, picked out, with nothing filtering it away (owed.ts openOwedFor).
function openInOwed(cl: Pick<Clean, 'id'>): void {
  void import('./owed').then(({ openOwedFor }) => openOwedFor(cl.id))
}

// This picker chooses only a destination. The reviewed move handler still owns
// agreement resets, version checks, the save queue and the exact inverse.
function openMovePicker(cl: Clean, opener: HTMLButtonElement): void {
  const gen = routeGen, who = diaryPreferenceKey('move')
  const dialog = el('dialog', {class:'booking-dialog diary-move-dialog','aria-label':`Move visit for ${cl.customer_name ?? 'visit'}`})
  const cancel = el('button', {type:'button'}, 'Cancel')
  const date = el('input', {type:'date','aria-label':'Move visit to date',required:''}); date.value = cl.date
  // A day that has gone is not offered (goneDay), as in Month.
  date.min = todayISO()
  const form = el('form', {class:'diary-move-form'}, el('label', {}, 'New date',date))
  const choices = el('div', {class:'diary-move-dates','aria-label':'Choose a day'})
  const from = defaultFrom(cl.date)
  const sync = (): void => {
    for (const b of choices.querySelectorAll<HTMLButtonElement>('button')) b.setAttribute('aria-pressed',String(b.dataset.date === date.value))
  }
  for (let day = from; day <= addDaysISO(from,6); day = addDaysISO(day,1)) {
    const target = day
    const b = el('button', {type:'button','data-date':day,'aria-pressed':String(day === date.value),'aria-label':`Choose ${dayLabel(day)}`},new Date(`${day}T12:00:00`).toLocaleDateString('en-GB',{weekday:'short',day:'numeric'}))
    if (day < todayISO()) b.disabled = true
    b.addEventListener('click',()=>{date.value = target; sync()}); choices.append(b)
  }
  date.addEventListener('change',sync)
  const save = el('button', {type:'submit',class:'btn-primary'}, 'Move visit')
  form.append(choices, el('p', {class:'diary-move-note'}, cl.confirmed ? 'Changing the day means the new date and time need agreement again.' : 'This changes the day. It does not confirm the date or time.'),el('div', {class:'diary-move-actions pin-foot'},cancel,save))
  form.addEventListener('submit',e=>{
    e.preventDefault()
    if (!date.value || !date.validity.valid || !form.reportValidity()) return
    if (routeGen !== gen || who !== diaryPreferenceKey('move')) { dialog.close(); return }
    const destination = date.value; dialog.close()
    if (destination === cl.date) return
    movingDueId = null; movingEnqId = null
    moveToDay(cl,destination)
  })
  cancel.addEventListener('click',()=>dialog.close())
  dialog.append(el('header', {class:'booking-head'},el('h2', {},`Move ${cl.customer_name ?? 'visit'}`)),form)
  dialog.addEventListener('close',()=>{dialog.remove(); const next = opener.isConnected ? opener : document.querySelector<HTMLButtonElement>(`[data-clean-id="${cl.id}"] .diary-move`); next?.focus({preventScroll:true})})
  document.body.append(dialog); dialog.showModal()
}

// The unagreed visits a person booked for this customer on this visit's day, this one first, gutters before windows.
// Contact reminders and Roundly's own suggestions are not in it.
function houseGroup(cl: Clean): Clean[] {
  const same = (payload?.cleans ?? []).filter((o) => o.customer_id === cl.customer_id && o.date === cl.date && o.state === 'booked' && !o.confirmed && !isContact(o) && !isSuggestion(o))
  return houseOrder(same)
}

// Agree exactly these visits; one Undo puts exactly these back (each at the version its own save returned).
function confirmGroup(group: Clean[]): void {
  const saved: { cl: Clean; version: number }[] = []
  let pending = group.length
  const done = (): void => {
    if (--pending > 0) return
    void load()
    if (!saved.length) return
    offerUndo(`Confirmed ${saved.map((x) => visitJobLabel(x.cl)).join(' and ')} for ${group[0]!.customer_name ?? 'them'}`, () => {
      for (const { cl, version } of saved) {
        void mutate({ label: `Undo confirmed: ${cl.customer_name ?? ''} ${cl.date}`, method: 'PATCH', path: `/api/cleans/${cl.id}`, body: { version, confirmed: 0 }, onAck: () => void load(), onConflict: () => void load() })
      }
    })
  }
  for (const cl of group) {
    void mutate({ label: `Confirm visit: ${cl.customer_name ?? ''} ${cl.date}`, method: 'PATCH', path: `/api/cleans/${cl.id}`, body: { version: cl.version, confirmed: 1 } }).then((ack) => {
      if (ack.ok) saved.push({ cl, version: (ack.row as { version?: number } | undefined)?.version ?? cl.version + 1 })
      else alert4xx(ack)
      done()
    })
  }
}

// ---- day notes --------------------------------------------------------------

// A day note typed but not yet saved (or refused) survives a re-render of
// the day, keyed by date, instead of vanishing when the diary redraws.
const noteDrafts = new Map<string, string>()
// Dates whose day note is saved but not yet landed (offline): the box stays
// locked across re-renders so a second Save cannot make a second note.
const noteSaving = new Set<string>()

function renderNotes(date: string, notes: DayNote[], container: HTMLElement): void {
  clear(container)
  for (const n of notes) {
    container.append(el('div', { class: 'day-note' }, n.note))
  }
  const input = el('input', { class: 'cell-input note-input', placeholder: '+ day note (payment messages sent…)' })
  if (noteDrafts.has(date)) input.value = noteDrafts.get(date)!
  if (noteSaving.has(date)) { input.value = noteDrafts.get(date) ?? ''; input.setAttribute('disabled', 'disabled'); input.placeholder = 'saving when the signal is back…' }
  input.addEventListener('input', () => { if (input.value.trim()) noteDrafts.set(date, input.value); else noteDrafts.delete(date) })
  const save = el('button', { class: 'note-save', type: 'button' }, 'Save note')

  // Enter was the ONLY way to save. Typing a note and tapping away lost it
  // with no warning — and on a phone keyboard "done" is the natural gesture,
  // not Enter. Now: an explicit button, and blur saves rather than discards.
  const commit = (): void => {
    const text = input.value.trim()
    // Tapping Save blurs the input first, so both paths fire for one gesture —
    // without this guard that is two POSTs with two idempotency keys, i.e. the
    // note saved twice.
    if (text === '' || input.hasAttribute('disabled')) return
    // codex MEDIUM-8: don't clear before the ack — a rejected note (over
    // the 500-char limit, auth expiry) must come back to the input, not
    // vanish as if saved.
    input.setAttribute('disabled', 'disabled')
    save.setAttribute('disabled', 'disabled')
    void mutate({
      label: `Day note ${date}`,
      method: 'POST',
      path: '/api/day-notes',
      body: { date, note: text },
      onAck: () => { noteSaving.delete(date); void load() },
      onQueued: () => { noteSaving.add(date); void load() },
    }).then((ack) => {
      if (!ack.ok && ack.status >= 400 && ack.status < 500) {
        noteSaving.delete(date)
        input.removeAttribute('disabled')
        save.removeAttribute('disabled')
        input.value = text
        noteDrafts.set(date, text) // the day may have been redrawn: the text is offered again on the fresh box
        window.alert(ack.error ?? 'rejected')
      } else if (ack.ok) {
        noteDrafts.delete(date)
        noteSaving.delete(date)
      }
    })
  }

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      commit()
    }
  })
  // A note in progress must survive a background refresh, same as any editor.
  input.addEventListener('focus', () => {
    editing = true
    save.classList.add('note-save-live')
  })
  input.addEventListener('blur', (event) => {
    // Moving round the Diary (its dates, search and filters, the ⋯) is not a request to save this draft. Keyboard
    // focus can leave the note before those controls' click guards run.
    if ((event.relatedTarget as Element | null)?.closest('.diary-clear-filters, .diary-week-strip, .week-nav, .diary-find-toggle, .diary-phone-find, .diary-more, .diary-desk-views, .diary-desk-filters, .diary-work-days')) return
    commit() // save BEFORE releasing the edit lock, so a pending refresh can't
    afterEdit() // rebuild the DOM out from under an in-flight note
  })
  save.addEventListener('click', commit)
  container.append(el('div', { class: 'note-row' }, input, save))
}

// ---- screen -----------------------------------------------------------------

// A read on coming back to the Diary (come-back.ts) is quiet: if it fails, the Diary stays as it is, with no "as it was"
// banner over it.
let quietNext = false

async function load(): Promise<void> {
  // The month is on screen: a week read (a late Undo, a move finishing) must not draw over it, and the month
  // reads again instead so it shows the change (Astra, 30 Sep).
  if (diaryView() === 'month') { monthOnDataChanged(); return }
  const entry = weekEntry; weekEntry = null
  const sequence = ++requestSequence
  const quiet = quietNext
  quietNext = false
  const gen = routeGen // codex HIGH-3: bail before render if the route changed mid-load
  const root = document.querySelector<HTMLElement>('#screen')!
  const to = addDaysISO(fromDate, WINDOW_DAYS - 1)
  // Only the default (today-forward) window is cached — that is the one Lewis
  // opens cold in a dead zone. Paging back through history offline is not a
  // real journey and caching every window would evict the one that matters.
  const cacheKey = fromDate === defaultFrom() ? 'schedule' : undefined
  try {
    // The customers read feeds only the panel's "Due this week" group, so it
    // may fail on its own: the diary renders without the group rather than
    // going down with it. Same cache key Messages uses — one payload, one
    // cached copy for both screens. The leads read feeds the "New enquiries"
    // group on the same terms: a failed read is no tab, not a dead diary.
    const [result, cData, lData, jData] = await Promise.all([
      api<SchedulePayload>(`/api/schedule?from=${fromDate}&to=${to}`, cacheKey),
      api<{ customers: Customer[] }>('/api/customers', 'customers').catch(() => null),
      api<{ leads: Lead[] }>('/api/leads', 'leads').catch(() => null),
      loadRoundJobs(),
    ])
    if (gen !== routeGen || sequence !== requestSequence || diaryView() === 'month') return
    if (editing) { refreshPending = true; return }
    const detail = document.querySelector<HTMLDialogElement>('.diary-detail-dialog[open]')
    if (detail) { detail.addEventListener('close', () => void load(), {once:true}); return }
    payload = result
    applyWaitingTimes(payload)
    customers = cData?.customers ?? null
    if (customers) noteJobOneNames(customers)
    roundJobList = jData
    leads = lData?.leads ?? null
    // A fresh read started after a saved move holds it: that move no longer needs laying over a saved copy.
    for (const [id, m] of recentMoves) if (sequence > m.seq) recentMoves.delete(id)
    noteSaving.clear() // a fresh read holds every note that has landed
    whatsNextStale()
    if (choosing) {
      choosing = false
      let day = chooseDay(payload, true, null)
      if (day === null) {
        const ahead = await readAhead(payload)
        if (gen !== routeGen || sequence !== requestSequence || diaryView() === 'month') return
        day = ahead ? chooseDay(payload, true, ahead) : null
      }
      setChosen(payload, day ?? todayISO())
    }
    if (goAhead()) return
    const restoreNavFocus = entry && document.activeElement?.getAttribute('aria-label') === entry.label && document.activeElement?.classList.contains('week-step')
    render(payload, root)
    if (entry && entry.from === payload.from && entry.gen === routeGen && entry.who === diaryPreferenceKey('selection')) {
      const days = root.querySelector<HTMLElement>('.diary-days')
      if (days) diaryMotion(days, [{opacity:.4},{opacity:1}], 160)
      if (restoreNavFocus) root.querySelector<HTMLButtonElement>(`.week-step[aria-label="${entry.label}"]`)?.focus({preventScroll:true})
    }
    playLanding(root)
    showFocus(root, sequence)
  } catch (err) {
    if (gen !== routeGen || sequence !== requestSequence || diaryView() === 'month' || quiet) return
    // Offline/timeout: show the last good round from this phone rather than a
    // blank screen, always behind the "as it was at HH:MM" banner.
    //
    // Only the today-forward window is CACHED, but the fallback is offered
    // for any window: a van that had paged back and then lost signal used to
    // get a blank screen with an error, because the lookup was skipped
    // whenever the diary had been paged. The saved copy is the today-forward
    // week, so the window jumps to today with it — the date box and the day
    // headings must not claim to be showing days this copy does not hold.
    const cached = readCache<SchedulePayload>('schedule')
    if (cached) {
      // The window follows the copy, not the calendar: the date box, the week
      // arrows, the day headings and the close-out forms all read fromDate, so
      // setting it to today while rendering a copy that starts yesterday would
      // just move the lie one field along.
      fromDate = cached.data.from ?? defaultFrom()
      mountedDay = todayISO()
      payload = cached.data
      applyWaitingTimes(payload)
      // No signal: only the days saved on the phone count (E4).
      if (choosing) { choosing = false; setChosen(payload, chooseDay(payload, false, null) ?? todayISO()) }
      // Moves saved and not yet confirmed by a fresh read stay where the server put them, unless the copy already
      // holds a newer version of the visit (P7).
      for (const [id, m] of recentMoves) {
        const held = payload.cleans.find((c) => c.id === id)
        if (held && (m.row.version ?? 0) > (held.version ?? 0)) applySavedMove(payload, { ...m.row, id })
      }
      render(cached.data, root)
      loadError(root, (err as Error).message, () => void load(), cached.at)
    } else {
      clear(root)
      loadError(root, (err as Error).message, () => void load())
    }
  }
}

// ---- the day on a map ------------------------------------------------------

// A map pin on the day heading. Opens that day's stops as dots on a map
// inside Roundly — the streets and the distances answer "do these times need
// moving?".
//
// It was a Google Maps link for about an hour. Google drops ONE pin per link;
// two or more addresses and it plans a ROUTE instead, which is the opposite
// of the question being asked (Liam, 2026-09-14: "it's trying to plan a route
// between them all ... it's also not showing the pins").
//
// It follows the worker and area filters, because the stops it shows are the
// rows the day card is showing.
// The Find button's magnifier (Design B), drawn like the map pin.
function magnifier(): SVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '18'); svg.setAttribute('height', '18'); svg.setAttribute('aria-hidden', 'true')
  const ring = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
  ring.setAttribute('cx', '10.5'); ring.setAttribute('cy', '10.5'); ring.setAttribute('r', '6.5')
  const handle = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  handle.setAttribute('d', 'M15.5 15.5 20 20')
  for (const part of [ring, handle]) { part.setAttribute('fill', 'none'); part.setAttribute('stroke', 'currentColor'); part.setAttribute('stroke-width', '2'); part.setAttribute('stroke-linecap', 'round') }
  svg.append(ring, handle)
  return svg
}

// A phone day's details (Design B), shown in a small window from its ⓘ and put back under the day when it closes.
function openFoldInWindow(title: string, fold: HTMLDetailsElement, opener: HTMLElement): void {
  const home = fold.parentElement, after = fold.nextSibling
  const dialog = el('dialog', {class:'booking-dialog diary-info-dialog', 'aria-label':title})
  const close = el('button', {type:'button', 'aria-label':'Close day details'}, 'Close')
  close.addEventListener('click', () => dialog.close())
  fold.open = true; fold.hidden = false
  dialog.append(el('header', {class:'booking-head'}, el('h2', {}, title), close), el('div', {class:'diary-info-content'}, fold))
  closeOnRosterChange(dialog)
  dialog.addEventListener('close', () => { fold.hidden = true; if (home?.isConnected) home.insertBefore(fold, after); dialog.remove(); if (opener.isConnected) opener.focus({preventScroll:true}) })
  document.body.append(dialog); dialog.showModal()
}

// Needs you's extra lines (Design B): what Plan work used to hold besides To place, each opening to the same list.
function planningExtras(root: HTMLElement, reviewCount: number): () => NeedsExtra[] {
  const review = root.querySelector<HTMLDetailsElement>('.review-queue')
  const offers = offersList()
  const waiting = offers.querySelectorAll('.diary-offer').length + Number(/(\d+) more/.exec(offers.textContent ?? '')?.[1] ?? 0)
  review?.remove()
  return () => [
    { key: 'review', label: 'Past visits to review', count: reviewCount, fill: into => { if (review) { review.open = true; into.append(review) } } },
    { key: 'offers', label: 'Dates offered, waiting', count: waiting, fill: into => into.append(offers) },
  ]
}

// Day details (Design B): the day's figures, who is out, notes, close-out and the week's working days, in a small
// window from the ⓘ on the day, instead of three boxes under it. The panels are the same ones, drawn fresh each time.
function openDayDetails(iso: string, dayPanel: HTMLElement, workPanel: HTMLElement, opener: HTMLElement): void {
  const dialog = el('dialog', {class:'booking-dialog diary-info-dialog', 'aria-label':`Day details, ${dayLabel(iso)}`})
  const close = el('button', {type:'button', 'aria-label':'Close day details'}, 'Close')
  // A day total being typed holds the Diary still until it is saved or cancelled (closeout.ts). Closing the window with
  // one typed in asks for Save or Cancel first, so nothing typed is lost; closing with none typed (or after) lets the
  // Diary move again (Astra's final check, 24 Oct 2026: it stayed locked).
  const typedAt = new WeakMap<HTMLFormElement, string>()
  const valuesOf = (form: HTMLFormElement): string => JSON.stringify([...form.querySelectorAll<HTMLInputElement | HTMLSelectElement>('input, select')].map(f => f.value))
  dialog.addEventListener('focusin', e => {
    const form = (e.target as Element | null)?.closest?.<HTMLFormElement>('form.closeout-form')
    if (form && !typedAt.has(form)) typedAt.set(form, valuesOf(form))
  })
  // Only while the form still holds the Diary: once it is saved or cancelled there is nothing left to lose.
  const unsaved = (): HTMLFormElement | null => editing ? [...dialog.querySelectorAll<HTMLFormElement>('form.closeout-form')].find(f => f.isConnected && typedAt.has(f) && typedAt.get(f) !== valuesOf(f)) ?? null : null
  const askFirst = (): boolean => {
    const form = unsaved()
    if (!form) return false
    if (!form.previousElementSibling?.classList.contains('diary-info-unsaved')) form.before(el('p', {class:'diary-info-unsaved', role:'alert'}, 'This day total is not saved yet. Save it, or press Cancel to leave it.'))
    form.querySelector<HTMLElement>('input, select')?.focus()
    return true
  }
  close.addEventListener('click', () => { if (!askFirst()) dialog.close() })
  dialog.addEventListener('cancel', e => { if (askFirst()) e.preventDefault() })
  dialog.append(el('header', {class:'booking-head'}, el('h2', {}, `Day details · ${dayLabel(iso)}`), close), el('div', {class:'diary-info-content'}, dayPanel, workPanel))
  // Choosing another day under Working days, or a roster change, redraws the diary: the window closes first. On the
  // way down (capture), so the day's own button then finds no window open and changes the day (bug hunt, 8 Oct 2026:
  // it closed afterwards, and the diary refused to move while it was still open).
  // The lock a day total form took goes with the window, and only that one: not a "Give them to" still saving (its own
  // finish frees it), nor one taken before the window opened. Freed before another working day is chosen, so that day
  // opens; and the Diary is drawn again afterwards, so a form left open is never reused without its lock.
  const lockedBefore = editing
  let freed = false
  const freeOwnLock = (): void => {
    if (freed || lockedBefore || !editing || !dialog.querySelector('form.closeout-form')) return
    // A save still on its way (Save greyed while it goes, or a "Give them to") frees the hold itself when it lands.
    if (dialog.querySelector('.day-ledger .closeout-btn:disabled, form.closeout-form button[type="submit"]:disabled')) return
    freed = true
    afterEdit()
  }
  workPanel.addEventListener('click', e => {
    if (!(e.target as Element).closest('.diary-work-day')) return
    if (askFirst()) { e.preventDefault(); e.stopPropagation(); return }
    freeOwnLock()
    dialog.close()
  }, {capture:true})
  closeOnRosterChange(dialog)
  dialog.addEventListener('close', () => {
    // Whatever closed it (Close, Escape, another day chosen, who is out changed).
    const hadForm = !!dialog.querySelector('form.closeout-form')
    freeOwnLock()
    dialog.remove(); if (opener.isConnected) opener.focus({preventScroll:true})
    const root = document.querySelector<HTMLElement>('#screen')
    if (hadForm && !editing && payload && root && window.location.hash.startsWith('#/schedule')) render(payload, root)
  })
  document.body.append(dialog); dialog.showModal()
}

// Who is out on the day, changed inside a Day details window: the window closes once the change is made, so the diary
// behind it shows the new name and its Undo bar can be pressed (bug hunt, 8 Oct 2026: the window stayed up with a
// dead, greyed list and the Undo hidden behind it). A change that is put back (the typed name cancelled) keeps it open.
function closeOnRosterChange(dialog: HTMLDialogElement): void {
  dialog.addEventListener('change', e => {
    const pick = (e.target as Element).closest<HTMLSelectElement>('.day-roster-select')
    if (pick?.disabled) dialog.close()
  })
}

function mapPin(): SVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '18'); svg.setAttribute('height', '18'); svg.setAttribute('aria-hidden', 'true')
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  path.setAttribute('d', 'M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11z')
  path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '2'); path.setAttribute('stroke-linejoin', 'round')
  const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
  dot.setAttribute('cx', '12'); dot.setAttribute('cy', '10'); dot.setAttribute('r', '2.5')
  dot.setAttribute('fill', 'none'); dot.setAttribute('stroke', 'currentColor'); dot.setAttribute('stroke-width', '2')
  svg.append(path, dot)
  return svg
}

function openNotOnMap(words: string, missing: { name: string; customerId: number; why: string }[]): void {
  const s = sheet(`Not on the map yet`)
  s.head.append(el('h2', {}, 'Not on the map yet'))
  s.body.append(el('p', { class: 'muted' }, `Nobody on ${words} is on the map yet.`))
  const list = el('ul', { class: 'not-on-map' })
  for (const m of missing) {
    const link = el('a', { href: `#/customer/${m.customerId}`, class: 'not-on-map-name' }, m.name)
    link.addEventListener('click', () => s.close())
    list.append(el('li', {}, link, el('span', { class: 'muted' }, postcodeWords(m.why))))
  }
  s.body.append(list)
  if (missing.some((m) => m.why.startsWith('Going on the map'))) s.body.append(el('p', { class: 'muted' }, 'Open the Diary again in a moment to see them on the map.'))
}

function dayMapButton(rows: Clean[], date: string): HTMLElement | null {
  const pins = pinsOf(rows)
  const missing = unmappable(rows)
  // Nothing to draw and nobody to explain away: no button at all.
  if (!pins.length && !missing.length) return null
  const words = dayLabel(date)
  const label = pins.length
    ? `Map of ${words}: ${spreadWords(pins)}`
    : `Map of ${words}: nobody on the map yet`
  const button = el('button', { type: 'button', class: 'day-map', 'aria-label': label, title: label })
  // Design B: a pin, in both layouts (it was the word Map in New).
  button.append(mapPin()); button.classList.add('diary-icon-button')
  // Nothing can be drawn: say so on the tap, not only in a tooltip a phone never shows (roundly-bugs' live check).
  // Who isn't on the map and why, each name opening their page (Liam, 26 Oct 2026: "flow isnt good as you cant click it
  // but sarah has a postcode so dont understand the message").
  if (!pins.length) {
    button.addEventListener('click', () => openNotOnMap(words, missing))
    return button
  }
  // On a computer the map opens in a SECOND TAB (#/map/<date>), so the diary
  // stays where it is and the two can be read together. Liam, 21 Sep 2026:
  // "should that open in a new tab so that you could be juggling both at the
  // same time? You can carry on sending messages and stuff... and be able to
  // see the map?" Working out the driving order means reading the map and the
  // day at once, and the overlay could only ever show one of them.
  //
  // On a phone it stays the overlay. A second tab on a phone is not side by
  // side, it is a worse overlay with a longer way back.
  if (!onAPhone()) {
    button.addEventListener('click', () => {
      // A pop-up blocker can refuse this; falling back to the overlay is
      // better than a tap that does nothing at all.
      const tab = window.open(`${window.location.pathname}#/map/${date}`, `roundly-map-${date}`)
      if (tab) { tab.focus(); return }
      button.disabled = true
      void import('../day-map-panel')
        .then((panel) => panel.openDayMap(rows, words))
        .finally(() => { button.disabled = false })
    })
    return button
  }
  // The map drawing and its street tiles are fetched on the first tap, not on
  // every load of the diary: they are the heaviest thing in the app and most
  // days nobody opens the map at all.
  button.addEventListener('click', () => {
    button.disabled = true
    void import('../day-map-panel')
      .then((panel) => panel.openDayMap(rows, words))
      .catch(() => window.alert('The map could not load. Check your signal and try again.'))
      .finally(() => { button.disabled = false })
  })
  return button
}

// ---- who is out on a day ---------------------------------------------------

// The roster picker on a day heading. "Nobody on" until someone is put there;
// then the day counts as RUNNING and Messages may offer it to a customer who
// has no booking yet.
//
// The list of names is not hardcoded: it is everyone who has ever worked the
// round (the same list the close-out uses), plus "+ Someone else" to type a
// new one, so a new starter is added once and is then on every dropdown.
//
// Three verbs behind one control: nobody -> POST, a different name -> PATCH,
// back to nobody -> DELETE. Each one offers the Undo bar, because picking the
// wrong day out of a column of them is the easy mistake to make.
const SOMEONE_ELSE = '__someone_else'

// `out`: the New diary's day heading, where the chooser reads as the day's own words ("Sendi out", "Nobody out") and is
// one tap away (Liam, 11 Oct 2026: "book the worker in that day under less taps").
function rosterPicker(date: string, row: RoundDay | null, workers: string[], opts: { out?: boolean } = {}): HTMLElement {
  const wrap = el('div', { class: `day-roster${opts.out ? ' diary-out-pick' : ''}` })
  const pick = el('select', { class: 'day-roster-select', 'aria-label': `Who is out on ${dayLabel(date)}` })
  pick.append(el('option', { value: '' }, opts.out ? 'Nobody out' : 'Nobody on'))
  const names = [...new Set([...workers, ...(row ? [row.worker] : [])])]
  for (const w of names) pick.append(el('option', { value: w }, opts.out ? `${w} out` : w))
  pick.append(el('option', { value: SOMEONE_ELSE }, '+ Someone else'))
  pick.value = row ? row.worker : ''
  if (row) pick.classList.add('day-roster-on')

  pick.addEventListener('change', () => {
    let chosen = pick.value
    if (chosen === SOMEONE_ELSE) {
      // The typed name goes straight to the same three verbs below; cancelling
      // puts the control back to what the day already said rather than to
      // "Nobody on", which would read as an instruction nobody gave.
      const typed = window.prompt(`Who is out on ${dayLabel(date)}?`, '')?.trim() ?? ''
      if (!typed) { pick.value = row ? row.worker : ''; return }
      chosen = typed.slice(0, 100)
    }
    if (row && chosen === row.worker) return
    pick.disabled = true
    if (!chosen) return clearRoster(date, row)
    if (!row) return addRoster(date, chosen)
    return changeRoster(date, row, chosen)
  })
  wrap.append(pick)
  return wrap
}

function addRoster(date: string, worker: string): void {
  void mutate<RoundDay>({
    label: `${worker} out on ${date}`,
    method: 'POST',
    path: '/api/round-days',
    body: { date, worker },
    onAck: () => void load(),
    onConflict: () => void load(),
  }).then((ack) => {
    alert4xx(ack)
    if (!ack.ok || !ack.row) return void load()
    const created = ack.row
    offerUndo(`${worker} is out on ${dayLabel(date)}`, () => {
      void mutate({
        label: `Undo ${worker} out on ${date}`,
        method: 'DELETE',
        path: `/api/round-days/${created.id}`,
        body: { version: created.version },
        onAck: () => void load(),
        onConflict: () => void load(),
      })
    })
  })
}

function changeRoster(date: string, row: RoundDay, worker: string): void {
  void mutate({
    label: `${worker} out on ${date}`,
    method: 'PATCH',
    path: `/api/round-days/${row.id}`,
    body: { version: row.version, worker },
    onAck: () => void load(),
    onConflict: () => void load(),
  }).then((ack) => {
    alert4xx(ack)
    undoPatch({
      text: `${worker} is out on ${dayLabel(date)} instead of ${row.worker}`,
      label: `Undo worker on ${date}`,
      path: `/api/round-days/${row.id}`,
      ack,
      version: row.version,
      body: { worker: row.worker },
      after: () => void load(),
    })
  })
}

function clearRoster(date: string, row: RoundDay | null): void {
  if (!row) return void load()
  void mutate({
    label: `Nobody out on ${date}`,
    method: 'DELETE',
    path: `/api/round-days/${row.id}`,
    body: { version: row.version },
    onAck: () => void load(),
    onConflict: () => void load(),
  }).then((ack) => {
    alert4xx(ack)
    if (!ack.ok && ack.status !== 0) return
    // A deleted roster row cannot be PATCHed back: the way back is a new one,
    // which is why this undo is written by hand rather than through undoPatch.
    offerUndo(`Nobody is out on ${dayLabel(date)}`, () => {
      void mutate({
        label: `Put ${row.worker} back on ${date}`,
        method: 'POST',
        path: '/api/round-days',
        body: { date, worker: row.worker },
        onAck: () => void load(),
        onConflict: () => void load(),
      })
    })
  })
}

// One area rule for the week and the month (month-view.ts): the typed Area, else the postcode's first half.
function areaOf(cl: Clean): string { return areaOfClean(cl) }
// The days finished with Finish my day in the read (/api/schedule's finished_days; absent from a read cached before).
function finishedDays(p: SchedulePayload): FinishedDay[] { return (p as SchedulePayload & { finished_days?: FinishedDay[] }).finished_days ?? [] }
// A one-person round's visit names (Liam, 19 Oct 2026): the owner's own name is never said, only someone else's.
function otherName(name: string | null | undefined): string { return otherThanOwner(name, getMe()?.workerName) }
// Whose visit it is, by the rule the worker's phone uses (functions/lib/
// worker-day.ts): the name on it, or, with no name, whoever the diary has out
// that day. So picking "Sendi" in the worker list shows what is on Sendi's
// phone (Liam, 2026-09-25), and "Unassigned" is only work nobody will see.
function visible(cl: Clean, roster: readonly RoundDay[]): boolean {
  const who = visitWorker(cl, roster).toLowerCase()
  // A one-person round has no worker filter (Liam, 19 Oct 2026): one kept from before never hides a visit.
  const wf = worksAlone() ? '' : workerFilter
  return (!wf || (wf === '__unassigned' ? !who : who === wf.toLowerCase())) && (!areaFilter || areaOf(cl) === areaFilter) && (!diarySearch || [cl.customer_name, cl.customer_address, visitJobLabel(cl)].join(' ').toLowerCase().includes(diarySearch.toLowerCase()))
}

// The one save behind putting a day in driving order — a row dropped on
// another row: the WHOLE day on the wire in its new reading order, so the
// stored order and the order on screen never drift apart again. While it is
// in flight no new grab may start: a second drag would work out its move
// from a day that has already changed underneath it.
let orderFeedback: DiaryOrderEffect | null = null
let reorderInFlight = false
function orderSaved(effect: DiaryOrderEffect, gen: number, who: string): void {
  if (gen !== routeGen || who !== diaryPreferenceKey('order')) return
  if (diaryView() === 'month') monthOnDataChanged(effect)
  else { orderFeedback = effect; dataChanged() }
}
async function saveDayOrder(date: string, moved: readonly Clean[], id: number): Promise<void> {
  const gen = routeGen, who = diaryPreferenceKey('order')
  const effect = diaryOrderCapture(date,id,false)
  reorderInFlight = true
  try {
    const inverse = inverseDayOrder(moved)
    let queued = false
    const ack = await mutate({ label: `Reorder ${dayLabel(date)}`, method: 'POST', path: '/api/reorder', body: { date, rows: moved.map(c => ({ id: c.id, version: c.version })) }, onAck: () => orderSaved(effect, gen, who), onConflict: () => { if (gen === routeGen && who === diaryPreferenceKey('order')) dataChanged() }, onQueued: () => { queued = true } })
    if (!ack.ok && ack.status >= 400 && ack.status < 500 && gen === routeGen && who === diaryPreferenceKey('order')) { alert4xx(ack); dataChanged() }
    // Offline reverse uses the same endpoint so the existing queue holds it
    // behind its forward save; a failed/conflicted forward holds the inverse.
    // No single-row chainVersion or guessed latest snapshot is involved.
    if ((ack.ok && !ack.noop) || queued) offerUndo(`${queued ? 'Queued order for' : 'Reordered'} ${dayLabel(date)}`, () => {
      const reverse = diaryOrderCapture(date,id,true)
      void mutate({ label: `Undo reorder ${dayLabel(date)}`, method: 'POST', path: '/api/reorder', body: { date, restore_order: true, rows: inverse }, onAck: () => orderSaved(reverse, gen, who), onConflict: () => { if (gen === routeGen && who === diaryPreferenceKey('order')) dataChanged() } }).then(back => { if (!back.ok && back.status >= 400 && back.status < 500) alert4xx(back) })
    })
  } finally {
    reorderInFlight = false
  }
}

function appendOrderButtons(row: HTMLElement, cl: Clean, rows: Clean[], inDayOrder: Clean[], date: string): void {
  const controls = el('span', { class: 'diary-order-buttons', role: 'group', 'aria-label': `Order ${cl.customer_name ?? 'visit'}` })
  // Use the displayed group, never another reply group sharing its storage band.
  // Linked houses retain their internal order; move the whole house as one block.
  const blocks: Clean[][] = []
  for (const visit of rows) {
    const previous = blocks[blocks.length - 1]
    if (severalJobsOn() && previous?.[0]?.customer_id === visit.customer_id) previous.push(visit)
    else blocks.push([visit])
  }
  const at = blocks.findIndex(b => b.some(v => v.id === cl.id))
  const shift = (direction: -1 | 1): void => {
    if (reorderInFlight || at + direction < 0 || at + direction >= blocks.length) return
    const movedBlocks = blocks.slice(); [movedBlocks[at], movedBlocks[at + direction]] = [movedBlocks[at + direction]!, movedBlocks[at]!]
    const ids = new Set(rows.map(v => v.id)); const replacement = movedBlocks.flat(); let i = 0
    const moved = inDayOrder.map(v => ids.has(v.id) ? replacement[i++]! : v)
    controls.closest<HTMLDialogElement>('dialog')?.close()
    row.querySelector<HTMLButtonElement>('.diary-row-summary')?.focus({preventScroll:true})
    void saveDayOrder(date, moved, cl.id)
  }
  for (const direction of [-1, 1] as const) {
    const button = el('button', { type: 'button', 'aria-label': `Move ${cl.customer_name ?? 'visit'} ${direction === -1 ? 'up' : 'down'}`, title: direction === -1 ? 'Move up (Alt ↑)' : 'Move down (Alt ↓)' }, direction === -1 ? '↑' : '↓')
    button.disabled = at + direction < 0 || at + direction >= blocks.length
    button.addEventListener('click', () => shift(direction)); controls.append(button)
  }
  ;(row.querySelector('.diary-visit-details') ?? row).append(controls)
  row.addEventListener('keydown', e => { if (e.altKey && ['ArrowUp','ArrowDown'].includes(e.key)) { e.preventDefault(); shift(e.key === 'ArrowUp' ? -1 : 1) } })
}

// ---- dragging a day row to a new place, by finger or by mouse ---------------
//
// One pointer gesture for every device: on a mouse the grab starts on the
// first small move with the button held; on a phone it starts after a long
// press with the finger still, so the day can still be scrolled from a row.
// While held, the row hangs from the pointer, the line under a neighbour
// shows where it will land, and the window scrolls itself near its edges so
// a phone can move a job past the fold. The save on release goes through
// draggedTo and saveDayOrder — the same whole-day save everything else uses.

// The rows of the day being dragged through, as viewport spans in reading
// order, so both the landing line and the drop read the same geometry. Only
// the held row's own heading group: "Asked, waiting" and "Not asked yet" share
// one band in the stored order, so a drop across them saved an order the screen
// then drew differently (Codex review, 29 Sep 2026).
function rowSpansIn(day: HTMLElement, group?: string): { id: number; top: number; bottom: number }[] {
  return [...day.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')].filter(r => group === undefined || r.dataset.group === group).map(r => {
    const rect = r.getBoundingClientRect()
    return { id: Number(r.dataset.cleanId), top: rect.top, bottom: rect.bottom }
  })
}

// The one answer behind both the landing line and the drop, so they can never
// disagree: the row under the pointer, the held row's own travelling span
// left out (src/day-order.ts dropTargetId). Read from the gesture's single
// lastY, never from a separate reading of the pointer.
function landingTarget(): number | null {
  if (!rowDrag || rowDrag.phase !== 'held') return null
  return dropTargetId(rowSpansIn(rowDrag.day, rowDrag.row.dataset.group), rowDrag.cleanId, rowDrag.lastY)
}

// The day card under the pointer while a row is held (the held row lets the pointer through), or null. A different
// day's card means the visit is being moved to that day, not reordered (Liam, 29 Sep: "I can't then drag it to a
// different day").
function dayUnderPointer(): HTMLElement | null {
  if (!rowDrag) return null
  // On the desktop diary the other days are dates in the week strip, so a held row can be let go on one of those.
  const under = document.elementFromPoint(rowDrag.lastX, rowDrag.lastY)
  // On the phone's Day, the other days are the strip's dates (round 2: "hold a visit's grip ... drag it to another day").
  return under?.closest<HTMLElement>('.day-card[data-date]') ?? under?.closest<HTMLElement>(diaryDesk() ? '.diary-desk-strip [data-date]' : '.diary-week-strip [data-date]') ?? null
}

function rowDragFrame(): void {
  if (!rowDrag || rowDrag.phase !== 'held') return
  const { row, day, cleanId, inDayOrder, lastY } = rowDrag
  // The row hangs from the pointer in page coordinates, so an auto-scroll
  // carries it with the page instead of leaving it behind.
  row.style.transform = `translate(${rowDrag.lastX - rowDrag.startX}px, ${lastY - rowDrag.fingerDy + window.scrollY - rowDrag.rowTopPage}px) scale(1.02)`
  // Over another day: that day lights up as where it will go, and no reorder line is drawn. Done work never
  // changes day (as the row menu says), and off every day card nothing happens (Codex).
  // Over Due (the phone's bar or the computer's tile): it lights up "Back to Due"; no day or line is shown.
  const dueHere = dueUnderPointer()
  for (const b of document.querySelectorAll<HTMLElement>('.diary-due-bar.drop-ready, .diary-wtile[data-tile="due"].drop-ready')) if (b !== dueHere) b.classList.remove('drop-ready')
  dueHere?.classList.add('drop-ready')
  // Over a person box (planning on a computer): that person lights up; no day or line is shown.
  const person = dueHere ? null : personUnderPointer()
  for (const b of document.querySelectorAll<HTMLElement>('.diary-plan-person.drop-ready')) if (b !== person) b.classList.remove('drop-ready')
  person?.classList.add('drop-ready')
  const over = person ? null : dayUnderPointer()
  const heldClean = payload?.cleans.find((c) => c.id === cleanId)
  // A day that has gone does not light up: it will not take the visit (goneDay).
  const otherDay = over && over.dataset.date !== day.dataset.date && (over.dataset.date ?? '') >= todayISO() && heldClean?.state === 'booked' ? over : null
  for (const d of document.querySelectorAll<HTMLElement>('.day-card.drop-ready, .diary-week-strip .drop-ready')) if (d !== otherDay) d.classList.remove('drop-ready')
  otherDay?.classList.add('drop-ready')
  // Where it would land, drawn as a line against the row under the pointer —
  // and only when the drop would truly take: draggedTo refuses a crossing
  // between bands, a timed row, a no-op, so the line can never promise one.
  const fixed = !!heldClean && !canReorder(heldClean, isSuggestion)
  const targetId = fixed || dueHere || person || otherDay || over !== day ? null : landingTarget()
  // Over a visit with a time: the line above it, where a time is pencilled in (tidy-up item 7).
  const pencil = fixed || dueHere || person || otherDay || over !== day ? null : pencilSlot()
  for (const marked of document.querySelectorAll<HTMLElement>('.row-drag-above, .row-drag-below')) marked.classList.remove('row-drag-above', 'row-drag-below')
  if (pencil) pencil.stops[pencil.index]!.rows[0]?.classList.add('row-drag-above')
  else if (targetId !== null && targetId !== cleanId && draggedTo(inDayOrder, cleanId, targetId, isSuggestion)) {
    const targetRow = day.querySelector(`.clean-row[data-clean-id="${targetId}"]`)
    targetRow?.classList.add(dropSide(inDayOrder.map(r => r.id), cleanId, targetId) === 'above' ? 'row-drag-above' : 'row-drag-below')
  }
  // Keep the page moving while the held row waits near an edge. On the desktop diary the list's visible top is the
  // sticky date strip's lower edge, and its dates are drop targets: the page scrolls just below the strip, and holds
  // still while a date is being chosen (Liam, 8 Oct: dragging worked worse than the week of day cards).
  const strip = document.querySelector<HTMLElement>(diaryDesk() ? '.diary-desk-strip' : '.diary-phone .diary-week-strip')?.getBoundingClientRect()
  const overStrip = !!strip && lastY >= strip.top && lastY <= strip.bottom
  const fromTop = strip && lastY > strip.bottom ? lastY - strip.bottom : lastY
  // On the phone the page ends at the Due bar's top edge, not the screen's (round 2).
  const fromBottom = (document.querySelector<HTMLElement>('.diary-due-bar:not([hidden])')?.getBoundingClientRect().top ?? window.innerHeight) - lastY
  // A narrow band there, so the first visible visit can still be dropped on without the page moving away from it.
  const topBand = strip ? 24 : AUTO_SCROLL_EDGE_PX
  if (overStrip) { /* choosing a date: no scrolling under the pointer */ }
  else if (fromTop < topBand) window.scrollBy(0, -autoScrollSpeed(fromTop))
  else if (fromBottom < AUTO_SCROLL_EDGE_PX) window.scrollBy(0, autoScrollSpeed(fromBottom))
  rowDrag.frame = requestAnimationFrame(rowDragFrame)
}

function startRowGrab(): void {
  if (!rowDrag || rowDrag.phase === 'held') return
  const { row, pointerId, pointerType } = rowDrag
  rowDrag.phase = 'held'
  if (rowDrag.timer !== null) { clearTimeout(rowDrag.timer); rowDrag.timer = null }
  // The gesture must survive the pointer leaving the row.
  try { row.setPointerCapture(pointerId) } catch { /* the pointer can be gone before the capture lands; the window listeners still see it */ }
  const rect = row.getBoundingClientRect()
  rowDrag.fingerDy = rowDrag.lastY - rect.top
  rowDrag.rowTopPage = rect.top + window.scrollY
  row.classList.add('row-drag-held')
  document.body.classList.add('diary-row-dragging') // the desktop strip shows its dates as places to drop
  if (pointerType !== 'mouse') navigator.vibrate?.(10) // the phone's "you have it"
  // The first time a job lifts on a phone, the one line that says what a hold can do (Liam didn't know it could move a
  // job to another day: docs/plans/diary-tidy/PLAN.md v2). Once per phone.
  if (pointerType !== 'mouse') { try { if (!localStorage.getItem('roundly:hold-tip')) { localStorage.setItem('roundly:hold-tip', '1'); toast('Drop it on a day at the top to move it there, or in the list to change the order.') } } catch { /* no storage: no tip */ } }
  rowDrag.frame = requestAnimationFrame(rowDragFrame)
}

function endRowDrag(): void {
  if (!rowDrag) return
  const { row, timer, frame, pointerId, phase } = rowDrag
  if (timer !== null) clearTimeout(timer)
  if (frame !== null) cancelAnimationFrame(frame)
  window.removeEventListener('pointermove', rowDragMove)
  window.removeEventListener('pointerup', rowDragUp)
  window.removeEventListener('pointercancel', rowDragCancel)
  window.removeEventListener('keydown', rowDragKey)
  row.classList.remove('row-drag-held')
  document.body.classList.remove('diary-row-dragging')
  row.style.transform = ''
  for (const d of document.querySelectorAll<HTMLElement>('.day-card.drop-ready, .diary-week-strip .drop-ready, .diary-plan-person.drop-ready, .diary-due-bar.drop-ready, .diary-wtile.drop-ready')) d.classList.remove('drop-ready')
  for (const marked of document.querySelectorAll<HTMLElement>('.row-drag-above, .row-drag-below')) marked.classList.remove('row-drag-above', 'row-drag-below')
  try { if (row.hasPointerCapture(pointerId)) row.releasePointerCapture(pointerId) } catch { /* the pointer may already be gone */ }
  rowDrag = null
  // A release that had the row can end in a click, and the row's face is
  // mostly the customer's link: without this a drop opens the customer page.
  // A press that never became a grab is an ordinary tap and keeps its click.
  if (phase === 'held') swallowNextClick()
}

function rowDragMove(e: PointerEvent): void {
  if (!rowDrag || e.pointerId !== rowDrag.pointerId) return
  rowDrag.lastY = e.clientY
  rowDrag.lastX = e.clientX
  if (rowDrag.phase === 'held') return // the frame loop follows the pointer
  const verdict = shouldGrab(rowDrag.pointerType, e.clientX - rowDrag.startX, e.clientY - rowDrag.startY, performance.now() - rowDrag.startedAt)
  if (verdict === 'abandon') return endRowDrag()
  if (verdict === 'grab') startRowGrab()
}

function rowDragUp(e: PointerEvent): void {
  if (!rowDrag || e.pointerId !== rowDrag.pointerId) return
  if (rowDrag.phase !== 'held') return endRowDrag() // a press that never grabbed: an ordinary tap
  rowDrag.lastY = e.clientY
  rowDrag.lastX = e.clientX
  // Let go over Due: back to Due (backToDue asks first about an agreed day).
  if (dueUnderPointer()) {
    const cl = payload?.cleans.find((c) => c.id === rowDrag!.cleanId)
    endRowDrag()
    if (cl && mayGoBackToDue(cl)) backToDue(cl)
    return
  }
  // Let go over a person box: the job is theirs, with Undo, the same as Whose job (giveJob).
  const person = personUnderPointer()
  if (person) {
    const cl = payload?.cleans.find((c) => c.id === rowDrag!.cleanId)
    const who = person.dataset.person ?? ''
    endRowDrag()
    if (cl && cl.state === 'booked') giveJob(cl, who === '' ? null : who)
    return
  }
  // Let go over another day: the visit moves to that day, with Undo, the same as Move to a day.
  const over = dayUnderPointer()
  if (over !== rowDrag.day) {
    const toDate = over?.dataset.date
    const cl = payload?.cleans.find((c) => c.id === rowDrag!.cleanId)
    endRowDrag() // off every day card, or done work: back where it was, nothing saved
    if (toDate && cl && cl.state === 'booked' && toDate !== cl.date) moveToDay(cl, toDate)
    return
  }
  // A timed visit let go on its own day: nothing changes (its place is its time).
  const heldCl = payload?.cleans.find((c) => c.id === rowDrag!.cleanId)
  if (heldCl && !canReorder(heldCl, isSuggestion)) { endRowDrag(); return }
  const pencil = pencilSlot()
  const targetId = landingTarget()
  const moved = targetId === null ? null : draggedTo(rowDrag.inDayOrder, rowDrag.cleanId, targetId, isSuggestion)
  const { date, cleanId } = rowDrag
  endRowDrag() // a null drop puts the row back where it was and saves nothing
  // Let go over a visit with a time: a time is pencilled in above it, never a reorder (tidy-up item 7).
  if (pencil) { const cl = payload?.cleans.find((c) => c.id === cleanId); if (cl) pencilIn(cl, date, pencil); return }
  if (moved) void saveDayOrder(date, moved, cleanId)
}

function rowDragCancel(): void { endRowDrag() }

function rowDragKey(e: KeyboardEvent): void {
  if (e.key === 'Escape' && rowDrag?.phase === 'held') { e.preventDefault(); endRowDrag() }
}

// Swallow just the one click a release can produce, then stand down — a
// lingering swallow would eat an innocent tap later.
function swallowNextClick(): void {
  const swallow = (e: MouseEvent): void => { e.preventDefault(); e.stopPropagation() }
  window.addEventListener('click', swallow, { capture: true })
  setTimeout(() => window.removeEventListener('click', swallow, { capture: true }), 0)
}

// ---- a time pencilled in by dragging (tidy-up item 7) -------------------------
//
// Liam, 20 Oct 2026: "when i drag Joel it should pencil a time in for him earlier than the others hence the drag?". A
// visit with no time, let go over one with a time, takes a time just before it: an hour before the first, or halfway
// between two (day-order.ts pencilTime, with Astra's rules and Sonnet's and GPT-6.1's edge cases, 20 Oct 2026). The day's
// agreement stays as it was and the time is not agreed ("time to confirm", as any time not agreed). Only a booked visit
// that is its customer's only visit that day, whoever's (the save checks it again, inside itself), never one with
// Couldn't do it (a time change would clear it), from today on, in a round with set times; anywhere else a drag is as
// before.
type TimedStop = { visits: Clean[]; rows: HTMLElement[]; at: number | null; length: number | null }
type PencilSlot = { stops: TimedStop[]; index: number } // let go above stops[index]

function canPencil(cl: Clean | undefined, date: string): cl is Clean {
  if (!cl || !setTimesOn() || date < todayISO()) return false
  if (cl.state !== 'booked' || isSuggestion(cl) || isContact(cl) || visibleTime(cl) || cl.blocked_reason) return false
  return !(payload?.cleans ?? []).some((c) => c.id !== cl.id && c.customer_id === cl.customer_id && c.date === date && c.state !== 'cancelled')
}

// The day's stops with a time, in the order on screen (a house's visits together), done work not among them (it is
// under Completed). A stop's time is its earliest one, and none when any of its times is not written as a time.
function timedStops(day: HTMLElement): TimedStop[] {
  const stops: TimedStop[] = []
  for (const row of day.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')) {
    if (!(row.dataset.group ?? '').startsWith('Times set:')) continue
    const cl = payload?.cleans.find((c) => c.id === Number(row.dataset.cleanId))
    if (!cl) continue
    const last = stops[stops.length - 1]
    if (last && severalJobsOn() && last.visits[0]!.customer_id === cl.customer_id) { last.visits.push(cl); last.rows.push(row) }
    else stops.push({ visits: [cl], rows: [row], at: null, length: null })
  }
  for (const stop of stops) {
    const times = stop.visits.map((v) => visibleTime(v)).filter((t): t is string => !!t)
    const read = times.map((t) => strictMinutes(t))
    stop.at = read.length && read.every((m) => m !== null) ? Math.min(...(read as number[])) : null
    const lengths = stop.visits.map((v) => v.duration_minutes ?? null)
    stop.length = lengths.every((m) => typeof m === 'number' && m > 0) ? (lengths as number[]).reduce((a, b) => a + b, 0) : null
  }
  return stops
}

// Where the held row would be pencilled in: over a stop with a time, above it. Null when this drag cannot pencil.
function pencilSlot(): PencilSlot | null {
  if (!rowDrag || rowDrag.phase !== 'held') return null
  if (!canPencil(payload?.cleans.find((c) => c.id === rowDrag!.cleanId), rowDrag.date)) return null
  const stops = timedStops(rowDrag.day)
  const spans = stops.flatMap((stop, i) => stop.rows.map((r) => { const b = r.getBoundingClientRect(); return { id: i, top: b.top, bottom: b.bottom } }))
  const index = rowIdAt(spans, rowDrag.lastY)
  return index === null ? null : { stops, index }
}

// Pencilled in and not saved yet (no signal): drawn where it will be, on every read, until its save lands or is refused.
// Read from the phone's own queue, so it is still drawn after the app restarts (Sonnet's review of the build, S-E2,
// 20 Oct 2026). A visit's waiting changes are laid over it in order, their time and time agreed only: a day confirmed
// while the pencil waits keeps its time, an Undo waiting behind it puts the row back (Astra's final review, 4). The same
// for a time chosen on the time sheet, with all it does: the time, its agreement, and Couldn't do it cleared, which its
// Undo puts back (tidy-up 2 item 1; Astra F13, Sonnet F17, Sol R10). A refused one is left out, so the row goes back.
const isPencil = (q: QueuedMutation): boolean => q.method === 'PATCH' && /^\/api\/cleans\/\d+$/.test(q.path) && (q.body as { pencil?: unknown } | null)?.pencil === true
// What the read said about a visit before anything waiting was laid over it, kept with the visit as read: laying them
// again (a change or its Undo queued, one refused) starts from the read, never from an earlier laying (Astra's final
// review, A5, 21 Oct 2026).
type AsRead = Pick<Clean, 'version' | 'confirmed'> & { time_slot: string | null; time_agreed_for: string | null; blocked_reason: Clean['blocked_reason']; blocked_note: string | null; blocked_at: string | null }
const asRead = new WeakMap<Clean, AsRead>()
function applyWaitingTimes(p: SchedulePayload): void {
  const waiting = new Map<string, QueuedMutation[]>()
  for (const q of getQueue()) if (q.method === 'PATCH' && q.status !== 'conflict' && q.status !== 'failed') waiting.set(q.path, [...(waiting.get(q.path) ?? []), q])
  for (const row of p.cleans) {
    const read = asRead.get(row)
    if (read && read.version === row.version) Object.assign(row, read)
    else if (read) asRead.delete(row)
    const list = waiting.get(`/api/cleans/${row.id}`)
    // The first waiting change was made on this copy of the visit; a later version means it has landed, or will clash.
    if (!list?.some((q) => isPencil(q) || timeOnly(q)) || (list[0]!.body as { version?: unknown } | null)?.version !== row.version) continue
    if (!asRead.has(row)) asRead.set(row, { version: row.version, confirmed: row.confirmed, time_slot: row.time_slot ?? null, time_agreed_for: row.time_agreed_for ?? null,
      blocked_reason: row.blocked_reason ?? null, blocked_note: row.blocked_note ?? null, blocked_at: row.blocked_at ?? null })
    const saved = asRead.get(row)!
    for (const q of list) {
      const body = (q.body ?? {}) as { time_slot?: unknown; time_agreed_for?: unknown; confirmed?: unknown; undo_restore?: unknown }
      const timeSent = typeof body.time_slot === 'string' || body.time_slot === null
      if (timeSent) {
        const moved = body.time_slot !== (row.time_slot ?? null)
        row.time_slot = body.time_slot as string | null
        // The server's own rules (functions/lib/cleans.ts): a changed time clears Couldn't do it and an agreed time not
        // named again; an Undo asks for what was cleared back.
        if (body.undo_restore === true && row.time_slot === saved.time_slot) Object.assign(row, { blocked_reason: saved.blocked_reason, blocked_note: saved.blocked_note, blocked_at: saved.blocked_at })
        else if (moved) Object.assign(row, { blocked_reason: null, blocked_note: null, blocked_at: null })
        if (moved && !('time_agreed_for' in body)) row.time_agreed_for = null
      }
      if (body.confirmed === 0 || body.confirmed === 1) row.confirmed = body.confirmed
      if (typeof body.time_agreed_for === 'string' || body.time_agreed_for === null) row.time_agreed_for = body.time_agreed_for
    }
  }
}

// A time change, its Undo or a pencil is drawn the moment it waits on the phone, and taken off the moment it is refused
// (Astra's final review, A5: an Undo with no signal kept showing the change it undid until another redraw). One gone
// from the queue has landed, and the read its answer starts draws it.
let waitingTimesSeen = new Map<string, string>()
onQueueChange(() => {
  const now = new Map(getQueue().filter((q) => isPencil(q) || timeOnly(q)).map((q) => [q.key, q.status] as const))
  const changed = [...now].some(([k, s]) => !waitingTimesSeen.has(k) || (waitingTimesSeen.get(k) !== s && (s === 'conflict' || s === 'failed')))
  waitingTimesSeen = now
  if (!changed) return
  const root = document.querySelector<HTMLElement>('#screen')
  if (!payload || !root?.querySelector('.day-card') || diaryView() !== 'week' || scheduleBusy() || document.querySelector('dialog[open]')) return
  applyWaitingTimes(payload); render(payload, root)
})

// A pencil refused (another phone put a second visit for them on the day, or the visit changed) is nothing to sort out
// on the phone: it comes off the phone's queue, is said, and the row goes back on the next read (Sonnet's review of the
// build, S-E1, 20 Oct 2026). One refused as it is made is said by pencilIn itself.
const pencilsInHand = new Set<string>()
onQueueChange(() => {
  const q = getQueue().find((m) => (m.status === 'conflict' || m.status === 'failed') && isPencil(m) && !pencilsInHand.has(m.key))
  if (!q) return
  const who = q.label.replace(/^Pencil in: /, '').replace(/ at [\d:]+$/, '').trim()
  toast(`${who ? `${who}: ` : ''}${q.error ?? 'That pencilled time did not save.'}`)
  dismiss(q.key) // its own queue change comes back here for the next one
})

function pencilIn(cl: Clean, date: string, slot: PencilSlot, parkingOk = false): void {
  const above = slot.stops.slice(0, slot.index + 1)
  const next = slot.stops[slot.index]!, prev = slot.index > 0 ? slot.stops[slot.index - 1]! : null
  // A time not written as a time at or above the place let go: there is no telling where this one goes (Sonnet's edge
  // cases, 20 Oct 2026).
  if (above.some((stop) => stop.at === null)) { toast('Too close to pencil a time here.'); return }
  const now = date === todayISO() ? strictMinutes(roundClock(new Date())) : null
  const answer = pencilTime(prev ? { at: prev.at!, length: prev.length } : null, { at: next.at! }, cl.duration_minutes ?? null, now)
  if ('refused' in answer) { toast(answer.refused === 'gone' ? 'That time has gone. Set a time by hand.' : 'Too close to pencil a time here.'); return }
  const time = clockOf(answer.minutes)
  // A pencilled time in their parking hours is asked about first (Parking notes, 0084).
  if (!parkingOk && askParking(parkingOf(cl), time, () => pencilIn(cl, date, slot, true), date)) return
  const first = (cl.customer_name ?? '').trim().split(/\s+/)[0] || 'them'
  // The same person's visit it still overlaps, by the lengths known (Sonnet's edge cases).
  const roster = payload?.round_days ?? []
  const whose = (c: Clean): string => visitWorker(c, roster).toLowerCase()
  const clash = (payload?.cleans ?? []).find((c) => {
    if (c.id === cl.id || c.date !== date || c.state !== 'booked' || (whose(c) !== whose(cl) && !worksAlone()) || (!whose(c) && !worksAlone())) return false
    const at = strictMinutes(visibleTime(c)), len = c.duration_minutes ?? null
    return at !== null && !!len && answer.minutes < at + len && at < answer.minutes + Math.max(1, cl.duration_minutes ?? 1)
  })
  const overlap = clash ? ` It overlaps ${(clash.customer_name ?? '').trim().split(/\s+/)[0] || 'another visit'}'s ${shownTime(visibleTime(clash) ?? '')}.` : ''
  const was = { version: cl.version, time_slot: cl.time_slot ?? null, confirmed: cl.confirmed, time_agreed_for: cl.time_agreed_for ?? null }
  const path = `/api/cleans/${cl.id}`
  const earlier = new Set(getQueue().map((q) => q.key))
  let queued = false
  const saving = mutate({
    label: `Pencil in: ${cl.customer_name ?? ''} at ${time}`,
    method: 'PATCH',
    path,
    body: { version: cl.version, time_slot: time, confirmed: cl.confirmed, time_agreed_for: null, pencil: true },
    onAck: () => void load(),
    onQueued: () => { queued = true },
  })
  // The key it is saved under, read off the queue as it is made (as add-details.ts does): a refusal takes it off.
  const key = getQueue().find((q) => !earlier.has(q.key) && q.path === path)?.key ?? null
  if (key) pencilsInHand.add(key)
  // Drawn at once where it goes, with or without signal.
  const here = document.querySelector<HTMLElement>('#screen')
  if (payload && here && diaryView() === 'week') { applyWaitingTimes(payload); render(payload, here) }
  void saving.then((ack) => {
    if (key) pencilsInHand.delete(key)
    if (!ack.ok && ack.status >= 400 && ack.status < 500) {
      if (key) dismiss(key)
      toast(ack.error ?? 'That did not save.')
      void load()
      return
    }
    undoPatch({
      text: `Pencilled ${first} in at ${shownTime(time)}${queued || !ack.ok ? ', waiting for signal' : ''}. Finish my day will ask about them.${overlap}`,
      label: `Undo pencil: ${cl.customer_name ?? ''} ${date}`,
      path: `/api/cleans/${cl.id}`,
      ack,
      version: was.version,
      // undo_restore: the source and door record a time change clears come back too (restoredByUndo).
      body: { time_slot: was.time_slot, confirmed: was.confirmed, time_agreed_for: was.time_agreed_for, undo_restore: true },
      after: () => void load(),
    })
  })
}

// ---- the week tray ----------------------------------------------------------
//
// The spreadsheet recorded a WEEK — "the Smiths are due w/c 22 Sep" — and the
// import had to land each of those on one date, so they arrived wearing a day
// nobody chose. The tray collects them at the top of the week and a move gives
// them a real day. Until then they are out of the day cards, so the day money
// stops counting work that is not actually booked onto that day. The
// source !== 'manual' guard is what lets a moved visit LEAVE: the move stamps
// source='manual' but created_by stays 'importer', so without it the row would
// match the tray forever.

// Moved to planning.isUnplaced, which now covers a SECOND way in: a human
// putting a customer in a week on purpose (source 'week'), not only the
// spreadsheet's own weeks. Everything below reads the one rule.
function isSheetWeek(cl: Clean, from: string, to: string): boolean {
  return isUnplaced(cl, from, to)
}

// One PATCH moves a sheet visit onto a day Liam chose. Only `date` goes on the
// wire: the server itself stamps source='manual' when a booked visit's date
// changes (functions/api/cleans/[id].ts) — that stamp is what takes the visit
// out of the tray. `adopt_booking` covers dropping a visit back onto the day
// it already carries, where nothing "moves" but the row must still become a
// human booking. It stays UNCONFIRMED either way: nobody has asked the
// customer yet, and the badge keeps saying so.
// A visit just moved: which one, and the day it should land on.
let landing: { id: number; date: string; at: number; reverse?: boolean; move?: DiaryMoveEffect } | null = null

// Called at the end of every diary draw: once the moved visit is drawn on its
// new day, it glows there once.
function playLanding(root: HTMLElement): void {
  const l = landing
  if (!l) return
  if (Date.now() - l.at > 8000) {
    landing = null
    return
  }
  if (payload?.cleans.find((c) => c.id === l.id)?.date !== l.date) return
  landing = null
  const row = root.querySelector<HTMLElement>(`.day-card .clean-row[data-clean-id="${l.id}"]`)
  if (phoneWeekActive()) { const tile = root.querySelector<HTMLElement>(`.diary-week-strip [data-date="${l.date}"]`); if (tile && !reducedMotionHere()) { tile.classList.add('rd-land'); window.setTimeout(() => tile.classList.remove('rd-land'), 600) } }
  if (l.move) diaryMoveSettle(root,l.move)
  else if (row) diaryFeedback(row, l.reverse)
}

// Moves on their way to the server, by visit (29 Sep, reviewed with Astra: docs/plans/instant-move). While one is,
// its new day shows "Moving Joel here…" (not a visit: no buttons, not counted, never saved on the phone), and the
// same visit cannot be moved again until the first move has an answer.
const movesInFlight = new Map<number, { date: string; name: string }>()
// Moves the server has said yes to and no later read has confirmed yet, with the read number at the time: laid over
// the phone's saved copy of the week if a later read fails, unless that copy already holds a newer version of the
// visit, so a saved move never appears to undo itself (P7).
const recentMoves = new Map<number, { row: Partial<Clean> & { id: number }; seq: number }>()

function drawMovingLines(root: HTMLElement): void {
  for (const [id, m] of movesInFlight) {
    const card = root.querySelector<HTMLElement>(`.day-card[data-date="${m.date}"]`)
    if (!card || card.querySelector(`.moving-line[data-clean-id="${id}"]`)) continue
    const line = el('p', { class: 'moving-line', role: 'status', 'data-clean-id': String(id) }, `Moving ${m.name} here…`)
    // Under the day's heading (and its Move here button, when one is showing).
    const after = card.querySelector(':scope > .move-here') ?? card.querySelector(':scope > .day-head')
    if (after) after.after(line)
    else card.prepend(line)
    if (phoneWeekActive()) {
      const strip = root.querySelector<HTMLElement>(`.diary-week-strip [data-date="${m.date}"]`)
      if (strip) strip.setAttribute('aria-busy', 'true')
      const receipt = el('p', {class:'moving-line diary-week-moving', role:'status', 'data-clean-id':String(id)}, `Moving ${m.name} to ${dayLabel(m.date)}…`)
      root.querySelector('.diary-week-strip')?.after(receipt)
    }
  }
}

// The server's row for a saved move, put into the diary's copy of the week as a NEW object (the old one is also the
// visit the Undo remembers): its fields over the joined customer fields the save does not return (P8). Only for a
// visit already in this week's days or panel; the caller falls back to reading the week for anything else.
function applySavedMove(p: SchedulePayload, row: Partial<Clean> & { id: number }): boolean {
  const i = p.cleans.findIndex((c) => c.id === row.id)
  if (i < 0) return false
  const merged = { ...p.cleans[i], ...row } as Clean
  // Put on its day now (the save's answer does not carry it): its words read so until the diary is read again.
  if (row.date && row.date !== p.cleans[i]!.date) merged.dated_on = new Date().toISOString().slice(0, 10)
  if (merged.date >= p.from && merged.date <= p.to) p.cleans[i] = merged
  else p.cleans.splice(i, 1)
  return true
}

// Several jobs: a gutters visit moved to a day up to a fortnight after the house's windows visit is refused (Liam
// Q11: on the windows day or the day before, never after). The windows day is named so the owner can use it.
function guttersAfterWindowsOn(cl: Clean, date: string): string | null {
  if (!severalJobsOn() || cl.kind !== 'gutter' || cl.state !== 'booked') return null
  const others = (payload?.cleans ?? []).filter((o) => o.customer_id === cl.customer_id && o.id !== cl.id && visitJobId(o) !== visitJobId(cl))
  const windowsNext = customers?.find((x) => x.id === cl.customer_id && !x.job_stopped_on)?.next_booked
  const visits = [...others, ...(windowsNext ? [{ state: 'booked' as const, date: windowsNext, deleted_at: null, job_id: null }] : [])]
  return windowsDayBefore(date, visits, todayISO())
}

// A day that has gone takes no visit, as in Month: a visit put there is missed the moment it lands, and someone placed
// from To place would be asked about that day (bug hunt, 8 Oct 2026). Every way of placing or moving asks this.
function goneDay(date: string): boolean {
  if (date >= todayISO()) return false
  toast(GONE_DAY_WORDS)
  return true
}

// A visit asked about its day, with no reply, put on another day: did they agree it? Yes moves it there agreed in one
// save (they-replied.ts); No moves it as moveToDay does and they are asked. Only from a day to a day still to come, New
// layout, never a placement from Due (which asks about the new day itself). True when the question took over.
function askedFirstOnMove(cl: Clean, date: string, after?: unknown, stay = false): boolean {
  // Not a visit held in a week with no day chosen: its date is a placeholder nobody was asked about.
  if (after || cl.state !== 'booked' || date === cl.date || date < todayISO() || isContact(cl) || isUnplaced(cl, cl.date, cl.date) || visitNextStep(cl) !== 'replied' || guttersAfterWindowsOn(cl, date)) return false
  // No: moved, and their message for the new day opens straight away, as a placement from Due does; Cancel there puts it
  // back (Astra, 12 Oct 2026: moved and not asked, the same day's earlier message read as if it were about the new day).
  askAgreedFirst(cl, date, (agreed) => {
    // Staying on the day the job left (the Move pop-up): Yes moves it without taking the Diary with it (Astra).
    if (agreed) agreeOnDay(cl, date, true, stay ? { ...repliedOptions(cl), follow: undefined } : repliedOptions(cl))
    else moveToDay(cl, date, (visit, takeOff, placement) => askAfterPlacing({ id: cl.customer_id, name: cl.customer_name ?? 'them' }, date, visit.id, takeOff, cl.date, placement), true, false, stay)
  })
  return true
}

const reducedMotionHere = (): boolean => typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches
// The new day in the date strip lifts once, so the eye follows where the job went.
function bumpStripDay(date: string): void {
  if (reducedMotionHere()) return
  const day = document.querySelector<HTMLElement>(`.diary-week-strip [data-date="${date}"], .diary-strip [data-date="${date}"]`)
  if (!day) return
  day.classList.remove('strip-bump'); void day.offsetWidth; day.classList.add('strip-bump')
  setTimeout(() => day.classList.remove('strip-bump'), 700)
}

// A drawn chevron: a typed "›" sits off the middle of the words (Liam, 22 Oct 2026: "arrows arent vertically aligned").
function chevronIcon(className: string): SVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('class', className); svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true')
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  path.setAttribute('d', 'm9 6 6 6-6 6')
  svg.append(path)
  return svg
}

// The phone's Move button: a booked job not started, not a reminder, on the owner's Diary (workers never reach it).
function mayMoveHere(cl: Clean): boolean {
  // Not one the customer cancelled (moving it would book them again) or the rest of a part done (GPT-6.1).
  return cl.state === 'booked' && !cl.started_at && !isContact(cl) && getMe()?.role === 'owner' && cl.blocked_reason !== 'customer_cancelled' && !cl.rest_of
}

// The six days, each with how many visits it has and whether anyone works it, where this week's read knows.
function moveSheetDays(cl: Clean): MoveDay[] {
  const p = payload
  // Always six days: a job booked later this week leaves out its own day and takes the next one instead.
  const near = moveDays(cl.date)
  return [...near, addDaysISO(near[near.length - 1], 1)].filter((d) => d !== cl.date).slice(0, 6).map((date) => {
    const known = !!p && date >= p.from && date <= p.to
    const count = known ? p!.cleans.filter((c) => c.date === date && c.state !== 'cancelled').length : null
    const roster = p?.round_days ?? []
    const off = known && roster.length > 0 && !roster.find((r) => r.date === date)?.worker?.trim()
    return { date, count, off }
  })
}

function openMoveFor(cl: Clean): void {
  const first = (cl.customer_name ?? '').trim().split(/\s+/)[0] || 'them'
  const street = splitAccessWarning(cl.customer_address ?? '').addr.split(',')[0]?.trim()
  openMoveSheet({
    first,
    sub: [shownVisitTime(cl), street].filter(Boolean).join(' · '),
    days: moveSheetDays(cl),
    note: shownVisitTime(cl) ? `Keeps the time, ${shownVisitTime(cl)}.` : 'No set time, as now.',
    nextWeek: addDaysISO(cl.date, 7),
    pick: (date) => moveToDay(cl, date, undefined, false, false, true),
  })
}

// The visit card (design Q, Liam 3-4 Nov 2026: "I feel if we click on a customer instead of going to day view it should
// slide up", then H, "day and time on one line", "agreed", "time pencilled too", "I like Q ship it";
// https://claude.ai/artifact/8KcfKL4XSgcFedHao1RJvA). A tap on a name in the phone's week slides it up from the bottom; a
// click on a strip in the computer's week opens it beside the week, as Book a visit does, and the week stays usable (a
// click on another strip swaps it). Name and job; one line with the day (tap to move) and the time (tap to change),
// green when agreed, dotted when only pencilled or offered, faded "No time" with none; "Agreed" at the end while
// anything is open (markAgreed); then Add a note, Message, Call, More (Directions, Parking, their page, the day).
let visitCardOpen: HTMLDialogElement | null = null
// Leaving the Diary (or its week) shuts the card, so the computer's page never stays narrowed on another screen.
if (typeof window !== 'undefined') window.addEventListener('hashchange', () => { if (visitCardOpen) closeVisitCard() })
const visitCardKeys = (e: KeyboardEvent): void => { if (e.key === 'Escape' && visitCardOpen) { e.preventDefault(); closeVisitCard() } }
function closeVisitCard(): void {
  document.removeEventListener('keydown', visitCardKeys)
  const d = visitCardOpen; visitCardOpen = null
  document.body.classList.remove('visit-side-open')
  for (const s of document.querySelectorAll('.is-card-open')) s.classList.remove('is-card-open')
  if (d?.open) d.close()
  d?.remove()
}
function openVisitCard(cl: Clean, from?: HTMLElement): void {
  // The card beside the week never blocks the week (another click swaps it), so it goes first.
  closeVisitCard()
  if (!diaryNavigationReady()) return
  const side = diaryDesk()
  const name = cl.customer_name ?? 'Visit'
  const first = name.trim().split(/\s+/)[0] || 'them'
  const future = cl.date > todayISO()
  const toCheck = confirmNeed(cl, visitCustomer(cl)) === 'check'
  const time = visibleTime(cl)
  const timeKey = agreedTimeKey(cl.date, time)
  const may = future && cl.state === 'booked' && !isContact(cl) && !isSuggestion(cl) && !toCheck
  const dayOpen = may && !cl.confirmed
  const timeOpen = may && !!timeKey && !timeIsAgreed(cl)
  const dayOk = cl.state === 'booked' && !!cl.confirmed
  const timeOk = !!time && dayOk && timeIsAgreed(cl)
  const dialog = el('dialog', {class:`visit-card${side ? ' visit-card-side' : ''}`, 'aria-label':`${name}, ${dayLabel(cl.date)}`}) as HTMLDialogElement
  const after = (): void => { closeVisitCard(); void load() }
  const x = el('button', {type:'button', class:'visit-card-close', 'aria-label':'Close'}, lineDrawing('cross', 18))
  x.addEventListener('click', () => closeVisitCard())
  // The price is the visit's own price button (Liam, 4 Nov 2026: "price cant be easily edited"): tap it for the price
  // sheet, the same one as Day's; the card steps aside first so the sheet is on top. A visit with no price says Add price.
  const sub = el('span', {class:'visit-card-sub'}, el('span', {}, visitJobLabel(cl)))
  if (!pricesHidden() && cl.amount_pence !== undefined && cl.state !== 'cancelled' && !isContact(cl)) {
    const price = priceButton(cl, {className:'visit-card-price', after:() => window.dispatchEvent(new CustomEvent('dropby:data-changed'))})
    price.addEventListener('click', () => closeVisitCard(), true)
    sub.append(price)
  }
  const head = el('div', {class:'visit-card-head'},
    el('div', {class:'visit-card-who'}, el('a', {href:`#/customer/${cl.customer_id}`, class:'visit-card-name', title:name}, name), sub), x)
  // The day: tap to move (the Diary's own six-day sheet), dotted until agreed.
  const dayBtn = el('button', {type:'button', class:`visit-card-seg is-day ${dayOk ? 'is-agreed' : 'is-pencilled'}`, 'aria-label':`${dayLabel(cl.date)}, ${dayOk ? 'day agreed' : 'not agreed yet'}. Move to another day`},
    lineDrawing('calendar', 17), el('span', {}, `${new Date(`${cl.date}T12:00:00`).toLocaleDateString('en-GB', {weekday:'short'})} ${Number(cl.date.slice(8))}${dayOk ? '' : '?'}`), el('span', {class:'visit-card-pen', 'aria-hidden':'true'}, lineDrawing('pencil', 12)))
  if (mayMoveHere(cl)) dayBtn.addEventListener('click', () => { closeVisitCard(); openMoveFor(cl) })
  else dayBtn.setAttribute('disabled', '')
  // The time: tap to change (the time sheet), dotted when offered and not agreed, faded "No time" with none.
  const timeBtn = el('button', {type:'button', class:`visit-card-seg is-time ${time ? (timeOk ? 'is-agreed' : 'is-pencilled') : 'is-none'}`, 'aria-label':time ? `${shownVisitTime(cl)}, ${timeOk ? 'time agreed' : 'not agreed yet'}. Change the time` : 'No time. Set a time'},
    lineDrawing('time', 17), el('span', {}, time ? (shownVisitTime(cl) ?? time) : 'No time'), ...(time ? [el('span', {class:'visit-card-pen', 'aria-hidden':'true'}, lineDrawing('pencil', 12))] : []))
  if (timeEditable(cl)) timeBtn.addEventListener('click', () => { const anchor = from ?? timeBtn; closeVisitCard(); openTimePicker(cl, anchor) })
  else timeBtn.setAttribute('disabled', '')
  const line = el('div', {class:'visit-card-line'}, dayBtn, timeBtn)
  if (dayOpen || timeOpen) {
    const agree = el('button', {type:'button', class:'visit-card-agree', 'aria-label':`Agreed: ${first} said yes to ${[dayOpen ? dayLabel(cl.date) : '', timeOpen ? shownVisitTime(cl) : ''].filter(Boolean).join(' at ')}`}, lineDrawing('tick', 16), el('span', {}, 'Agreed'))
    agree.addEventListener('click', () => markAgreed(cl, agree, after))
    line.append(agree)
  }
  const help = el('p', {class:'visit-card-help'}, dayOpen || timeOpen ? `Tap the day to move ${first}, the time to change it. Agreed when ${first} says yes.` : `Tap the day to move ${first}, the time to change it.`)
  const square = (drawing: Drawing, words: string, act: (() => void) | null, href?: string): HTMLElement => {
    const b = href ? el('a', {class:'visit-card-tile', href}, el('span', {class:'visit-card-ring', 'aria-hidden':'true'}, lineDrawing(drawing, 22)), el('span', {}, words))
      : el('button', {type:'button', class:'visit-card-tile'}, el('span', {class:'visit-card-ring', 'aria-hidden':'true'}, lineDrawing(drawing, 22)), el('span', {}, words))
    if (act) b.addEventListener('click', act)
    else if (!href) b.setAttribute('disabled', '')
    return b
  }
  const note = square('note', 'Add a note', cl.state === 'cancelled' || isContact(cl) ? null : () => {
    closeVisitCard()
    void import('../diary-note').then(({ openVisitNote }) => openVisitNote({ id: cl.id, version: cl.version, customer_id: cl.customer_id, customer_name: name, state: cl.state, note: cl.note ?? null, date: cl.date }, () => void load()))
  })
  const message = square('bubble', 'Message', noMessages(cl) ? null : () => { closeVisitCard(); openMessagesFor({ id: cl.customer_id, name }, 'customer', { jobId: cl.job_id ?? null }) })
  const phone = visitReach(cl).phone?.trim()
  const call = phone ? square('phone', 'Call', null, `tel:${phone.replace(/[^\d+]/g, '')}`) : square('phone', 'Call', null)
  const moreList = el('div', {class:'visit-card-more', hidden:''})
  const more = square('dots', 'More', () => { const shut = !moreList.hidden; moreList.hidden = shut; more.setAttribute('aria-expanded', String(!shut)) })
  more.setAttribute('aria-expanded', 'false')
  const goTo = directionsHref(cl.customer_maps_link, addressLine(splitAccessWarning(cl.customer_address ?? '').addr, cl.customer_postcode ?? null, ', '))
  if (goTo) moreList.append(el('a', {href:goTo, target:'_blank', rel:'noopener', class:'visit-card-more-row'}, lineDrawing('navigate', 18), 'Directions'))
  if (!isContact(cl) && cl.state !== 'cancelled') {
    const parking = el('button', {type:'button', class:'visit-card-more-row'}, lineDrawing('car', 18), 'Parking')
    parking.addEventListener('click', () => { closeVisitCard(); openParkingFromDiary(cl) })
    moreList.append(parking)
  }
  moreList.append(el('a', {href:`#/customer/${cl.customer_id}`, class:'visit-card-more-row'}, lineDrawing('person', 18), `${first}'s page`))
  const openDay = el('button', {type:'button', class:'visit-card-more-row'}, lineDrawing('calendar', 18), `Open ${dayLabel(cl.date)}`)
  openDay.addEventListener('click', () => {
    closeVisitCard()
    const root = document.querySelector<HTMLElement>('#screen')
    selectedDate = cl.date; setWeekMode('day'); if (payload && root) render(payload, root)
  })
  moreList.append(openDay)
  const tiles = el('div', {class:'visit-card-tiles'}, note, message, call, more)
  dialog.append(el('div', {class:'visit-card-grab', 'aria-hidden':'true'}), head, line, help, tiles, moreList)
  // Swipe down on the phone's sheet closes it.
  if (!side) {
    let y0 = 0
    dialog.addEventListener('touchstart', e => { y0 = e.touches[0]?.clientY ?? 0 }, {passive:true})
    dialog.addEventListener('touchend', e => { const y = e.changedTouches[0]?.clientY ?? 0; if (y - y0 > 80 && dialog.scrollTop <= 0) closeVisitCard() }, {passive:true})
    dialog.addEventListener('click', e => { if (e.target === dialog) closeVisitCard() })
  }
  dialog.addEventListener('cancel', e => { e.preventDefault(); closeVisitCard() })
  dialog.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); closeVisitCard() } })
  document.body.append(dialog)
  visitCardOpen = dialog
  from?.classList.add('is-card-open')
  if (side) { document.body.classList.add('visit-side-open'); dialog.show(); document.addEventListener('keydown', visitCardKeys) } else dialog.showModal()
  x.focus({preventScroll:true})
}

// The visit's customer as the parking question reads them (parking-ask.ts).
function openParkingFromDiary(cl: Clean): void {
  void import('../parking-sheet').then(({ openParkingFor }) => openParkingFor({ id: cl.id, version: cl.version, customer_id: cl.customer_id, customer_name: cl.customer_name ?? 'them',
    parking: cl.customer_parking ?? null, customer_version: cl.customer_version ?? null }, false, () => void load()))
}
const parkingOf = (cl: Clean): ParkingCustomer => ({ customer_name: cl.customer_name ?? null, parking: cl.customer_parking ?? null, duration_minutes: cl.duration_minutes ?? null })

// stay: the phone's Move button (docs/plans/diary-tidy/PLAN.md v2, Astra): the Diary stays on the day being worked, so the
// next job can be moved too; "View" beside Undo goes to the new day.
function moveToDay(cl: Clean, date: string, after?: (visit: { id: number }, takeOff: () => void, placement: Placement) => void, answered = false, parkingOk = false, stay = false): void {
  // One move per visit at a time: a second one waits for the first's answer (P9).
  if (movesInFlight.has(cl.id)) { toast(`Still moving ${cl.customer_name ?? 'that visit'}. One moment.`); return }
  // A timed visit moved to another day keeps its time: in their parking hours, asked first (Parking notes, 0084; the
  // reviews: day moves keep the time, so they are asked about too).
  if (!parkingOk && date !== cl.date && askParking(parkingOf(cl), visibleTime(cl), () => moveToDay(cl, date, after, answered, true, stay), date)) return
  if (!answered && askedFirstOnMove(cl, date, after, stay)) return
  // A day that has gone (goneDay, written out: the move checks lift this function on its own).
  if (date < todayISO()) { toast(GONE_DAY_WORDS); return }
  const windowsDay = guttersAfterWindowsOn(cl, date)
  if (windowsDay) { window.alert(`The windows are booked ${dayLabel(windowsDay)}. Gutters go on the windows day or the day before, never after. Move the gutters to ${dayLabel(windowsDay)} or earlier.`); return }
  movingId = null
  // A due-group placement can reach the move path too (a missed visit moves
  // rather than creates): without this the tray selection survived the move
  // and every day kept offering "Book on this day" afterwards.
  movingDueId = null
  // What the Undo puts back, taken before anything changes (Codex, 29 Sep: the instant draw used to overwrite it).
  const was = { date: cl.date, version: cl.version, confirmed: cl.confirmed, timeAgreed: timeIsAgreed(cl) ? cl.time_agreed_for : null, weekOnly: isUnplaced(cl, cl.date, cl.date) }
  // A visit that couldn't be done (today or a day gone), moved: its message is the missed one ("Sorry, we ran out of time
  // today. Could we come on Friday instead?"), taken before the move clears Couldn't do it (docs/plans/rearrange/PLAN.md).
  const missed = missedOf(cl)
  const selectedBefore = selectedDate
  const gen = routeGen, who = diaryPreferenceKey('move')
  const current = (): boolean => routeGen === gen && diaryView() === 'week' && who === diaryPreferenceKey('move')
  // Still in the Diary, Month included: their message and the Undo belong to it (round 3 review: a drop in Month moved
  // the visit with no message and no Undo). current() stays for what only the week draws.
  const sameScreen = (): boolean => routeGen === gen && who === diaryPreferenceKey('move')
  const effect = diaryMoveCapture(cl.date,date,cl.id)
  let reverse: DiaryMoveEffect | undefined
  let undoFrom = ''
  // The row lands on its new day with a short lemon glow when it is drawn again (Liam, 2026-09-24); the redraw waits a
  // turn, as it did behind the slide off the old day. Meanwhile the new day says "Moving … here…".
  // Moved from the phone's Move (stay): the job slides up and away first, and its new day in the strip lifts once it is
  // drawn again (Liam, 22 Oct 2026: "Any brand animation or satisfying animations we can add"; none with reduced motion).
  const leaving = stay && !reducedMotionHere() ? document.querySelector<HTMLElement>(`.clean-row[data-clean-id="${cl.id}"]`) : null
  leaving?.classList.add('diary-row-leaving')
  const gone = leaving ? new Promise<void>((r) => setTimeout(r, 260)) : Promise.resolve()
  const onScreen = date >= fromDate && date <= addDaysISO(fromDate, WINDOW_DAYS - 1)
  // Drawn straight from the server's answer only when nothing else on the diary depends on it: a visit already in
  // this week, moving to a day not in the past (a missed visit, or one moved into the past, changes the due and
  // review lists, which only a fresh read of the week gets right; Codex).
  const instant = onScreen && date >= todayISO() && !!payload?.cleans.some((c) => c.id === cl.id) && !(payload?.overdue ?? []).some((c) => c.id === cl.id)
  movesInFlight.set(cl.id, { date, name: cl.customer_name ?? 'the visit' })
  if (cl.date !== date) forgetQueued(cl.id)
  const root = document.querySelector<HTMLElement>('#screen')
  if (root) drawMovingLines(root)
  const finish = (): void => {
    movesInFlight.delete(cl.id)
    for (const l of document.querySelectorAll(`.moving-line[data-clean-id="${cl.id}"]`)) l.remove()
  }
  void mutate({
    label: `Move: ${cl.customer_name ?? ''} to ${dayLabel(date)}`,
    method: 'PATCH',
    path: `/api/cleans/${cl.id}`,
    body: { version: was.version, date, adopt_booking: true },
    onAck: ack => {
      // Offline saves acknowledge later through the shared queue. Follow this
      // result only while the person is still looking at the same day.
      if (!stay && current() && ack.ok && !ack.noop && selectedDate === selectedBefore) selectedDate = (ack.row as Partial<Clean> | undefined)?.date ?? date
    },
  }).then((ack) => {
    // Left the diary while it was saving: the screen now showing is told to refresh; nothing of the diary is drawn
    // into it (Codex).
    const stillHere = current()
    const here = document.querySelector<HTMLElement>('#screen')
    if (ack.ok) {
      const row = ack.row as (Partial<Clean> & { id: number }) | undefined
      if (!stay && stillHere && !ack.noop && selectedDate === selectedBefore) selectedDate = row?.date ?? date
      if (stillHere && !ack.noop) landing = { id: cl.id, date: row?.date ?? date, at: Date.now(), move:effect }
      if (!stillHere) { finish(); window.dispatchEvent(new CustomEvent('dropby:data-changed')) }
      else if (!instant || !row || !payload) {
        // A day in another week goes to that week; a missed visit waits for the fresh read. The line stays until then.
        if (!onScreen && !stay) fromDate = defaultFrom(date)
        void load().finally(finish)
      } else {
        finish()
        // Drawn at once from the server's answer; any read started before the save is set aside (P7), and the week is
        // read again behind it.
        requestSequence++
        recentMoves.set(cl.id, { row, seq: requestSequence })
        applySavedMove(payload, row)
        void gone.then(() => {
          if (!current()) return
          if (payload && here && !editing && here.isConnected) { render(payload, here); playLanding(here); if (stay) bumpStripDay(date) }
          void load()
        })
      }
    } else {
      finish()
      landing = null
      if (ack.status >= 400 && ack.status < 500 && ack.status !== 409) {
        alert4xx(ack)
        if (stillHere) void load()
      } else if (stillHere) {
        // Waiting for signal, held, or changed by someone else: the visit is drawn again where Roundly has it, and
        // the saving note at the bottom says what is happening (P9).
        void gone.then(() => {
          if (!current()) return
          if (payload && here && !editing && here.isConnected) render(payload, here)
          if (ack.status === 409) void load()
        })
      }
    }
    // Undo restores the original arrangement. A week-only visit returns to
    // its tray using the existing week_only contract, never a false Monday.
    if (!sameScreen() || ack.noop) return
    // Placed from To place (Design B): their message next; its Cancel puts the visit back as this Undo does.
    if (ack.ok && after) {
      const saved = (ack.row as { version?: number } | undefined)?.version ?? was.version + 1
      const before = { date: was.date, confirmed: was.confirmed, time_agreed_for: was.timeAgreed, ...(was.weekOnly ? { week_only: true } : {}) }
      after(cl, () => void mutate({ label: `Undo move: ${cl.customer_name ?? ''} back to ${dayLabel(was.date)}`, method: 'PATCH', path: `/api/cleans/${cl.id}`,
        body: { version: saved, ...before, undo_restore: true },
        onAck: () => void load(), onConflict: () => void load() }), { kind: 'move', id: cl.id, version: saved, before })
    }
    // Asked about the old day and not agreed: the message has gone and cannot be unsent, so they are told it moved too
    // (round 4 of docs/plans/diary-due/PLAN.md: "a sent message cannot be unsent").
    const askedAbout = !was.confirmed && !was.weekOnly && cl.source !== 'tentative' && cl.source !== 'suggested'
      && messagesThisCycle({ rebook_messages: cl.customer_rebook_messages, rebook_messaged_on: cl.customer_rebook_messaged_on, last_clean: cl.customer_last_clean }) > 0
    const tell = ack.ok && was.date !== date && (was.confirmed || askedAbout)
    const savedVersion = (ack.row as { version?: number } | undefined)?.version ?? was.version + 1
    const missedLink = ack.ok && missed && was.date !== date && !after ? missedMessageLink(cl, date, missed, savedVersion, { date: was.date, confirmed: was.confirmed, time_agreed_for: was.timeAgreed }) : null
    undoPatch({
      // Onto a day set to someone, the visit became theirs (the server, 27 Oct 2026): said here, and Undo gives the name back.
      text: ack.ok ? `Moved ${cl.customer_name ?? 'visit'} to ${dayLabel(date)}${nowWhose(cl, ack.row)}${was.confirmed && was.date !== date ? ' · New date needs agreement' : askedAbout && was.date !== date ? ` · They were asked about ${dayLabel(was.date)}` : ''}` : 'Move not confirmed · Check save status',
      // Release 2 (JOINT-PLAN 4c): an agreed visit moved needs telling. Messages opens their card in "Visit moved, tell
      // them" with the visit moved message ready (it reads the move from the saved record).
      ...(missedLink ? { link: missedLink } : tell ? { link: messageThemLink(cl) } : stay && ack.ok && was.date !== date ? { link: { label: 'View', act: () => { selectedDate = date; if (date < fromDate || date > addDaysISO(fromDate, WINDOW_DAYS - 1)) fromDate = defaultFrom(date); void load() } } } : {}),
      label: `Undo move: ${cl.customer_name ?? ''} back to ${dayLabel(was.date)}`,
      path: `/api/cleans/${cl.id}`,
      ack,
      version: was.version,
      // undo_restore: the door record and review mark the move cleared come back too (server reads them from its record).
      body: { date: was.date, confirmed: was.confirmed, time_agreed_for: was.timeAgreed, ...(was.weekOnly ? { week_only: true } : {}), undo_restore: true },
      before: () => { landing = null; undoFrom = selectedDate; if (current()) reverse = diaryMoveCapture(date,was.date,cl.id) },
      // Like the move itself, Undo follows the visit back only while the same day is still chosen.
      // A move into another week took the diary there (a Sunday visit moved to Monday), so Undo brings it back too.
      // The Move pop-up kept you on your day (stay), so its Undo does too: a missed visit moved from today goes back to
      // last week without taking the Diary there (pretend-day check, 23 Oct 2026).
      onAck: back => { if (back.ok && !back.noop && current() && selectedDate === undoFrom && (!stay || selectedDate === was.date)) { selectedDate = was.date; if (was.date < fromDate || was.date > addDaysISO(fromDate, WINDOW_DAYS - 1)) fromDate = defaultFrom(was.date); landing = {id:cl.id,date:was.date,at:Date.now(),reverse:true,move:reverse} } },
      after: () => { if (current()) void load(); else window.dispatchEvent(new CustomEvent('dropby:data-changed')) },
    })
  })
}

// The answer the review box is waiting for: "this one didn't happen, rebook
// them". One save on the visit itself (reviewed_on, migration 0016) and it
// leaves the box for good — no date changes, nothing is booked and nothing is
// cancelled, because the customer is already in Due this week and that is
// where the new day gets chosen. The gesture is the drag Liam asked for
// (review row onto the Due this week list) and the button is the same save
// for a phone, which has no drag. Undo puts the mark back to whatever it was.
function markReviewed(cl: Clean, why?: { blocked_reason: string; blocked_note: string | null }): void {
  const who = cl.customer_name ?? 'visit'
  void mutate({
    label: `Reviewed: ${who}, ${dayLabel(cl.date)} didn't happen`,
    method: 'PATCH',
    path: `/api/cleans/${cl.id}`,
    // Not done's picked reason (Couldn't do it) saved in the same change.
    body: { version: cl.version, reviewed_on: todayISO(), ...why },
    onAck: (ack) => {
      alert4xx(ack)
      void load()
      undoPatch({
        // They wait in To place (bug hunt, 8 Oct 2026).
        text: `${who}: back in To place to rebook`,
        label: `Undo reviewed: ${who} back in Past bookings`,
        path: `/api/cleans/${cl.id}`,
        ack,
        version: cl.version,
        body: { reviewed_on: cl.reviewed_on ?? null, ...(why ? { blocked_reason: null } : {}) },
        after: () => void load(),
      })
    },
    onConflict: () => void load(),
  })
}

// One review-box row: the visit as the day cards draw it, plus the one action
// the box exists to collect, and draggable onto the Due this week list.
//
// `canMove` is false for the few customers that list will not take — nobody
// on pause, nobody without a cycle to be due on, anyone already sitting in
// the sheet tray or told "ask again" on a later date. For them the move would
// empty the box and put them nowhere, which is the one thing worse than the
// box nagging: their visit would be in no list at all. They keep every other
// answer (Done, Cancel, move on, reschedule) and stay in the box until one of
// those is given.
// "Nobody replied, move on": a passed day nobody answered about, taken off the day (see renderClean), from the visit's
// details and from its Past visits to review card (tidy-up item 1, Liam, 20 Oct 2026). Null where it is not offered.
function nobodyRepliedButton(cl: Clean): HTMLElement | null {
  if (!(cl.date < todayISO() && !cl.confirmed && !cl.blocked_reason && !isContact(cl) && !isSuggestion(cl))) return null
  const moveOn = el('button', { class: 'diary-secondary-action' }, 'Nobody replied, move on')
  moveOn.addEventListener('click', async () => {
    if (!window.confirm(`Nobody replied about the ${dayLabel(cl.date)} visit for ${cl.customer_name}. Take it off the day? They stay due, so they will come back in next week's list.`)) return
    moveOn.disabled = true
    const ack = await mutate({ label: `Move on: ${cl.customer_name}`, method: 'DELETE', path: `/api/cleans/${cl.id}`, body: { version: cl.version }, onAck: dataChanged, onConflict: dataChanged })
    if (!ack.ok && ack.status >= 400 && ack.status < 500) { moveOn.disabled = false; alert4xx(ack) }
    // The way back is a create, and only once the delete actually landed:
    // a re-create offered while the delete is still queued could land
    // first and be deleted by it.
    if (ack.ok) {
      offerUndo(`Took the ${dayLabel(cl.date)} visit for ${cl.customer_name ?? 'them'} off the day`, () => {
        void mutate({
          label: `Undo move on: ${cl.customer_name ?? 'visit'} back on ${dayLabel(cl.date)}`,
          method: 'POST',
          path: `/api/customers/${cl.customer_id}/cleans`,
          // Several jobs on: put back as the same job and kind (PLAN 4), so a gutters visit comes back gutters.
          // ...with its insides and extras inside the price, as it was (0087; Sonnet's extras review 7).
          body: { date: cl.date, ...(cl.amount_pence !== null ? { amount_pence: cl.amount_pence } : {}), ...(cl.inside_pence ? { inside_pence: cl.inside_pence } : {}), ...(cl.extras_json ? { extras_json: cl.extras_json } : {}), state: 'booked', allow_additional: false,
            ...(severalJobsOn() ? { kind: cl.kind, ...(visitJobId(cl) !== null ? { job_id: visitJobId(cl) } : {}) } : {}) },
          onAck: () => void load(),
          onConflict: () => void load(),
        })
      })
    }
  })
  return moveOn
}

// Past visits to review, one card per visit (tidy-up item 1; Liam, 20 Oct 2026: "this section here is not good"): the
// name and the price on one line (the price button, outside and inside prices as everywhere), where and which job,
// then what happened in plain words in place of the words for a visit still to come ("Tue 13 Oct: booked, not marked
// done"), and Done and Not done the same size side by side. The same saves as before: Done is "How was it paid?", Not
// done asks what next, and the customer page's #/schedule?notdone=<id> opens it here (askNotDone).
function reviewCard(cl: Clean, canMove: boolean): HTMLElement {
  const who = cl.customer_name ?? 'this visit'
  const card = el('div', { class: 'clean-row review-row review-card', 'data-clean-id': String(cl.id) })
  const name = el('a', { class: 'review-card-name', href: `#/customer/${cl.customer_id}` }, cl.customer_name ?? 'Visit')
  const price = cl.amount_pence !== undefined
    ? priceButton(cl, { className: 'diary-price', after: () => window.dispatchEvent(new CustomEvent('dropby:data-changed')) })
    : el('span', { class: 'diary-price' }, 'No price')
  // A one-person round names nobody but someone else (Liam, 19 Oct 2026).
  const where = [splitAccessWarning(cl.customer_address ?? '').addr.split(',')[0]?.trim(), severalJobsOn() ? visitJobLabel(cl) : '', worksAlone() ? otherName(cl.worker) : cl.worker?.trim()].filter(Boolean).join(' · ')
  const time = visibleTime(cl)
  const said = `${dayLabel(cl.date)}${time ? `, ${shownTime(time)}` : ''}: ${cl.confirmed ? 'agreed' : 'booked'}, not marked done`
  card.append(el('div', { class: 'review-card-top' }, name, price))
  if (where) card.append(el('p', { class: 'review-card-where' }, where))
  card.append(el('p', { class: 'review-card-said' }, said))
  // The house's access warning and a door record ("Couldn't do it") say so too, and the visit's note, as the row did.
  const door = [splitAccessWarning(cl.customer_address ?? '').warn, cl.blocked_reason ? blockedBadgeText(cl) : '', blockedNoteText(cl.blocked_reason, cl.blocked_note)].filter(Boolean).join(' · ')
  if (door) card.append(el('p', { class: 'review-card-door' }, door))
  if (cl.note) card.append(el('p', { class: 'review-card-note diary-row-note' }, cl.note.split('\n').map(noteText).join('\n')))
  const done = el('button', { type: 'button', class: 'btn-primary review-card-act' }, 'Done') as HTMLButtonElement
  done.addEventListener('click', (e) => { e.preventDefault(); void import('./owed').then(({ openDonePopup }) => openDonePopup(cl)) })
  const notDone = el('button', { type: 'button', class: 'diary-not-done review-card-act', 'aria-label': `${who}: not done` }, 'Not done') as HTMLButtonElement
  notDone.addEventListener('click', (e) => { e.preventDefault(); openNotDone(cl, canMove, notDone) })
  if (askNotDone === cl.id) { askNotDone = null; setTimeout(() => { if (notDone.isConnected) openNotDone(cl, canMove, notDone) }, 0) }
  card.append(el('div', { class: 'review-card-acts diary-quick-actions' }, done, notDone))
  const moveOn = nobodyRepliedButton(cl)
  if (moveOn) card.append(el('div', { class: 'review-card-more' }, moveOn))
  return card
}

// Past visits to review > Not done (Liam, 9 Oct 2026). Each answer is the save it names (docs/DIARY-AND-MESSAGES.md
// section 2): Book them again (back in To place; when To place would not take them, a new day straight away and their
// message next, as placing from To place does), Cancel this visit (Cancel visit's save and Undo; they stay on the
// round), Off the round (Taken off as Messages saves it, this visit cancelled with it, one Undo for both).
// Drawn as design D (Liam, 23 Oct 2026, docs/brand/README.md Picture tiles): who it is with their initials in lemon,
// "What happened?" as six picture tiles, then the booking's answers as four big tiles, Move the lemon one.
function openNotDone(cl: Clean, canMove: boolean, opener: HTMLButtonElement): void {
  const gen = routeGen
  const who = cl.customer_name ?? 'them'
  const dialog = el('dialog', { class: 'booking-dialog diary-notdone-dialog', 'aria-label': `Not done: ${who}, ${dayLabel(cl.date)}` })
  const close = el('button', { type: 'button', 'aria-label': 'Close' }, 'Close')
  const body = el('div', { class: 'diary-notdone-body' })
  const tiles = el('div', { class: 'diary-notdone-choices' })
  const choice = (drawing: Drawing, title: string, hint: string, act: () => void, extra = ''): void => {
    const b = el('button', { type: 'button', class: `diary-notdone-choice${extra}` }, lineDrawing(drawing, 26), el('span', { class: 'diary-notdone-words' }, el('strong', {}, title), el('span', {}, hint))) as HTMLButtonElement
    b.addEventListener('click', () => { dialog.close(); if (routeGen === gen) act() })
    tiles.append(b)
  }
  // Couldn't do it, with why, as Today saves it (ui.ts blockedSaveOf); Undo after. Not again once it has a reason.
  // A reason is picked, not saved at once (Liam, 23 Oct 2026: "Should i be able to select two ie if i click weather it
  // takes it out of the flow?"): it turns lemon and the pop-up stays open, then the booking's answer saves both
  // (Weather then Move: their message says "Sorry, the weather stopped us"), or "Save, decide later" saves the reason.
  const asksWhy = cl.state === 'booked' && !cl.blocked_reason && !cl.started_at
  let picked: string | null = null
  const ask = el('p', { class: 'diary-notdone-ask' }, asksWhy ? 'Or change the booking' : 'What next?')
  const later = el('button', { type: 'button', class: 'diary-notdone-later' }, 'Save, decide later') as HTMLButtonElement
  later.hidden = true
  later.addEventListener('click', () => { const code = picked; dialog.close(); if (code && routeGen === gen) saveCouldnt(cl, code) })
  if (asksWhy) {
    const why = el('div', { class: 'diary-notdone-why', role: 'group', 'aria-label': "Couldn't do it: why?" })
    const reasons: [string, HTMLElement][] = []
    for (const [code, label] of BLOCKED_CHOICES) {
      const b = el('button', { type: 'button', class: 'diary-notdone-reason', 'aria-pressed': 'false' }, el('span', { class: 'diary-notdone-ring' }, lineDrawing(reasonDrawing(code))), label)
      b.addEventListener('click', () => {
        picked = picked === code ? null : code
        for (const [c, r] of reasons) r.setAttribute('aria-pressed', String(c === picked))
        later.hidden = !picked
        ask.textContent = picked ? 'What next?' : 'Or change the booking'
      })
      reasons.push([code, b])
      why.append(b)
    }
    body.append(el('p', { class: 'diary-notdone-ask' }, 'What happened?'), why)
  }
  // The visit as the picked reason leaves it, for a move: its message is the missed one, worded by the reason (a move
  // clears Couldn't do it on the server, so it is not saved first).
  const withWhy = (): Clean => picked ? { ...cl, ...blockedSaveOf(picked, '') } as Clean : cl
  body.append(ask, tiles)
  // Move to another day first (Liam, 22 Oct 2026: "Theres no way to mark move or rebook or not done basically we didnt
  // do it and its not easy to move them from owed"; docs/plans/one-look/PLAN.md 4): the Move pop-up, then the Diary's move.
  if (mayMoveHere(cl)) choice('calendarMove', 'Move to another day', 'Keeps its time', () => openMoveFor(withWhy()), ' diary-notdone-move')
  // Back in To place, with the picked reason saved in the same change.
  if (canMove) choice('again', 'Book them again', 'Back in To place', () => markReviewed(cl, picked ? blockedSaveOf(picked, '') : undefined))
  // A job already started keeps its times: no new day for it here (GPT-6.1: the move would clear the start).
  // Not beside Move, which already picks the day (the drawing: Move, Couldn't do it, Cancel, Off the round).
  else if (!cl.started_at && !mayMoveHere(cl)) body.append(el('div', { class: 'diary-notdone-pick' }, ...menuDateLine('Book them again: pick a new day', `Pick a new day for ${who}`, (d) => { dialog.close(); if (routeGen === gen) rebookOn(withWhy(), d) }, { min: todayISO() })))
  choice('calendarCross', 'Cancel this visit', 'They stay on the round', () => cancelVisit(cl, () => {}, { ask: false, undoText: `Cancelled the ${dayLabel(cl.date)} visit for ${who}. They stay on the round` }))
  // Needs the customer as the customers list has them, for the exact Undo; someone already Taken off is not offered it.
  const c = customerOf(cl.customer_id)
  if (c && standingOf(c) !== 'taken_off') choice('personOff', 'Off the round', 'And cancel this visit', () => void takeOffWithVisit(cl, c), ' diary-notdone-off')
  if (asksWhy) body.append(later)
  const face = el('span', { class: 'diary-notdone-face', 'aria-hidden': 'true' }, initialsOf(cl.customer_name ?? ''))
  const head = el('div', { class: 'diary-notdone-who' }, el('h2', {}, cl.customer_name ?? 'This visit'), el('p', {}, `${dayLabel(cl.date)} · didn't happen`))
  dialog.append(el('header', { class: 'booking-head diary-notdone-head' }, face, head, close), body)
  close.addEventListener('click', () => dialog.close())
  dialog.addEventListener('close', () => { dialog.remove(); if (opener.isConnected) opener.focus({ preventScroll: true }) })
  document.body.append(dialog)
  dialog.showModal()
}

// Couldn't do it saved from the Not done choices (Owed's "Didn't happen", the review box): the visit's reason and note,
// as Today's chooser saves them, with Undo.
function saveCouldnt(cl: Clean, code: string): void {
  const body: Record<string, unknown> = { version: cl.version, ...blockedSaveOf(code, '') }
  void mutate<Clean>({ label: `Couldn't do it: ${cl.customer_name ?? ''} ${cl.date}`, method: 'PATCH', path: `/api/cleans/${cl.id}`, body, onConflict: () => void load() })
    .then((ack) => {
      if (ack.ok || ack.status === 0) {
        void load()
        undoPatch({ text: `Marked ${cl.customer_name ?? 'the visit'} couldn't do it`, label: `Undo couldn't do it: ${cl.customer_name ?? ''}`, path: `/api/cleans/${cl.id}`, ack, version: cl.version,
          body: { blocked_reason: null }, after: () => void load() })
      } else alert4xx(ack)
    })
}

// Book them again on a day: the missed visit moves there (To place's "Move to a day…" path) and their message opens;
// its Cancel puts the visit back on its passed day, still to review.
function rebookOn(cl: Clean, date: string): void {
  if (goneDay(date)) return
  const due = { id: cl.customer_id, name: cl.customer_name ?? 'Customer' }
  moveToDay(cl, date, (visit, takeOff, placement) => askAfterPlacing(due, date, visit.id, takeOff, cl.date, placement))
}

// Taken off as Messages' "Take off round" saves it, then this visit cancelled once that has saved (leftover-visit.ts
// cancelAfter: with no signal, only after it lands). One Undo puts both back.
async function takeOffWithVisit(cl: Clean, c: Customer): Promise<void> {
  const path = `/api/customers/${c.id}`
  const restore = standingFields(c)
  let queuedKey: string | null = null
  const ack = await mutate({ method: 'PATCH', path, label: `Taken off round: ${c.name}`, body: { version: c.version, customer_context: { action: 'set_standing', standing: 'taken_off', reason: '' } },
    onQueued: (m) => { queuedKey = m.key }, onConflict: () => void load() })
  if (!ack.ok && ack.status !== 0) { alert4xx(ack); void load(); return }
  const extra = await cancelAfter(ack, queuedKey, { id: cl.id, version: cl.version, date: cl.date }, c.name)
  void load()
  const version = (ack.row as { version?: number } | undefined)?.version ?? c.version + 1
  offerUndo(`Took ${c.name} off the round${extra.words}`, () => {
    extra.undo()
    void mutate({ label: `Undo taken off: ${c.name}`, method: 'PATCH', path, body: { version, customer_context: { action: 'restore_standing', fields: restore } },
      onAck: (back) => { if (!back.ok && back.status >= 400 && back.status < 500) window.alert(`Undo was refused: ${back.error ?? 'rejected'}`); void load() }, onConflict: () => void load() })
  })
}

// The picture that follows the pointer while a row is dragged. Left to itself, Brave/Chrome photographed a whole
// corner of the page around the row (Liam's screenshot, 29 Sep: three customers and two days under the pointer).
// A copy of just this row, card-sized and off screen, is handed over instead, then removed once taken.
function dragPicture(e: DragEvent, row: HTMLElement): void {
  if (!e.dataTransfer) return
  // A card that lifts, follows and leans (drag-fly.ts, 12 Oct 2026); this plain copy only with reduced motion.
  if (flyDrag(e, row)) return
  const rect = row.getBoundingClientRect()
  const width = Math.min(rect.width, 420)
  const ghost = row.cloneNode(true) as HTMLElement
  ghost.classList.remove('first-visit-glow', 'tray-row-moving', 'guide-glow')
  ghost.classList.add('drag-picture')
  ghost.removeAttribute('id')
  ghost.style.width = `${width}px`
  document.body.append(ghost)
  const x = Math.max(8, Math.min(e.clientX - rect.left, width - 8))
  const y = Math.max(8, Math.min(e.clientY - rect.top, ghost.offsetHeight - 8))
  e.dataTransfer.setDragImage(ghost, x, y)
  window.setTimeout(() => ghost.remove(), 0)
}

function cancelMoveSelection(): void {
  const back = phoneWeekActive() ? phoneWeekReturn : null; phoneWeekReturn = null
  movingId = null
  movingDueId = null
  movingEnqId = null
  if (diaryView() === 'month') { monthRedraw(); return }
  const root = document.querySelector<HTMLElement>('#screen')
  if (payload && root && !editing) render(payload, root)
  back?.()
}

// A tap anywhere else lets go of a picked customer too (Liam, 29 Sep: "if I click anywhere else on the page it
// would deselect it"). Not a tap on a pickable row (that picks it, or lets it go), on Move here / Book on this day,
// on a row's menu, on the week panel's tabs, or inside a dialog. Runs after the row's own handler.
document.addEventListener('click', (e) => {
  if (movingId === null && movingDueId === null && movingEnqId === null) return
  // The diary is on screen (it is also the screen with no address at all).
  if (!document.querySelector('#screen .week-nav')) return
  const t = e.target as Element | null
  // Boxes and choosers on the page (who is out, a day note) and the placing hint keep the pick (Codex).
  if (!t || t.closest('.tray-row, .due-row, .diary-move, .diary-week-strip, .diary-desk-nav, .diary-desk-views, .diary-work-days, .move-here, .row-menu, .diary-due-bar, .diary-phone-week, .diary-week-place-bar, .diary-put-here, dialog, input, select, textarea, label, [contenteditable]')) return
  cancelMoveSelection()
})

// Escape backs out of a move. A dialog owns Escape first: with the booking
// panel open it closes and the selection survives for the next press. So does
// an open menu (the ⋯ at the top, a row's ⋯): that press only closes it (Astra).
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape' || (movingId === null && movingDueId === null && movingEnqId === null)) return
  if (document.querySelector('dialog[open]') || menuOpen()) return
  cancelMoveSelection()
})
// A ⋯ or contact menu open on the page, which an Escape closes before anything else.
function menuOpen(): boolean { return !!document.querySelector('details.row-menu[open], details.way-menu[open], [aria-haspopup][aria-expanded="true"]') }

// ---- the row menu (plan v3 item B) ------------------------------------------
//
// The ⋯ at the end of a panel row: the actions that are not placing. A
// <details>, the same shape as the Columns picker on Work, and the dismiss is
// bound ONCE on the document for the same reason — render() rebuilds every
// row on each move or booking, so a per-menu listener would pile up.

// ---- the week panel's move-all (WEEK-PANEL-NEXT-4 item C) --------------------
//
// The ⋯ on the "This week" line: one item that slides every booked visit in
// the week on screen to next week — for the week nobody is rostered for, so
// he does not have to open seven ⋯ menus in a row. The same rowMenu the panel
// rows use; the only difference is where it lives: INSIDE the tray's summary,
// so the tap that opens the menu must never also fold the panel.

// ---- one menu for a job, wherever the job is sitting -------------------------
//
// Lewis, 17 and 19 September 2026, having learned the ⋯ in Due this week and
// then lost it the moment the job landed on a day:
//
//   "I see this at the top of schedule, the few jobs that are in the this week
//    box, but I'm not sure how to do that for other jobs I've added in or
//    moved around. There are a few in the day box that aren't there, and then
//    when they say they wanna push it, I can't."
//
// He could. The day row called it "Edit / reschedule" and opened the whole
// booking panel, while the row one box above offered a one-tap menu for the
// same job. Three places, three gestures, one intention.
//
// So there is now ONE menu and one builder for it, and every job row carries
// it: the Due this week rows, the week tray, and the day cards. The first line
// is always the move, named by where the job will LAND ("Move to Thu 1 Oct"),
// because that is the question being answered.
//
// The lines that appear depend on two things — WHERE the row is (a customer
// with nothing booked can only be placed; a real visit can be moved) and WHAT
// STATE the visit is in (work that is done cannot be moved into the future,
// and the server refuses it anyway; a cancelled visit can only be removed).

type JobMenuTarget =
  | { kind: 'due'; customer: Customer; anchor: string | null; payload: SchedulePayload }
  | { kind: 'tray'; clean: Clean }
  | { kind: 'day'; clean: Clean; day: Clean[] }

// A date line: the picker plus a button that says what tapping it will do.
// A bare `change` listener was not enough — a picker opened and closed on the
// same value fires nothing, and on a phone the wheel commits as you scroll.
function menuDateLine(label: string, aria: string, act: (date: string) => void, opts: { value?: string; verb?: string; min?: string } = {}): HTMLElement[] {
  const wrap = el('div', { class: 'row-menu-date' })
  const input = el('input', { type: 'date', 'aria-label': aria })
  // A day that has gone is not offered (goneDay), as Month's own picker does.
  if (opts.min) input.min = opts.min
  if (opts.value) input.value = opts.value
  const go = el('button', { type: 'button', class: 'row-menu-go' }, opts.verb ?? 'Move')
  const update = (): void => {
    const ok = !!input.value && input.validity.valid && (!opts.min || input.value >= opts.min)
    go.disabled = !ok
    go.textContent = ok ? `${opts.verb ?? 'Move'} ${shortDate(input.value)}` : (opts.verb ?? 'Move')
  }
  input.addEventListener('change', update)
  input.addEventListener('input', update)
  go.addEventListener('click', () => { if (input.value && input.validity.valid) act(input.value) })
  update()
  wrap.append(input, go)
  return [el('span', { class: 'row-menu-label' }, label), wrap]
}

// Put an existing visit in a WEEK with no day, the tray/day twin of
// placeDueInWeek's move arm: the save snaps to the week's Monday and
// `week_only` tells the server this is deliberately dayless, overriding the
// stamp a plain date move would make.
function moveCleanToWeek(cl: Clean, week: string): void {
  const was = { version: cl.version, date: cl.date, time_slot: cl.time_slot ?? null, confirmed: cl.confirmed, time_agreed_for: timeIsAgreed(cl) ? cl.time_agreed_for : null, ...(isUnplaced(cl, cl.date, cl.date) ? { week_only: true } : {}) }
  const monday = mondayOf(week)
  movingId = null
  movingDueId = null
  void mutate({
    label: `Put in the week of ${shortDate(monday)}: ${cl.customer_name ?? ''}`,
    method: 'PATCH',
    path: `/api/cleans/${cl.id}`,
    body: { version: cl.version, date: monday, week_only: true },
    onAck: () => void load(),
    onConflict: () => void load(),
  }).then((ack) => {
    if (!ack.ok && ack.status >= 400 && ack.status < 500) alert4xx(ack)
    undoPatch({
      text: `${cl.customer_name ?? 'They'} are in the week of ${shortDate(monday)}, no day yet`,
      ...(ack.ok && was.confirmed ? { link: messageThemLink(cl) } : {}),
      label: `Undo week: ${cl.customer_name ?? ''} back to ${dayLabel(cl.date)}`,
      path: `/api/cleans/${cl.id}`,
      ack,
      version: was.version,
      body: { date: was.date, time_slot: was.time_slot, confirmed: was.confirmed, time_agreed_for: was.time_agreed_for, ...(was.week_only ? { week_only: true } : {}), undo_restore: true },
      after: () => void load(),
    })
  })
}

// A time on a visit: the shared save (visit-time.ts), drawn at once on the Week and read again after.
function setVisitTime(cl: Clean, time: string | null, agree: boolean | null = null): void {
  saveVisitTime(cl, time, agree, diaryTimeHooks())
}
function diaryTimeHooks(): VisitTimeHooks {
  return {
    changed: () => void load(),
    drawNow: () => { const here = document.querySelector<HTMLElement>('#screen'); if (payload && here && diaryView() === 'week') { applyWaitingTimes(payload); render(payload, here) } },
  }
}

// Cancel visit and Dismiss reminder, with Undo like every other change to a visit (bug hunt, 8 Oct 2026: Cancel had
// none, and the bar of the change before it stayed up pointing at the cancelled visit). Cancelling clears whether the
// day and time were agreed; Undo books it again with both put back, and undo_restore brings back a door record too.
// ask: false when the tap was already the answer (Not done > Cancel just this visit); Undo is still offered.
function cancelVisit(cl: Clean, close: () => void, opts: { ask?: string | false; undoText?: string } = {}): void {
  // The same save and Undo as the customer page's Cancel visit (visit-actions.ts).
  cancelVisitWithUndo(cl, { ...opts, close, changed: dataChanged, refused: () => void load() })
}

// Removing a cancelled visit takes it off the day; Undo puts that same row back as it was (the server reinstates a
// removed visit asked for again on its day, restore_if_removed), so nothing about it is guessed.
function removeCancelledVisit(cl: Clean, close: () => void): void {
  if (!window.confirm(`Remove the cancelled ${dayLabel(cl.date)} visit for ${cl.customer_name}?\n\nIt comes off the day and off their cancelled count.`)) return
  close()
  void mutate({ label: `Remove cancelled: ${cl.customer_name}`, method: 'DELETE', path: `/api/cleans/${cl.id}`, body: { version: cl.version }, onAck: dataChanged, onConflict: dataChanged })
    .then((ack) => {
      if (!ack.ok && ack.status >= 400 && ack.status < 500) { alert4xx(ack); return }
      if (!ack.ok) return
      offerUndo(`Removed the cancelled ${dayLabel(cl.date)} visit for ${cl.customer_name ?? 'them'}`, () => {
        void mutate({
          label: `Undo remove: ${cl.customer_name ?? ''} ${cl.date}`,
          method: 'POST',
          path: `/api/customers/${cl.customer_id}/cleans`,
          body: { date: cl.date, state: 'cancelled', restore_if_removed: true, ...(severalJobsOn() ? { kind: cl.kind, ...(visitJobId(cl) !== null ? { job_id: visitJobId(cl) } : {}) } : {}) },
          onAck: () => void load(),
          onConflict: () => void load(),
        }).then((back) => { if (!back.ok && back.status >= 400 && back.status < 500) window.alert(`Undo was refused: ${back.error ?? 'rejected'}`) })
      })
    })
}

function markNotPaid(cl: Clean, close: () => void): void {
  close()
  void mutate({
    label: `Mark unpaid: ${cl.customer_name ?? ''} ${cl.date}`,
    method: 'PATCH',
    path: `/api/cleans/${cl.id}`,
    body: { version: cl.version, payment_status: 'unpaid', payment_method: null, chased: 0 },
    onAck: () => void load(),
    onConflict: () => void load(),
  }).then((ack) => {
    if (!ack.ok && ack.status >= 400 && ack.status < 500) alert4xx(ack)
    undoPatch({ text: `Marked ${cl.customer_name ?? 'visit'} not paid`, label: `Undo not paid: ${cl.customer_name ?? ''} ${cl.date}`, path: `/api/cleans/${cl.id}`, ack, version: cl.version,
      body: { payment_status: 'paid', payment_method: cl.payment_method ?? null, chased: cl.chased }, after: () => void load() })
  })
}

// Due's "Next week" (Liam, 11 Oct 2026; docs/plans/diary-due/PLAN.md): out of Due, and left alone by Messages, until the
// Monday after this week. Per job (an extra job saves on its own row). Nothing is sent and nothing else changes; Undo.
function pushPath(c: DueEntry): { path: string; version: number } {
  return c.dueJob ? { path: `/api/customer-jobs/${c.dueJob.id}`, version: c.dueJob.version } : { path: `/api/customers/${c.id}`, version: c.version }
}
function pushToNextWeek(c: DueEntry): void {
  const until = nextMondayAfter(todayISO())
  const { path, version } = pushPath(c)
  const was = { due_pushed_until: c.due_pushed_until ?? null, due_pushes: c.due_pushes ?? 0 }
  const who = c.dueJob ? `${c.name}'s ${c.dueJob.name.toLowerCase()}` : c.name
  void mutate({
    label: `Next week: ${who}`,
    method: 'PATCH',
    path,
    body: { version, due_pushed_until: until, due_pushes: was.due_pushes + 1 },
    onAck: (ack) => {
      alert4xx(ack)
      void load()
      undoPatch({ text: `${who} moved to next week's Due`, label: `Undo next week: ${who}`, path, ack, version, body: was, after: () => void load() })
    },
    onConflict: () => void load(),
  })
}
function backIntoDue(c: DueEntry): void {
  const { path, version } = pushPath(c)
  void mutate({ label: `Back into Due: ${c.name}`, method: 'PATCH', path, body: { version, due_pushed_until: null }, onAck: (ack) => { alert4xx(ack); void load() }, onConflict: () => void load() })
}
function pushLine(c: DueEntry, close: () => void): HTMLElement {
  const b = el('button', { type: 'button' }, 'Next week')
  b.append(el('span', { class: 'row-menu-when' }, 'out of Due until then'))
  b.addEventListener('click', () => { close(); pushToNextWeek(c) })
  return b
}
function dueGroupsFor(p: SchedulePayload): DueGroups {
  return dueGroups(p, customers, roundJobList, todayISO(), (c) => askAgainLater(c))
}
function dueGroupLine(kind: string, c: DueEntry, p: SchedulePayload): string {
  if (kind === 'next') return `back in Due ${dayLabel(c.due_pushed_until!)}${(c.due_pushes ?? 0) > 1 ? ` · pushed ${c.due_pushes} times` : ''}`
  if (kind === 'first') return `never visited · ${setCycleDays(c) ? cycleLabel(setCycleDays(c), c.cycle_text) || 'cycle set' : 'no cycle yet'}`
  const from = dueFrom(c, p, todayISO())
  const behind = Math.floor(cleansBehind(c, p, todayISO()))
  return `${from ? `due ${dayLabel(from)}` : 'due'} · ${behind} cleans behind`
}

// "Not now, ask again on…" — the customer-level snooze, the same save the
// Messages card makes. Only a due row has it: it is about the CUSTOMER, and a
// visit already in the diary is the opposite of leaving them alone.
function notNowLines(c: Customer, close: () => void): HTMLElement[] {
  // Starts on a month from today, as Messages' Not now does (29 Sep); any date can be picked instead.
  return menuDateLine('Not now, ask again on…', `Ask ${c.name} again from a date`, (askOn) => {
    close()
    const body = notNowPatch(c, askOn)
    void mutate({
      label: `Not now: ${c.name}, ask again ${shortDate(askOn)}`,
      method: 'PATCH',
      path: `/api/customers/${c.id}`,
      body: { version: c.version, ...body },
      onAck: (ack) => {
        alert4xx(ack)
        void load()
        undoPatch({ text: `Marked ${c.name} not now, ask again ${shortDate(askOn)}`, label: `Undo not now: ${c.name}`, path: `/api/customers/${c.id}`, ack, version: c.version,
          body: { follow_up_on: c.follow_up_on ?? null, last_contacted_on: c.last_contacted_on ?? null, contact_note: c.contact_note ?? null }, after: () => void load() })
      },
      onConflict: () => void load(),
    })
  }, { value: addDaysISO(todayISO(), 30), verb: 'Ask again' })
}

function jobMenu(t: JobMenuTarget): HTMLElement {
  const who = t.kind === 'due' ? t.customer.name : (t.clean.customer_name ?? 'this visit')
  const heading = t.kind === 'day' ? `${who} · ${dayLabel(t.clean.date)}` : who
  return rowMenu(`More actions: ${who}`, (list, closeMenu) => {
    const close = (): void => { closeMenu(); list.closest<HTMLDialogElement>('.diary-detail-dialog')?.close() }
    // The name at the top of the list, because two menus can sit within a
    // thumb's width of each other and the wrong Jackie is a real booking.
    list.append(el('div', { class: 'row-menu-head' }, heading))

    // Asking happens in Messages (Diary and Messages as one, Liam 8 Oct 2026): this opens their card there.
    const messageThem = (id: number, name: string): HTMLButtonElement => {
      const b = el('button', { type: 'button', class: 'row-menu-message' }, 'Message them')
      b.addEventListener('click', () => { close(); openMessagesFor({ id, name }, 'customer') })
      return b
    }
    // Design B: Call moved off the visit into its ⋯; the details still have it too.
    if (t.kind === 'day' && t.clean.state !== 'cancelled') {
      // Call, then the ways to message them, as flat lines from one set of details (contact-tile.ts, visitReach); the
      // Messages line stays the recorded way to ask.
      const reach = visitReach(t.clean)
      const tel = telHref(reach.phone ?? null)
      if (tel) list.append(el('a', { href: tel, class: 'row-menu-call', 'data-call-name': reach.name }, `Call ${reach.phone?.trim()}`))
      list.append(...contactLines(reach, 'row-menu-chat', { call: false, onOpen: close }))
    }
    if (t.kind === 'due') {
      const to = t.anchor ? nextWeekFrom(t.anchor) : null
      const next = el('button', { type: 'button', class: 'row-menu-first' }, to ? `Move to ${dayLabel(to)}` : 'Move to next week')
      if (to) next.append(el('span', { class: 'row-menu-when' }, 'next week'))
      next.disabled = !to
      next.addEventListener('click', () => { close(); if (to) placeDueOn(t.customer, to) })
      list.append(next)
      list.append(...menuDateLine('Move to a day…', `Book ${t.customer.name} on a day`, (d) => { close(); placeDueOn(t.customer, d) }, { min: todayISO() }))
      list.append(...menuDateLine('Put in a week, pick the day later…', `Put ${t.customer.name} in a week`, (d) => { close(); placeDueInWeek(t.customer, d, t.payload) }, { verb: 'Week of' }))
      list.append(el('hr', { class: 'row-menu-rule' }))
      list.append(messageThem(t.customer.id, t.customer.name))
      list.append(pushLine(t.customer, close))
      list.append(...notNowLines(t.customer, close))
      return
    }

    const cl = t.clean
    if (cl.state === 'cancelled') {
      const remove = el('button', { type: 'button', class: 'row-menu-danger' }, 'Remove from the day')
      remove.addEventListener('click', () => removeCancelledVisit(cl, close))
      list.append(remove)
      return
    }

    // Done work does not move. The API refuses a future date on it, and a past
    // one would rewrite history — so the lines are simply not offered.
    if (cl.state !== 'done') {
      // A tray row has a WEEK, not a day, so its "next week" is the next week
      // rather than the next day — it must stay dayless, which is week_only.
      if (t.kind === 'tray') {
        const to = nextWeekFrom(cl.date)
        const next = el('button', { type: 'button', class: 'row-menu-first' }, `Move to the week of ${shortDate(mondayOf(to))}`)
        next.append(el('span', { class: 'row-menu-when' }, 'next week'))
        next.addEventListener('click', () => { close(); moveCleanToWeek(cl, to) })
        list.append(next)
      } else {
        const to = nextWeekFrom(cl.date)
        const next = el('button', { type: 'button', class: 'row-menu-first' }, `Move to ${dayLabel(to)}`)
        next.append(el('span', { class: 'row-menu-when' }, 'next week'))
        next.addEventListener('click', () => { close(); moveToDay(cl, to) })
        list.append(next)
      }
      list.append(...menuDateLine('Move to a day…', `Move the ${who} visit to a day`, (d) => { close(); moveToDay(cl, d) }, { min: todayISO() }))
      list.append(...menuDateLine('Put in a week, pick the day later…', `Put the ${who} visit in a week`, (d) => { close(); moveCleanToWeek(cl, d) }, { verb: 'Week of' }))
    }

    // No set times (Your business): no time to set or change.
    if (t.kind === 'day' && setTimesOn()) {
      list.append(el('hr', { class: 'row-menu-rule' }))
      // The visit's time pop-up, the same as tapping its time (27 Oct 2026: no phone's own wheel in a menu; Liam, "Yes" to
      // Roundly's wheel everywhere): its times around the visit, Other… with the wheel, Time agreed, Save.
      const setIt = el('button', { type: 'button', class: 'row-menu-time', 'aria-label': `${cl.time_slot ? 'Change the time' : 'Set a time'} for the ${who} visit` }, cl.time_slot ? 'Change the time…' : 'Set a time…')
      setIt.addEventListener('click', () => { close(); openTimePicker(cl, setIt) })
      list.append(setIt)
    }

    list.append(el('hr', { class: 'row-menu-rule' }))
    if (confirmNeed(cl, visitCustomer(cl)) === 'day' && !noMessages(cl)) list.append(messageThem(cl.customer_id, cl.customer_name ?? 'Customer'))
    // Asked and waiting: They replied is here too (12 Oct 2026).
    if (t.kind === 'day' && visitNextStep(cl) === 'replied') {
      const replied = el('button', { type: 'button', class: 'row-menu-replied' }, 'They replied…')
      replied.addEventListener('click', () => { close(); openTheyReplied(cl, repliedOptions(cl)) })
      list.append(replied)
    }
    // A visit whose main button asks them (or "They replied"): Mark confirmed is here, for a day they agreed another way.
    if (t.kind === 'day' && (visitNextStep(cl) === 'ask' || visitNextStep(cl) === 'replied')) {
      const agreed = el('button', { type: 'button', class: 'row-menu-confirm' }, 'Mark confirmed', el('span', { class: 'row-menu-when' }, 'they agreed another way'))
      agreed.addEventListener('click', () => { close(); markDayAgreed(cl, agreed, () => void load()) })
      list.append(agreed)
      // Several jobs on the same day: the one-tap confirm for all of them stays reachable (review, 12 Oct 2026).
      const group = severalJobsOn() ? houseGroup(cl) : []
      if (group.length > 1 && group[0]!.id === cl.id) {
        const both = el('button', { type: 'button', class: 'row-menu-confirm' }, `Confirm ${group.map((v) => visitJobLabel(v)).join(' and ')}`)
        both.addEventListener('click', () => { close(); both.setAttribute('disabled', 'disabled'); confirmGroup(group) })
        list.append(both)
      }
    }
    // A one-person round's booking has no worker unless the visit carries someone else's name (Sol's review, 19 Oct
    // 2026): the item says what it opens.
    const edit = el('button', { type: 'button' }, worksAlone() && !otherName(cl.worker) ? 'Change price or note…' : 'Change price, worker or note…')
    edit.addEventListener('click', () => { close(); openBooking({ customerId: cl.customer_id, cleanId: cl.id }) })
    list.append(edit)
    // Parking… (parking design B, 27 Oct 2026): the customer's Parking, from any of their visits.
    const parking = el('button', { type: 'button' }, 'Parking…')
    parking.addEventListener('click', () => { close(); openParkingFromDiary(cl) })
    list.append(parking)
    // Add a note… (28 Oct 2026): the same note sheet as the visit's details tile, here too because the computer's Diary
    // opens no details sheet (its name opens their page; Liam: "i dont see any visit").
    if (t.kind === 'day') {
      const note = el('button', { type: 'button' }, 'Add a note…')
      note.addEventListener('click', () => {
        close()
        void import('../diary-note').then(({ openVisitNote }) => openVisitNote({ id: cl.id, version: cl.version, customer_id: cl.customer_id, customer_name: cl.customer_name ?? 'them', state: cl.state, note: cl.note ?? null, date: cl.date }, () => void load()))
      })
      list.insertBefore(note, parking)
    }

    if (t.kind === 'day' && cl.state === 'done' && cl.payment_status !== 'paid') {
      const owe = el('button', { type: 'button' }, 'Open in Owed')
      owe.addEventListener('click', () => { close(); openInOwed(cl) })
      list.append(owe)
    }
    if (t.kind === 'day' && cl.state === 'done' && cl.payment_status === 'paid') {
      const notPaid = el('button', { type: 'button' }, 'Mark as not paid')
      notPaid.addEventListener('click', () => markNotPaid(cl, close))
      list.append(notPaid)
    }

    if (cl.state === 'booked') {
      const cancel = el('button', { type: 'button', class: 'row-menu-danger' }, 'Cancel visit')
      cancel.addEventListener('click', () => cancelVisit(cl, close))
      list.append(cancel)
    }
  })
}

// The Diary's ⋯ beside + Book a visit (tidy-up item 4; Liam, 20 Oct 2026, his drawing top-after.jpg), on a phone and a
// computer, in Day and Week: "Jump to a date…" opens a date box, with Today when today is not the day on show; "Move
// this week to next week…" asks before anything moves (WEEK-PANEL-NEXT-4 item C). Month has the same ⋯ with its own
// jump (month.ts diaryMoreMenu).
function diaryMore(p: SchedulePayload, date: HTMLInputElement, toToday: () => void, find?: () => void): HTMLElement {
  return diaryMoreMenu('More: dates and this week', [
    // The phone's search left its own button for here (the Diary redesign, phone 4): the same search, Who and Area.
    ...(find ? [{ title: 'Find a visit…', hint: 'By name, address, job, who or area', fill: (_box: HTMLElement, close: () => void) => { close(); find() } }] : []),
    { title: 'Jump to a date…', hint: 'Or back to today', fill: (box, close) => {
      const back = el('button', { type: 'button', class: 'diary-more-today' }, 'Today')
      back.addEventListener('click', () => { close(); toToday() })
      box.replaceChildren(el('label', { class: 'diary-more-field' }, el('span', {}, 'Jump to a date'), date), ...(selectedDate !== todayISO() ? [back] : []))
      date.focus({ preventScroll: true })
    } },
    { title: 'Move this week to next week…', hint: 'All of this week’s visits, after asking', className: 'week-move-confirm', fill: (box, close) => {
      const moves = weekMoveSet(p.cleans, p.from, p.to)
      if (!moves.length) { box.replaceChildren(el('span', { class: 'week-move-q' }, 'Nothing booked this week.')); return }
      // The question in the app's own words, not the browser's: one line with the w/c date, plus the roster when anyone
      // IS on this week, so the owner sees what they are about to undo. Not in a one-person round: every working day
      // is theirs (Liam, 19 Oct 2026).
      const weekday = (iso: string): string => ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][new Date(`${iso}T12:00:00`).getDay()]!
      const roster = worksAlone() ? '' : (p.round_days ?? [])
        .filter(rd => rd.date >= p.from && rd.date <= p.to)
        .map(rd => `${rd.worker} is on ${weekday(rd.date)}`)
        .join(' · ')
      const go = el('button', { type: 'button', class: 'btn-primary' }, 'Move')
      const keep = el('button', { type: 'button' }, 'Keep')
      go.addEventListener('click', () => { close(); moveWeek(p, moves) })
      keep.addEventListener('click', () => close())
      box.replaceChildren(
        el('span', { class: 'week-move-q' }, `Move ${moves.length} visit${moves.length === 1 ? '' : 's'} to w/c ${shortDate(addDaysISO(p.from, 7))}?`),
        ...(roster ? [el('span', { class: 'week-move-q week-move-roster' }, roster)] : []),
        el('div', { class: 'week-move-btns' }, go, keep))
      go.focus({ preventScroll: true })
    } },
  ])
}

// The move itself: ONE PATCH per visit, all in flight together — each visit
// is its own row, so the same-row hold never queues them behind one another.
// Nothing reloads until every ack is back: a reload halfway would rebuild the
// panel while saves are still landing (the 20-second queue trap). Then ONE
// undo bar, whose action puts every visit that moved back on its original
// date under the version its own move returned — a failed or conflicted
// visit stays where it was, and says so.
function moveWeek(p: SchedulePayload, moves: WeekMove[]): void {
  movingId = null
  movingDueId = null
  movingEnqId = null
  const byId = new Map(p.cleans.map(c => [c.id, c]))
  const sent = moves.map((m) => {
    const cl = byId.get(m.id)
    if (!cl) return Promise.resolve({ m, ack: { ok: false, status: 0 } as Ack, name: 'visit', v0: 0, before: null })
    const v0 = cl.version
    const before = { date: cl.date, time_slot: cl.time_slot ?? null, confirmed: cl.confirmed, time_agreed_for: timeIsAgreed(cl) ? cl.time_agreed_for : null, ...(isUnplaced(cl, cl.date, cl.date) ? { week_only: true } : {}) }
    return mutate({
      label: `Move week: ${cl.customer_name ?? ''}`,
      method: 'PATCH',
      path: `/api/cleans/${cl.id}`,
      body: { version: cl.version, date: m.to, adopt_booking: true },
    }).then((ack) => ({ m, ack, name: cl.customer_name ?? 'visit', v0, before }))
  })
  void Promise.all(sent).then((done) => {
    const moved = done.filter(r => r.ack.ok)
    void load()
    const putBack = (): void => {
      const backs = moved.map((r) => {
        const row = r.ack.row as { version?: number } | undefined
        const version = typeof row?.version === 'number' ? row.version : r.v0 + 1
        return mutate({
          label: `Undo move week: ${r.name} back to ${dayLabel(r.m.from)}`,
          method: 'PATCH',
          path: `/api/cleans/${r.m.id}`,
          body: { version, ...r.before, undo_restore: true },
          onConflict: () => void load(),
        }).then((ack) => {
          // A refused undo must be seen, not swallowed — the bar is the
          // owner's safety net (the same rule undoPatch applies).
          if (!ack.ok && ack.status >= 400 && ack.status < 500) window.alert(`Undo was refused: ${ack.error ?? 'rejected'}`)
          return ack
        })
      })
      void Promise.all(backs).then(() => void load()) // reload after the last one
    }
    if (moved.length === done.length) {
      offerUndo(`Moved ${moved.length} visit${moved.length === 1 ? '' : 's'} to next week`, putBack)
    } else {
      toast(`${moved.length} of ${done.length} moved; the rest did not, reload to see`)
      if (moved.length) offerUndo(`Moved ${moved.length} of ${done.length} visits to next week`, putBack)
    }
  })
}

// The customer's missed visit, from the payload's overdue list (booked, past,
// not a contact reminder). The server orders that list date ASC, id ASC, so
// the first hit is the OLDEST — the one a placement moves, one PATCH. Null
// when they have none (or the overdue read failed, which the diary survives).
// Per job (several jobs, src/diary-sets.ts): a gutters row finds the gutters' missed visit, never the windows'.
function missedCleanFor(c: DueEntry, p: SchedulePayload): Clean | null {
  return missedCleanOf(c, p, todayISO())
}

// ONE RULE for the whole panel (Liam, after an un-agreed Tuesday sat on a day
// card pretending to be agreed): the panel is for a date by the end of the
// week on screen that nobody has agreed — and since plan v3 (item A), not
// more than a fortnight before the week starts either. The fortnight is the
// fix for Ruth: nobody was rostered, the week rolled past her date, and the
// next panel asked only "who is due in the week I am looking at" — she had
// dropped out entirely, into Messages as overdue, with nothing to drag. Now
// someone you did not get to stays in front of you as the weeks move (their
// badge turns late, dueRow), while the long-overdue stay out: Messages owns
// chasing, this panel is for placing. Either nothing is in the diary yet (the
// original group), or the only future visit is the app's own suggestion,
// dated inside the week — the same kind of thing as a spreadsheet date, so it
// belongs in the panel too, and placing it MOVES that visit rather than
// making a second one (duePlacement below).
//
// The rule lives in src/diary-sets.ts dueEntries, per JOB since several jobs (step 2): a customer's windows and
// their gutters are two rows ("Gutters · £60"), each placed on its own. In order: a customer not active, or whose
// job has work waiting in a week with no day, is left out; so is one told "not now, ask again on…" for a date
// still to come (askAgainLater, the rule Messages' lists read); so is a job with no cycle. A MISSED visit
// qualifies them (item B) unless a real visit is already ahead (rebooked); with nothing booked they are in when the
// due date falls in the week or the fortnight before it; otherwise only as a carrier (below).
function dueCustomers(p: SchedulePayload): DueEntry[] {
  return dueEntries(p, customers, roundJobList, todayISO(), (c) => askAgainLater(c))
}

// The carrier half of that rule: their next visit is a suggestion — nobody
// agreed it — dated inside the week on screen, and no other future visit of
// theirs is in view (the week payload is the only place a second one could
// show; if one does, the suggestion stays a day proposal). A suggestion dated
// OUTSIDE the week on screen stays out of the panel, as now — it keeps its
// place on its own day card.
function dueCarrier(c: DueEntry, p: SchedulePayload): boolean {
  return dueCarrierOf(c, p, todayISO())
}

// What placing a due row on a day does. A customer with a MISSED visit MOVES
// that visit (item B — one PATCH on the same row, so the review box empties
// as they are placed instead of growing a second visit beside it); then a
// carrier MOVES their suggestion (the same PATCH the sheet rows use — the
// server stamps it a human booking and leaves it unconfirmed); a customer
// with nothing in the diary gets the create, as before. 'none' is the stale
// race — the customer still reads as a carrier but the payload no longer
// holds the suggestion — and doing nothing there beats creating a second
// visit.
function duePlacement(c: DueEntry, p: SchedulePayload): { kind: 'move'; clean: Clean } | { kind: 'create' } | { kind: 'none' } {
  const missed = missedCleanFor(c, p)
  if (missed) return { kind: 'move', clean: missed }
  if (!dueCarrier(c, p)) { const reminder = reminderAhead(c, p); return reminder ? { kind: 'move', clean: reminder } : { kind: 'create' } }
  const clean = p.cleans.find(cl => cl.id === c.next_booked_id && isSuggestion(cl))
  return clean ? { kind: 'move', clean } : { kind: 'none' }
}

// Roundly's "ask them" reminder, when it is all they have ahead (a customer whose cycle was set after their last visit;
// round 2): placing them moves it to the day, where the server makes it the owner's own visit, exactly as a suggestion
// is moved. A new visit beside it would be refused ("already has a booking"). Drawn from the week when it is in it, else
// from the customers read, which carries what a move needs (its id, version and date).
function reminderAhead(c: DueEntry, p: SchedulePayload): Clean | null {
  if (c.dueJob || c.next_booked_source !== 'tentative' || c.next_booked_confirmed || !c.next_booked_id || !c.next_booked || bookedAhead(c)) return null
  const inWeek = p.cleans.find((cl) => cl.id === c.next_booked_id)
  if (inWeek) return inWeek
  if (c.next_booked_version == null) return null
  return { id: c.next_booked_id, version: c.next_booked_version, customer_id: c.id, customer_name: c.name, customer_address: c.address, date: c.next_booked,
    state: 'booked', source: 'tentative', confirmed: 0, time_slot: null, time_agreed_for: null, job_id: null, kind: 'window', amount_pence: c.reg_price_pence,
    payment_status: 'unknown', payment_method: null, chased: 0, duration_minutes: null, sort_order: null, worker: null, note: null } as unknown as Clean
}

// The fields a new visit for a due row carries beyond its date: the job's price, and for an extra job its job and
// kind (several jobs), so a gutters row books gutters at the gutters price.
// The price is the booking form's (pricing.ts priceFor): no cycle, or more than one and a half cycles since the last
// visit, takes their one-off price when they have one (round 2 review: 158 of Dropby's 182 active customers have one).
// An extra job keeps its own price.
function duePrice(c: DueEntry, date: string): number | null {
  return c.dueJob ? c.reg_price_pence : priceFor(c, date, c.last_clean).pence
}
function dueBody(c: DueEntry, date: string): Record<string, unknown> {
  const pence = duePrice(c, date)
  return {
    ...(pence !== null ? { amount_pence: pence } : {}),
    ...(c.dueJob ? { job_id: c.dueJob.id, kind: c.dueJob.kind } : {}),
  }
}

// "Mrs Smith" or, for an extra job's row, "Mrs Smith's gutters".
function dueWho(c: DueEntry): string {
  return c.dueJob ? `${c.name}'s ${c.dueJob.name.toLowerCase()}` : c.name
}

// A create cannot be undone with a PATCH: the way back is to delete the visit
// the POST made, by the id the ack carries — the same shape as the roster
// undo in this file.
function bookDueOnDay(c: DueEntry, date: string, alongside: { worker?: string | null; time_slot?: string | null } = {}, after?: (visit: { id: number; version: number }, takeOff: () => void, placement: Placement) => void): void {
  if (goneDay(date)) return
  movingDueId = null
  const earlier = new Set(getQueue().map((q) => q.key))
  void mutate<{ id: number; version: number }>({
    label: `Book: ${dueWho(c)} on ${dayLabel(date)}`,
    method: 'POST',
    path: `/api/customers/${c.id}/cleans`,
    // allow_additional:false — the server refuses a second future visit. The
    // queue holds same-row work behind the first save and then releases each
    // one, so two quick placements would otherwise book the same customer
    // twice (the same defect proven on the WhatsApp send, 2026-09-16).
    body: { date, ...dueBody(c, date), state: 'booked', allow_additional: false,
      ...(alongside.worker ? { worker: alongside.worker } : {}), ...(alongside.time_slot ? { time_slot: alongside.time_slot } : {}) },
    // The day they went on lights up once when it is drawn again, only for a booking the server took (the movement set's
    // land; Astra, 24 Oct 2026: marked before the save, a refused or cancelled placing glowed on the next redraw). A
    // visit moved from Due keeps the move's own glow on its row.
    onAck: (ack) => { if (ack.ok && !ack.noop) diaryLandOn(date); void load() },
    onConflict: () => void load(),
  }).then((ack) => {
    // Two people at once (round 5): someone else booked them a moment ago on another phone or computer. Said in words,
    // with the day they are on now, not the server's refusal.
    if (!ack.ok && ack.status === 409) {
      // Nothing is left to save, so it is let go from the changes waiting to send (no red "didn't save", and no later
      // booking of theirs held behind it: round 5 review).
      const held = getQueue().find((q) => !earlier.has(q.key) && q.path === `/api/customers/${c.id}/cleans` && q.method === 'POST' && q.status === 'conflict')
      if (held) dismiss(held.key)
      if (ack.code === 'job_stopped') { toast(`${dueWho(c)} has been stopped, so nothing new was booked.`); void load(); return }
      void load().then(() => {
        const now = customers?.find((x) => x.id === c.id)
        const at = now?.next_booked && now.next_booked >= todayISO() ? now.next_booked : null
        toast(at ? `${dueWho(c)} was just put on ${dayLabel(at)} on another phone or computer, so nothing more was booked.` : `${dueWho(c)} was just booked on another phone or computer, so nothing more was booked.`)
      })
      return
    }
    if (!ack.ok && ack.status >= 400 && ack.status < 500) alert4xx(ack)
    // No signal (round 5): on the phone now, saved when signal returns; their message waits as "Message N" for then.
    if (ack.status === 0 && after) queueMessage({ id: c.id, name: c.name, date, visitId: 0 })
    if (!ack.ok || !ack.row) return void load()
    const created = ack.row
    const takeOff = (): void => {
      void mutate({
        label: `Undo book: ${c.name} off ${dayLabel(date)}`,
        method: 'DELETE',
        path: `/api/cleans/${created.id}`,
        body: { version: created.version },
        onAck: () => void load(),
        onConflict: () => void load(),
      })
    }
    offerUndo(`Booked ${dueWho(c)} on ${dayLabel(date)}`, takeOff)
    after?.(created, takeOff, { kind: 'pencil', id: created.id, version: created.version })
  })
}

// The row menu's book actions place a due row exactly where a day-drop does
// (duePlacement): a customer with nothing in the diary gets the create
// (bookDueOnDay, whose POST carries allow_additional:false — the server
// refuses the second future visit, which is what makes a double tap safe);
// a carrier MOVES their in-week suggestion instead of making a second visit.
// However someone in To place is put on a day (dropped, tapped then a date tapped, or the ⋯'s "Move to …"), New opens
// their message next, Design B (bug hunt, 8 Oct 2026: the ⋯ booked them with no message). Cancel there says what it
// does: a new visit comes off the day; a missed visit or Roundly's suggestion goes back.
function placeDueOn(c: DueEntry, date: string, p: SchedulePayload | null = payload): void {
  if (!p) return
  const place = duePlacement(c, p)
  const back = place.kind === 'move' && place.clean.date !== date ? place.clean.date : null
  const ask = (visit: { id: number }, takeOff: () => void, placement: Placement): void => askAfterPlacing(c, date, visit.id, takeOff, back, placement)
  // A visit they had agreed, moved: "your visit has moved", never a fresh ask (round 4). moveToDay's Undo bar offers it.
  if (place.kind === 'move' && place.clean.confirmed) moveToDay(place.clean, date)
  else if (place.kind === 'move') moveToDay(place.clean, date, ask)
  else if (place.kind === 'create') bookDueOnDay(c, date, {}, ask)
}

// Put a due row into a WEEK instead of onto a day (Liam, 2026-09-18: "we're
// probably managing them from this week's schedule, so there should be another
// way to do this"). The booking panel's tick was the only way in, and the panel
// is a detour from the list he actually works.
//
// Same three-way placement as a day drop, so a customer never grows a second
// visit: a MISSED visit moves into the week, then a carrier suggestion moves,
// and only a customer with nothing in the diary gets a create. The date is the
// week's Monday either way — one date per week, so two people put in the same
// week read as the same week.
function placeDueInWeek(c: DueEntry, week: string, p: SchedulePayload): void {
  const monday = mondayOf(week)
  movingDueId = null
  const place = duePlacement(c, p)
  if (place.kind === 'none') return void load()
  const label = `Put in the week of ${shortDate(monday)}: ${c.name}`
  if (place.kind === 'move') {
    const cl = place.clean
    const was = { version: cl.version, date: cl.date, time_slot: cl.time_slot ?? null, confirmed: cl.confirmed, time_agreed_for: timeIsAgreed(cl) ? cl.time_agreed_for : null, ...(isUnplaced(cl, cl.date, cl.date) ? { week_only: true } : {}) }
    void mutate({
      label,
      method: 'PATCH',
      path: `/api/cleans/${cl.id}`,
      body: { version: cl.version, date: monday, week_only: true },
      onAck: () => void load(),
      onConflict: () => void load(),
    }).then((ack) => {
      if (!ack.ok && ack.status >= 400 && ack.status < 500) alert4xx(ack)
      // Restore the complete original arrangement; week-only clears the time
      // and both agreements, so a date alone cannot undo the placement.
      undoPatch({
        text: `${c.name} is in the week of ${shortDate(monday)}, no day yet`,
        label: `Undo week: ${c.name} back to ${dayLabel(cl.date)}`,
        path: `/api/cleans/${cl.id}`,
        ack,
        version: was.version,
        body: { date: was.date, time_slot: was.time_slot, confirmed: was.confirmed, time_agreed_for: was.time_agreed_for, ...(was.week_only ? { week_only: true } : {}), undo_restore: true },
        after: () => void load(),
      })
    })
    return
  }
  void mutate<{ id: number; version: number }>({
    label,
    method: 'POST',
    path: `/api/customers/${c.id}/cleans`,
    // allow_additional:false for the same reason a day placement sends it:
    // two quick taps must not book the same customer twice.
    body: { date: monday, ...dueBody(c, monday), state: 'booked', week_only: true, allow_additional: false },
    onAck: () => void load(),
    onConflict: () => void load(),
  }).then((ack) => {
    if (!ack.ok && ack.status >= 400 && ack.status < 500) alert4xx(ack)
    if (!ack.ok || !ack.row) return void load()
    const created = ack.row
    offerUndo(`${c.name} is in the week of ${shortDate(monday)}, no day yet`, () => {
      void mutate({
        label: `Undo week: ${c.name} out of ${shortDate(monday)}`,
        method: 'DELETE',
        path: `/api/cleans/${created.id}`,
        body: { version: created.version },
        onAck: () => void load(),
        onConflict: () => void load(),
      })
    })
  })
}

// "Next week" has to mean a week that has not happened yet — the rule (step
// forward in whole weeks until the date is today or later) and its reasoning
// live in ../week-move.ts now, shared with the week panel's move-all (item C).
// The row menu's "Move to next week" imports the same function.

function dueRow(c: DueEntry, p: SchedulePayload): HTMLElement {
  const selected = movingDueId === dueKey(c)
  const due = dueDate(c)
  // A missed visit is the row's story, not a due date: the badge says what
  // was booked and didn't happen, in the late colour (item B), and "Book
  // next week" anchors on the missed day — the cycle due date is stale next
  // to a visit that was already missed.
  const missed = missedCleanFor(c, p)
  const anchor = missed?.date ?? due
  const row = el('div', {
    class: `clean-row tray-row due-row${selected ? ' tray-row-moving' : ''}`,
    role: 'button',
    tabindex: '0',
    draggable: 'true',
    'aria-pressed': selected ? 'true' : 'false',
    'aria-label': missed
      ? `${c.name} was due ${dayLabel(missed.date)} and never got done. Tap it, then tap Book on this day to move it to a new day.`
      : `${c.name} due ${due ? dayLabel(due) : 'this week'}, no visit yet. Tap it, then tap Book here on the day they should come.`,
  })
  row.dataset.pick = `due:${dueKey(c)}`
  row.addEventListener('click', (e) => {
    if ((e.target as Element | null)?.closest('.row-menu')) return // the ⋯ menu answers for itself
    movingDueId = selected ? null : dueKey(c)
    movingId = null
    movingEnqId = null
    notePick(row)
    const root = document.querySelector<HTMLElement>('#screen')
    if (payload && root) render(payload, root)
  })
  // A row announced as a button answers its key too, not just the tap. A key
  // aimed at a control inside the row (the ⋯ menu) is that control's.
  row.addEventListener('keydown', (e) => {
    if (e.target !== row) return
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); row.click() }
  })
  // The payload prefix marks this drag as a customer, not a visit id — the
  // day's drop handler reads the difference.
  row.addEventListener('dragstart', (e) => {
    if (!e.dataTransfer) return
    window.getSelection()?.removeAllRanges()
    e.dataTransfer.setData('text/plain', `due:${dueKey(c)}`)
    e.dataTransfer.effectAllowed = 'move'
    dragPicture(e, row)
    row.classList.add('tray-row-moving')
  })
  row.addEventListener('dragend', () => {
    row.classList.remove('tray-row-moving')
    for (const d of document.querySelectorAll<HTMLElement>('.day-card.drop-ready')) d.classList.remove('drop-ready')
  })
  const main = el('div', { class: 'sched-clean-main' })
  const line = el('span', { class: 'sched-clean-line' })
  // As on the sheet rows: the name opens the customer, everything else selects.
  const nameLink = el('a', { href: `#/customer/${c.id}`, class: 'sched-clean-link', 'aria-label': `Open ${c.name}` }, el('strong', {}, c.name))
  nameLink.addEventListener('click', (e) => e.stopPropagation())
  line.append(nameLink)
  if (c.address) {
    const { addr, warn } = splitAccessWarning(c.address)
    line.append(el('span', { class: 'sched-addr' }, ` ${addr}`))
    if (warn) line.append(el('span', { class: 'access-warn' }, warn))
  }
  main.append(line)
  const sub = el('span', { class: 'clean-badges' })
  // An extra job's row says which job (several jobs): "Gutters · £60".
  const price = duePrice(c, todayISO())
  if (c.dueJob) sub.append(el('span', { class: 'badge' }, `${c.dueJob.name}${price !== null ? ` · ${money(price)}` : ''}`))
  else if (price !== null) sub.append(el('span', { class: 'badge' }, money(price)))
  // The badge only when it has something to say: messaged-and-unreplied
  // reads "asked 16 Sep, no reply", the same wording the day rows use. A
  // customer never messaged gets nothing — there is no visit yet for "not
  // asked yet" to describe.
  // The same words Messages uses for them (visit-words.ts): offered days waiting, or asked and no reply.
  const ask = askWords(c, c.dueJob?.id ?? null)
  if (ask !== 'Not asked yet') sub.append(el('span', { class: 'badge badge-unconfirmed' }, ask))
  // The badge once the date has passed turns the late colour (plan v3 item
  // A): inside the panel's fortnight of grace the row is still here to be
  // placed, but "still to do" must not read as "due this week". A missed
  // customer gets the was-booked badge instead (item B) — same late colour;
  // their cycle due date is stale beside a visit that already didn't happen.
  // Back from "Not now, ask again on": they asked to wait, so the card says until when, never "late" (Due, round 1).
  const waited = c.follow_up_on && c.follow_up_on <= todayISO() && (!c.last_clean || c.follow_up_on > c.last_clean) ? c.follow_up_on : null
  if (missed) sub.append(el('span', { class: 'badge badge-due-week badge-due-late' }, `was due ${shortDate(missed.date)}, not done`))
  else if (waited) sub.append(el('span', { class: 'badge badge-due-week' }, `asked to wait until ${shortDate(waited)}`))
  else if (due) sub.append(el('span', { class: `badge badge-due-week${due < todayISO() ? ' badge-due-late' : ''}` }, `due ${dayLabel(due)}`))
  if ((c.due_pushes ?? 0) > 0) sub.append(el('span', { class: 'badge' }, `pushed ${c.due_pushes}×`))
  main.append(sub)

  // The same ⋯ every job row carries, wherever it sits (see jobMenu). A due
  // row is a CUSTOMER with nothing agreed, so its move lines place rather
  // than move, and it alone can be told "not now".
  // Diary and Messages as one (Liam, 8 Oct 2026): asking them happens in Messages, one tap from the row.
  const message = el('button', { type: 'button', class: 'diary-due-message', 'aria-label': `Message ${c.name}` }, 'Message')
  message.addEventListener('click', (e) => { e.stopPropagation(); openMessagesFor({ id: c.id, name: c.name }, 'customer') })
  row.append(main, message, jobMenu({ kind: 'due', customer: c, anchor, payload: p }))
  // Gutters due near the windows' booked day (several jobs, Liam Q1 and Q11): Roundly asks, and moves nothing itself.
  if (c.dueJob?.kind === 'gutter' && anchor) {
    const windows = customers?.find((x) => x.id === c.id)
    const day = windows && !windows.job_stopped_on && windows.next_booked ? gutterAsk(anchor, windows.next_booked) : null
    const key = `due:${dueKey(c)}:${day}`
    if (day && !gutterAskDeclined.has(key)) row.append(gutterAskBar(`Windows booked ${dayLabel(day)}. Book the gutters that day, first?`, () => void guttersOntoWindowsDay(c, null, day), key))
  }
  return row
}

// Yes to "Do the gutters that day, first?": the gutters go onto the windows day as part of the same stop, with the
// windows visit's person and time, so the worker's Today shows one card with the gutters above (Liam Q9, Q11). A
// due row is booked (or its own missed or suggested visit moved); a booked gutters visit is moved.
async function guttersOntoWindowsDay(due: DueEntry | null, visit: Clean | null, day: string): Promise<void> {
  const customerId = due?.id ?? visit!.customer_id
  let windows: Clean | undefined
  try {
    const detail = await api<{ cleans: Clean[] }>(`/api/customers/${customerId}`)
    windows = detail.cleans.find((v) => v.state === 'booked' && v.date === day && visitJobId(v) === null)
  } catch {
    // No signal: the gutters still go onto the day; the person and time are the day's own.
  }
  // A one-person round's saves never carry someone else's name (the server refuses it; review, 19 Oct 2026).
  const alongside = { worker: worksAlone() && otherName(windows?.worker) ? null : windows?.worker ?? null, time_slot: windows?.time_slot ?? null }
  if (due) {
    const place = payload ? duePlacement(due, payload) : { kind: 'create' as const }
    if (place.kind === 'create') return bookDueOnDay(due, day, alongside)
    if (place.kind === 'move') return guttersMove(place.clean, day, alongside)
    return void load()
  }
  guttersMove(visit!, day, alongside)
}

function guttersMove(cl: Clean, day: string, alongside: { worker: string | null; time_slot: string | null }): void {
  const was = { version: cl.version, date: cl.date, time_slot: cl.time_slot ?? null, worker: cl.worker ?? null, confirmed: cl.confirmed, time_agreed_for: timeIsAgreed(cl) ? cl.time_agreed_for : null }
  const body: Record<string, unknown> = { version: cl.version, date: day, adopt_booking: true }
  if (alongside.time_slot) body.time_slot = alongside.time_slot
  if (alongside.worker) body.worker = alongside.worker
  void mutate({ label: `Move: ${cl.customer_name ?? ''} gutters to ${dayLabel(day)}`, method: 'PATCH', path: `/api/cleans/${cl.id}`, body }).then((ack) => {
    if (!ack.ok && ack.status >= 400 && ack.status < 500) alert4xx(ack)
    void load()
    undoPatch({ text: `Moved ${cl.customer_name ?? 'the'} gutters to ${dayLabel(day)}`, label: `Undo move: ${cl.customer_name ?? ''} gutters back to ${dayLabel(was.date)}`, path: `/api/cleans/${cl.id}`, ack, version: was.version,
      // A one-person round's Undo leaves someone else's name alone rather than send it (review, 19 Oct 2026).
      body: { date: was.date, time_slot: was.time_slot, ...(worksAlone() && otherName(was.worker) ? {} : { worker: was.worker }), confirmed: was.confirmed, time_agreed_for: was.time_agreed_for, undo_restore: true }, after: () => void load() })
  })
}

// "Windows booked Thu 30 Oct. Do the gutters that day, first?" Yes does it; No hides the question for now.
function gutterAskBar(question: string, yes: () => void, key: string): HTMLElement {
  const bar = el('div', { class: 'gutters-ask', role: 'group', 'aria-label': question })
  const ok = el('button', { type: 'button', class: 'btn-primary' }, 'Yes')
  const no = el('button', { type: 'button' }, 'No')
  for (const b of [ok, no]) b.addEventListener('click', (e) => e.stopPropagation())
  ok.addEventListener('click', () => { ok.disabled = true; yes() })
  no.addEventListener('click', () => { gutterAskDeclined.add(key); bar.remove() })
  bar.append(el('span', {}, question), ok, no)
  return bar
}

// A booked gutters visit within a fortnight either side of a windows visit booked at the same house, and on neither
// the windows day nor the day before it (gutters go on the windows day or the day before, never after): the diary
// asks to move it onto the windows day. Several jobs on only; never a done visit.
function gutterAskFor(cl: Clean, p: SchedulePayload): HTMLElement | null {
  if (!severalJobsOn() || cl.state !== 'booked' || cl.kind !== 'gutter' || isContact(cl)) return null
  const today = todayISO()
  const windowsDays = [
    ...p.cleans.filter((o) => o.customer_id === cl.customer_id && o.id !== cl.id && o.state === 'booked' && o.kind === 'window' && visitJobId(o) !== visitJobId(cl) && o.date >= today && !isContact(o)).map((o) => o.date),
    ...(customers?.find((x) => x.id === cl.customer_id && !x.job_stopped_on)?.next_booked ? [customers!.find((x) => x.id === cl.customer_id)!.next_booked!] : []),
  ].sort()
  for (const w of windowsDays) {
    const day = gutterAsk(cl.date, w)
    if (!day || day < today) continue
    const key = `visit:${cl.id}:${day}`
    if (gutterAskDeclined.has(key)) return null
    return gutterAskBar(`Windows booked ${dayLabel(day)}. Do the gutters that day, first?`, () => void guttersOntoWindowsDay(null, cl, day), key)
  }
  return null
}

// One enquiry row. A lead has no page of its own — New jobs is its home —
// so unlike the other two groups the name is not a link. No Cancel either:
// winning or losing the job is a New-jobs edit, not a diary act.
function enquiryRow(l: Lead): HTMLElement {
  const selected = movingEnqId === l.id
  const row = el('div', {
    class: `clean-row tray-row due-row${selected ? ' tray-row-moving' : ''}`,
    role: 'button',
    tabindex: '0',
    draggable: 'true',
    'aria-pressed': selected ? 'true' : 'false',
    'aria-label': `Enquiry from ${l.name}${l.quoted_on ? `, ${shortDate(l.quoted_on)}` : ''}, not on the round yet. Tap it, then tap Book as new customer on the day for their first visit.`,
  })
  row.dataset.pick = `enq:${l.id}`
  row.addEventListener('click', () => {
    movingEnqId = selected ? null : l.id
    movingId = null
    movingDueId = null
    notePick(row)
    const root = document.querySelector<HTMLElement>('#screen')
    if (payload && root) render(payload, root)
  })
  // A row announced as a button answers its key too, not just the tap.
  row.addEventListener('keydown', (e) => {
    if (e.target !== row) return
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); row.click() }
  })
  // The payload prefix marks this drag as an enquiry — the day's drop
  // handler reads the difference.
  row.addEventListener('dragstart', (e) => {
    if (!e.dataTransfer) return
    window.getSelection()?.removeAllRanges()
    e.dataTransfer.setData('text/plain', `enq:${l.id}`)
    e.dataTransfer.effectAllowed = 'move'
    dragPicture(e, row)
    row.classList.add('tray-row-moving')
  })
  row.addEventListener('dragend', () => {
    row.classList.remove('tray-row-moving')
    for (const d of document.querySelectorAll<HTMLElement>('.day-card.drop-ready')) d.classList.remove('drop-ready')
  })
  const main = el('div', { class: 'sched-clean-main' })
  const line = el('span', { class: 'sched-clean-line' })
  line.append(el('strong', {}, l.name))
  if (l.address) {
    const { addr, warn } = splitAccessWarning(l.address)
    line.append(el('span', { class: 'sched-addr' }, ` ${addr}`))
    if (warn) line.append(el('span', { class: 'access-warn' }, warn))
  }
  main.append(line)
  const sub = el('span', { class: 'clean-badges' })
  // The phone is on the row because ringing back is the first act on an
  // enquiry — same call link the day rows use.
  const tel = telHref(l.phone)
  if (tel && l.phone) sub.append(el('a', { href: tel, class: 'maps-link call-link', 'aria-label': `Call ${l.name}` }, l.phone))
  sub.append(el('span', { class: 'badge badge-enquiry' }, `Enquiry ${shortDate(l.quoted_on) || 'no date'}`))
  // Tapped Reply today: the row stays in view for the day, marked, so a tap
  // that never became a message can be taken back from here. Jill Green,
  // 2026-09-17: the tap was counted, the message never went, and the row
  // had left the tab with nowhere on the diary to put her back.
  const messagedToday = enquiryMessagedToday(l, todayISO())
  if (messagedToday) sub.append(el('span', { class: 'badge badge-booked' }, 'messaged today'))
  // "if short": one line on a phone; a longer note lives in New jobs.
  if (l.notes && l.notes.length <= 80) sub.append(el('span', { class: 'clean-note' }, l.notes))
  main.append(sub)
  row.append(main)
  if (messagedToday) {
    const actions = el('div', { class: 'clean-actions' })
    // The send that is still the enquiry's latest change (put_back_key), put back exactly (tidy-up item 6, 20 Oct 2026).
    if (l.put_back_key) {
      const didnt = el('button', { type: 'button', class: 'link-button rebook-didnt-send' }, "Didn't send it? Put them back")
      didnt.addEventListener('click', (e) => { e.stopPropagation(); if (!enquiryFree(l, e)) return; didnt.disabled = true; uncountEnquiryReply(l) })
      actions.append(didnt)
    }
    row.append(actions)
    return row
  }
  // Reply by WhatsApp, or by email when the lead has an address. Round icons
  // now, not the wide green button (Liam 2026-09-17: "it can just be a phone
  // icon in green. Also do a email icon"). The tap must not also select the
  // row for placing, so it stops at the link. Both taps count the same way
  // (recordEnquiryReply) and the note line says which went.
  // Text for a round that texts, else WhatsApp as before (contact.ts leadPhoneLink).
  const phoneLink = leadPhoneLink(l.phone, enquiryFirstMessage(l.name), { own: l.message_by })
  const wa = phoneLink.href
  const mail = enquiryEmailHref(l.email, l.name)
  const actions = el('div', { class: 'clean-actions enquiry-icons' })
  if (wa) {
    const way = phoneLink.channel === 'text' ? 'text' : 'whatsapp'
    const link = el('a', { href: wa, target: way === 'text' ? '_self' : '_blank', rel: 'noopener', class: 'icon-btn icon-btn-wa', 'aria-label': `${way === 'text' ? 'Text' : 'WhatsApp'} ${l.name}` })
    link.append(wayIcon(way))
    link.addEventListener('click', e => e.stopPropagation())
    link.addEventListener('auxclick', e => e.stopPropagation())
    bindEmailSend(link, () => enquiryFree(l) ? { href: wa, name: l.name, sent: () => recordEnquiryReply(l, link, phoneLink.channel) } : null)
    actions.append(link)
  }
  if (mail) {
    const mlink = el('a', { href: mail, class: 'icon-btn icon-btn-mail', 'aria-label': `Email ${l.name}` })
    mlink.append(mailIcon())
    mlink.addEventListener('click', e => e.stopPropagation())
    mlink.addEventListener('auxclick', e => e.stopPropagation())
    bindEmailSend(mlink, () => enquiryFree(l) ? { href: mail, sent: () => recordEnquiryReply(l, mlink, 'email') } : null)
    actions.append(mlink)
  }
  if (!wa && !mail) {
    actions.append(el('span', { class: 'muted' }, 'No number or email on file'))
  }
  // One Reply on the card, as small as the tray's other buttons (Liam, 4 Nov 2026: the two round buttons were "too big";
  // https://claude.ai/artifact/31KRPRm6zQtQbbDNQzdnMW): a tap shows the ways to reach them, each named (Text or WhatsApp,
  // Email, Call), the same links and counting as before.
  if (wa || mail) {
    for (const a of actions.querySelectorAll<HTMLElement>('a.icon-btn')) a.append(el('span', { class: 'enquiry-way-word' }, a.getAttribute('aria-label')?.split(' ')[0] ?? ''))
    if (tel && l.phone) {
      const call = el('a', { href: tel, class: 'icon-btn icon-btn-call', 'aria-label': `Call ${l.name}` }, el('span', { class: 'enquiry-way-word' }, 'Call'))
      call.addEventListener('click', e => e.stopPropagation())
      actions.append(call)
    }
    actions.hidden = true
    const reply = el('button', { type: 'button', class: 'btn-primary enquiry-reply', 'aria-expanded': 'false' }, 'Reply')
    reply.addEventListener('click', (e) => { e.stopPropagation(); actions.hidden = !actions.hidden; reply.setAttribute('aria-expanded', String(!actions.hidden)) })
    reply.addEventListener('keydown', e => e.stopPropagation())
    row.append(reply)
  }
  row.append(actions)
  return row
}

// The standard first reply to a website enquiry, sent from here rather than
// making him walk to Messages (Liam 2026-09-16: "there's no WhatsApp button
// there on those new enquiries... should just be a standard, thanks for
// reaching out"). The WORDS are `enquiryFirstMessage`, the same ones Messages
// sends — one reply, one place it is written, whichever screen taps it.
//
// Sending keeps the row in the tab for the rest of today, marked "messaged
// today" with a put-back, then it leaves: once they have been messaged they
// are no longer a NEW enquiry, they are one waiting for a reply, and Messages
// owns that ladder (first message, five days, chase, take off).
function recordEnquiryReply(l: Lead, link: HTMLAnchorElement, channel: NoteChannel): void {
  const today = todayISO()
  const n = enquiryMessages(l) + 1
  const note = appendNote(l.contact_note, enquiryNoteLine(noteDate(today), n, channel))
  const body: Record<string, unknown> = {
    version: l.version,
    enquiry_messages: n,
    enquiry_messaged_on: today,
    last_contacted_on: today,
  }
  // Left out when the line would not fit: the owner's own note must survive.
  if (note !== (l.contact_note ?? '')) body.contact_note = note
  // One send action (functions/lib/enquiry-send.ts; tidy-up items 6 and 9, 20 Oct 2026): its words kept, read up to what
  // this phone had seen from them, and one exact put-back.
  body.sent = { way: channel === 'WhatsApp' ? 'whatsapp' : channel, words: enquiryFirstMessage(l.name), upto: l.last_in_id ?? 0 }
  link.setAttribute('aria-disabled', 'true')
  void mutate({
    label: `Enquiry ${channel}: ${l.name}`,
    method: 'PATCH',
    path: `/api/leads/${l.id}`,
    body,
    onAck: (ack) => {
      alert4xx(ack)
      void load()
      // Undo puts that send back on the server, exactly, while it is still the latest change.
      const key = (ack.row as { sent_key?: unknown } | undefined)?.sent_key
      if (typeof key === 'string') undoPatch({ text: countedWords(channel, l.name), label: `Undo enquiry ${channel}: ${l.name}`, path: `/api/leads/${l.id}`, ack, version: l.version, body: { unsend: key }, after: () => void load() })
    },
    onConflict: () => void load(),
  })
}

// One at a time (AGREED.md 6, "a double tap records once"; GPT-6.1's review, E04, 20 Oct 2026): while a send or its
// put-back is still on its way for this enquiry (no signal, or not answered yet), another tap on its links opens nothing
// and records nothing, as Messages' cards do (rebook.ts enquirySending).
function enquiryFree(l: Lead, e?: Event): boolean {
  const busy = getQueue().some((q) => q.path === `/api/leads/${l.id}` && q.method === 'PATCH' && q.status !== 'conflict' && q.status !== 'failed' && !!q.body
    && typeof q.body === 'object' && ('sent' in (q.body as Record<string, unknown>) || 'unsend' in (q.body as Record<string, unknown>)))
  if (!busy) return true
  e?.preventDefault()
  toast('Still saving that job. Try again in a moment.')
  return false
}

// The way back once the ten-second undo has gone: the server puts that exact send back while it is still the enquiry's
// latest change (put_back_key), the same put-back Messages offers (rebook.ts putBackSend). No count is taken off by hand
// (tidy-up item 6, 20 Oct 2026).
function uncountEnquiryReply(l: Lead): void {
  const key = l.put_back_key
  if (!key) return
  const path = `/api/leads/${l.id}`
  void mutate({
    label: `Didn't send: ${l.name}`,
    method: 'PATCH',
    path,
    body: { version: l.version, unsend: key },
    onAck: () => void load(),
    onConflict: (ack) => {
      // Changed since, or already put back: said in the server's words, never left as a change to sort out.
      for (const q of getQueue()) if (q.path === path && q.status === 'conflict' && !!q.body && typeof q.body === 'object' && 'unsend' in (q.body as Record<string, unknown>)) dismiss(q.key)
      toast(ack.error ?? "That message can't be put back now.")
      void load()
    },
  }).then((ack) => { if (!ack.ok && ack.status >= 400 && ack.status < 500 && ack.status !== 409) toast(ack.error ?? "That message can't be put back now.") })
}

// ---- placing an enquiry -----------------------------------------------------
//
// Dropping an enquiry on a day is THREE saves in order, each needing the one
// before it — the fresh lead version, then the new customer id: mark the
// lead CONFIRMED, convert it, book the first visit. Confirming is also what
// takes the row out of the tab (only status_raw moves the derived status).
// The offline queue chains versions within ONE method+path only, so the
// chain is threaded by hand through these awaits — and a step that does not
// ack (offline park, 409, rejection) STOPS the chain on screen: a
// half-converted lead is worse than an unplaced one, and an offline park has
// no ack to continue from.

// Leads with a placement in flight. A second placement of the same lead (a
// double-tap, or a drop racing a tap) would 409 against its own first step —
// refused outright instead.
const placingEnquiries = new Set<number>()

function stopPlacement(lead: Lead, ack: Ack, step: string, advice: string): void {
  placingEnquiries.delete(lead.id)
  window.alert(`Placing ${lead.name} stopped at ${step}: ${ack.error ?? `HTTP ${ack.status}`}. ${advice}`)
  void load()
}

function placeEnquiry(lead: Lead, date: string): void {
  if (goneDay(date)) return
  movingEnqId = null
  // No price yet: their quote comes before a day (round 5 of docs/plans/diary-due/PLAN.md). The quote writer opens;
  // once it is saved they can be put on a day.
  if (lead.initial_pence == null && lead.regular_pence == null) {
    toast(`${lead.name} has no price yet. Write their quote first, then put them on a day.`)
    void import('../write-quote').then(({ openWriteQuote }) => openWriteQuote(lead, () => void load()))
    return
  }
  if (placingEnquiries.has(lead.id)) {
    toast(`Still placing ${lead.name} — wait for it to finish`)
    return
  }
  // Placing an enquiry is three saves, each waiting on the one before, so it needs signal: with none, say so before
  // anything is saved, rather than stopping after the first (the review of 27 Oct 2026).
  if (isLocalOnly() || (typeof navigator !== 'undefined' && navigator.onLine === false)) {
    toast(`No signal. Putting ${lead.name} on a day needs signal: nothing has changed. Try again with signal, or use Book them in on their card.`)
    return
  }
  // Someone already on the round? New jobs never auto-links, and neither
  // does a drop: ANY match candidate opens the same choose-existing-or-
  // create dialog New jobs converts with (no second copy of that machinery).
  // A failed customers read counts as UNKNOWN, and unknown goes the safe way
  // round: the dialog fetches its own list.
  const hasCandidate = customers ? findCustomerMatches(lead, customers).length > 0 : true
  placingEnquiries.add(lead.id)
  void mutate<Lead>({
    label: `Confirm enquiry: ${lead.name}`,
    method: 'PATCH',
    path: `/api/leads/${lead.id}`,
    body: { version: lead.version, status_raw: 'CONFIRMED' },
  }).then((confirmAck) => {
    if (!confirmAck.ok || !confirmAck.row) {
      // Signal lost on the way: the confirm saves when it is back; the rest is finished from New jobs.
      if (confirmAck.status === 0) {
        placingEnquiries.delete(lead.id)
        toast(`Signal lost. ${lead.name} is marked confirmed when it is back; then put them on the day from New jobs.`)
        void load()
        return
      }
      return stopPlacement(lead, confirmAck, 'marking confirmed', 'The enquiry may already have gone through — check New jobs before trying again.')
    }
    const confirmed = confirmAck.row
    if (hasCandidate) {
      // The dialog finishes the job (link an existing customer or create).
      // Cancelling it here leaves the lead CONFIRMED with its Convert…
      // button in New jobs — the truth of what already happened.
      // The New-jobs screen is imported HERE, not at the top of the file:
      // its module-level queue listener reads `location`, and the client
      // harness (bug-hunt-client) loads this screen with no location — the
      // same lazy pattern as the day-map panel above.
      placingEnquiries.delete(lead.id)
      void import('./new-jobs')
        .then((nj) => {
          nj.openConvert(confirmed, document.body)
          // Say out loud what already happened. Marking the lead confirmed is
          // what makes the dialog legal (canConvertLead), and it also takes the
          // enquiry OUT of this tab and out of the Messages enquiry list. Close
          // the dialog without finishing and the enquiry has quietly moved to
          // one screen; a line on the way in is cheaper than wondering later
          // where they went.
          toast(`${lead.name} is marked confirmed now. If you close that panel without finishing, pick them up in New jobs.`)
          void load()
        })
        .catch(() => window.alert(`Could not open the choose-customer panel. ${lead.name} is marked confirmed — finish placing them from New jobs.`))
      return
    }
    return mutate<Lead>({
      label: `Convert enquiry: ${lead.name}`,
      method: 'POST',
      path: `/api/leads/${lead.id}/convert`,
      body: { mode: 'create', version: confirmed.version },
    }).then((convertAck) => {
      if (!convertAck.ok || !convertAck.row) {
        return stopPlacement(lead, convertAck, 'creating the customer', `${lead.name} is marked confirmed but no customer was made — finish the conversion in New jobs.`)
      }
      const customerId = convertAck.row.converted_customer_id
      if (typeof customerId !== 'number') {
        return stopPlacement(lead, { ok: false, status: 0, error: 'the answer did not name the new customer' }, 'creating the customer', `${lead.name} is marked confirmed — check New jobs.`)
      }
      // The first visit carries the lead's initial price — the same figure a
      // created customer keeps as their first-clean price — falling back to
      // the regular price when only that was quoted. allow_additional:false
      // is the server's second-visit guard: without it the same placement
      // twice books the same person twice.
      const price = lead.initial_pence ?? lead.regular_pence
      return mutate({
        label: `Book first visit: ${lead.name} on ${dayLabel(date)}`,
        method: 'POST',
        path: `/api/customers/${customerId}/cleans`,
        body: { date, ...(price !== null ? { amount_pence: price } : {}), state: 'booked', allow_additional: false },
      }).then((bookAck) => {
        if (!bookAck.ok) {
          return stopPlacement(lead, bookAck, 'booking the visit', `${lead.name} is a customer now but nothing is on ${dayLabel(date)} — book their first visit from their page.`)
        }
        placingEnquiries.delete(lead.id)
        toast(`${lead.name} is a customer — first visit booked for ${dayLabel(date)}`)
        void load()
      })
    })
  })
}

function trayRow(cl: Clean): HTMLElement {
  const selected = movingId === cl.id
  const row = el('div', {
    class: `clean-row tray-row${selected ? ' tray-row-moving' : ''}`,
    'data-clean-id': String(cl.id),
    role: 'button',
    tabindex: '0',
    draggable: 'true',
    'aria-pressed': selected ? 'true' : 'false',
    'aria-label': `${cl.customer_name ?? `#${cl.customer_id}`}, ${fromTheSheet(cl) ? `sheet said w/c ${shortDate(cl.date)}` : `week of ${shortDate(cl.date)}, no day chosen`}. Tap it, then tap Move here on the day it belongs to.`,
  })
  row.dataset.pick = `clean:${cl.id}`
  row.addEventListener('click', (e) => {
    if ((e.target as Element | null)?.closest('.row-menu')) return // the ⋯ menu answers for itself
    movingId = selected ? null : cl.id
    movingEnqId = null
    const root = document.querySelector<HTMLElement>('#screen')
    notePick(row)
    if (payload && root) render(payload, root)
  })
  // A row announced as a button answers its key too, not just the tap. A key
  // aimed at a control inside the row (the ⋯ menu) is that control's.
  row.addEventListener('keydown', (e) => {
    if (e.target !== row) return
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); row.click() }
  })
  row.addEventListener('dragstart', (e) => {
    if (!e.dataTransfer) return
    // Only this customer is dragged: any text left selected on the page would otherwise be dragged instead, with
    // every customer and day in it (Liam, 29 Sep), and the drop would move nothing.
    window.getSelection()?.removeAllRanges()
    e.dataTransfer.setData('text/plain', String(cl.id))
    e.dataTransfer.effectAllowed = 'move'
    dragPicture(e, row)
    row.classList.add('tray-row-moving')
  })
  row.addEventListener('dragend', () => {
    row.classList.remove('tray-row-moving')
    for (const d of document.querySelectorAll<HTMLElement>('.day-card.drop-ready')) d.classList.remove('drop-ready')
  })
  const main = el('div', { class: 'sched-clean-main' })
  const line = el('span', { class: 'sched-clean-line' })
  // The name still opens the customer (as on the day rows), but the row's tap
  // belongs to the move: only the name is a link, everything else selects.
  const nameLink = el('a', { href: `#/customer/${cl.customer_id}`, class: 'sched-clean-link', 'aria-label': `Open ${cl.customer_name ?? 'customer'}` }, el('strong', {}, cl.customer_name ?? `#${cl.customer_id}`))
  nameLink.addEventListener('click', (e) => e.stopPropagation())
  line.append(nameLink)
  if (cl.customer_address) {
    // Same split as the day rows: the address reads, the buried access
    // warning (e.g. "DO NOT BOOK BETWEEN 11-1PM") gets its own weight.
    const { addr, warn } = splitAccessWarning(cl.customer_address)
    line.append(el('span', { class: 'sched-addr' }, ` ${addr}`))
    if (warn) line.append(el('span', { class: 'access-warn' }, warn))
  }
  main.append(line)
  const sub = el('span', { class: 'clean-badges' })
  // Whole pounds, as everywhere else in the Diary ("£35", not "£35.00"); and "Not asked yet" alone, since nobody has a time
  // before they're asked (Liam, 4 Nov 2026: "Do all four").
  if (cl.amount_pence !== null) sub.append(el('span', { class: 'badge' }, (priceWords(cl) ?? money(cl.amount_pence)).replace(/\.00\b/g, '')))
  const asking = agreementBadge(cl)
  if (asking.childElementCount === 0) asking.textContent = (asking.textContent ?? '').replace(/ · no set time$/, '')
  sub.append(asking)
  // The two-line card (Liam, 3 Nov 2026: "2 lines is much better"): the week is said once, by the list's own heading on
  // the phone and here as "No day yet" on the computer, never three times; the job joins the line.
  sub.append(el('span', { class: `badge badge-sheet-said${fromTheSheet(cl) ? '' : ' is-week'}`, title: `Week of ${shortDate(mondayOf(cl.date))}, no day yet` }, fromTheSheet(cl) ? `sheet said w/c ${shortDate(cl.date)}` : 'No day yet'))
  const job = visitJobLabel(cl)
  if (job) sub.append(el('span', { class: 'badge badge-job' }, job))
  const also = alsoBookedText(cl, payload?.also_booked, todayISO())
  if (also) sub.append(el('span', { class: 'badge badge-also-booked' }, also))
  main.append(sub)
  // Cancel left the face with everything else: it is in the ⋯ now, which is
  // the same menu the day rows and the Due this week rows carry. A tray row
  // holds a WEEK rather than a day, so its "next week" keeps it dayless.
  row.append(main, jobMenu({ kind: 'tray', clean: cl }))
  return row
}

// The enquiries nobody has answered yet (see render's note on the rule): Due's New tab, the week's and the month's.
function freshEnquiries(): Lead[] {
  if (!leads) return []
  const today = todayISO()
  const cutoff = addDaysISO(today, -2)
  const oldest = addDaysISO(today, -ENQUIRY_FRESH_DAYS)
  // A row messaged TODAY stays too (marked, with a put-back), because the tap counts the message before it is known
  // to have gone.
  const fresh = (l: Lead): boolean =>
    Math.max(0, Math.round(Number(l.enquiry_messages) || 0)) === 0 &&
    (!l.last_contacted_on || l.last_contacted_on < cutoff)
  return leads
    .filter(leadIsOpen)
    // Remind me in a week (tidy-up item 6, Sonnet's edge case S E3, 20 Oct 2026): a reminder still to come keeps them
    // off, as on Messages; a reply from them wins. Its day come, first until something is done.
    .filter((l) => !(askAgainLater(l) && !((l.replies_unseen ?? 0) > 0)))
    .filter((l) => !!l.quoted_on && l.quoted_on >= oldest)
    .filter((l) => fresh(l) || enquiryMessagedToday(l, today))
    .sort((a, b) => Number(isFollowupDue(b)) - Number(isFollowupDue(a)) || (b.quoted_on ?? '9999-12-31').localeCompare(a.quoted_on ?? '9999-12-31') || b.id - a.id)
}

function render(p: SchedulePayload, root: HTMLElement): void {
  // Planning shows only while its day is drawn (the Day draws several days; startPlanning, the phone Day's card).
  root.classList.remove('diary-planning')
  diaryDraws++
  // Month is on screen: the week is never drawn over it (round 3 review); Month reads again instead.
  if (diaryView() === 'month') { monthOnDataChanged(); return }
  beginDiaryColours(`${weekMode()}:${onAPhone() ? 'phone' : 'desk'}:${p.from}`, JSON.stringify([diarySearch, workerFilter, areaFilter]))
  // Day drawn without going ahead to the Diary's own later day: the person picked the day, which stays.
  if (weekMode() === 'day' || selectedDate !== chosenDay) chosenAhead = null
  // A Due card held on the phone: the diary is drawn again once it is let go (round 2 review).
  if (dueDragLive()) {
    // Only while the diary is still the screen (the router keeps #screen for every screen).
    const gen = routeGen
    if (!drawAfterDrag) { drawAfterDrag = true; whenDueDragEnds(() => { drawAfterDrag = false; const now = document.querySelector<HTMLElement>('#screen'); if (payload && gen === routeGen && now === root && root.isConnected && diaryView() === 'week') render(payload, root) }) }
    return
  }
  // A one-person round has no worker filter (Liam, 19 Oct 2026): one chosen before it was switched on is cleared, so it
  // can never hide visits.
  if (worksAlone()) workerFilter = ''
  selectInitialDay(p)
  const orderFocus = root.querySelector<HTMLElement>('.diary-order-buttons :focus')?.getAttribute('aria-label')
  // Redrawing empties the screen for a moment, and the browser then drops the reader back up the page (Liam,
  // 29 Sep: tapping a week-panel customer jumped him to the top). Where they were is put back once drawn.
  const focusedVisit = root.querySelector<HTMLElement>('.diary-row-summary:focus')?.closest<HTMLElement>('[data-clean-id]')?.dataset.cleanId
  const focused = document.activeElement as HTMLElement | null
  const active = diaryDesk() && focused?.closest ? focused : null
  const activeRow = active?.closest('.diary-desk-agenda') ? active.closest<HTMLElement>('.clean-row') : null
  const deskFocusAt = active && activeRow ? {id: activeRow.dataset.cleanId, cls: ['diary-row-summary','diary-desk-confirm','diary-move','diary-done','diary-row-name'].find(c => active.classList.contains(c))} : null
  const keepY = window.scrollY
  // Design B's stops snap into place on the phone's Day (stop-motion.ts); a reorder settles its own way.
  const stopsBefore = !diaryDesk() && weekMode() === 'day' && !orderFeedback ? captureStops(root, selectedDate) : null
  clear(root)
  const heading = el('div', { class: 'page-heading' }, el('div', {}, el('h2', {}, 'The diary'), el('p', { class: 'muted' }, 'Plan the week, agree visits and record completed work.')))
  const book = el('button', { class: 'btn-primary' }, '+ Book a visit')
  // Today when the diary is showing this week (Liam's iPhone, 26 Sep: it
  // offered Monday, already past); otherwise the first day on show.
  book.addEventListener('click', () => {
    const today = todayISO()
    // Nobody on the round yet: the first job, never a customer picker with nobody in it (19 Oct 2026).
    if (customers && customers.length === 0) { void import('../first-job').then((m) => m.openFirstJob()); return }
    openBooking({ date: selectedDate >= p.from && selectedDate <= p.to ? selectedDate : today >= fromDate && today <= addDaysISO(fromDate, WINDOW_DAYS - 1) ? today : fromDate })
  })
  heading.append(book); diaryPage(root, heading); root.append(heading)
  // A new round's welcome (welcome.ts) sits first until its three steps are
  // done; it loads on its own and never holds up the diary.
  const welcome = el('div', { class: 'welcome-slot' })
  root.append(welcome)
  // The card drawn last time goes straight back while the new one is worked out, so the page does not jump
  // when the diary redraws (Liam, 29 Sep: tapping a week-panel customer threw him back to the top).
  const keptNext = lastWhatsNextCard()
  if (keptNext) welcome.replaceChildren(keptNext)
  // When there is no welcome, a new round gets "What's next" in its place (whats-next.ts).
  const diaryCustomers = customers
  void renderWelcome(welcome, diaryCustomers).then((shown) => {
    if (!shown && welcome.isConnected) { void renderWhatsNext(welcome, diaryCustomers); return }
    // A new round's "Book your first job" goes straight under the dates on a phone, the first thing seen (19 Oct 2026:
    // it was drawn under the whole week).
    const dates = welcome.parentElement?.querySelector<HTMLElement>(':scope > .diary-phone-dates')
    if (shown && dates && welcome.querySelector('.first-job-card') && dates.nextElementSibling !== welcome) dates.after(welcome)
  })
  // The compact action summary sits above everything else on the diary. It
  // loads its own whole-round data and must never block the day view — the
  // worst case inside it is a counts-unavailable line (see attention.ts).
  setNeedsExtras(() => []) // the New layouts add theirs once drawn (Design B)
  setWaitingLine(waitingLineOf)
  // The phone diary draws only the lines acted on there, and counts them on its Needs you button (round 2).
  // ...and so does the computer since round 3 (the same lines; Waiting on is on its Due column).
  setNeedsOnly(PHONE_NEEDS)
  setNeedsWatch(onNeedsLines)
  setNoDateOpener(() => (phoneNew() ? openDueSheet('first') : openDeskFirstVisit()))
  const attention = el('div', {class:'diary-attention-slot'}); root.append(attention); renderAttention(attention)
  const workers = knownWorkers(p)
  const roster = p.round_days ?? []
  const allOverdue = p.overdue ?? []
  // The review box IS the missed list (item B) — the same predicate Due this
  // week and Messages read, so a visit leaves the box the moment it moves.
  // It also leaves the moment the customer has a real visit in the diary
  // ahead of them (rebooked): booking someone back in from the booking panel
  // creates a visit beside the missed one instead of moving it, and the box
  // must not keep asking for work that is already agreed. When the customer
  // read failed there is nothing to test against, so every missed visit stays
  // listed — the box over-asking beats it going quiet.
  // Per job (several jobs, src/diary-sets.ts): the gutters booked ahead never settle a missed windows visit.
  const overdue = reviewVisits(allOverdue, customers, roundJobList, todayISO())
  const contacts = [...allOverdue.filter(isContact), ...p.cleans.filter(isContact)].filter((c, i, list) => list.findIndex(x => x.id === c.id) === i)
  // Nothing waiting: no box at all, the same rule the week panel below follows
  // when its three groups are empty (Liam, 2026-09-18 — "· 0" is nothing he
  // would act on, and left open it was a heading, a paragraph and a line of
  // nothing at the top of the screen he opens most). It comes back the moment
  // a visit needs an answer. A box whose rows are all hidden by the worker or
  // area filter STAYS: "none match these filters" is a real thing to know,
  // and going quiet there would read as no missed visits at all.
  if (overdue.length) {
    const review = el('details', { class: 'review-queue' })
    review.open = reviewOpen
    review.addEventListener('toggle', () => reviewOpen = review.open)
    review.append(el('summary', {}, `Past bookings to review · ${overdue.length}`), el('p', { class: 'muted' },
      // The words of the two buttons on every card and the Not done choices (Liam, 9 Oct 2026).
      'The day passed and nobody said what happened. Done if it was cleaned. Not done if it wasn\'t: say what happened, then move it, book them again, cancel this visit, or take them off the round.'))
    // Who Due this week would actually take, worked out once for the whole box.
    // Pushed to next week counts: they come back on Monday (round 1 review).
    const dueNowGroups = dueGroups(p, customers, roundJobList, todayISO(), (c) => askAgainLater(c), true)
    const dueNow = new Set([...dueNowGroups.due, ...dueNowGroups.goneQuiet, ...dueNowGroups.firstVisit, ...dueNowGroups.nextWeek].map(dueKey))
    const shown = overdue.filter(c => visible(c, p.round_days ?? []))
    for (const cl of shown) review.append(reviewCard(cl, dueNow.has(visitKey(cl))))
    if (!shown.length) review.append(el('p', {}, 'No past bookings match these filters.'))
    root.append(review)
  }

  // The day to jump to (the ⋯'s "Jump to a date…"), the arrows, Today and the worker and area choices (the magnifier).
  const date = el('input', { type: 'date', 'aria-label': 'Jump to a date' }); date.value = selectedDate
  date.addEventListener('change', () => { if (date.value && date.validity.valid) { if (!diaryNavigationReady()) { date.value = selectedDate; return }; fromDate = defaultFrom(date.value); selectedDate = date.value; void load() } })
  // Previous and next week are the arrows either side of "Week of" below
  // (Liam, 2026-09-25: on a phone the week's jobs started two screens down,
  // under seven buttons).
  const step = (label: string, glyph: string, offset: number): HTMLElement => {
    const btn = el('button', { type: 'button', class: 'week-step', 'aria-label': label, title: label }, glyph)
    btn.addEventListener('click', () => { if (!diaryNavigationReady()) return; fromDate = addDaysISO(fromDate, offset); selectedDate = addDaysISO(selectedDate,offset); weekEntry = {from:fromDate,gen:routeGen,who:diaryPreferenceKey('selection'),label}; void load() })
    return btn
  }
  const toToday = (): void => { if (!diaryNavigationReady()) return; fromDate = defaultFrom(); selectedDate = todayISO(); chosenAhead = null; void load() }
  const today = el('button', {}, 'Today'); today.addEventListener('click', toToday)
  const worker = el('select', { 'aria-label': 'Filter by worker' })
  worker.append(el('option', { value: '' }, 'All workers'), el('option', { value: '__unassigned' }, 'Unassigned'))
  for (const w of workers) worker.append(el('option', { value: w }, w))
  worker.value = workerFilter; worker.addEventListener('change', () => { if (!diaryNavigationReady()) { worker.value = workerFilter; return }; workerFilter = worker.value; render(p, root) })
  const areaPick = el('select', { 'aria-label': 'Filter diary by area' }) as HTMLSelectElement; areaPick.append(el('option', { value: '' }, 'All areas'))
  for (const a of [...new Set([...p.cleans, ...allOverdue].map(areaOf))].sort()) areaPick.append(el('option', { value: a }, a))
  if (areaFilter && ![...areaPick.options].some(o => o.value === areaFilter)) areaPick.append(el('option', { value: areaFilter }, areaFilter))
  areaPick.value = areaFilter; areaPick.addEventListener('change', () => { if (!diaryNavigationReady()) { areaPick.value = areaFilter; return }; areaFilter = areaPick.value; render(p, root) })
  // Rename the chosen area (design A of https://claude.ai/artifact/1zfWhmDP4dh9gYqwKyavpb): beside the box once one is
  // picked; the box itself stays the filter.
  const area = el('span', { class: 'diary-area-pick' }, areaPick,
    ...(areaFilter && areaFilter !== 'Not set' && getMe()?.role === 'owner' ? [areaRenameLink(areaFilter)] : []))
  // The week's anchor (Liam: "it should say Week of, in big-ish letters, and
  // it'll be the Monday's date, because it's easy to get lost as to what week
  // you're on"): one heading above the panel and the day cards, named for the
  // Monday, with the Sunday kept small on the same line.
  // The week's own money under its heading: what the round has actually
  // earned this week and how much of it is still sitting unpaid. Both are
  // summed from the visits on screen, so they answer the week being looked at
  // rather than "this week" in the abstract.
  const weekDone = p.cleans.filter(c => c.state === 'done' && c.date >= p.from && c.date <= p.to)
  const weekTook = weekDone.reduce((sum, c) => sum + (c.amount_pence ?? 0), 0)
  const weekOwed = weekDone.filter(c => c.payment_status !== 'paid').reduce((sum, c) => sum + (c.amount_pence ?? 0), 0)
  const weekHead = el('div', { class: 'week-heading' },
    el('h3', {}, `Week of ${dayLabel(p.from)}`),
    el('span', { class: 'muted' }, `to ${dayLabel(p.to)}`))
  if (weekDone.length) {
    const line = el('p', { class: 'week-money' })
    line.append(el('span', { class: 'week-money-took' }, `Work done so far ${money(weekTook)}`))
    if (weekOwed > 0) line.append(el('span', { class: 'week-money-owed' }, `${money(weekOwed)} still owed`))
    weekHead.append(line)
  }
  root.append(el('div', { class: 'week-nav' }, step('Previous week', '‹', -7), weekHead, step('Next week', '›', 7)))

  // The close-out attributes the window's logged work per worker; the editing
  // lock stays HERE so day notes and close-out forms still coordinate through
  // one flag and one pending-refresh path.
  const closeoutCtx = {
    cleans: p.cleans,
    roster,
    workers,
    finished: finishedDays(p),
    isEditing: () => editing,
    beginEdit: () => {
      editing = true
    },
    afterEdit,
    reload: () => void load(),
  }
  const days = el('div', { class: 'diary-days' })
  // The panel's due group, computed once: the tabs and the day-card
  // subtraction both read it. A collected customer's in-week suggestion (the
  // carrier case) belongs to the panel now — the same removal the sheet-week
  // visits already get, so day money, workload and the map stop counting a
  // date nobody agreed.
  // Due (round 1 of docs/plans/diary-due/PLAN.md): the bar most behind first; Gone quiet, First visit and Next week apart.
  const dueSets = dueGroupsFor(p)
  const dueList = dueSets.due
  const dueWaiting = [...dueSets.due, ...dueSets.goneQuiet, ...dueSets.firstVisit]
  // Next week's too can be put on a day, by a drag or a tap then a day (Liam, 4 Nov 2026: "i move alan to next week but want
  // to drag him onto a different day"); they stay out of what Due counts and hides.
  const duePlaceable = [...dueWaiting, ...dueSets.nextWeek]
  // Per job: the gutters row in the panel never takes the windows' suggestion off its day.
  const notCollected = collectedFilter(dueWaiting)
  // The panel's enquiry group: enquiries NOBODY HAS ANSWERED YET, not every
  // live lead. Liam, 2026-09-16: "the new enquiries shouldn't all be on this
  // form as we've already attempted contact with everyone in the new jobs
  // column, just this one new job". The first version showed all 41 live
  // leads when exactly ONE — Jill Green — had never been contacted.
  //
  // The rule is Messages' own `freshEnquiries` (enquiry-message.ts +
  // rebook.ts): never messaged, quoted within the last month, and not
  // contacted in the last two days. Copied rather than imported because
  // rebook.ts does not export it and is not this worker's file to change; if
  // that rule ever moves, this comment is the pointer to move it with.
  // Not week-scoped: an enquiry is due now, not w/c anything.
  const enquiryList = freshEnquiries()
  // The tray sits full-width above the row of day cards (grid-column spans
  // both), so the week's unplaced sheet work is the first thing read.
  const sheetRows = p.cleans.filter(c => isSheetWeek(c, p.from, p.to) && visible(c, []))
  // Due is at the phone's foot (round 2) and down the computer's left (round 3), drawn by presentWeek / presentDesk.
  // Placing someone from To place on a day, however it was chosen (dropped on a date or its card, or picked and then
  // a date tapped): a customer due gets the visit and then their message (Design B); a week-only visit moves; an
  // enquiry becomes a customer as before.
  const placeDue = (due: DueEntry, date: string): void => placeDueOn(due, date, p)
  placePicked = (date: string): boolean => {
    if (movingDueId !== null) { const due = duePlaceable.find(c => dueKey(c) === movingDueId); if (due) { placeDue(due, date); return true } }
    if (movingId !== null) { const visit = p.cleans.find(c => c.id === movingId); if (visit) { moveToDay(visit, date); return true } }
    if (movingEnqId !== null) { const enq = leads?.find(l => l.id === movingEnqId); if (enq) { placeEnquiry(enq, date); return true } }
    return false
  }
  // One drop handler for a day, wherever the day is drawn: its card, and on the desktop diary its date in the
  // week strip, so a tray row can be dropped on a day that is not the one on show.
  const acceptDayDrop = (target: HTMLElement, date: string): void => {
    target.addEventListener('dragover', (e) => {
      // A day that has gone is not somewhere to drop anyone (goneDay): the pointer says no and nothing lights up.
      if (!e.dataTransfer || date < todayISO()) return
      e.preventDefault()
      e.dataTransfer.dropEffect = 'move'
      target.classList.add('drop-ready')
    })
    target.addEventListener('dragleave', () => target.classList.remove('drop-ready'))
    target.addEventListener('drop', (e) => {
      e.preventDefault()
      target.classList.remove('drop-ready')
      const data = e.dataTransfer?.getData('text/plain') ?? ''
      // A "Dates offered, waiting" card: the day they picked (offerDrag).
      if (data.startsWith('offer:')) {
        const [, id, job] = data.split(':')
        if (Number(id)) acceptDayFromDiary(Number(id), job ? Number(job) : null, date)
        return
      }
      if (data.startsWith('enq:')) {
        const enq = leads?.find((l) => l.id === Number(data.slice(4)))
        if (enq) placeEnquiry(enq, date)
        return
      }
      if (data.startsWith('due:')) {
        const due = duePlaceable.find(c => dueKey(c) === data.slice(4))
        if (due) placeDue(due, date)
        return
      }
      // A visit dragged out of the Pencilled list (the Diary redesign).
      const id = Number(data.startsWith('pencil:') ? data.slice(7) : data)
      const visit = p.cleans.find(c => c.id === id)
      if (visit) moveToDay(visit, date)
    })
  }
  for (let date = p.from; date <= p.to; date = addDaysISO(date, 1)) {
    const day = el('section', { class: `day-card${date === todayISO() ? ' day-today' : ''}`, 'data-date': date })
    // A day row's customer link and badges are natively draggable — on a
    // computer a press-and-move would start the browser's own link drag and
    // fight the row drag for the same gesture. The card ends that at the
    // source. This cannot touch the week tray's drag: its dragstart fires on
    // the tray row, outside every card, and a drop FROM the tray onto a card
    // never needs the card to start one. The tray, due, enquiry and review
    // rows keep their own behaviour untouched.
    // A name in the day's "Offered to …" note is the one drag that starts here (offerDrag).
    day.addEventListener('dragstart', (e) => { if (!(e.target as Element | null)?.closest?.('.diary-offered-name')) e.preventDefault() })
    // Sheet-week visits live in the tray, not here — their day is not chosen
    // yet, so the card stops pretending to hold them (money, workload and the
    // map all read from this list). Collected suggestions leave with them.
    const all = p.cleans.filter(c => c.date === date && visible(c, p.round_days ?? []) && !isContact(c) && !isSheetWeek(c, p.from, p.to) && notCollected(c))
    const live = all.filter(c => c.state !== 'cancelled')
    const suggested = live.filter(isSuggestion)
    const booked = live.filter(c => c.state === 'booked' && !isSuggestion(c))
    const done = live.filter(c => c.state === 'done')
    // Who worked the day, in the heading: "Thu 10 Sep · Sendi". A one-person round names nobody but someone else
    // (Liam, 19 Oct 2026).
    const names = [...new Set([...done, ...booked].map(c => worksAlone() ? otherName(c.worker) : c.worker?.trim()).filter((w): w is string => !!w))]
    const head = el('div', { class: 'day-head' }, el('h3', {}, names.length ? `${dayLabel(date)} · ${names.join(', ')}` : dayLabel(date)))
    const add = el('button', {class:'diary-book-here'}, '+ Book here'); const pickedDate = date
    add.addEventListener('click', () => openBooking({ date: pickedDate }))
    // Who is OUT on this day, which is a different question from who worked
    // the visits already on it: a day with nobody booked still needs to be
    // markable as running, because that is what lets Messages offer it.
    const rostered = roster.find(r => r.date === date) ?? null
    if (rostered) day.classList.add('day-running')
    // While a tray row is selected, every day offers itself as the target —
    // the phone has no drag, so the button is the tap path.
    let moveHere: HTMLElement | null = null
    // A day that has gone offers no Move here or Book on this day (goneDay).
    if (date < todayISO()) { /* not a place to put anyone */ }
    else if (movingId !== null) {
      const moving = p.cleans.find(c => c.id === movingId)
      if (moving) {
        moveHere = el('button', { class: 'btn-primary move-here', 'aria-label': `Move ${moving.customer_name ?? 'this visit'} to ${dayLabel(date)}` }, 'Move here')
        moveHere.addEventListener('click', () => moveToDay(moving, date))
      } else {
        movingId = null // the selected row is gone (cancelled elsewhere): drop the selection
      }
    } else if (movingDueId !== null) {
      const due = duePlaceable.find(c => dueKey(c) === movingDueId)
      if (due) {
        // NOT "Book here": every day card already carries a "+ Book here" that
        // opens the booking form, and two near-identical labels on one card is
        // how the wrong one gets tapped (it caught the manager verifying this).
        // The button is the same for both kinds of due row — Liam does not
        // care which of the two it is — but a customer whose only future visit
        // is the app's own in-week suggestion MOVES that visit; only a
        // customer with nothing in the diary creates one.
        moveHere = el('button', { class: 'btn-primary move-here', 'aria-label': `Book ${dueWho(due)} on ${dayLabel(date)}` }, 'Book on this day')
        moveHere.addEventListener('click', () => placeDue(due, date))
      } else {
        movingDueId = null // the selected customer is gone: drop the selection
      }
    } else if (movingEnqId !== null) {
      const enq = leads?.find((l) => l.id === movingEnqId)
      if (enq) {
        // Not "Book here" — that is the booking form; and not the due rows'
        // "Book on this day", because this first makes a NEW customer. The
        // label says what actually happens.
        moveHere = el('button', { class: 'btn-primary move-here', 'aria-label': `Make ${enq.name} a customer and book their first visit on ${dayLabel(date)}` }, 'Book as new customer')
        moveHere.addEventListener('click', () => placeEnquiry(enq, date))
      } else {
        movingEnqId = null // the selected lead is gone (dealt with elsewhere): drop the selection
      }
    }
    // Drop target for a dragged tray row (pointer devices); the highlight
    // answers the hover, the drop does what Move here does. A day row moving
    // within its day is a pointer drag now and never raises these HTML5
    // events at all — the rows themselves answer for it.
    acceptDayDrop(day, date)
    // The stops the van actually drives: what this day card is showing, minus
    // the machine's own proposals and anything with no address.
    // In the Diary's one order (tidy-up, Liam, 20 Oct 2026): the map's numbers follow the day's.
    const stops = diaryDayOrder(live.filter(c => !isSuggestion(c)), severalJobsOn())
    const map = dayMapButton(stops, date)
    // No day chooser in a one-person round (Liam, 19 Oct 2026): working days are set in My working days only.
    if (!worksAlone()) head.append(rosterPicker(date, rostered, workers))
    if (map) head.append(map)
    head.append(add); day.append(head)
    // The phone has one "Put … on" above the day instead (round 2).
    if (moveHere && !phoneNew()) day.append(moveHere)
    const offered = offeredOn(date); if (offered.length) day.append(offeredNote(offered, date))
    const total = (rows: Clean[]): string => `${money(rows.reduce((sum, c) => sum + (c.amount_pence ?? 0), 0))}${rows.some(c => c.amount_pence === null) ? ' + unpriced jobs' : ''}`
    // Money for the day, split the way it is read back: what came in and what
    // is still owed. Empty parts stay silent so a planning day reads short.
    const paid = done.filter(c => c.payment_status === 'paid')
    const owed = done.filter(c => c.payment_status !== 'paid')
    // One line for the day's money, each part LABELLED and coloured by what it
    // means, instead of a run of bare figures divided by dots. The workload
    // ("3h 15m known") joins it rather than taking a line of its own — on a
    // phone the card was losing two lines to numbers before a single job.
    const moneyLine = el('p', { class: 'day-money' })
    const part = (label: string, value: string, tone?: string): void => {
      const span = el('span', { class: `day-money-part${tone ? ` day-money-${tone}` : ''}` })
      span.append(el('span', { class: 'day-money-label' }, label), el('span', { class: 'day-money-value' }, value))
      moneyLine.append(span)
    }
    const agreed = booked.filter(c => c.confirmed), pencilled = booked.filter(c => !c.confirmed)
    if (agreed.length) part('Agreed', total(agreed))
    if (pencilled.length) part('Not agreed', total(pencilled))
    if (done.length) {
      part('Done', total(done))
      if (paid.length) part('Paid', total(paid), 'paid')
      // Counted as Owed counts (docs/DIARY-AND-MESSAGES.md, Owed): not paid, at what is still to pay, apart from payment
      // not recorded.
      const unpaid = owed.filter(c => c.payment_status === 'unpaid'), unknown = owed.filter(c => c.payment_status !== 'unpaid')
      const left = unpaid.reduce((n, c) => n + Math.max(0, (c.amount_pence ?? 0) - Math.max(0, c.from_credit_pence ?? 0) - Math.max(0, c.paid_in_pence ?? 0)), 0)
      if (unpaid.length) part('Not paid', `${money(left)}${unpaid.some(c => c.amount_pence === null) ? ' + unpriced jobs' : ''}`, 'owed')
      if (unknown.length) part('Payment not recorded', total(unknown))
    }
    // The workload carries the job count, so the money parts do not repeat it.
    // An empty day says "Nothing booked" and nothing else: "0 jobs · 0h 0m
    // known" on six empty cards was six lines saying the same nothing.
    if (!booked.length && !done.length) moneyLine.append(el('span', { class: 'day-money-part muted' }, !live.length && (diarySearch || workerFilter || areaFilter) && p.cleans.some(c => c.date === date && c.state !== 'cancelled' && !isContact(c) && !isSheetWeek(c,p.from,p.to) && notCollected(c)) ? 'No matching visits' : 'Nothing booked'))
    day.append(moneyLine)
    moneyLine.replaceChildren(...[...moneyLine.children].filter(node => !['Agreed', 'Not agreed'].includes(node.querySelector('.day-money-label')?.textContent ?? '')))
    if (booked.length || !done.length) day.insertBefore(diaryDayTotals(live), moneyLine)
    if (workerFilter || areaFilter || diarySearch) day.append(el('p', { class: 'muted' }, 'Figures show matching visits. Day close-out below covers the whole day.'))
    // The whole day in its reading order (src/day-order.ts) — what the rows
    // are drawn in, and what a drag works its move out from.
    const inDayOrder = orderDay(p.cleans.filter(c => c.date === date && c.state !== 'cancelled' && !isContact(c)), isSuggestion)
    // The day sorts itself: timed jobs first in time order, then the ones
    // agreed without a time, then the ones nobody has agreed. A row moves by
    // being dragged — a long press on a phone, a small move on a mouse — and
    // a timed row is not grabbable: its time is its place, and the way to
    // move it is to change the time. The drag is off while a worker or area
    // filter is on: the day on screen is then not the whole day /api/reorder
    // must hear about.
    function group(rows: Clean[], label?: string): void {
      let target: HTMLElement = day
      if (label === 'Completed' && rows.length) {
        // "Done · 3", how many are not paid, and the day's money marked "worked" so it never reads as money received, on
        // every view (Liam's pick 6A, 22 Oct 2026, agreed with Astra; the computer week's total, Liam picked A 15 Oct 2026).
        const notPaid = rows.filter((r) => r.payment_status === 'unpaid').length
        const completed = el('details', {class:'diary-completed'},el('summary', {},el('span', {class:'diary-completed-count'}, `Done · ${rows.length}`),
          ...(notPaid && !pricesHidden() ? [el('span', {class:'diary-completed-owed'}, `· ${notPaid} not paid`)] : []),
          ...(pricesHidden() ? [] : [el('span', {class:'diary-completed-total'}, `${total(rows)} worked`)]))) as HTMLDetailsElement
        const key = `${diaryPreferenceKey('selection')}:${date}`
        // On a computer Done starts open and stays as you leave it (Liam, 28 Oct 2026: "i dont like the fact the done is
        // closed ... adds an extra click"); the phone folds it as before.
        completed.open = diaryDesk() ? !doneFolded() : completedOpen.has(key)
        completed.addEventListener('toggle', () => { if (diaryDesk()) setDoneFolded(!completed.open); else if (completed.open) completedOpen.add(key); else completedOpen.delete(key) })
        day.append(completed); target = completed
      } else if (label && rows.length) day.append(el('h4', { class: 'day-group' }, label, el('span', {}, String(rows.length))))
      for (const cl of rows) {
        // The heading it sits under, so a drag lands only among its own group (rowSpansIn).
        const row = el('div', { class: `clean-row clean-${cl.state}`, 'data-clean-id': String(cl.id), 'data-group': `${label ?? ''}:${bandOf(cl, isSuggestion(cl))}` })
        // The visit's ⋯ stays while a search or filter is on (bug hunt, 8 Oct 2026); only its reordering is off then.
        renderClean(cl, row, undefined, inDayOrder)
        if (cl.state !== 'cancelled' && !workerFilter && !areaFilter && !diarySearch && canReorder(cl, isSuggestion)) {
          attachRowDrag(row, cl)
          appendOrderButtons(row, cl, rows.filter(c => bandOf(c, isSuggestion(c)) === bandOf(cl, isSuggestion(cl))), inDayOrder, date)
        } else if (cl.state === 'booked' && !isContact(cl) && !isSuggestion(cl) && !workerFilter && !areaFilter && !diarySearch) {
          // A timed visit is held too, to drop it on another day, a person or Due (Liam, 4 Nov 2026: Back to Due); its
          // place in the day stays its time, so it is never reordered or pencilled by the drop (rowDragFrame, rowDragUp).
          attachRowDrag(row, cl)
        }
        const ask = gutterAskFor(cl, p)
        if (ask) row.append(ask)
        target.append(row)
      }
    }
    // The drag half of the row's ordering, for every device at once — the
    // gesture is a pointer one, so a finger, a trackpad and a mouse all work
    // the same way. The policy (when a press becomes a grab, what a press on
    // a control does, where a drop lands) lives in src/day-order.ts, tested;
    // this is the listening.
    function attachRowDrag(row: HTMLElement, cl: Clean): void {
      row.classList.add('can-grab')
      row.addEventListener('pointerdown', (e) => {
        // One drag at a time. A press still waiting can only be a stale one
        // whose release was lost (a button let go outside the window), so a
        // new press sweeps it aside; a held row is a drag in progress and
        // nothing else may start.
        if (rowDrag) { if (rowDrag.phase === 'held') return; endRowDrag() }
        if (reorderInFlight) return
        if (e.pointerType === 'mouse' && e.button !== 0) return
        const t = e.target as Element | null
        const control = t?.closest('button, a, input, select, textarea, summary')
        const openMenu = t?.closest('details.row-menu[open]')
        // A press that landed on a control is a tap and must stay one: ⋯
        // opens the menu, Confirmed confirms, the call link calls. The
        // customer link is the row's face, not a control — it wraps the name,
        // the address and the badges — so its press may become a drag (the
        // threshold decides; a held release is swallowed so it never opens
        // the customer), while its tap still opens the customer.
        if (!control?.matches('.diary-row-summary') && pressOnControl(control?.tagName ?? null, !!openMenu, control?.matches('a.sched-clean-main, a.diary-row-name') ?? false)) return
        window.addEventListener('pointermove', rowDragMove)
        window.addEventListener('pointerup', rowDragUp)
        window.addEventListener('pointercancel', rowDragCancel)
        window.addEventListener('keydown', rowDragKey)
        rowDrag = {
          row, cleanId: cl.id, date, day, inDayOrder,
          pointerId: e.pointerId, pointerType: e.pointerType,
          startX: e.clientX, startY: e.clientY, lastY: e.clientY, lastX: e.clientX,
          startedAt: performance.now(),
          fingerDy: 0, rowTopPage: 0, phase: 'press', timer: null, frame: null,
        }
        // A finger or a pen holds still (~400ms) before it grabs; a mouse
        // grabs on the first small move (rowDragMove). A finger that travels
        // first is a scroll: the press is given up without ever having
        // stopped it, so the page moves as normal.
        if (e.pointerType !== 'mouse') {
          rowDrag.timer = window.setTimeout(() => {
            if (rowDrag?.phase === 'press') startRowGrab()
          }, LONG_PRESS_MS)
        }
      })
      // Once the row is held, the page must not take the moving finger over
      // as a scroll — and of the two, only this event can stop it. Before the
      // grab, nothing here calls preventDefault, so scrolling from a row
      // works exactly as before.
      row.addEventListener('touchmove', (e) => {
        if (rowDrag?.phase === 'held') e.preventDefault()
      }, { passive: false })
      // The long press that starts a phone grab would otherwise open the
      // browser's own menu for it.
      row.addEventListener('contextmenu', (e) => {
        if (rowDrag && rowDrag.row === row) e.preventDefault()
      })
    }
    // A reply or follow-up recorded on a visit (or a door record): "N to look at before going".
    const hasReply = (c: Clean): boolean => c.customer_status === 'paused' || !!c.customer_follow_up_on || (c.customer_message_reply === 'dates' && (() => {
      try { const map = JSON.parse(c.customer_message_replies || '{}'); return Object.keys(map).length ? !!map[c.job_id == null ? 'main' : String(c.job_id)] : (c.customer_message_reply_job_id ?? null) === (c.job_id ?? null) } catch { return false }
    })())
    const decisions = booked.filter(c => hasReply(c) || c.blocked_reason)
    if (decisions.length) {
      // Liam's words (9 Oct 2026, diary#15: "whatever you recommend"): the same count, said as what it is for.
      const reviewDay = el('button', {type:'button',class:'diary-review-day'}, `${decisions.length} to look at before going · Review`)
      reviewDay.addEventListener('click', () => day.querySelector<HTMLButtonElement>(`[data-clean-id="${decisions[0]!.id}"] .diary-row-summary`)?.click())
      day.append(reviewDay)
    }
    // One order for the day (tidy-up, Liam, 20 Oct 2026: option A; Astra's review): stop by stop, those with a time first
    // in time order whether agreed or not, then agreed with no time, then not yet agreed, then completed
    // (diary-stops.ts). The numbers, the map, both booking previews and these headings read it; Today keeps its own.
    const groups = diaryDayGroups([...booked, ...done], severalJobsOn())
    const bands: [Clean[], string][] = [
      [groups.timed, 'Times set'],
      [groups.agreed, groups.agreed.some(c => !c.confirmed) ? 'Agreed visits & linked jobs' : 'Agreed visits'],
      [groups.pencilled, 'Pencilled visits'],
      [groups.completed, 'Completed'],
    ]
    for (const [rows, label] of bands.filter(([rows]) => rows.length)) group(rows, label)
    // No second line on an empty day: the day's own line already says "Nothing booked" (Liam 29 Sep 2026).
    group(orderDay(suggested), `Suggestions · ${suggested.length} · ${total(suggested)} potential`)
    // The computer's Week and Day (the redesign, Week 4 and Day 4) say it on the job itself, as a red ! with its reason
    // (flagRow); once the rows are drawn (Sonnet's check, 26 Oct 2026: before, it found none); the line above stays for the phone and is hidden there (diary-redesign.css).
    for (const c of decisions) {
      const why = c.blocked_reason ? '' : c.customer_status === 'paused' ? 'Paused, check before going'
        : c.customer_follow_up_on ? `Ask again ${shortDate(c.customer_follow_up_on)}` : 'They replied with other dates'
      for (const r of day.querySelectorAll<HTMLElement>(`.clean-row[data-clean-id="${c.id}"]`)) if (why) r.dataset.decide = why
    }
    // Roundly's "ask them" reminders on their own day, and one missed carried over to today, so it is never lost
    // (round 5: "Missed contact reminders carry over to the next day"). Plan visit and Dismiss reminder on each; they
    // are not visits and count in no total.
    {
      const today = todayISO()
      const remind = contacts.filter(c => c.date === date || (date === today && c.date < today)).filter(c => visible(c, []))
      if (remind.length) {
        day.append(el('h4', { class: 'day-group diary-contact-group' }, 'To contact', el('span', {}, String(remind.length))))
        for (const cl of remind) {
          const row = el('div', { class: 'clean-row diary-contact-row', 'data-contact-id': String(cl.id) })
          renderClean(cl, row)
          if (cl.date < date) row.append(el('p', { class: 'diary-contact-carried' }, `From ${dayLabel(cl.date)}, not done yet`))
          day.append(row)
        }
      }
    }
    const cancelled = all.filter(c => c.state === 'cancelled')
    if (cancelled.length) {
      // Liam, 3 Nov 2026: "Keep as not going ahead" (it was "cancelled").
      const box = el('details', { class: 'cancelled-visits' }, el('summary', {}, `${cancelled.length} not going ahead`))
      for (const cl of cancelled) { const row = el('div', { class: 'clean-row' }); renderClean(cl, row, undefined, inDayOrder); box.append(row) }
      day.append(box)
    }
    const notes = el('div', { class: 'day-notes' }); renderNotes(date, p.day_notes.filter(n => n.date === date), notes)
    // A round with people to pay closes out its day on its own page (0095); a one-person round keeps Day totals here.
    const entry = closeOutEntry(date, p.cleans, p.day_ledger, roster, p.day_crews ?? [], { setting: p.owner_pay, partners: p.pay_partners, takes: p.owner_takes, owners: p.owners })
    const ledger = worksAlone() ? el('div', { class: 'day-ledger' }) : null
    if (ledger) renderDayLedger(date, p.day_ledger.filter(l => l.date === date), ledger, closeoutCtx)
    if (entry) day.append(entry)
    day.append(diaryDayFooter(notes, ledger))
    {
      head.querySelector('h3')!.textContent = new Date(`${date}T12:00:00`).toLocaleDateString(screenLocale(), {weekday:'long', day:'numeric', month:'short'})
      const rosterControl = head.querySelector('.day-roster')
      const details = el('details', {class:'diary-day-details'},el('summary', {},'Day details'))
      if (rosterControl) details.append(el('div', {class:'diary-day-worker'}, el('span', {}, 'Out on this day'), rosterControl))
      const totals = day.querySelector('.diary-day-totals'); if (totals) details.append(totals)
      details.append(moneyLine)
      const footer = day.querySelector('.diary-day-footer'); if (footer) details.append(footer)
      day.append(details)
      if (diaryDesk()) head.after(diaryDayProgress(live,!!(diarySearch || workerFilter || areaFilter)))
      else {
        // Design B (phone): the day's details behind a small ⓘ on the day, not a fold under it.
        // Design B (Liam, 23 Oct 2026): the map, who is out and the day's details as picture tiles above the stops.
        const info = el('button', {type:'button', class:'diary-icon-button diary-day-info diary-tile', 'aria-label':`Day details for ${dayLabel(date)}`, title:'Day details'},
          el('span', {class:'diary-tile-ring', 'aria-hidden':'true'}, lineDrawing('info', 19)), el('span', {class:'diary-tile-words'}, el('strong', {}, 'Day details'), el('small', {}, 'Notes, money, totals')))
        info.addEventListener('click', () => openFoldInWindow(`Day details · ${dayLabel(date)}`, details, info))
        details.hidden = true
        const bookHere = head.querySelector('.diary-book-here'); if (bookHere) head.insertBefore(info, bookHere); else head.append(info)
        // Who is out, chosen on the day's line in one tap (Liam, 11 Oct 2026); its details keep it too. Not in a
        // one-person round (19 Oct 2026).
        if (!worksAlone()) head.insertBefore(el('div', {class:'diary-tile diary-out-tile'}, el('span', {class:'diary-tile-ring', 'aria-hidden':'true'}, lineDrawing('person', 19)),
          el('span', {class:'diary-tile-words'}, el('strong', {}, 'Out today'), rosterPicker(date, rostered, workers, { out: true }))), info)
        const map = head.querySelector<HTMLElement>('.day-map')
        if (map) {
          // Still to do: booked and not already "Couldn't do it" (as Day done counts the day; GPT-6.1 review).
          const left = all.filter(c => c.state === 'booked' && !c.blocked_reason && !isContact(c) && !isSuggestion(c)).length
          const ring = el('span', {class:'diary-tile-ring', 'aria-hidden':'true'})
          ring.append(...Array.from(map.childNodes))
          map.classList.add('diary-tile')
          map.append(ring, el('span', {class:'diary-tile-words'}, el('strong', {}, 'Map'), el('small', {}, left ? `${left} stop${left === 1 ? '' : 's'} left` : 'All done')))
          head.insertBefore(map, head.querySelector('.diary-out-tile') ?? info)
        }
        // The day's card, as Today's (Liam, 4 Nov 2026, the Day in Today's look): the ring, the money worked, taken and
        // not paid on a day gone or today, what is booked and still to ask on a day to come, and Map; Out today and Day
        // details stay as two slim buttons under it. Prices hidden: no card (a worker never sees the Diary).
        if (!pricesHidden()) head.prepend(dayMoneyCard(date, all.filter(c => !isSuggestion(c)), map))
        // To tell, by itself (Liam, 4 Nov 2026, 1A): an agreed customer moved to this day and not told yet, under the tiles.
        const tell = toTellBox(all)
        if (tell) head.after(tell)
      }
    }
    // Day done in the Diary too (Liam said yes to D4, 22 Oct 2026): the moment the last of today's jobs is marked done
    // here, the whole day's jobs (never the filtered list), once per round per day, shared with Today (showDayDone).
    if (date === todayISO()) {
      const whole = p.cleans.filter(c => c.date === date && !isContact(c) && !isSuggestion(c) && !isSheetWeek(c, p.from, p.to) && notCollected(c))
      // Compared only with the draw just before, and shown only in Day view on today (every other card is hidden there, and
      // the Week views show no day card to hold it): a job finished while today was off the screen is not celebrated on
      // coming back (Sonnet's review; Astra, phone Week, 23 Oct 2026).
      const was = diaryTodayStates?.draw === diaryDraws - 1 ? diaryTodayStates.states : null
      diaryTodayStates = { draw: diaryDraws, states: new Map(whole.map(c => [c.id, c.state])) }
      const onShow = weekMode() === 'day' && selectedDate === date
      if (onShow && was && whole.some(c => was.get(c.id) === 'booked' && c.state === 'done')) showDayDone((box) => head.after(box), date, whole, pricesHidden())
      else if (onShow) keepDayDone((box) => head.after(box), date, whole)
    }
    // A day with nothing on it folds to its heading: on a phone six empty
    // cards were a screen each. Today stays open; a day with a note, a
    // close-out or any visit (even cancelled) stays open too. While a tray or
    // due row is selected no day folds — the Book here / Move here buttons
    // live under the heading, and a folded day would hide the tap path.
    const selectionLive = movingId !== null || movingDueId !== null || movingEnqId !== null
    const hasNotes = p.day_notes.some(n => n.date === date) || p.day_ledger.some(l => l.date === date)
    const unfiltered = p.cleans.filter(c => c.date === date && !isContact(c) && notCollected(c))
    const emptyDay = all.length === 0 && unfiltered.length === 0 && !hasNotes && date !== todayISO() && !selectionLive
    if (emptyDay) {
      // A day's note and totals are behind its ⓘ, so a fold held nothing and opened to nothing (bug hunt, 8 Oct 2026). The
      // phone says so and offers the booking, in the computer's words; the computer draws its own (presentDesk).
      if (!diaryDesk()) {
        day.classList.add('day-empty')
        const bookDay = el('button', {type:'button', class:'btn-primary'}, `+ Book a visit on ${dayLabel(date)}`)
        bookDay.addEventListener('click', () => openBooking({ date: pickedDate }))
        const longDate = new Date(`${date}T12:00:00`).toLocaleDateString(screenLocale(), {weekday:'long', day:'numeric', month:'long'})
        day.append(weekMode() === 'day' ? el('div', {class:'diary-empty'}, el('p', {}, el('strong', {}, `No visits booked on ${longDate}.`)), bookDay) : el('p', {class:'diary-empty-line'}, 'Nothing booked'))
      }
    }
    days.append(day)
  }
  root.append(days)
  const placeCount = p.cleans.filter(c => isSheetWeek(c,p.from,p.to) && visible(c,[])).length + dueList.length + enquiryList.length
  root.classList.remove('diary-phone', 'diary-phone-week-view') // presentWeek puts it back on a phone
  const due: PhoneDue = { sets: dueSets, held: sheetRows, enquiries: enquiryList, noCycle: noCycleSet(p, customers, todayISO(), (c) => askAgainLater(c)) }
  if (diaryDesk()) presentDesk(root, p, {heading, book, date, today, toToday, worker, area, reviewCount: overdue.length, placeCount, contactCount: contacts.length, acceptDayDrop, notCollected, due})
  else presentWeek(root, p, heading, book, date, toToday, worker, area, due)
  finishDiary(root)
  if (focusedVisit) root.querySelector<HTMLButtonElement>(`[data-clean-id="${focusedVisit}"] .diary-row-summary`)?.focus({preventScroll:true})
  if (deskFocusAt?.cls) root.querySelector<HTMLButtonElement>(`.diary-desk-agenda [data-clean-id="${deskFocusAt.id}"] .${deskFocusAt.cls}`)?.focus({preventScroll:true})
  if (orderFocus) [...root.querySelectorAll<HTMLButtonElement>('.diary-order-buttons button')].find(b => b.getAttribute('aria-label') === orderFocus)?.focus({preventScroll:true})
  if (orderFeedback) { diaryOrderSettle(root, orderFeedback); orderFeedback = null }
  drawMovingLines(root)
  showPlacingGuide()
  // Finish my day (0064): a line under the heading for each day someone has finished that the owner has not looked at.
  const top = root.querySelector<HTMLElement>(':scope > .page-heading')
  if (top) { const slot = el('div', {class:'diary-finished-days'}); top.after(slot); finishedDaysArea(slot, 'diary') }
  if (keepY > 0 && Math.abs(window.scrollY - keepY) > 2) window.scrollTo({ top: keepY, behavior: 'auto' })
  if (stopsBefore) settleStops(root, stopsBefore)
}

// ---- the desktop diary (approved Opus design, 8 Oct 2026) ----------------------------------------------------
//
// Liam chose this desktop layout: the week as a compact strip of dates above the chosen day's visits, and a
// right-hand column for Plan work and the day's own details, notes, map and who is out. Every control here is one
// render() already built with its real handler (booking, Done, Move, payments, notes, close-out, roster, map,
// filters); this only arranges them. A phone keeps presentWeek.
let deskIdentity = ''
// Design B: Find (search, Who, Area, Go to date) folded behind one button unless in use.
let deskFindOpen = false
let deskPlanOpen = true
let deskPlanBody: 'place' | 'review' | 'round' | null = null
let deskPlanChosen = false // a row the owner opened or closed by hand wins over To place opening by itself
interface DeskParts {
  heading: HTMLElement; book: HTMLElement; date: HTMLInputElement; today: HTMLElement; toToday: () => void; worker: HTMLElement; area: HTMLElement
  reviewCount: number; placeCount: number; contactCount: number
  acceptDayDrop: (target: HTMLElement, date: string) => void; notCollected: (c: Clean) => boolean
  due: PhoneDue
}
const cash = (pence: number): string => money(pence).replace(/\.00$/, '')
// "Sunday 11 October 2026" / "Sunday, October 11, 2026" (Step 2 round 7).
const longDay = (iso: string, year = false): string => `${new Date(`${iso}T12:00:00`).toLocaleDateString(screenLocale(), {weekday:'long', day:'numeric', month:'long'})}${year ? `${monthFirst() ? ',' : ''} ${iso.slice(0, 4)}` : ''}`
function weekWords(from: string, to: string): string {
  const a = new Date(`${from}T12:00:00`), b = new Date(`${to}T12:00:00`)
  const month = (d: Date): string => d.toLocaleDateString('en-GB', {month:'long'})
  // A US or Canadian round: "October 5 to 11, 2026", "September 28 to October 4, 2026" (Step 2 round 7).
  if (monthFirst()) return a.getMonth() === b.getMonth() ? `${month(b)} ${a.getDate()} to ${b.getDate()}, ${b.getFullYear()}`
    : `${month(a)} ${a.getDate()}${a.getFullYear() === b.getFullYear() ? '' : `, ${a.getFullYear()}`} to ${month(b)} ${b.getDate()}, ${b.getFullYear()}`
  return a.getMonth() === b.getMonth() ? `${a.getDate()} to ${b.getDate()} ${month(b)} ${b.getFullYear()}`
    : `${a.getDate()} ${month(a)}${a.getFullYear() === b.getFullYear() ? '' : ` ${a.getFullYear()}`} to ${b.getDate()} ${month(b)} ${b.getFullYear()}`
}
// Each date is kept on one line ("28 Sep to / 4 Oct 2026", never "28 Sep to 4 / Oct"), and the months are the app's
// own short names, "Sep" in every browser (Liam's phone, 9 Oct 2026).
const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
// A visit, due customer or enquiry dragged out of Plan work lights the strip's dates as places to drop it (bound once:
// render() redraws the page, the document stays).
let planDragCueBound = false
function bindPlanDragCue(): void {
  if (planDragCueBound) return
  planDragCueBound = true
  document.addEventListener('dragstart', e => {
    const from = (e.target as Element | null)?.closest?.('.diary-plan-panel, .diary-offers, .diary-offered-day')
    if (from && !(e.dataTransfer?.getData('text/plain') ?? '').startsWith('review:')) document.body.classList.add('diary-row-dragging')
  })
  for (const end of ['dragend', 'drop'] as const) document.addEventListener(end, () => { if (!rowDrag) document.body.classList.remove('diary-row-dragging') })
}
function presentDesk(root: HTMLElement, p: SchedulePayload, parts: DeskParts): void {
  bindPlanDragCue()
  const { heading, book, date, today, toToday, worker, area, reviewCount, placeCount, contactCount, acceptDayDrop, notCollected, due } = parts
  selectInitialDay(p)
  const identity = diaryPreferenceKey('selection')
  if (deskIdentity !== identity) { deskIdentity = identity; deskPlanOpen = true; deskPlanBody = null; deskPlanChosen = false; deskDueOpen = false; deskNeedsOpen = false; deskWeekLens = null }
  // Liam, 8 Oct: with visits waiting for a day, Plan work opens on To place by itself, ready to drag onto a date.
  if (!deskPlanChosen && deskPlanBody === null && placeCount > 0) deskPlanBody = 'place'
  // Liam, 8 Oct ("do it"): no Day view on a computer. Week already shows one day under the dates; a Day choice saved
  // on a phone stays the phone's and is not changed here.
  const iso = selectedDate
  const filtered = !!(diarySearch || workerFilter || areaFilter)
  const roster = p.round_days ?? []
  const whoFor = (c: Clean): string => visitWorker(c, roster)
  root.classList.remove('diary-day-view')
  const focusAfter = (selector: string): void => { root.querySelector<HTMLElement>(selector)?.focus({preventScroll:true}) }

  // ---- the top line: title, the magnifier, dates, Today, ⋯, view, Book ----
  // The arrows move by the view (PLAN round 3): a day in Day, with the day between them; a week in Week.
  const byDay = weekMode() === 'day'
  // The heading says when, in words (the Diary redesign: "This week", "Tomorrow"; src/diary-heading.ts), and the dates
  // and the period's figures under it (filled in by Week and Day once they are counted).
  const period = el('p', {class:'diary-period diary-desk-sub', 'aria-live':'polite'}, byDay ? '' : weekDates(p.from, p.to, todayISO()))
  const nav = el('div', {class:'week-nav diary-desk-nav', role:'group', 'aria-label':'Change dates'})
  const step = (direction: -1 | 1): HTMLElement => {
    const label = `${direction < 0 ? 'Previous' : 'Next'} ${byDay ? 'day' : 'week'}`
    const button = el('button', {type:'button', class:'week-step diary-desk-step', 'aria-label':label, title:label}, el('span', {'aria-hidden':'true'}, direction < 0 ? '‹' : '›'))
    button.addEventListener('click', () => {
      if (!diaryNavigationReady()) return
      const next = addDaysISO(selectedDate, direction * (byDay ? 1 : 7))
      selectedDate = next
      if (next >= p.from && next <= p.to) { render(p, root); focusAfter(`.diary-desk-step[aria-label="${label}"]`); return }
      fromDate = defaultFrom(next); weekEntry = {from:fromDate, gen:routeGen, who:diaryPreferenceKey('selection'), label}; void load()
    })
    return button
  }
  // The arrows hug the dates they change, "‹ 5 to 11 Oct ›", with Today a button of its own beside them (Liam, 9 Oct
  // 2026: either side of Today they read as a day at a time). One copy of the dates, between the arrows.
  nav.append(step(-1), step(1))
  today.classList.add('diary-desk-today')
  // Design B (Liam, 8 Oct 2026: "a bit intimidating"): search, Who and Area sit behind the magnifier, and stay open while
  // any of them is in use; the date to jump to is in the ⋯ (tidy-up item 4, 20 Oct 2026).
  const findOpen = deskFindOpen || filtered
  const find = el('button', {type:'button', class:`diary-find-toggle${findOpen ? ' is-on' : ''}`, 'aria-expanded':String(findOpen), 'aria-controls':'diary-desk-find', 'aria-label':'Search and filters', title:'Search and filters'}, magnifier())
  find.addEventListener('click', () => {
    if (!diaryNavigationReady()) return
    deskFindOpen = !findOpen; render(p, root)
    root.querySelector<HTMLElement>(deskFindOpen ? '#diary-desk-search' : '.diary-find-toggle')?.focus({preventScroll:true})
  })
  const views = threeViewSwitch(weekMode(), view => pickView(view, p, root)); views.classList.add('diary-desk-views')
  heading.className = 'page-heading diary-desk-head diary-top'
  heading.replaceChildren(el('div', {class:'diary-desk-title'}, el('h2', {}, byDay ? dayHeading(iso, todayISO()) : weekHeading(p.from, todayISO())), period), find, nav, today, diaryMore(p, date, toToday), views, book)
  for (const old of root.querySelectorAll(':scope > .week-nav')) old.remove()

  // ---- the day cards: only the chosen day is on show ----
  const days = root.querySelector<HTMLElement>('.diary-days')!
  const cards = [...days.querySelectorAll<HTMLElement>(':scope > .day-card[data-date]')]
  const drawn = (card: HTMLElement): Clean[] => {
    const ids = [...new Set([...card.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')].map(row => Number(row.dataset.cleanId)))]
    return ids.map(id => p.cleans.find(c => c.id === id)).filter((c): c is Clean => !!c)
  }
  const wholeDay = (day: string): Clean[] => p.cleans.filter(c => c.date === day && !isContact(c) && !isSheetWeek(c, p.from, p.to) && notCollected(c))
  // What a day card draws (render's own rule), so the strip and the figures never count a row the day does not show.
  const dayRows = (day: string): Clean[] => wholeDay(day).filter(c => visible(c, roster))
  for (const card of cards) { card.hidden = card.dataset.date !== iso; card.inert = card.hidden }
  // "Give them dates" from another screen (the import's finish, the welcome): First visit open (round 3 review).
  if (takeNoDateGlow()) { deskDueFor(); deskDueTab = 'first'; deskDueOpen = true; deskPencilOpen = false; deskNeedsOpen = false }
  const dueCol = deskDueColumn(p, due, () => render(p, root))
  for (const row of days.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')) jobLook(row)
  if (weekMode() !== 'week') for (const row of days.querySelectorAll<HTMLElement>('.day-card .clean-row[data-clean-id]')) flagRow(row, row.querySelector<HTMLElement>('.diary-row-line .diary-row-name'))
  if (weekMode() === 'week') return presentDeskWeek(root, p, heading, days, cards, dayRows, wholeDay, whoFor, filtered, worker, area, reviewCount, dueCol, due)

  // ---- the week strip ----
  const picking = movingId !== null || movingDueId !== null || movingEnqId !== null
  const pickedName = p.cleans.find(c => c.id === movingId)?.customer_name ?? dueCustomers(p).find(c => dueKey(c) === movingDueId)?.name ?? leads?.find(l => l.id === movingEnqId)?.name ?? 'them'
  let strip: HTMLElement | null = null
  {
    strip = el('nav', {class:'diary-week-strip diary-desk-strip', 'aria-label':'Days this week'})
    for (const card of cards) {
      const day = card.dataset.date!
      const f = diaryDayFacts(dayRows(day), whoFor)
      const hidden = filtered && !f.visits && wholeDay(day).some(c => c.state !== 'cancelled')
      const out = roster.find(r => r.date === day)?.worker
      // Liam, 8 Oct: whether the day still needs confirming, first, by the rule Needs you counts with (planning.ts
      // confirmNeed): "3 to confirm (1 time)" until the day and any set time are agreed, "1 to check" for a visit whose
      // customer is paused, stopped, taken off or needs a visit. A past day says neither: Review owns its visits.
      const needs = dayNeeds(dayRows(day), day)
      // A one-person round has nobody unassigned and nobody out (Liam, 19 Oct 2026).
      // The week's day heads retain visits, money and who is out. The shared state mark shows done out of booked.
      const pencilledHere = day >= todayISO() ? pencilledRows(dayRows(day)).length : 0
      const allNotes = [pencilledHere ? `${pencilledHere} pencilled` : '', needs.check, needs.offered, f.unassigned && !worksAlone() ? `${f.unassigned} unassigned` : '', out && !worksAlone() ? `${out} out` : ''].filter(Boolean)
      const notes = allNotes.slice(0, 2)
      const main = f.visits ? `${f.visits} visit${f.visits === 1 ? '' : 's'} · ${cash(f.pence)}${f.unpriced ? ' + unpriced' : ''}` : hidden ? 'No matches' : 'No visits'
      const isToday = day === todayISO()
      const button = el('button', {type:'button', class:`diary-strip-day${isToday ? ' is-today' : ''}${day === iso ? ' is-selected' : ''}`, 'data-date':day,
        'aria-pressed':String(day === iso), 'aria-current':isToday ? 'date' : 'false', 'aria-label':`${dayLabel(day)}${isToday ? ', today' : ''}: ${[main, ...allNotes].join(', ')}`},
        el('span', {class:'diary-strip-head'}, el('span', {}, new Date(`${day}T12:00:00`).toLocaleDateString('en-GB', {weekday:'short'})), el('b', {}, String(Number(day.slice(8))))),
        ...(isToday ? [el('span', {class:'diary-strip-today'}, 'Today')] : []),
        el('span', {class:`diary-strip-main${f.visits ? '' : ' is-quiet'}`}, main),
        ...notes.map(n => el('span', {class:'diary-strip-note'}, n)),
        )
      const dayBadge = colourDay(button, wholeDay(day), `strip:${day}`, isToday, {date:day, closed:closedDiaryDay(p, day)})
      button.append(dayBadge)
      // Workload words stay on the date button; the new state adds information.
      button.setAttribute('aria-label', `${button.getAttribute('aria-label')}, ${dayBadge.getAttribute('aria-label')}`)
      if (needs.check && !button.querySelector('.diary-state-warning')) button.append(el('span', {class:'diary-state-warning', role:'img', 'aria-label':needs.check, title:needs.check}))
      if (picking && day >= todayISO()) { button.classList.add('is-target'); button.setAttribute('aria-label', `Put ${pickedName} on ${button.getAttribute('aria-label')}`) }
      button.addEventListener('click', () => {
        if (!diaryNavigationReady()) return
        if (picking && placePicked(day)) return
        if (day === selectedDate) return
        selectedDate = day; render(p, root)
        focusAfter(`.diary-desk-strip [data-date="${day}"]`)
      })
      acceptDayDrop(button, day)
      strip.append(button)
    }
    // Arrow keys walk the dates; Enter or Space chooses one.
    strip.addEventListener('keydown', event => {
      const all = [...strip!.querySelectorAll<HTMLButtonElement>('button')], at = all.indexOf(document.activeElement as HTMLButtonElement)
      const to = event.key === 'ArrowRight' ? at + 1 : event.key === 'ArrowLeft' ? at - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? all.length - 1 : null
      if (to === null || at < 0) return
      event.preventDefault(); all[Math.max(0, Math.min(all.length - 1, to))]?.focus()
    })
  }

  // ---- the chosen day ----
  const card = cards.find(c => c.dataset.date === iso)!
  // To tell, by itself (Liam, 4 Nov 2026, 2A), at the top of the day's list.
  card.querySelector(':scope > .diary-to-tell')?.remove()
  const toTell = toTellBox(dayRows(iso))
  if (toTell) card.prepend(toTell)
  const fold = card.querySelector<HTMLDetailsElement>(':scope > .day-fold')
  if (fold) { for (const child of [...fold.children]) if (child.tagName !== 'SUMMARY') card.append(child); fold.remove(); card.classList.remove('day-empty') }
  const head = card.querySelector<HTMLElement>(':scope > .day-head')!
  const mapButton = head.querySelector<HTMLButtonElement>('.day-map')
  const detailsFold = card.querySelector<HTMLElement>(':scope > .diary-day-details')
  const rosterControl = detailsFold?.querySelector<HTMLElement>('.day-roster') ?? head.querySelector<HTMLElement>('.day-roster')
  const notes = detailsFold?.querySelector<HTMLElement>('.day-notes')
  const ledger = detailsFold?.querySelector<HTMLElement>('.day-ledger')
  detailsFold?.remove()
  for (const note of card.querySelectorAll<HTMLElement>(':scope > p.muted')) if (note.textContent?.startsWith('Figures show matching visits')) note.remove()
  const shown = diaryDayFacts(dayRows(iso), whoFor)
  const whole = diaryDayFacts(wholeDay(iso), whoFor)
  const estimate = diaryEstimate(shown)
  const stat = (label: string, value: string, note = ''): HTMLElement => el('div', {}, el('dt', {}, label), el('dd', {}, value, ...(note ? [el('small', {}, note)] : [])))
  const progress = card.querySelector<HTMLElement>(':scope > .diary-day-progress')
  head.classList.add('diary-agenda-head')
  // Design B: one plain line of figures instead of four boxes; the map and the day's details behind two small buttons.
  const facts = [
    filtered ? `${shown.visits} matching visit${shown.visits === 1 ? '' : 's'}` : '',
    shown.visits ? `${cash(shown.pence)}${shown.unpriced ? ' + unpriced' : ''} booked` : 'Nothing booked',
    shown.visits ? `${shown.done} of ${shown.visits} done` : '',
  ].filter(Boolean).join(' · ')
  // Who is out, chosen right here (Liam, 11 Oct 2026); the day's details keep it too. Never in a one-person round
  // (19 Oct 2026): working days are set in My working days only.
  const outPick = worksAlone() ? null : rosterPicker(iso, roster.find(r => r.date === iso) ?? null, knownWorkers(p), { out: true })
  // Design B for the Day (Liam, 24 Oct 2026: "awesome yes i really like that", https://claude.ai/artifact/GvAv9orrjczy2hBG43Dq6E):
  // the tiles move out of the day to a row of their own under the dates (Due, Out today, Day details, Book here, Needs
  // you), the map leaves the tiles to sit beside the stops, and the day's heading keeps its ring of done out of booked.
  mapButton?.remove()
  head.replaceChildren(
    el('div', {class:'diary-agenda-main'},
      el('div', {class:'diary-agenda-title'}, el('h3', {id:'diary-agenda-title'}, longDay(iso)), ...(iso === todayISO() ? [el('span', {class:'diary-today-tag'}, 'Today')] : [])),
      el('p', {class:'diary-agenda-facts'}, facts)),
    )
  head.append(colourDay(head, wholeDay(iso), `agenda:${iso}`, false, {date:iso, closed:closedDiaryDay(p, iso)}))
  // One numbered list in the order the day is worked, done jobs included, with the same numbers on the map (Liam, 28 Oct
  // 2026: "the customers done have numbers for the order that correspond on the map"; design B).
  const numbered = new Map<number, number>()
  diaryDayOrder(drawn(card).filter(c => c.state !== 'cancelled' && !isSuggestion(c) && !isContact(c)), severalJobsOn()).forEach((c, i) => numbered.set(c.id, i + 1))
  for (const row of Array.from(card.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]'))) {
    const id = Number(row.dataset.cleanId)
    if (!row.dataset.cleanId || row.closest('.cancelled-visits') || !numbered.has(id) || row.querySelector(':scope > .diary-row-n')) continue
    const done = row.classList.contains('clean-done')
    const n = el('span', {class:`diary-row-n${done ? ' is-done' : ''}`, 'aria-hidden':'true'}, String(numbered.get(id)))
    const grip = row.querySelector<HTMLElement>(':scope > .diary-grip')
    if (grip) grip.after(n); else row.prepend(n)
  }
  progress?.remove()

  const search = el('input', {type:'search', id:'diary-desk-search', placeholder:'Customer, address or job', autocomplete:'off'})
  search.value = diarySearch
  search.addEventListener('input', () => {
    if (!diaryNavigationReady()) { search.value = diarySearch; return }
    diarySearch = search.value; const cursor = search.selectionStart
    render(p, root)
    const next = root.querySelector<HTMLInputElement>('#diary-desk-search'); next?.focus({preventScroll:true})
    try { next?.setSelectionRange(cursor, cursor) } catch { /* Search selection differs by browser. */ }
  })
  worker.setAttribute('aria-label', 'Who: filter by worker'); area.querySelector('select')?.setAttribute('aria-label', 'Area: filter by area')
  const clearFilters = el('button', {type:'button', class:'diary-clear-filters'}, 'Clear filters')
  clearFilters.disabled = !filtered
  clearFilters.addEventListener('pointerdown', event => { if (editing) event.preventDefault() })
  clearFilters.addEventListener('click', () => {
    if (!diaryNavigationReady()) return
    diarySearch = ''; workerFilter = ''; areaFilter = ''; render(p, root); focusAfter('#diary-desk-search')
  })
  const filterBar = el('div', {class:'diary-desk-filters', id:'diary-desk-find', role:'search', 'aria-label':'Find visits'},
    el('label', {class:'diary-field diary-field-grow'}, el('span', {}, 'Search visits'), search),
    // No Who in a one-person round (Liam, 19 Oct 2026).
    ...(worksAlone() ? [] : [el('div', {class:'diary-field'}, el('span', {'aria-hidden':'true'}, 'Who'), worker)]),
    el('div', {class:'diary-field'}, el('span', {'aria-hidden':'true'}, 'Area'), area),
    clearFilters,
    el('p', {class:'diary-filter-status', role:'status'}, filtered ? `Filters on: showing ${shown.visits} of ${whole.visits} visit${whole.visits === 1 ? '' : 's'} on this day.` : ''))
  filterBar.hidden = !findOpen
  head.after(filterBar)

  if (!shown.visits && !shown.suggested) {
    const empty = el('div', {class:'diary-empty'})
    if (filtered && whole.visits) {
      const again = el('button', {type:'button', class:'btn-primary'}, 'Clear filters')
      again.addEventListener('click', () => clearFilters.click())
      empty.append(el('p', {}, el('strong', {}, 'No visits match these filters.'), ` ${whole.visits} visit${whole.visits === 1 ? ' is' : 's are'} on this day.`), again)
    } else {
      const bookDay = el('button', {type:'button', class:'btn-primary'}, `+ Book a visit on ${dayLabel(iso)}`)
      bookDay.addEventListener('click', () => openBooking({date: iso}))
      empty.append(el('p', {}, el('strong', {}, `No visits booked on ${longDay(iso)}.`)), bookDay)
    }
    filterBar.after(empty)
  }
  const cancelledSummary = card.querySelector<HTMLElement>(':scope > .cancelled-visits > summary')
  if (cancelledSummary) cancelledSummary.textContent = `${shown.cancelled} cancelled visit${shown.cancelled === 1 ? '' : 's'}, not counted in totals or progress`
  const agenda = el('section', {class:'diary-desk-agenda', 'aria-labelledby':'diary-agenda-title'}, days)

  // ---- the right-hand column: the day on a map, or Needs you when its tile is pressed ----
  const rail = el('aside', {class:'diary-rail', 'aria-label':'The day on a map and Needs you'})
  const welcome = root.querySelector<HTMLElement>(':scope > .welcome-slot')
  // Design B (Liam, 8 Oct 2026): no Plan work panel. To place is the row above the dates; what else it held (past
  // visits to review, dates offered and waiting, contact reminders) are lines under Needs you.
  const needsYou = root.querySelector<HTMLElement>(':scope > .diary-attention-slot')
  setNeedsExtras(planningExtras(root, reviewCount))
  if (needsYou) needsYou.classList.add('diary-needs-you')

  // Day details: the whole day, whatever the filters show, with the real roster, notes and close-out.
  const kv = (label: string, value: string | HTMLElement): HTMLElement[] => [el('dt', {}, label), el('dd', {}, value)]
  // A one-person round has no Out on this day (Liam, 19 Oct 2026): Working days below says which days are theirs.
  const out = worksAlone() ? null : el('div', {class:'diary-day-out'}, el('span', {}, 'Out on this day'), ...(rosterControl ? [rosterControl] : []))
  const dayPanel = el('section', {class:'diary-panel diary-day-panel', 'aria-labelledby':'diary-day-panel-title'},
    el('h3', {id:'diary-day-panel-title'}, 'Day details'),
    ...(filtered ? [el('p', {class:'diary-panel-note'}, 'Whole day, not just the matching visits.')] : []),
    el('dl', {class:'diary-kv'},
      ...kv('Day', dayLabel(iso)),
      ...kv('Booked total', `${cash(whole.pence)}${whole.unpriced ? ' + unpriced' : ''} (${whole.visits} visit${whole.visits === 1 ? '' : 's'})`),
      ...kv('Day agreed', whole.open ? `${whole.agreed} of ${whole.open} open` : 'Nothing open'),
      ...kv('Estimated time', [diaryEstimate(whole).main, diaryEstimate(whole).note].filter(Boolean).join(', ')),
      ...kv('Done', `${whole.done} of ${whole.visits}`),
      ...kv('Paid', whole.paid ? `${cash(whole.paidPence)} (${whole.paid})` : 'None recorded'),
      ...(whole.owed ? kv('Not paid', `${cash(whole.owedPence)} (${whole.owed})`) : []),
      ...(whole.unrecorded ? kv('Payment not recorded', `${cash(whole.unrecordedPence)} (${whole.unrecorded})`) : []),
      ...(worksAlone() ? [] : kv('Unassigned', String(whole.unassigned))),
      ...kv('Cancelled', whole.cancelled ? `${whole.cancelled}, not counted` : 'None'),
      ...(whole.suggested ? kv('Suggested', `${whole.suggested}, not counted`) : [])),
    ...(out ? [out] : []))
  if (notes) dayPanel.append(el('h4', {}, 'Day notes'), notes)
  if (ledger) dayPanel.append(el('details', {class:'diary-day-tool diary-desk-ledger'}, el('summary', {}, 'Day totals and close-out'), ledger))

  // The day on a map, beside the stops (design B): the stops the list shows, in its order and with its numbers (a done
  // visit is a tick, "Couldn't do it" grey), so a search shows the same stops on both. "Bigger map" opens it in a tab of
  // its own as the pin did, or over the diary when a pop-up blocker says no.
  const mapRows = diaryDayOrder(drawn(card).filter(c => c.state !== 'cancelled' && !isSuggestion(c) && !isContact(c)), severalJobsOn())
    .map(c => ({ ...c, n: numbered.get(c.id) ?? null }))
  const stopsLeft = mapRows.filter(c => c.state === 'booked' && !c.blocked_reason).length
  const bigger = el('button', {type:'button', class:'diary-map-bigger'}, 'Bigger map')
  bigger.addEventListener('click', () => {
    const tab = window.open(`${window.location.pathname}#/map/${iso}`, `roundly-map-${iso}`)
    if (tab) { tab.focus(); return }
    bigger.disabled = true
    void import('../day-map-panel').then(panel => panel.openDayMap(mapRows, dayLabel(iso))).finally(() => { bigger.disabled = false })
  })
  const mapHost = el('div', {class:'diary-map-host'})
  const mapPanel = el('section', {class:'diary-panel diary-daymap-panel', 'aria-labelledby':'diary-map-title'},
    el('div', {class:'diary-daymap-head'},
      el('div', {}, el('h3', {id:'diary-map-title'}, 'The day on a map'), el('p', {class:'diary-panel-note'}, mapRows.length ? `${stopsLeft ? `${stopsLeft} stop${stopsLeft === 1 ? '' : 's'} left` : 'All done'} · numbers match the list` : filtered ? 'No matching visits to show' : 'Nothing booked')),
      ...(mapRows.length ? [bigger] : [])),
    mapHost,
    ...(pinsOf(mapRows).length ? [el('p', {class:'diary-panel-note'}, "Tap a number for the name, address and their page. Grey: couldn't do it.")] : []))

  // Who is out each day of this week: what lets Messages offer a day.
  const workPanel = el('section', {class:'diary-panel diary-work-panel', 'aria-labelledby':'diary-work-title'}, el('h3', {id:'diary-work-title'}, 'Working days'))
  const weekList = el('ul', {class:'diary-work-days'})
  for (let day = p.from; day <= p.to; day = addDaysISO(day, 1)) {
    const who = roster.find(r => r.date === day)?.worker
    const target = day
    // A one-person round (Liam, 19 Oct 2026): "Mon · working" or "Mon · day off", never a name.
    const alone = worksAlone()
    const state = alone ? (who ? 'working' : 'day off') : ''
    const chooser = el('button', {type:'button', class:`diary-work-day${who ? ' is-on' : ''}${day === iso ? ' is-selected' : ''}`, 'aria-pressed':String(day === iso), 'aria-label':`${dayLabel(day)}: ${alone ? state : who ? `${who} out` : 'nobody out'}`},
      el('b', {}, new Date(`${day}T12:00:00`).toLocaleDateString('en-GB', {weekday:'short'})), ` · ${alone ? state : who ?? 'nobody'}`)
    chooser.addEventListener('click', () => {
      if (target === selectedDate || !diaryNavigationReady()) return
      selectedDate = target; render(p, root); focusAfter(`.diary-work-day[aria-label^="${dayLabel(target)}"]`)
    })
    weekList.append(el('li', {}, chooser))
  }
  workPanel.append(weekList, el('p', {class:'diary-panel-note'}, worksAlone() ? 'Messages offers customers your working days. Change them in My working days.' : 'Choose who is out with Out on this day, above. Messages can offer a day with someone out.'))
  if (ownerDoesJobs() || worksAlone()) workPanel.append(el('a', {href:'#/my-days', class:'diary-panel-link'}, 'My working days →'))

  // ---- the tiles under the dates (design B): Due, Out today, Day details, Book here, Needs you ----
  const tile = (key: string, drawing: TileDrawing, count: string, words: string, press?: () => void, on = false, tone = '', stay = true): HTMLElement => deskTile(root, key, drawing, count, words, press, on, tone, stay)
  const redraw = (): void => render(p, root)
  const dueCount = due.held.length + due.sets.due.length
  // Who is out keeps its real chooser (Nobody out, a name, Someone else); the whole tile opens it.
  const outTile = outPick ? el('div', {class:'diary-wtile diary-out-tile', 'data-tile':'out'},
    el('span', {class:'diary-wtile-ring', 'aria-hidden':'true'}, lineDrawing('person', 17)), el('span', {class:'diary-wtile-count diary-out-pick-slot'}, outPick), el('span', {class:'diary-wtile-words'}, 'Out today')) : null
  const info = tile('info', 'info', whole.visits ? `${whole.done} of ${whole.visits}` : '', 'Day details · notes, totals', () => openDayDetails(iso, dayPanel, workPanel, info), false, '', false)
  info.setAttribute('aria-label', `Day details for ${dayLabel(iso)}: notes, totals and working days`)
  // The redesign's Day (Day 4): Due, Pencilled and Needs you as in Week (Pencilled counts the strip's week, from today
  // on), then Out today and Day details; the date strip below is the week's seven day heads.
  const weekAhead = cards.flatMap(c => c.dataset.date! >= todayISO() ? dayRows(c.dataset.date!) : [])
  const dayPencil = pencilledRows(weekAhead)
  const tiles = el('div', {class:'diary-week-tiles diary-day-tiles diary-tile-row', role:'group', 'aria-label':'This day at a glance'},
    actionTiles(root, dueCount, barCards(due, p).filter(b => b.late).length, countPencilled(dayPencil.map(r => r.step)), redraw),
    el('span', {class:'diary-tile-sep', 'aria-hidden':'true'}),
    ...(outTile ? [outTile] : []),
    info)
  const daySub = heading.querySelector<HTMLElement>('.diary-desk-sub')
  if (daySub) daySub.textContent = `${whole.visits} visit${whole.visits === 1 ? '' : 's'} · ${cash(whole.pence)}${whole.unpriced ? ' + unpriced' : ''}${whole.visits ? ` · ${whole.done} of ${whole.visits} done` : ''}`

  // ---- page order: top line, dates, tiles, any placing bar, then Due (when open), the day, and the map or Needs you ----
  const moveBar = picking ? (() => {
    const cancel = el('button', {type:'button'}, 'Cancel'); cancel.addEventListener('click', () => cancelMoveSelection())
    return el('div', {class:'diary-move-bar', role:'status'}, el('span', {}, el('strong', {}, `Now tap a day for ${pickedName}`), ' · or drag them onto it.'), cancel)
  })() : null
  // Someone placed whose message waits: with Due closed its chip stays in sight above the day.
  const laterChip = deskDueOpen ? null : messageLaterChip()
  const laterBar = laterChip ? el('div', {class:'diary-week-later'}, laterChip, el('span', {}, 'placed, message not sent yet')) : null
  // Due opens beside the day, pushing the map out until it closes (the drawing: "The map comes back when you close this").
  if (deskDueOpen) {
    dueCol.classList.add('diary-due-drawer')
    const hint = dueCol.querySelector<HTMLElement>('.diary-due-col-hint')
    if (hint) hint.textContent = 'Drag someone onto the day, or onto another day above, or click them and then a day. The map comes back when you close this.'
    const close = el('button', {type:'button', class:'diary-drawer-close', 'aria-label':'Close the Due list'}, el('span', {'aria-hidden':'true'}, '✕'))
    close.addEventListener('click', () => { deskDueOpen = false; redraw(); focusAfter('.diary-wtile[data-tile="due"]') })
    dueCol.querySelector('.diary-due-col-head')?.append(close)
  }
  if (deskDueOpen) { deskPencilOpen = false; deskNeedsOpen = false } else if (deskPencilOpen) deskNeedsOpen = false
  // Needs you opens on the left of the day, where Due and Pencilled do; the map stays beside it.
  const needsCol = deskNeedsOpen && needsYou && !picking ? deskNeedsDrawer(needsYou, () => { deskNeedsOpen = false; redraw(); focusAfter('.diary-wtile[data-tile="needs"]') }) : null
  if (welcome && !deskDueOpen) rail.append(welcome)
  // The day's card above the map on a computer, dark (Liam, 4 Nov 2026, layout 1A,
  // https://claude.ai/artifact/FZzTFHcM9o35oj15N35Mk1): the same figures and Plan as the phone's card; the map is beside it.
  // The same visits the day's list shows (dayRows), as the phone's card (Sonnet, 6.1, 4 Nov 2026).
  if (!deskDueOpen && !pricesHidden()) {
    const money = dayMoneyCard(iso, dayRows(iso).filter(c => !isSuggestion(c)), null)
    money.classList.add('is-desk')
    rail.append(money)
    // Planning: a box for each person to drop a visit on (Liam's drawing 3, "Drop on a person"), with how many of the
    // day's visits are theirs. Unassigned only when the day has no person of its own (a job with no name is theirs).
    const own = getMe()?.workerName?.trim() ?? ''
    const names: string[] = []
    for (const n of [own, ...knownWorkers(p)]) if (n.trim() && !names.some(x => x.toLowerCase() === n.trim().toLowerCase())) names.push(n.trim())
    if (!worksAlone() && names.length > 1) {
      const booked = dayRows(iso).filter(c => c.state === 'booked' && !isSuggestion(c))
      const dayPerson = roster.find(r => r.date === iso)?.worker?.trim() ?? ''
      const count = (n: string): number => booked.filter(c => visitWorker(c, roster).toLowerCase() === n.toLowerCase()).length
      const box = (label: string, person: string, n: number): HTMLElement => el('div', { class: 'diary-plan-person', 'data-person': person, title: `Drop a customer here to give the job to ${person || 'nobody yet'}` }, el('b', {}, label), el('span', {}, String(n)))
      const boxes = names.map(n => box(n, n, count(n)))
      if (!dayPerson) boxes.push(box('Unassigned', '', booked.filter(c => !visitWorker(c, roster)).length))
      rail.append(el('section', { class: 'diary-plan-people', 'aria-label': 'Drop on a person' }, el('h3', {}, 'Drop on a person'), el('div', { class: 'diary-plan-people-row' }, ...boxes)))
    }
  }
  if (!deskDueOpen) rail.append(mapPanel)
  // Kept on the page out of sight, so its count keeps filling the tile and its lines stay ready to open.
  if (needsYou && !needsCol) { needsYou.hidden = true; rail.append(needsYou) }
  const railShown = !deskDueOpen
  rail.hidden = !railShown
  bindWeekEscape()
  if (deskDueOpen && deskPencilOpen) deskPencilOpen = false
  const pencilCol = deskPencilOpen && !picking ? deskPencilColumn(dayPencil, redraw) : null
  if (pencilCol) tuckOnDrag(pencilCol)
  const workspace = el('div', {class:`diary-workspace diary-day-workspace${deskDueOpen || pencilCol || needsCol ? ' has-due' : ''}${railShown ? ' has-rail' : ''}`}, ...(deskDueOpen ? [dueCol] : pencilCol ? [pencilCol] : needsCol ? [needsCol] : []), agenda, rail)
  const welcomeAbove = welcome && deskDueOpen ? welcome : null
  heading.after(el('div', {class:'diary-desk-frame diary-day-frame'}, el('div', {class:'diary-desk-main'}, tiles, ...(strip ? [strip, diaryColourKey()] : []), ...(moveBar ? [moveBar] : []), ...(laterBar ? [laterBar] : []), ...(welcomeAbove ? [welcomeAbove] : []), workspace)))
  if (!deskDueOpen) placeDeskMap(iso, mapRows, mapHost)
}

// ---- the map beside the day (design B) ----
// One map, kept while the same stops are on show: the Diary is drawn again on every change, so the map moves to the new
// page rather than being drawn again, and measures its box again. Gone when Week, Month or another page is shown.
let deskMap: { key: string; map: import('../day-map-panel').DeskDayMap } | null = null
// The visits the map on show last counted as done, so only one marked done since then ripples (the movement set). Counted
// from the whole day, not the stops a search leaves, so clearing a search ripples nothing; forgotten when the map goes
// (another day, Week, Month, leaving the Diary), so nothing ripples on opening a day (Astra, 24 Oct 2026).
let deskMapDone: { iso: string; ids: Set<number> } | null = null
let deskMapAsk = 0
function dropDeskMap(): void { deskMapAsk++; deskMap?.map.remove(); deskMap = null }
function placeDeskMap(iso: string, rows: (Clean & { n: number | null })[], host: HTMLElement): void {
  const key = JSON.stringify([iso, rows.map(c => [c.id, c.n, c.state, c.blocked_reason ?? null, c.customer_lat ?? null, c.customer_lng ?? null, c.customer_name ?? null, c.customer_address ?? null, c.customer_postcode ?? null])])
  const doneNow = new Set((payload?.cleans ?? []).filter(c => c.date === iso && c.state === 'done').map(c => c.id))
  if (deskMap?.key === key) {
    // The same stops on show: a visit a search hides that was marked done meanwhile joins what the map has counted.
    if (deskMapDone?.iso === iso) deskMapDone.ids = doneNow
    host.append(deskMap.map.holder)
    const map = deskMap.map
    requestAnimationFrame(() => map.resize())
    return
  }
  const before = deskMap && deskMapDone?.iso === iso ? deskMapDone.ids : null
  dropDeskMap()
  deskMapDone = { iso, ids: doneNow }
  if (!rows.length) return
  const just = new Set(before ? [...doneNow].filter(id => !before.has(id)) : [])
  host.classList.add('is-loading')
  const ask = deskMapAsk
  // The map's drawing and street tiles load on a computer's Day only, the first time it is shown.
  void import('../day-map-panel').then(panel => {
    if (ask !== deskMapAsk || !host.isConnected) return
    deskMap = { key, map: panel.drawDeskDayMap(rows, just) }
    host.classList.remove('is-loading')
    host.append(deskMap.map.holder)
    deskMap.map.resize()
  }).catch(() => {
    host.classList.remove('is-loading')
    if (host.isConnected) host.replaceChildren(el('p', {class:'diary-panel-note'}, 'The map could not load. Check your signal and try again.'))
  })
}
window.addEventListener('hashchange', () => { if (!window.location.hash.startsWith('#/schedule')) dropDeskMap() })

// Week on a computer (Liam, 8 Oct 2026, end of day: "we'll have a day, a week and a month"): all seven days side by
// side. Each column is that day's real card, so a visit drags to another day and someone in Due drops onto one (their
// message opens, as in Day); a day's name opens it in Day.
// Design B (Liam picked it, 24 Oct 2026: "the wider week is actually better now i understand the logic of the slide";
// https://claude.ai/artifact/GvAv9orrjczy2hBG43Dq6E): tiles along the top say the week at a glance and the days take the
// whole width. Due and Needs you are tiles that slide their lists over the week (Due from the left, Needs you from the
// right); dragging someone past the Due list's edge tucks it away so Monday and Tuesday take a drop too. Not asked yet,
// Times to confirm, Done and Free days light those up across the week. Each person is one line (time, price, where they
// stand, a flag when there is something to know before going); the visit itself opens its details with every button,
// and today's and past days keep Done on the line (Sonnet's and GPT-6.1's reviews).
type WeekLens = 'done' | 'free'
let deskDueOpen = false
// The Pencilled list (the Diary redesign, 26 Oct 2026): over the left like Due, one of the two at a time.
let deskPencilOpen = false
let deskNeedsOpen = false
let deskWeekLens: WeekLens | null = null
function presentDeskWeek(root: HTMLElement, p: SchedulePayload, heading: HTMLElement, days: HTMLElement, cards: HTMLElement[], dayRows: (day: string) => Clean[], wholeDay: (day: string) => Clean[], whoFor: (c: Clean) => string, filtered: boolean, worker: HTMLElement, area: HTMLElement, reviewCount: number, dueCol: HTMLElement, due: PhoneDue): void {
  if (deskDueOpen && deskPencilOpen) deskPencilOpen = false
  dropDeskMap()
  const picking = movingId !== null || movingDueId !== null || movingEnqId !== null
  const pickedName = p.cleans.find(c => c.id === movingId)?.customer_name ?? dueCustomers(p).find(c => dueKey(c) === movingDueId)?.name ?? leads?.find(l => l.id === movingEnqId)?.name ?? 'them'
  const today = todayISO()
  const roster = p.round_days ?? []
  // A day the round can take work: in a one-person round only the owner's working days (My working days).
  const workable = (day: string): boolean => day >= today && (!worksAlone() || roster.some(r => r.date === day && !!r.worker))
  const lens = deskWeekLens
  // Pencilled (src/pencilled.ts): the visits on show from today on, in the same order as the days.
  const ahead = cards.flatMap(card => card.dataset.date! >= today ? dayRows(card.dataset.date!) : [])
  const pencilRows = pencilledRows(ahead)
  const pencil = countPencilled(pencilRows.map(r => r.step))
  let visits = 0, pence = 0, unpriced = false, doneCount = 0, donePence = 0
  const freeDays: string[] = []
  for (const card of cards) {
    const day = card.dataset.date!
    card.hidden = false; card.inert = false
    const fold = card.querySelector<HTMLDetailsElement>(':scope > .day-fold')
    if (fold) { for (const child of [...fold.children]) if (child.tagName !== 'SUMMARY') card.append(child); fold.remove(); card.classList.remove('day-empty') }
    for (const extra of card.querySelectorAll<HTMLElement>(':scope > .diary-day-details, :scope > .diary-day-progress, :scope > .day-money')) extra.remove()
    const rows = dayRows(day)
    const f = diaryDayFacts(rows, whoFor)
    visits += f.visits; pence += f.pence; unpriced ||= f.unpriced; doneCount += f.done
    donePence += rows.filter(c => c.state === 'done').reduce((n, c) => n + (c.amount_pence ?? 0), 0)
    const needs = dayNeeds(rows, day)
    // A day whose visits the search, Who or Area hide is not free: it says so, and never counts as a free day.
    const hidden = filtered && !f.visits && wholeDay(day).some(c => c.state !== 'cancelled')
    const isToday = day === today
    const target = picking && day >= today
    const open = el('button', {type:'button', class:'diary-week-open', 'aria-label':target ? `Put ${pickedName} on ${dayLabel(day)}` : `Open ${dayLabel(day)} in Day`},
      el('span', {}, new Date(`${day}T12:00:00`).toLocaleDateString('en-GB', {weekday:'short'})), el('b', {}, String(Number(day.slice(8)))), ...(isToday ? [el('span', {class:'diary-strip-today'}, 'Today')] : []))
    open.addEventListener('click', () => {
      if (!diaryNavigationReady()) return
      if (picking && placePicked(day)) return
      selectedDate = day; setWeekMode('day'); render(p, root)
      root.querySelector<HTMLElement>(`.diary-desk-strip [data-date="${day}"]`)?.focus({preventScroll:true})
    })
    // Visits and money stay on one line, warnings and who is out stay under it; the shared mark shows done/total.
    const out = roster.find(r => r.date === day)?.worker
    // The redesign's day head (Week 4): visits and money, who is out, and only what stops a visit going ahead ("1 to
    // check"); what is still to agree is the Pencilled tile's, and each job's own tile says it.
    const more = [needs.check, out && !worksAlone() ? `${out} out` : ''].filter(Boolean) as string[]
    const head = card.querySelector<HTMLElement>(':scope > .day-head')
    const ring = head ? colourDay(head, wholeDay(day), `week:${day}`, isToday, {date:day, closed:closedDiaryDay(p, day)}) : null
    if (ring && needs.check && !ring.querySelector('.diary-state-warning')) ring.append(el('span', {class:'diary-state-warning', role:'img', 'aria-label':needs.check, title:needs.check}))
    head?.replaceChildren(el('div', {class:'diary-week-headline'}, open, ...(ring ? [ring] : [])),
      el('p', {class:'diary-week-facts'}, el('span', {class:'diary-week-sum'}, f.visits ? `${f.visits} visit${f.visits === 1 ? '' : 's'} · ${cash(f.pence)}${f.unpriced ? ' + unpriced' : ''}` : hidden ? 'No matches' : day >= today ? 'Free' : 'Nothing booked'), ...more.map(m => el('span', {class:'diary-week-need'}, m))))
    card.classList.toggle('is-today', isToday); card.classList.toggle('is-target', target); card.classList.toggle('is-gone', day < today)
    // Each person one line: the price joins where they stand, and anything to know before going (an access note, parking,
    // couldn't do it) shows as a flag that names it, never hidden by the narrow column.
    for (const row of card.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')) weekRow(row)
    // A day with nothing booked: a calm Free day that books here (and takes a drop like any day); a day gone says so.
    if (hidden) {
      card.querySelector(':scope > .diary-free-day')?.remove()
      card.append(el('p', {class:'diary-free-day is-gone'}, 'No matching visits'))
    } else if (!f.visits && !f.suggested && !card.querySelector('.clean-row[data-clean-id]')) {
      card.querySelector(':scope > .diary-free-day')?.remove()
      if (day >= today) {
        const free = el('button', {type:'button', class:'diary-free-day', 'aria-label':target ? `Put ${pickedName} on ${dayLabel(day)}` : `${dayLabel(day)} is free: book a visit`}, el('span', {class:'diary-free-ring', 'aria-hidden':'true'}, lineDrawing('calendarPlus', 18)), el('strong', {}, 'Free day'), el('span', {}, target ? `Put ${pickedName} here` : 'Drop someone due'))
        // Someone picked goes on this day, as a click on its name does; otherwise a new booking on it.
        free.addEventListener('click', () => { if (!diaryNavigationReady()) return; if (picking && placePicked(day)) return; openBooking({ date: day }) })
        card.append(free)
        if (workable(day)) freeDays.push(day)
      } else card.append(el('p', {class:'diary-free-day is-gone'}, 'Nothing booked'))
    }
    // The tile picked lights its people (or days) and fades the rest; tapped again, everyone shows.
    if (lens) weekLens(card, lens, freeDays.includes(day))
  }
  // The magnifier's search, Who and Area, as in Day.
  const search = el('input', {type:'search', id:'diary-desk-search', placeholder:'Customer, address or job', autocomplete:'off'})
  search.value = diarySearch
  search.addEventListener('input', () => {
    if (!diaryNavigationReady()) { search.value = diarySearch; return }
    diarySearch = search.value; const cursor = search.selectionStart
    render(p, root)
    const next = root.querySelector<HTMLInputElement>('#diary-desk-search'); next?.focus({preventScroll:true})
    try { next?.setSelectionRange(cursor, cursor) } catch { /* Search selection differs by browser. */ }
  })
  const clear = el('button', {type:'button', class:'diary-clear-filters'}, 'Clear filters'); clear.disabled = !filtered
  clear.addEventListener('click', () => { if (!diaryNavigationReady()) return; diarySearch = ''; workerFilter = ''; areaFilter = ''; render(p, root) })
  const findBar = el('div', {class:'diary-desk-filters', id:'diary-desk-find', role:'search', 'aria-label':'Find visits'},
    el('label', {class:'diary-field diary-field-grow'}, el('span', {}, 'Search visits'), search),
    // No Who in a one-person round (Liam, 19 Oct 2026).
    ...(worksAlone() ? [] : [el('div', {class:'diary-field'}, el('span', {'aria-hidden':'true'}, 'Who'), worker)]),
    el('div', {class:'diary-field'}, el('span', {'aria-hidden':'true'}, 'Area'), area), clear)
  findBar.hidden = !(deskFindOpen || filtered)
  const moveBar = picking ? (() => {
    const cancel = el('button', {type:'button'}, 'Cancel'); cancel.addEventListener('click', () => cancelMoveSelection())
    return el('div', {class:'diary-move-bar', role:'status'}, el('span', {}, el('strong', {}, `${pickedName} picked: tap a day for them`), ' · or drag them onto it.'), cancel)
  })() : null
  const needsYou = root.querySelector<HTMLElement>(':scope > .diary-attention-slot')
  setNeedsExtras(planningExtras(root, reviewCount))
  if (needsYou) needsYou.classList.add('diary-needs-you')

  // ---- the tiles along the top ----
  const redraw = (): void => render(p, root)
  const focusOn = (selector: string): void => root.querySelector<HTMLElement>(selector)?.focus({preventScroll:true})
  // A tile or the lens line pressed while someone is picked lets go of them first, as any tap elsewhere would (the
  // document's own let-go then has nothing to do), so the page is drawn once and the keyboard stays where it is put.
  const letGo = (): void => { movingId = null; movingDueId = null; movingEnqId = null }
  const dueCount = due.held.length + due.sets.due.length
  const tile = (key: string, drawing: TileDrawing, count: string, words: string, press?: () => void, on = false, tone = ''): HTMLElement => deskTile(root, key, drawing, count, words, press, on, tone)
  const lensTile = (key: WeekLens): () => void => () => { deskWeekLens = deskWeekLens === key ? null : key; redraw() }
  const sub = heading.querySelector<HTMLElement>('.diary-desk-sub')
  if (sub) sub.textContent = `${weekDates(p.from, p.to, today)} · ${visits} visit${visits === 1 ? '' : 's'} · ${cash(pence)}${unpriced ? ' + unpriced' : ''}`
  const late = barCards(due, p).filter(b => b.late).length
  const tiles = el('div', {class:'diary-week-tiles diary-tile-row', role:'group', 'aria-label':'This week at a glance'},
    actionTiles(root, dueCount, late, pencil, redraw),
    // Design D (Liam, 3 Nov 2026: "I like D", worked through with Astra; https://claude.ai/artifact/JxdZQm6CVsyn8tdBonFteo):
    // the three lists as picture squares; Done and Free days, which light days rather than open a list, as two small
    // Highlight days buttons; the visits and money stay only in the line under the title (the tile repeated it).
    el('span', {class:'diary-highlights', role:'group', 'aria-label':'Highlight days'},
      el('span', {class:'diary-highlights-cap', 'aria-hidden':'true'}, 'Highlight days'),
      tile('done', 'tick', String(doneCount), `done · ${cash(donePence)}`, lensTile('done'), lens === 'done', 'green'),
      tile('free', 'calendarPlus', String(freeDays.length), `free day${freeDays.length === 1 ? '' : 's'}`, lensTile('free'), lens === 'free')))
  const lensWords: Record<WeekLens, string> = {
    done: `${doneCount} done this week · ${cash(donePence)}`,
    free: freeDays.length ? `${freeDays.length} free day${freeDays.length === 1 ? '' : 's'} this week · ${dueCount} due who could fill them` : 'No free days left this week',
  }
  const lensBar = lens ? (() => {
    const everyone = el('button', {type:'button', class:'diary-week-lens-off'}, 'Show everyone')
    everyone.addEventListener('click', () => { const was = deskWeekLens; letGo(); deskWeekLens = null; redraw(); focusOn(`.diary-wtile[data-tile="${was}"]`) })
    const act = lens === 'free' && dueCount ? (() => { const b = el('button', {type:'button', class:'diary-week-lens-act'}, 'Open Due'); b.addEventListener('click', () => { letGo(); deskDueOpen = true; deskPencilOpen = false; deskNeedsOpen = false; redraw(); focusOn('.diary-due-drawer .diary-drawer-close') }); return b })() : null
    return el('div', {class:'diary-week-lens', role:'status'}, el('strong', {}, lensWords[lens]), ...(act ? [act] : []), everyone)
  })() : null

  // Someone placed whose message waits ("Message them later"): with the Due list closed its chip stays in sight above the
  // days, as it is at the top of the list when open.
  const laterChip = deskDueOpen && !picking ? null : messageLaterChip()
  const laterBar = laterChip ? el('div', {class:'diary-week-later'}, laterChip, el('span', {}, `placed, message not sent yet`)) : null

  // ---- the lists that slide over the week ----
  const stage = el('div', {class:'diary-week-stage'})
  const grid = el('section', {class:'diary-desk-weekgrid', 'aria-label':'This week, day by day'}, days)
  stage.append(grid)
  // While someone is picked the Due list steps aside, so every day is in reach (Liam's tap-then-day drawing).
  if (deskDueOpen && !picking) {
    dueCol.classList.add('diary-due-drawer')
    const close = el('button', {type:'button', class:'diary-drawer-close', 'aria-label':'Close the Due list'}, el('span', {'aria-hidden':'true'}, '✕'))
    close.addEventListener('click', () => { deskDueOpen = false; redraw(); root.querySelector<HTMLElement>('.diary-wtile[data-tile="due"]')?.focus({preventScroll:true}) })
    dueCol.querySelector('.diary-due-col-head')?.append(close)
    stage.append(dueCol)
    tuckOnDrag(dueCol)
  }
  if (deskPencilOpen && !picking) {
    const pencilCol = deskPencilColumn(pencilRows, redraw)
    stage.append(pencilCol)
    tuckOnDrag(pencilCol)
  }
  if (deskNeedsOpen && needsYou && !picking && !deskDueOpen && !deskPencilOpen) {
    stage.append(deskNeedsDrawer(needsYou, () => { deskNeedsOpen = false; redraw(); root.querySelector<HTMLElement>('.diary-wtile[data-tile="needs"]')?.focus({preventScroll:true}) }))
  } else if (needsYou) {
    // Kept on the page out of sight, so its count keeps filling the tile and its lines stay ready to open.
    needsYou.hidden = true
    stage.append(needsYou)
  }
  bindWeekEscape()
  heading.after(findBar, el('div', {class:'diary-desk-frame diary-week-frame'}, el('div', {class:'diary-desk-main'}, tiles, ...(lensBar ? [lensBar] : []), ...(moveBar ? [moveBar] : []), ...(laterBar ? [laterBar] : []), stage, diaryColourKey())))
  usedDiaryWeek()
}

// ---- Pencilled (the Diary redesign, 26 Oct 2026; docs/plans/diary-redesign/PLAN.md sections 1 and 3) --------------
// Each visit on show from today on, with its step; none for a visit that is not Pencilled (src/pencilled.ts).
interface PencilRow { cl: Clean; step: PencilledStep }
// The shared day-only rule includes today. Past work belongs to review; time-only work stays amber on its visit.
function pencilledRows(rows: Clean[]): PencilRow[] {
  const today = todayISO()
  return rows.flatMap(cl => { const step = pencilledStep(cl, visitCustomer(cl), today); return step ? [{ cl, step }] : [] })
}

// Due, Pencilled and Needs you: the three tiles that ask something of you, first in every Diary view's row.
function actionTiles(root: HTMLElement, dueCount: number, late: number, pencil: PencilledCount, redraw: () => void): HTMLElement {
  const lateWords = late ? el('em', {class:'diary-wtile-late'}, `${late} late`) : null
  const due = deskTile(root, 'due', 'list', String(dueCount), deskDueOpen ? 'Due · list open' : 'Due', () => { deskDueOpen = !deskDueOpen; if (deskDueOpen) { deskPencilOpen = false; deskNeedsOpen = false } redraw() }, deskDueOpen, 'due')
  if (lateWords) due.querySelector('.diary-wtile-words')?.after(lateWords)
  const pen = deskTile(root, 'pencil', 'pencil', String(pencil.all), deskPencilOpen ? 'Pencilled · list open' : 'Pencilled', () => { deskPencilOpen = !deskPencilOpen; if (deskPencilOpen) { deskDueOpen = false; deskNeedsOpen = false } redraw() }, deskPencilOpen, 'pencil')
  if (pencil.ask) pen.querySelector('.diary-wtile-words')?.after(el('em', {class:'diary-wtile-ask'}, `${pencil.ask} to ask`))
  pen.setAttribute('aria-label', `${pencil.all} pencilled, ${pencil.ask} to ask`)
  const needs = deskTile(root, 'needs', '!', needsTileCount(), deskNeedsOpen ? 'Needs you · open' : 'Needs you', () => { deskNeedsOpen = !deskNeedsOpen; if (deskNeedsOpen) { deskDueOpen = false; deskPencilOpen = false } redraw() }, deskNeedsOpen, 'amber')
  return el('span', {class:'diary-action-tiles diary-action-squares'}, due, pen, needs)
}

// The Pencilled list over the left of the week, like Due: Not asked yet, Asked waiting, in
// that order; each visit with its own next step and Move, and a grip to drag it onto a day (the list tucks away while
// you drag, as Due's does). Every button is the visit's existing action, never a new route.
// Where a left list (Pencilled, Due) was put down, over the page (Liam, 26 Oct 2026: "pick it up and move it anywhere
// and then orginal position"; then "due should also be draggable?"); null is its own place at the side. Kept while the
// Diary is open, through redraws and views.
type ListFloat = { x: number; y: number } | null
const listFloat: Record<'pencil' | 'due' | 'needs', ListFloat> = { pencil: null, due: null, needs: null }
const clampFloat = (f: { x: number; y: number }, w: number): { x: number; y: number } =>
  ({ x: Math.max(8, Math.min(f.x, window.innerWidth - w - 8)), y: Math.max(8, Math.min(f.y, window.innerHeight - 120)) })
let listResizeBound = false
function bindListResize(): void {
  if (listResizeBound) return
  listResizeBound = true
  window.addEventListener('resize', () => {
    for (const col of document.querySelectorAll<HTMLElement>('[data-float].is-floating')) {
      const which = col.dataset.float as 'pencil' | 'due' | 'needs', f = listFloat[which]
      if (!f) continue
      listFloat[which] = clampFloat(f, col.offsetWidth)
      col.style.left = `${Math.round(listFloat[which]!.x)}px`; col.style.top = `${Math.round(listFloat[which]!.y)}px`
    }
  })
}
// The handle that picks a left list up (drag it anywhere, or the arrow keys on it) and "Back to the side". The list
// stays where it is put, on top of the page as it scrolls; in the phone's sheet it is never moved (Sonnet's check: a
// position from a wide window leaked into it).
function listMover(col: HTMLElement, which: 'pencil' | 'due' | 'needs', name: string): { grip: HTMLElement; back: HTMLElement } {
  col.dataset.float = which
  const grip = el('button', {type:'button', class:'diary-pencil-move', 'aria-label':`Move the ${name} list: drag it, or use the arrow keys`, title:'Drag to move this list'}, el('span', {'aria-hidden':'true'}, '⠿'))
  // Design G (Liam, 3 Nov 2026: "Return to side should be an icon"): a round icon with its words on hover and for
  // screen readers.
  const back = el('button', {type:'button', class:'diary-pencil-back', 'aria-label':`Put the ${name} list back to the side`, title:'Back to the side'})
  back.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M9 4v16M16 12h-4m0 0 2-2m-2 2 2 2"/></svg>'
  const place = (): void => {
    const f = listFloat[which], sheet = col.classList.contains('diary-pencil-sheet') || !!col.closest('dialog')
    back.hidden = !f || sheet
    // Design M (Liam, 3 Nov 2026: "I like M"): while the list is out, its tile along the top says "Bring it back here"
    // and a click on it puts the list back at the side.
    const tile = document.querySelector<HTMLElement>(`#screen .diary-wtile[data-tile="${which}"]`), words = tile?.querySelector<HTMLElement>('.diary-wtile-words')
    if (tile && words) {
      const home = !!f && !sheet
      if (home && tile.dataset.words === undefined) tile.dataset.words = words.textContent ?? ''
      if (!home && tile.dataset.words !== undefined) { words.textContent = tile.dataset.words; delete tile.dataset.words }
      if (home) words.textContent = 'Bring it back here'
      tile.classList.toggle('is-home', home)
      if (home) tile.setAttribute('aria-label', `Put the ${name} list back to the side`); else tile.removeAttribute('aria-label')
    }
    if (!f || sheet) { col.classList.remove('is-floating'); col.style.left = ''; col.style.top = ''; return }
    listFloat[which] = clampFloat(f, col.offsetWidth || 360)
    col.classList.add('is-floating'); col.style.left = `${Math.round(listFloat[which]!.x)}px`; col.style.top = `${Math.round(listFloat[which]!.y)}px`
  }
  // Put down where it was straight away (no jump from the side on a redraw), again once drawn, and kept on screen when
  // the window changes.
  place(); window.setTimeout(place, 0); bindListResize()
  back.addEventListener('click', () => { listFloat[which] = null; place(); grip.focus({preventScroll:true}) })
  // The whole top bar picks the list up too (Liam, 3 Nov 2026: "What if you could drag the side bit anywhere not just
  // from the corner", design G), not its buttons; the list itself holds names to drag onto days, so it never moves it.
  const pickUp = (handle: HTMLElement) => (e: PointerEvent): void => {
    if (e.button !== 0) return
    if (handle !== grip && (e.target as Element | null)?.closest('button, a, input, select, [role="tab"]')) return
    e.preventDefault()
    const r = col.getBoundingClientRect(), dx = e.clientX - r.left, dy = e.clientY - r.top, sx = e.clientX, sy = e.clientY
    // A click that does not move leaves the list where it is (Astra, 3 Nov 2026: a still click on the bar undocked it).
    let moving = false
    try { handle.setPointerCapture(e.pointerId) } catch { /* the pointer already went */ }
    const move = (ev: PointerEvent): void => {
      if (!moving) { if (Math.hypot(ev.clientX - sx, ev.clientY - sy) < 5) return; moving = true; listFloat[which] = { x: r.left, y: r.top } }
      listFloat[which] = { x: ev.clientX - dx, y: ev.clientY - dy }; place()
    }
    const up = (): void => { handle.removeEventListener('pointermove', move); handle.removeEventListener('pointerup', up); handle.removeEventListener('pointercancel', up) }
    handle.addEventListener('pointermove', move); handle.addEventListener('pointerup', up); handle.addEventListener('pointercancel', up)
  }
  grip.addEventListener('pointerdown', pickUp(grip))
  // Once the grip is in its top bar, the bar moves the list as well.
  window.setTimeout(() => { const bar = grip.parentElement; if (bar && bar !== col && !col.closest('dialog') && !col.classList.contains('diary-pencil-sheet')) { bar.classList.add('diary-list-bar'); bar.addEventListener('pointerdown', pickUp(bar)) } }, 0)
  grip.addEventListener('keydown', (e) => {
    const step = ({ArrowLeft:[-24, 0], ArrowRight:[24, 0], ArrowUp:[0, -24], ArrowDown:[0, 24]} as Record<string, [number, number]>)[e.key]
    if (!step) return
    e.preventDefault()
    const r = col.getBoundingClientRect(), f = listFloat[which]
    listFloat[which] = { x: (f?.x ?? r.left) + step[0], y: (f?.y ?? r.top) + step[1] }; place()
  })
  return { grip, back }
}
// Needs you over the left, as Due and Pencilled are (Liam, 26 Oct 2026: "should needs you open on the left hand side";
// "do both"): one of the three at a time, with the same handle and Back to the side. What is inside is unchanged.
function deskNeedsDrawer(needsYou: HTMLElement, onClose: () => void): HTMLElement {
  const drawer = el('aside', {class:'diary-needs-drawer', 'aria-label':'Needs you'})
  const close = el('button', {type:'button', class:'diary-drawer-close', 'aria-label':'Close Needs you'}, el('span', {'aria-hidden':'true'}, '✕'))
  close.addEventListener('click', onClose)
  const { grip, back } = listMover(drawer, 'needs', 'Needs you')
  needsYou.hidden = false
  drawer.append(el('div', {class:'diary-pencil-head diary-needs-head'}, grip, el('span', {class:'diary-wtile-ring is-needs', 'aria-hidden':'true'}, '!'), el('h3', {}, 'Needs you'), back, close), needsYou)
  tuckOnDrag(drawer)
  return drawer
}

function deskPencilColumn(rows: PencilRow[], redraw: () => void): HTMLElement {
  const col = el('aside', {class:'diary-pencil-drawer', 'aria-label':'Pencilled'})
  const close = el('button', {type:'button', class:'diary-drawer-close', 'aria-label':'Close the Pencilled list'}, el('span', {'aria-hidden':'true'}, '✕'))
  close.addEventListener('click', () => { deskPencilOpen = false; redraw(); document.querySelector<HTMLElement>('.diary-wtile[data-tile="pencil"]')?.focus({preventScroll:true}) })
  const { grip, back } = listMover(col, 'pencil', 'Pencilled')
  col.append(el('div', {class:'diary-pencil-head'}, grip, el('span', {class:'diary-wtile-ring is-pencil', 'aria-hidden':'true'}, lineDrawing('pencil', 16)),
    el('h3', {}, `Pencilled · ${rows.length}`), back, close),
    el('p', {class:'diary-pencil-intro'}, rows.length ? 'Drag a name onto a day: this list tucks away while you drag.' : diarySearch || workerFilter || areaFilter ? 'No pencilled visits match the search or filters.' : 'Nothing pencilled from today on: every visit day is agreed.'))
  for (const step of PENCILLED_STEPS) {
    const mine = rows.filter(r => r.step === step)
    if (!mine.length) continue
    const group = el('section', {class:'diary-pencil-group', 'data-step':step}, el('div', {class:'diary-pencil-group-head'}, el('strong', {}, `${STEP_TITLES[step]} · ${mine.length}`), el('span', {}, STEP_NOTES[step])))
    for (const r of mine) group.append(pencilRow(r))
    col.append(group)
  }
  return col
}

function pencilRow(r: PencilRow): HTMLElement {
  const cl = r.cl
  const name = cl.customer_name ?? `#${cl.customer_id}`
  const words = visitWords(cl, visitCustomer(cl))
  const row = el('article', {class:`diary-pencil-row is-${r.step}`, draggable:'true', 'data-clean-id':String(cl.id)},
    el('div', {class:'diary-pencil-line'}, el('span', {class:'diary-pencil-grip', 'aria-hidden':'true'}, '⋮⋮'),
      el('a', {href:`#/customer/${cl.customer_id}`, class:'diary-pencil-name'}, name), el('span', {class:'diary-pencil-day'}, `· ${dayLabel(cl.date)}`),
      el('b', {class:'diary-pencil-price'}, cl.amount_pence !== null ? cash(cl.amount_pence) : '')),
    el('p', {class:'diary-pencil-why'}, [words.day, words.time].filter(Boolean).join(' · ')))
  row.addEventListener('dragstart', (e) => {
    if (!e.dataTransfer) return
    window.getSelection()?.removeAllRanges()
    e.dataTransfer.setData('text/plain', `pencil:${cl.id}`)
    e.dataTransfer.effectAllowed = 'move'
    dragPicture(e, row)
    row.classList.add('tray-row-moving')
  })
  row.addEventListener('dragend', () => row.classList.remove('tray-row-moving'))
  const acts = el('div', {class:'diary-pencil-acts'})
  const after = (): void => void load()
  const add = addDetailsStep(cl, r.step === 'ask' ? 'ask' : visitNextStep(cl))
  // From the phone's sheet the sheet closes first, so the action's own pop-up or move can open (GPT-6.1's hunt, 1).
  const ready = (): boolean => { if (row.closest('dialog')) closePhoneSheet(); return diaryNavigationReady() }
  const lemon = (text: string, act: (b: HTMLButtonElement) => void): HTMLButtonElement => {
    const b = el('button', {type:'button', class:'btn-primary'}, text) as HTMLButtonElement
    b.addEventListener('click', () => { if (ready()) act(b) })
    return b
  }
  // The step decides the button (today's own visits are not in the list: their rows offer Done): the time is agreed; no way
  // to message them yet is Add details; not asked is Message (a moved visit: Tell them; Don't message: Mark
  // confirmed); asked is They replied (first job) or Mark confirmed (an extra job, as its row does).
  if (add) acts.append(lemon(add.words, () => add.open()))
  else if (r.step === 'ask' && (noMessages(cl) || visitJobId(cl) !== null)) acts.append(lemon('Mark confirmed', (b) => markDayAgreed(cl, b, after)))
  else if (r.step === 'ask' && words.day.startsWith('Moved from')) acts.append(lemon('Tell them', () => openMessagesFor({ id: cl.customer_id, name }, 'customer', { jobId: cl.job_id ?? null })))
  else if (r.step === 'ask') acts.append(lemon(`Message ${name.trim().split(/\s+/)[0] || 'them'}`, () => askAboutDay(cl.customer_id, cl.date, { visitId: cl.id, onDone: after })))
  else if (askedNoReply(cl)) acts.append(lemon('They replied…', () => openTheyReplied(cl, repliedOptions(cl))))
  else acts.append(lemon('Mark confirmed', (b) => markDayAgreed(cl, b, after)))
  const move = el('button', {type:'button', class:'btn-secondary'}, 'Move') as HTMLButtonElement
  move.addEventListener('click', () => { if (!ready()) return; if (mayMoveHere(cl)) openMoveFor(cl); else openMovePicker(cl, move) })
  // On a phone (Pencilled A, Liam 4 Nov 2026: "A on both"): small cards two a row, Move in the card's ⋯.
  if (!phoneWeekActive()) acts.append(move)
  if (phoneWeekActive()) {
    const link = row.querySelector<HTMLElement>('.diary-pencil-name')
    row.draggable = false
    if (link && mayMoveHere(cl)) link.replaceWith(weekName(name, `visit:${cl.id}`, () => pickPhoneWeek('visit', cl.id), iso => placePhoneWeek('visit', cl.id, iso)))
    row.querySelector('.diary-pencil-day')?.replaceChildren(dayLabel(cl.date))
    row.querySelector('.diary-pencil-line')?.append(rowMenu(`More actions for ${name}`, list => list.append(move, el('a', {href:`#/customer/${cl.customer_id}`}, 'Open their page'))))
    for (const b of acts.querySelectorAll<HTMLButtonElement>('button')) if (b.textContent?.startsWith('Message ')) { b.setAttribute('aria-label', b.textContent); b.textContent = 'Message' }
    if (!noMessages(cl) && ![...acts.querySelectorAll('button')].some(b => b.textContent?.startsWith('Message'))) {
      const message = el('button', {type:'button', class:'btn-secondary', 'aria-label':`Message ${name.trim().split(/\s+/)[0] || 'them'}`}, 'Message')
      message.addEventListener('click', () => { if (ready()) askAboutDay(cl.customer_id, cl.date, {visitId:cl.id, onDone:after}) })
      acts.append(message)
    }
    if (![...acts.querySelectorAll('button')].some(b => b.textContent === 'Mark confirmed')) {
      const agreed = el('button', {type:'button', class:'diary-week-agreed', 'aria-label':`Agreed: ${name} said yes`}, '✓ Agreed') as HTMLButtonElement
      agreed.addEventListener('click', () => { if (!ready()) return; if (askedNoReply(cl)) openTheyReplied(cl, repliedOptions(cl)); else markDayAgreed(cl, agreed, after) })
      acts.prepend(agreed)
    }
  }
  row.append(acts)
  return row
}

// Escape closes whichever list is open over the week (the Due list first) and gives the keyboard back to its tile, from
// anywhere on the page. One press does one thing: heard before the page's other Escape handlers, it stands aside for a
// pop-up, someone picked (Escape lets go of them), a visit being dragged, an open ⋯ or contact menu, and a box being
// typed in, and takes the press only when it closes a list. Bound once.
let weekEscapeBound = false
function bindWeekEscape(): void {
  if (weekEscapeBound) return
  weekEscapeBound = true
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape' || e.defaultPrevented || document.querySelector('dialog[open]')) return
    if (movingId !== null || movingDueId !== null || movingEnqId !== null || rowDrag) return
    if (menuOpen()) return
    if ((e.target as Element | null)?.closest?.('input, textarea, select, [contenteditable]')) return
    const root = document.querySelector<HTMLElement>('#screen')
    if (!root?.querySelector('.diary-week-frame, .diary-day-frame, .diary-month-frame') || !(deskDueOpen || deskPencilOpen || deskNeedsOpen)) return
    const month = !!root.querySelector('.diary-month-frame')
    if (!month && !payload) return
    e.preventDefault()
    const key = deskDueOpen ? 'due' : deskPencilOpen ? 'pencil' : 'needs'
    if (key === 'due') deskDueOpen = false; else if (key === 'pencil') deskPencilOpen = false; else deskNeedsOpen = false
    if (month) monthRedraw(); else render(payload!, root)
    root.querySelector<HTMLElement>(`.diary-wtile[data-tile="${key}"]`)?.focus({preventScroll:true})
  }, true)
}

// A tile along the top of the computer's Week and Day (design B): a small picture, a count, a line of words. Pressed with
// someone picked it lets go of them first, as any tap elsewhere would (the document's own let-go then has nothing to do),
// so the page is drawn once; a list just opened takes the keyboard, otherwise the tile pressed keeps it. `stay` false:
// the press opens a pop-up, which looks after the keyboard itself.
type TileDrawing = Parameters<typeof lineDrawing>[0] | '!'
function deskTile(root: HTMLElement, key: string, drawing: TileDrawing, count: string, words: string, press?: () => void, on = false, tone = '', stay = true): HTMLElement {
  const ring = el('span', {class:`diary-wtile-ring${tone ? ` is-${tone}` : ''}`, 'aria-hidden':'true'}, drawing === '!' ? '!' : lineDrawing(drawing, 17))
  const kids = [ring, el('strong', {class:'diary-wtile-count'}, count), el('span', {class:'diary-wtile-words'}, words)]
  if (!press) return el('div', {class:'diary-wtile', 'data-tile':key}, ...kids)
  const b = el('button', {type:'button', class:`diary-wtile${on ? ' is-on' : ''}`, 'data-tile':key, ...(stay ? {'aria-pressed':String(on)} : {})}, ...kids)
  b.addEventListener('click', () => {
    // Design M: a list moved out puts itself back when its tile says "Bring it back here".
    if (b.classList.contains('is-home')) { [...document.querySelectorAll<HTMLElement>('.diary-due-col, .diary-pencil-drawer, .diary-needs-drawer')].find(l => l.dataset.float === key)?.querySelector<HTMLElement>('.diary-pencil-back')?.click(); return }
    if (!diaryNavigationReady()) return
    movingId = null; movingDueId = null; movingEnqId = null
    press()
    if (!stay) return
    const focus = (selector: string): void => root.querySelector<HTMLElement>(selector)?.focus({preventScroll:true})
    if (key === 'due' && deskDueOpen) focus('.diary-due-drawer .diary-drawer-close')
    else if (key === 'pencil' && deskPencilOpen) focus('.diary-pencil-drawer .diary-drawer-close')
    else if (key === 'needs' && deskNeedsOpen) focus('.diary-needs-drawer .diary-drawer-close')
    else focus(`.diary-wtile[data-tile="${key}"]`)
  })
  return b
}

// Each job keeps its actions: done retains its look, day agreed has a dot/tint, unagreed has a pencil/dashed edge.
function jobLook(row: HTMLElement): void {
  const cl = payload?.cleans.find(c => c.id === Number(row.dataset.cleanId))
  if (!cl) return
  const look = visitColour(cl)
  row.dataset.look = look ?? (isSuggestion(cl) ? 'suggested' : '')
  // The computer's Day hides the summary status and shows its separate agreement line.
  // Week and phone Day show the summary instead. Put one mark in the visible slot;
  // an agreed day keeps its dot even while the independent time tag stays amber.
  for (const mark of row.querySelectorAll('.diary-visit-mark')) mark.remove()
  const agreement = diaryDesk() && weekMode() === 'day' ? row.querySelector<HTMLElement>('.diary-row-chips .diary-agree') : null
  const target = agreement ?? row.querySelector<HTMLElement>('.diary-row-status') ?? row.querySelector<HTMLElement>('.diary-agree')
  if (target && look && look !== 'done') {
    const mark = stateMark(look); mark.classList.add('diary-visit-mark'); target.prepend(mark)
  }
}

// One person, one line in the week: their price joins where they stand, and a flag says there is something to know.
function weekRow(row: HTMLElement): void {
  jobLook(row)
  const status = row.querySelector<HTMLElement>('.diary-row-status')
  // The price button's words without its pencil: the line reads "£65.00 · Not asked yet".
  const price = row.querySelector<HTMLElement>('.diary-row-quick .price-edit-btn, .diary-row-quick .diary-price')?.textContent?.replace(/[✎✏]/g, '').trim()
  if (status && price && !status.querySelector('.diary-week-price')) status.prepend(el('span', {class:'diary-week-price'}, `${price} · `))
  stripRow(row, price, status)
  flagRow(row, row.querySelector<HTMLElement>('.diary-row-title'))
}

// Design 1, tidied columns (Liam, 3 Nov 2026: "I like 1", then "Maybe appear after one tap"; drawing
// https://claude.ai/artifact/Fmpkr3vLb7EeHFDkYmpqDv): on a computer's week each visit is one slim strip, the name (cut
// with "…" when long, whole on hover) and its time and price; the colour says where it stands, and "8am?" in amber that
// the day is agreed and the time is still to confirm. Its one button (Done, Message, They replied) and the rest are in
// the visit's details, one tap on the strip. The words stay for screen readers in the strip's label.
function stripRow(row: HTMLElement, price: string | undefined, status: HTMLElement | null): void {
  const cl = payload?.cleans.find(c => c.id === Number(row.dataset.cleanId))
  const face = row.querySelector<HTMLElement>(':scope > .diary-row-summary')
  const title = face?.querySelector<HTMLElement>('.diary-row-title')
  if (!cl || !face || !title || row.classList.contains('is-strip')) return
  row.classList.add('is-strip')
  // One click (or Enter) opens the visit card beside the week (design Q; Liam, 4 Nov 2026, after "now vs redesigned":
  // "Yes"), in place of the older details pop-up.
  face.addEventListener('click', e => { if ((e.target as Element).closest('.diary-week-flag')) return; e.preventDefault(); e.stopImmediatePropagation(); openVisitCard(cl, row) }, true)
  const name = cl.customer_name ?? 'Visit'
  const pending = cl.state === 'booked' && !!cl.confirmed && !!visibleTime(cl) && !timeIsAgreed(cl)
  const time = title.querySelector<HTMLElement>(':scope > small')
  const shortPrice = price && /\d/.test(price) ? price.replace(/\.00$/, '') : ''
  const end = el('span', {class:'diary-strip-end'})
  const when = time?.textContent?.trim() ?? ''
  if (when) end.append(el('span', {class:`diary-strip-time${pending ? ' is-pending' : ''}`}, when))
  if (shortPrice) end.append(el('span', {class:'diary-strip-price'}, `${when ? ' · ' : ''}${shortPrice}`))
  if (cl.state === 'done' && cl.payment_status === 'unpaid') end.append(el('span', {class:'diary-week-payment', title:'Not paid yet'}, ` ${currencySymbol()}`))
  time?.remove()
  const strong = title.querySelector<HTMLElement>(':scope > strong')
  if (strong) strong.title = name
  title.append(end)
  const plain = status?.cloneNode(true) as HTMLElement | undefined
  for (const n of plain?.querySelectorAll('.diary-state-mark, .diary-details-cue') ?? []) n.remove()
  const words = plain?.textContent?.replace(/\s+/g, ' ').trim()
  const said = when ? `${when}${pending ? ', time to confirm' : ''}` : ''
  face.setAttribute('aria-label', `${name}${words ? `, ${words}` : ''}${said ? `, ${said}` : ''}. Details`)
}

// A red ! beside the name when there is something to know before going: an access note, parking, a block, or a reply
// or follow-up to read first (row.dataset.decide, set where the day is drawn). Week 4 and Day 4 replaced the day's
// "N to look at before going · Review" line with it (Liam's drawings, 26 Oct 2026).
function flagRow(row: HTMLElement, after: HTMLElement | null): void {
  if (!after || row.querySelector('.diary-week-flag')) return
  const warn = [...row.querySelectorAll<HTMLElement>('.diary-row-warning, .diary-row-blocked, .access-warn')].map(n => n.textContent?.trim() ?? '').filter(Boolean)
  if (row.dataset.decide) warn.unshift(row.dataset.decide)
  if (!warn.length) return
  const flag = el('span', {class:'diary-week-flag', role:'img', 'aria-label':`To know before going: ${warn.join('; ')}`, title:warn.join('\n')}, '!')
  if (after.classList.contains('diary-row-name')) after.after(flag); else after.append(flag)
}

// What a lit tile shows: its people (or free days) bright, the rest faded; Done opens each day's done list.
function weekLens(card: HTMLElement, lens: WeekLens, free: boolean): void {
  if (lens === 'free') { card.classList.toggle('is-lit', free); card.classList.toggle('is-faded', !free); return }
  const day = card.dataset.date!
  for (const row of card.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')) {
    const cl = payload?.cleans.find(c => c.id === Number(row.dataset.cleanId))
    const hit = !!cl && lens === 'done' && cl.state === 'done'
    void day
    row.classList.toggle('is-lit', hit); row.classList.toggle('is-faded', !hit)
  }
  if (lens === 'done') for (const d of card.querySelectorAll<HTMLDetailsElement>('details.diary-completed')) d.open = true
  for (const fold of card.querySelectorAll<HTMLElement>('.diary-completed > summary')) fold.classList.toggle('is-faded', lens !== 'done')
}

// Dragging someone past the Due list's edge tucks it away, so the days under it take the drop; it comes back when the
// drag ends. The list is moved off the page, never removed: the card being dragged must stay to hear its dragend.
let tuckBound = false
function tuckOnDrag(drawer: HTMLElement): void {
  drawer.addEventListener('dragstart', () => { document.body.classList.add('diary-row-dragging'); drawer.classList.add('is-dragging') })
  if (tuckBound) return
  tuckBound = true
  document.addEventListener('dragover', e => {
    const open = document.querySelector<HTMLElement>('.diary-due-drawer.is-dragging, .diary-pencil-drawer.is-dragging, .diary-needs-drawer.is-dragging')
    if (!open) return
    // Once past the edge it stays tucked until the drag ends, so the pointer can go back to Monday underneath.
    // Out of any side (Astra, 3 Nov 2026: a list moved to the right was only tucked when dragged out of its right edge).
    const r = open.getBoundingClientRect()
    if (!open.classList.contains('is-tucked') && (e.clientX > r.right - 6 || e.clientX < r.left + 6 || e.clientY < r.top + 6 || e.clientY > r.bottom - 6)) open.classList.add('is-tucked')
  })
  for (const end of ['dragend', 'drop'] as const) document.addEventListener(end, () => {
    for (const d of document.querySelectorAll<HTMLElement>('.diary-due-drawer, .diary-pencil-drawer, .diary-needs-drawer')) d.classList.remove('is-tucked', 'is-dragging')
  })
}

// ---- the phone diary (round 2 of docs/plans/diary-due/PLAN.md, Liam 11 Oct 2026) ------------------------------------
//
// It opens straight on the day: the dates, the week's strip, the day's visits as one numbered list, and the Due bar at the
// foot with everyone due, to put on a day with a thumb. Week is every day as a row to drop onto; Month is for looking.
// Needs you is a button by the day's summary with only the lines Liam acts on there; the rest live where they are
// worked (Slipping and Going cold at the top of Due, No date yet as its First visit tab, a visit to confirm on its day,
// waiting replies and offered days behind "Waiting on N"). Every control is the one render() built, with its handler.
type DueTab = 'due' | 'new' | 'first' | 'next' | 'quiet' | 'nocycle'
interface PhoneDue { sets: DueGroups; held: Clean[]; enquiries: Lead[]; noCycle: NoCycleEntry[] }
type NoCycleEntry = ReturnType<typeof noCycleSet>[number]
let phoneSheet: { kind: 'due'; tab: DueTab; sheet: Sheet; drawn: DueTab | null } | { kind: 'needs' | 'waiting' | 'pencil'; sheet: Sheet } | null = null
let phoneDue: PhoneDue | null = null
let drawAfterDrag = false
let focusDueKey: string | null = null
let needsLines: NeedsLine[] = []
let needsReady = false
let popDue = false
// Needs you in New (PLAN: "cut from 13 groups to the 5 only Liam can act on"). Contact reminders are on their own day
// since round 5.
const PHONE_NEEDS = ['replied', 'waiting', 'workernotes', 'notes', 'followup', 'review'] as const
const WAITING_KEYS = ['awaiting', 'offers']
function phoneNew(): boolean { return !diaryDesk() }
function needsWords(): string {
  if (!needsReady) return 'Needs you'
  const shown = needsLines.filter(l => (PHONE_NEEDS as readonly string[]).includes(l.key))
  if (shown.some(l => l.count === null)) return 'Needs you'
  return `Needs you · ${shown.reduce((n, l) => n + (l.count ?? 0), 0)}`
}
// The computer Week's Needs you tile: the count alone, "…" until it has loaded.
function needsTileCount(): string { return needsWords().replace(/^Needs you( · )?/, '') || '…' }
function waitingCount(): number | null {
  if (!needsReady) return null
  if (needsLines.some(l => WAITING_KEYS.includes(l.key) && l.count === null)) return null
  return needsLines.filter(l => WAITING_KEYS.includes(l.key)).reduce((n, l) => n + (l.count ?? 0), 0)
}
// Needs you has filled (it loads the round on its own): the button's count and Waiting on follow it.
function onNeedsLines(lines: NeedsLine[], ready: boolean): void {
  needsLines = lines; needsReady = ready
  const root = document.querySelector<HTMLElement>('#screen')
  const button = root?.querySelector<HTMLElement>('.diary-needs-button')
  if (button) button.textContent = needsWords()
  const tileCount = root?.querySelector<HTMLElement>('.diary-wtile[data-tile="needs"] .diary-wtile-count, .diary-ptile[data-tile="needs"] .diary-ptile-top b')
  if (tileCount) tileCount.textContent = needsTileCount()
  for (const holder of root?.querySelectorAll<HTMLElement>('.diary-due-bar, .diary-due-col-head') ?? []) showWaiting(holder, waitingCount(), openWaitingSheet)
  if (phoneSheet?.kind === 'waiting') fillWaitingSheet()
}
// Where "Put on" puts someone from the list: the day on show, or today when that day has gone.
const putDay = (): string => selectedDate >= todayISO() ? selectedDate : todayISO()

// Plan the day (Liam, 4 Nov 2026: "Build plan the day"; https://claude.ai/artifact/HCuB6JeXBdaKp7Q3dJUVcu row 3, Astra's
// three rounds): on a phone's Day the owner taps Plan, and the day stays the same screen with planning switched on: the
// stops one line each with no Done ticks, a hint under the card, a tap on a stop opens the time sheet with Move to
// another day, Whose job and Message under it, and the Day's own hold-to-drag (Any time stops, within their group) and
// drag onto a day stay as they are. What was agreed with a customer and has changed since Plan was tapped is listed as
// "To tell" with a Message button each; nothing is sent until one is tapped. Done planning says how many are not told.
interface PlanBefore { date: string; time: string | null; worker: string | null; confirmed: number; name: string; customerId: number }
// told: what each customer was told about (their day and time then); a later change makes them to tell again.
let planning: { date: string; before: Map<number, PlanBefore>; told: Map<number, string> } | null = null
function startPlanning(date: string): void {
  if (!payload) return
  const before = new Map<number, PlanBefore>()
  // Only the planned day's own visits (kept when they move): a change on another day is not this plan's (6.1, 4 Nov 2026).
  for (const c of payload.cleans) if (c.date === date && c.state === 'booked' && !isSuggestion(c) && !isContact(c)) before.set(c.id, { date: c.date, time: visibleTime(c), worker: c.worker?.trim() || null, confirmed: c.confirmed ?? 0, name: c.customer_name ?? 'Visit', customerId: c.customer_id })
  // Planning another day first ends this one, saying who is not told yet (Astra, 6.1).
  if (planning && planning.date !== date) endPlanning()
  planning = { date, before, told: new Map() }
  redrawDiary()
}
// What a visit is now, for "told": its day and time.
const toldKey = (c: { date: string; time: string | null }): string => `${c.date}|${c.time ?? ''}`
function isTold(c: PlanChange): boolean { return planning?.told.get(c.id) === toldKey({ date: c.date, time: c.time }) }
interface PlanChange { id: number; name: string; customerId: number; date: string; time: string | null; words: string; tell: boolean }
function planChanges(): PlanChange[] {
  if (!planning || !payload) return []
  const out: PlanChange[] = []
  for (const [id, was] of planning.before) {
    const now = payload.cleans.find(c => c.id === id)
    // Not in the loaded days: it may have moved or gone, which this phone cannot tell, so it is not listed (Astra, 6.1).
    if (!now || now.state !== 'booked') continue
    const nowDate = now?.date ?? null, nowTime = now ? visibleTime(now) : null, nowWorker = now?.worker?.trim() || null
    const parts: string[] = []
    if (nowDate !== was.date) parts.push(`moved to ${dayLabel(nowDate!)}${nowTime ? ` at ${shownTime(nowTime)}` : ''}`)
    else if (nowTime !== was.time) parts.push(`${was.time ? shownTime(was.time) : 'any time'} to ${nowTime ? shownTime(nowTime) : 'any time'}`)
    const tell = parts.length > 0 && was.confirmed === 1
    if ((nowWorker ?? '') !== (was.worker ?? '') && now) parts.push(nowWorker ? `now with ${nowWorker}` : 'back to the day\'s person')
    if (parts.length) out.push({ id, name: was.name, customerId: was.customerId, date: nowDate ?? was.date, time: nowTime, words: parts.join(' · '), tell })
  }
  return out
}
function endPlanning(): void {
  const left = planChanges().filter(c => c.tell && !isTold(c)).length
  planning = null
  redrawDiary()
  if (left) toast(`${left} not told yet. Message them from their visit, or later from Messages.`)
}
function redrawDiary(): void {
  const root = document.querySelector<HTMLElement>('#screen')
  if (payload && root) render(payload, root)
}
// The tap on a stop while planning: the time sheet with Move to another day, Whose job and Message under it.
function planSheet(cl: Clean, opener: HTMLElement, openDetails?: () => void): void {
  openSharedTimePicker(cl, opener, { ...diaryTimeHooks(), extra: (close) => {
    const box = el('div', { class: 'today-time-extra diary-plan-extra' })
    const first = (cl.customer_name ?? '').trim().split(/\s+/)[0] || 'them'
    const move = el('button', { type: 'button', class: 'btn-secondary' }, 'Move to another day') as HTMLButtonElement
    move.addEventListener('click', () => { close(); openMovePicker(cl, opener as HTMLButtonElement) })
    const msg = el('button', { type: 'button', class: 'btn-secondary' }, `Message ${first}`)
    msg.addEventListener('click', () => { close(); askAboutDay(cl.customer_id, cl.date, { visitId: cl.id, onDone: () => void load() }) })
    // Everything else on the visit (Call, Cancel, They replied, Mark confirmed) stays one tap away (Sonnet).
    const open = el('button', { type: 'button', class: 'btn-secondary' }, 'Open their visit')
    open.addEventListener('click', () => { close(); openDetails?.() })
    // Move only where the visit can move (a started visit, the rest of a part done, and the like cannot; Sonnet).
    const due = el('button', { type: 'button', class: 'btn-secondary' }, 'Back to Due')
    due.addEventListener('click', () => { close(); backToDue(cl) })
    box.append(...(mayMoveHere(cl) ? [move] : []), msg, ...(openDetails ? [open] : []), ...(mayGoBackToDue(cl) && !pricesHidden() ? [due] : []))
    const own = getMe()?.workerName?.trim() ?? ''
    const names: string[] = []
    for (const n of [own, ...knownWorkers(payload)]) if (n.trim() && !names.some(x => x.toLowerCase() === n.trim().toLowerCase())) names.push(n.trim())
    if (!worksAlone() && names.length > 1) {
      const current = (cl.worker?.trim() || '').toLowerCase()
      const row = el('div', { class: 'booking-chips', role: 'group', 'aria-label': 'Whose job' })
      for (const n of names) {
        const on = n.toLowerCase() === current
        const b = el('button', { type: 'button', class: 'booking-chip', 'aria-pressed': String(on) }, own && n.toLowerCase() === own.toLowerCase() ? 'You' : n)
        b.addEventListener('click', () => {
          if (on) return
          close()
          giveJob(cl, n)
        })
        row.append(b)
      }
      box.append(el('p', { class: 'today-time-label' }, 'Whose job'), row)
    }
    return box
  } })
}
// Whose job, with Undo: the planning sheet's Whose job and a drop on a person box (computer planning) both save here.
// null hands it back to the day's person, or to nobody when the day has none.
function giveJob(cl: Clean, n: string | null): void {
  if ((cl.worker?.trim() || '').toLowerCase() === (n ?? '').toLowerCase()) return
  const own = getMe()?.workerName?.trim() ?? ''
  const was = cl.worker?.trim() ? cl.worker : null
  const whose = n === null ? 'unassigned' : own && n.toLowerCase() === own.toLowerCase() ? 'yours' : `${n}'s`
  void mutate({ label: `Whose job: ${cl.customer_name ?? ''} to ${n ?? 'nobody'}`, method: 'PATCH', path: `/api/cleans/${cl.id}`, body: { version: cl.version, worker: n }, onAck: () => void load(), onConflict: () => void load() })
    .then((ack) => {
      if (!ack.ok && ack.status >= 400 && ack.status < 500) { window.alert(ack.error ?? 'That did not save.'); void load(); return }
      undoPatch({ text: `${cl.customer_name ?? 'Visit'} is ${whose} on ${dayLabel(cl.date)}`, label: `Undo whose job: ${cl.customer_name ?? ''}`, path: `/api/cleans/${cl.id}`, ack, version: cl.version, body: { worker: was }, after: () => void load() })
    })
}
// Back to Due (Liam, 4 Nov 2026, https://claude.ai/artifact/YSJn5QyTa5fiCqHyQUDh3m 1 and 2): the phone's Due bar at the
// bottom, where they came from, or the computer's Due tile, under a held row.
function dueUnderPointer(): HTMLElement | null {
  if (!rowDrag) return null
  const under = document.elementFromPoint(rowDrag.lastX, rowDrag.lastY)
  return under?.closest<HTMLElement>('.diary-due-bar, .diary-wtile[data-tile="due"]') ?? null
}
// May this visit go back to Due: a booked visit not started, never a suggestion or a contact reminder.
function mayGoBackToDue(cl: Clean): boolean {
  return cl.state === 'booked' && !cl.started_at && !isSuggestion(cl) && !isContact(cl) && !pricesHidden()
}
// Take the visit off its day: the customer is back in Due with the others. Undo puts the very visit back (the server's
// put-back of a removed visit, restore_if_removed). An agreed day is asked about first: they are expecting you.
function backToDue(cl: Clean): void {
  if (!diaryNavigationReady() || !mayGoBackToDue(cl)) return
  const name = cl.customer_name ?? 'Visit'
  const first = name.trim().split(/\s+/)[0] || 'them'
  const takeOff = (then?: () => void): void => {
    void mutate({ label: `Back to Due: ${name}`, method: 'DELETE', path: `/api/cleans/${cl.id}`, body: { version: cl.version }, onAck: () => void load(), onConflict: () => void load() })
      .then((ack) => {
        if (!ack.ok && ack.status >= 400 && ack.status < 500) { toast(ack.error ?? `${name} couldn't go back to Due.`); void load(); return }
        offerUndo(`${name} is back in Due`, () => void mutate({ label: `Undo back to Due: ${name}`, method: 'POST', path: `/api/customers/${cl.customer_id}/cleans`,
          body: { date: cl.date, state: 'booked', kind: cl.kind, ...(cl.amount_pence !== undefined ? { amount_pence: cl.amount_pence } : {}), job_id: cl.job_id ?? null, restore_if_removed: true },
          onAck: () => void load(), onConflict: () => void load() }))
        then?.()
      })
  }
  if (!cl.confirmed) { takeOff(); return }
  const s = sheet('Back to Due')
  s.head.append(el('h3', {}, `${name} agreed ${dayLabel(cl.date)}. Put ${first === 'them' ? 'them' : first} back in Due?`))
  const time = shownVisitTime(cl)
  s.body.append(el('p', {}, `They're expecting you on ${dayLabel(cl.date)}${time ? ` at ${time}` : ''}. The visit comes off that day and they go back in Due.`))
  const tell = el('button', { type: 'button', class: 'btn-primary' }, `Message ${first}, then put back`)
  tell.addEventListener('click', () => { s.close(); takeOff(() => openMessagesFor({ id: cl.customer_id, name }, 'customer', { jobId: cl.job_id ?? null })) })
  const just = el('button', { type: 'button', class: 'btn-secondary' }, `Put back, I'll tell ${first === 'them' ? 'them' : first}`)
  just.addEventListener('click', () => { s.close(); takeOff() })
  const keep = el('button', { type: 'button', class: 'link-button' }, `Keep on ${dayLabel(cl.date)}`)
  keep.addEventListener('click', () => s.close())
  s.body.append(el('div', { class: 'diary-back-due-choices' }, tell, just, keep))
}
// The person box under a held row while a computer's day is being planned (Liam's drawing 3: "Drop on a person").
function personUnderPointer(): HTMLElement | null {
  if (!rowDrag) return null
  return document.elementFromPoint(rowDrag.lastX, rowDrag.lastY)?.closest<HTMLElement>('.diary-plan-person[data-person]') ?? null
}
// "To tell": what changed for a customer who had agreed, each with Message; the rest saved quietly underneath.
// A changed time on an agreed day (Liam, 4 Nov 2026: the approved drawings list "8am to 9am"; To tell gap 1): read from the
// visit's own record (retimed: functions/lib/cleans.ts retimedSql), on every phone and computer.
function retimedUntold(c: Clean): { from: string; to: string } | null {
  const to = visibleTime(c)
  const [from, told] = (c.retimed ?? '').split('|')
  if (!from || told === '1' || c.state !== 'booked' || !c.confirmed || timeIsAgreed(c) || !to || to === from) return null
  return { from, to }
}
// To tell (Liam, 4 Nov 2026, 1A and 2A): the day's agreed customers moved to it and not told yet, read from the visit's own
// record (moved_from, moved_told: functions/lib/cleans.ts), so they stay until a message to them is recorded, from Messages
// or "I messaged them myself" there; and agreed times changed, with Agree 9am. Each Message opens that
// visit's own message (its day carried, Astra). Both read from the visit's record, so they stay after closing the app.
function toTellBox(visits: Clean[]): HTMLElement | null {
  const live = visits.filter(c => c.state === 'booked' && c.date >= todayISO() && !isSuggestion(c) && !isContact(c))
  const moved = live.filter(c => movedUntold(c, visitCustomer(c)))
  const retimed = live.filter(c => !moved.includes(c)).map(c => ({ c, t: retimedUntold(c) })).filter((x): x is { c: Clean; t: { from: string; to: string } } => !!x.t)
  if (!moved.length && !retimed.length) return null
  const box = el('section', { class: 'diary-plan-tell diary-to-tell', 'aria-label': 'To tell' }, el('h3', {}, `To tell · ${moved.length + retimed.length}`))
  const first = (c: Clean): string => (c.customer_name ?? '').trim().split(/\s+/)[0] || 'them'
  for (const c of moved) {
    const b = el('button', { type: 'button', class: 'btn-primary' }, `Message ${first(c)}`)
    b.addEventListener('click', () => openMessagesFor({ id: c.customer_id, name: c.customer_name ?? 'Customer' }, 'customer', { jobId: c.job_id ?? null, visitId: c.id, day: c.date }))
    box.append(el('div', { class: 'diary-plan-tell-row' }, el('span', {}, `${c.customer_name ?? 'Visit'} · moved from ${dayLabel(c.moved_from!)}`), b))
  }
  for (const { c, t } of retimed) {
    const b = el('button', { type: 'button', class: 'btn-primary' }, `Message ${first(c)}`)
    b.addEventListener('click', () => askAboutDay(c.customer_id, c.date, { visitId: c.id, onDone: () => void load() }))
    // Told them in person and they said yes: Agree 9am, the same save and Undo as the row's (it leaves To tell with it).
    const agree = el('button', { type: 'button', class: 'btn-secondary' }, `Agree ${shownTime(t.to)}`)
    agree.addEventListener('click', () => markTimeAgreed(c, agree, () => void load()))
    box.append(el('div', { class: 'diary-plan-tell-row' }, el('span', {}, `${c.customer_name ?? 'Visit'} · ${shownTime(t.from)} to ${shownTime(t.to)}`), b, agree))
  }
  return box
}
function planTellCard(): HTMLElement | null {
  const changes = planChanges()
  if (!changes.length) return null
  const tell = changes.filter(c => c.tell && !isTold(c))
  const card = el('section', { class: 'diary-plan-tell', 'aria-label': 'To tell' }, el('h3', {}, tell.length ? `To tell · ${tell.length}` : 'Everyone told'))
  for (const c of tell) {
    const first = c.name.trim().split(/\s+/)[0] || 'them'
    // Message opens their message for the visit; the owner says when they are told (a message closed or kept unsent is
    // not telling them; Astra, 6.1, Sonnet). Say the new time in the message: it asks about the day.
    const b = el('button', { type: 'button', class: 'btn-primary' }, `Message ${first}`)
    b.addEventListener('click', () => askAboutDay(c.customerId, c.date, { visitId: c.id, onDone: () => void load() }))
    const told = el('button', { type: 'button', class: 'btn-secondary' }, 'Told them')
    told.addEventListener('click', () => { planning?.told.set(c.id, toldKey(c)); redrawDiary() })
    card.append(el('div', { class: 'diary-plan-tell-row' }, el('span', {}, `${c.name} · ${c.words}`), b, told))
  }
  const quiet = changes.filter(c => !c.tell || isTold(c))
  if (quiet.length) card.append(el('p', { class: 'muted' }, `Also saved: ${quiet.map(c => `${c.name} ${c.words}${isTold(c) ? ' (told)' : ''}`).join('; ')}`))
  return card
}

// The phone Day's card (design: https://claude.ai/artifact/HCuB6JeXBdaKp7Q3dJUVcu): today or a day gone counts done of
// booked in a ring, "£60 worked" and "£25 taken · £35 not paid" (each visit's own unpaid balance after credit and part
// payments, as Today's owedOn); a day to come counts agreed of booked, "£480 booked" and "3 to ask". Map is the day's
// own map tile, pressed for it.
function dayMoneyCard(date: string, visits: Clean[], map: HTMLElement | null): HTMLElement {
  const pounds = (p: number): string => money(p).replace(/\.00$/, '')
  const booked = visits.filter(c => (c.state === 'booked' && !c.blocked_reason) || c.state === 'done')
  const ahead = date > todayISO()
  const ns = 'http://www.w3.org/2000/svg'
  const ring = (n: number, of: number): SVGElement => {
    const svg = document.createElementNS(ns, 'svg'); svg.setAttribute('viewBox', '0 0 52 52'); svg.setAttribute('width', '52'); svg.setAttribute('height', '52'); svg.setAttribute('aria-hidden', 'true')
    const c = (stroke: string, dash?: string): SVGElement => { const e = document.createElementNS(ns, 'circle'); for (const [k, v] of Object.entries({ cx: '26', cy: '26', r: '21', fill: 'none', stroke, 'stroke-width': '6', ...(dash ? { 'stroke-dasharray': dash, transform: 'rotate(-90 26 26)', 'stroke-linecap': 'round' } : {}) })) e.setAttribute(k, v); return e }
    svg.append(c('#e3e8ee')); if (n > 0) svg.append(c(ahead ? 'var(--brand-ink)' : '#188038', `${(132 * Math.min(1, of ? n / of : 0)).toFixed(1)} 132`))
    return svg
  }
  const card = el('div', { class: 'diary-day-money' })
  if (ahead) {
    const agreed = booked.filter(c => c.confirmed === 1).length
    const total = booked.reduce((sum, c) => sum + (c.amount_pence ?? 0), 0)
    const ask = booked.length - agreed
    card.append(el('span', { class: 'diary-day-money-ring' }, ring(agreed, booked.length), el('b', {}, `${agreed}/${booked.length}`)),
      el('span', { class: 'diary-day-money-words' }, el('strong', {}, `${pounds(total)} booked`), el('span', {}, `${agreed} agreed`, ...(ask ? [' · ', el('b', { class: 'is-ask' }, `${ask} to ask`)] : []))))
  } else {
    const finished = booked.filter(c => c.state === 'done')
    const worked = finished.reduce((sum, c) => sum + (c.amount_pence ?? 0), 0)
    const taken = finished.reduce((sum, c) => sum + visitReceived(c), 0)
    const owed = finished.reduce((sum, c) => sum + (c.carryover !== 1 && c.payment_status === 'unpaid' ? toCollect(c) ?? 0 : 0), 0)
    card.append(el('span', { class: 'diary-day-money-ring' }, ring(finished.length, booked.length), el('b', {}, `${finished.length}/${booked.length}`)),
      el('span', { class: 'diary-day-money-words' }, el('strong', {}, `${pounds(worked)} worked`), el('span', {}, `${pounds(taken)} taken`, ...(owed ? [' · ', el('b', { class: 'is-owed' }, `${pounds(owed)} not paid`)] : []))))
  }
  // Map as its own picture tile beside the money (Liam, 4 Nov 2026: "Map should be icon like previous"); no Plan button:
  // To tell, the time sheet and Drop on a person do its work without a mode (1A, 2A).
  if (map) { map.classList.add('diary-day-money-maptile'); card.append(map) }
  return card
}

function presentWeek(root: HTMLElement, p: SchedulePayload, heading: HTMLElement, book: HTMLElement, date: HTMLInputElement, toToday: () => void, worker: HTMLElement, area: HTMLElement, due: PhoneDue): void {
  dropDeskMap()
  selectInitialDay(p)
  diaryHeading(heading)
  phoneDue = due
  const dayView = weekMode() === 'day'
  if (phoneSheet?.kind === 'due') {
    const dialog = phoneSheet.sheet.dialog
    if (!dialog.classList.contains('diary-week-tray') || dialog.dataset.dueMemory && dialog.dataset.dueMemory !== phoneDueMemory().open) closePhoneSheet()
  }
  root.classList.add('diary-phone')
  root.classList.toggle('diary-day-view', dayView)
  root.classList.toggle('diary-phone-week-view', !dayView)
  const nav = root.querySelector<HTMLElement>('.week-nav')!
  const title = nav.querySelector<HTMLElement>('h3')!
  nav.querySelector('.week-heading>.muted')?.remove()
  nav.querySelector('.week-money')?.remove()
  // The Diary redesign (phone 4): "‹ This week ›" with its dates and figures under it, and ⋯, as the page's top line;
  // Day · Week · Month and + Book a visit on the line under the tiles.
  const views = threeViewSwitch(weekMode(), choice => pickView(choice, p, root))
  // Beside one day the arrows step a day (round 2 review: "‹ Sunday 11 Oct ›" read as a day), into the next week's dates
  // when they cross it; beside the week, a week.
  if (dayView) for (const old of [...nav.querySelectorAll<HTMLButtonElement>('.week-step')]) {
    const back = (old.getAttribute('aria-label') ?? '').startsWith('Previous')
    const label = back ? 'Previous day' : 'Next day'
    const fresh = el('button', {type:'button', class:'week-step', 'aria-label':label, title:label}, back ? '‹' : '›')
    fresh.addEventListener('click', () => {
      if (!diaryNavigationReady()) return
      const next = addDaysISO(selectedDate, back ? -1 : 1)
      selectedDate = next
      if (next >= p.from && next <= p.to) { syncDay(); return }
      fromDate = defaultFrom(next); weekEntry = {from:fromDate, gen:routeGen, who:diaryPreferenceKey('selection'), label}; void load()
    })
    old.replaceWith(fresh)
  }
  const picking = movingId !== null || movingDueId !== null || movingEnqId !== null
  const pickedDue = [...due.sets.due, ...due.sets.goneQuiet, ...due.sets.firstVisit].find(c=>dueKey(c) === movingDueId)
  const pickedName = p.cleans.find(c=>c.id === movingId)?.customer_name ?? (pickedDue ? (pickedDue.dueJob ? `${pickedDue.name} · ${pickedDue.dueJob.name}` : pickedDue.name) : null) ?? leads?.find(l=>l.id === movingEnqId)?.name ?? 'them'
  const pickedKey = movingId !== null ? `visit:${movingId}` : movingDueId !== null ? `due:${movingDueId}` : null
  const cards = [...root.querySelectorAll<HTMLElement>('.day-card[data-date]')]
  // The visits drawn on a day: suggestions held for Due and visits held in a week are not on it.
  const visitsOn = (card: HTMLElement): Clean[] => {
    const ids = new Set([...card.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')].map(row=>Number(row.dataset.cleanId)))
    // Keep the actual Day order (times first, then agreed, then pencilled), including
    // the first three names in Week. SQL's null-time-first order can hide a timed job.
    const byId = new Map(p.cleans.map(c => [c.id, c]))
    return [...ids].map(id => byId.get(id)).filter((c): c is Clean => !!c && c.state !== 'cancelled' && !isContact(c))
  }
  // One line under the week's name (design B, Liam 4 Nov 2026: "B is the one"): the money and how far along it is,
  // agreed while booking, done once work has started ("£596 · 6 of 9 agreed"). The day squares show the rest.
  const facts = (visits: Clean[]): string => {
    const f = diaryDayFacts(visits)
    return f.visits ? `${cash(f.pence)}${f.unpriced ? ' +' : ''} · ${f.done ? `${f.done} of ${f.visits} done` : `${f.agreed} of ${f.visits} agreed`}` : 'No visits'
  }
  const range = (): string => {
    const a = new Date(`${p.from}T12:00:00Z`), z = new Date(`${p.to}T12:00:00Z`)
    const mon = (d: Date): string => d.toLocaleDateString('en-GB', { month: 'short', timeZone: 'UTC' })
    return a.getUTCMonth() === z.getUTCMonth() && a.getUTCFullYear() === z.getUTCFullYear() && !monthFirst() && p.to.slice(0, 4) === todayISO().slice(0, 4) ? `${a.getUTCDate()} to ${z.getUTCDate()} ${mon(z)}` : weekDates(p.from, p.to, todayISO())
  }
  for (const card of cards) for (const row of card.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')) jobLook(row)
  const strip = el('nav', {class:'diary-week-strip', 'aria-label':'Days this week'})
  const dayButtons = new Map<string,HTMLButtonElement>()
  const summaryText = el('p', {class:'diary-phone-summary-text'})
  const needsButton = el('button', {type:'button', class:'diary-needs-button'}, needsWords())
  needsButton.addEventListener('click', () => { if (diaryNavigationReady()) openNeedsSheet() })
  const putHere = el('button', {type:'button', class:'btn-primary diary-put-here'})
  putHere.addEventListener('click', () => { if (diaryNavigationReady()) placePicked(selectedDate) })
  title.after(summaryText)
  const syncDay = (): void => {
    date.value = selectedDate
    title.textContent = dayView ? dayHeading(selectedDate, todayISO()) : weekHeading(p.from, todayISO())
    for (const card of cards) {
      const shown = dayView && card.dataset.date === selectedDate
      card.hidden = !shown; card.inert = !shown
      // The day's list takes someone pushed up from Due, as its date does.
      if (shown && selectedDate >= todayISO()) card.dataset.dueDrop = selectedDate; else delete card.dataset.dueDrop
    }
    for (const [iso,b] of dayButtons) { b.classList.toggle('is-selected', iso === selectedDate); b.setAttribute('aria-pressed', String(iso === selectedDate)) }
    const card = cards.find(c => c.dataset.date === selectedDate)
    // Each part kept whole, so a narrow phone breaks the line between parts ("14 visits · 6 agreed"), never inside one.
    const whole = (line: string): string => line.split(' · ').map(part => part.replace(/ /g, '\u00a0')).join(' · ')
    summaryText.textContent = whole(dayView ? (card ? facts(visitsOn(card)) : 'No visits') : `${range()} · ${facts(cards.flatMap(visitsOn))}`)
    putHere.hidden = !(dayView && picking && selectedDate >= todayISO())
    putHere.textContent = `Put ${pickedName} on ${dayLabel(selectedDate)}`
  }
  for (const card of cards) {
    const iso = card.dataset.date!
    const visits = visitsOn(card)
    const actual = diaryDayFacts(visits).visits
    const needs = dayNeeds(visits, iso)
    const warnings = (dayView ? visits : p.cleans.filter(c => c.date === iso && !isUnplaced(c, iso, iso))).filter(c => c.state === 'booked' && !isSuggestion(c) && !isContact(c) && (c.blocked_reason || splitAccessWarning(c.customer_address ?? '').warn || confirmNeed(c, visitCustomer(c)) === 'check'))
    const checkWords = !dayView && warnings.length ? `${warnings.length} to check` : needs.check
    const pencilledDay = iso >= todayISO() ? pencilledRows(visits).length : 0
    const need = [pencilledDay ? `${pencilledDay} pencilled` : '', needs.check, needs.offered].filter(Boolean).join(', ')
    const isToday = iso === todayISO()
    // Today takes the weekday's place; its lemon ring and the selected day's dark outline are independent.
    const button = el('button', {type:'button', class:isToday ? 'is-today' : '', 'data-date':iso, 'aria-pressed':String(iso === selectedDate), 'aria-current':isToday ? 'date' : 'false',
      'aria-label':`Go to ${dayLabel(iso)}${isToday ? ', today' : ''}, ${actual} visit${actual === 1 ? '' : 's'}${need ? `, ${need}` : ''}`},
      el('span', {class:'diary-strip-dow'}, isToday && dayView ? 'Today' : new Date(`${iso}T12:00:00`).toLocaleDateString(screenLocale(), {weekday:'short'})),
      el('b', {class:'diary-strip-num'}, String(Number(iso.slice(8)))),
      )
    const dayBadge = colourDay(button, p.cleans.filter(c => c.date === iso), `phone-strip:${iso}`, isToday, {date:iso, closed:closedDiaryDay(p, iso)})
    button.append(dayBadge)
    // Day view's strip matches the week strip: day, date and mark only (Liam, 1 Nov 2026: the grey "5 visits" / "free" under each day was extra wording).
    button.setAttribute('aria-label', `${button.getAttribute('aria-label')}, ${dayBadge.getAttribute('aria-label')}`)
    if (checkWords && !button.querySelector('.diary-state-warning')) button.append(el('span', {class:'diary-state-warning', role:'img', 'aria-label':checkWords, title:checkWords}))
    if (iso >= todayISO()) button.dataset.dueDrop = iso
    if (picking && iso >= todayISO()) { button.classList.add('is-target'); button.setAttribute('aria-label', `Put ${pickedName} on ${(button.getAttribute('aria-label') ?? '').replace(/^Go to /, '')}`) }
    button.addEventListener('click', () => {
      if (!diaryNavigationReady()) return
      if (!dayView && picking && iso < todayISO()) { toast(GONE_DAY_WORDS); return }
      if (picking && placePicked(iso)) return
      if (picking) { toast(GONE_DAY_WORDS); return }
      selectedDate = iso
      if (dayView) syncDay()
      else { setWeekMode('day'); closePhoneSheet(); render(p, root) }
    })
    dayButtons.set(iso, button)
    if (dayView) strip.append(button)
    else {
      if (checkWords && !button.getAttribute('aria-label')?.includes(checkWords)) button.setAttribute('aria-label', `${button.getAttribute('aria-label')}, ${checkWords}`)
      const hidden = !!(diarySearch || workerFilter || areaFilter) && !diaryDayFacts(visits).visits && p.cleans.some(c => c.date === iso && countsAsDayVisit(c))
      strip.append(el('div', {class:'diary-week-date'}, button, el('span', {class:'diary-week-money'}, hidden ? 'No matches' : phoneWeekMoney(visits))))
    }
    // The day says what it still needs on its own first line, beside its map and details: Pencilled now (phone 4).
    const pencilledOn = iso >= todayISO() ? pencilledRows(visits).length : 0
    const line = [pencilledOn ? `${pencilledOn} pencilled` : '', needs.check, needs.offered].filter(Boolean).join(' · ')
    const head = card.querySelector<HTMLElement>(':scope > .day-head')
    if (head && line) head.prepend(el('p', {class:'diary-day-needs'}, line))
    // One numbered list: the order the day is worked in (times, agreed, then pencilled); done work folds away unnumbered.
    let n = 0
    for (const row of card.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')) {
      if (row.closest('.diary-completed, .cancelled-visits') || !/^(Times set|Agreed|Pencilled)/.test(row.dataset.group ?? '')) continue
      row.querySelector('.diary-row-summary')?.prepend(el('span', {class:'diary-row-n', 'aria-hidden':'true'}, String(++n)))
    }
  }
  // Needs you · Due · Pencilled (phone 4): number then word, a second small line when there is one. Needs you and Due open
  // their own sheets (the Due bar at the foot stays as it is); Pencilled opens its two day-only groups.
  const weekAhead = cards.flatMap(card => card.dataset.date! >= todayISO() ? visitsOn(card) : [])
  const phonePencil = pencilledRows(weekAhead)
  const pen = countPencilled(phonePencil.map(r => r.step))
  const late = barCards(due, p).filter(b => b.late).length
  const dueCount = due.held.length + due.sets.due.length
  const phoneTile = phoneTileButton
  const needsCount = needsTileCount()
  const summary = el('div', {class:'diary-phone-tiles', role:'group', 'aria-label':'What needs you'},
    // Due, Pencilled, Needs you: the computer's order (design D).
    phoneTile('due', 'list', !dayView && !customers ? '…' : String(dueCount), 'Due', late ? `${late} late` : '', () => openDueSheet('due')),
    phoneTile('pencil', 'pencil', String(pen.all), 'Pencilled', pen.ask ? `${pen.ask} to ask` : '', () => openPencilSheet(phonePencil)),
    phoneTile('needs', '!', needsCount, 'Needs you', '', () => openNeedsSheet()))
  void needsButton
  // With a search or filter in use the box stays open, so Find a visit… takes you to it rather than closing it.
  heading.replaceChildren(nav, diaryMore(p, date, toToday, () => { filtersOpen = diarySearch || workerFilter || areaFilter ? true : !findOpen; render(p, root); root.querySelector<HTMLElement>(filtersOpen ? '[aria-label="Search diary"]' : '.diary-phone-head .diary-more > summary')?.focus({preventScroll:true}) }))
  heading.classList.add('diary-phone-head')
  const viewsRow = el('div', {class:'diary-phone-dates diary-phone-views'}, views, book)
  const days = root.querySelector<HTMLElement>('.diary-days')
  // The strip owns every day. Compact rows show work, and keep the actual reminder/offer controls.
  const openWeekDay = (iso: string): void => {
    if (!diaryNavigationReady()) return
    if (picking) { if (iso < todayISO()) toast(GONE_DAY_WORDS); else placePicked(iso); return }
    selectedDate = iso; setWeekMode('day'); closePhoneSheet(); render(p, root)
    root.querySelector<HTMLElement>(`.diary-week-strip [data-date="${iso}"]`)?.focus({preventScroll:true})
  }
  const weekRows = dayView ? null : phoneWeekRows(cards.map(card => {
    const iso = card.dataset.date!, visits = visitsOn(card), f = diaryDayFacts(visits)
    // Visits not going ahead stay on the Day view only (Liam, 3 Nov 2026), not on the week's cards.
    const support = [...card.querySelectorAll<HTMLElement>(':scope > .diary-contact-row, :scope > .diary-offered-day')]
    for (const row of card.querySelectorAll<HTMLElement>('.clean-row[data-clean-id]')) {
      const cl = p.cleans.find(c => c.id === Number(row.dataset.cleanId))
      if (cl && isSuggestion(cl)) {
        support.push(el('div', {class:'diary-week-suggestion'}, el('p', {}, 'Suggested by Roundly, not booked'), row))
      }
    }
    if (support.some(n => n.classList.contains('diary-contact-row'))) support.unshift(el('h4', {class:'diary-contact-group'}, 'To contact'))
    const rostered = worksAlone() ? '' : otherName((p.round_days ?? []).find(r => r.date === iso)?.worker)
    const ownerOut = (p.owners ?? []).some(name => name.trim().toLowerCase() === rostered.toLowerCase())
    const needs = dayNeeds(visits, iso)
    return { iso, visits: visits.filter(c => !isSuggestion(c)), money: phoneWeekMoney(visits),
      // The dashed names already say who is pencilled (design 1B), so the count goes; what is still to check stays.
      needs: [needs.check, needs.offered].filter(Boolean).join(' · '),
      workers: rostered && !ownerOut ? `${rostered} out` : '', support }
  }), {
    open: openWeekDay,
    pick: cl => pickPhoneWeek('visit', cl.id),
    place: (cl, iso) => placePhoneWeek('visit', cl.id, iso),
    movable: mayMoveHere,
    timePending: cl => cl.state === 'booked' && !!cl.confirmed && !!visibleTime(cl) && !timeIsAgreed(cl),
    visit: (cl, chip) => openVisitCard(cl, chip),
    time: cl => cl.state === 'booked' ? shownVisitTime(cl) ?? '' : '',
    who: cl => worksAlone() ? otherName(cl.worker) : visitWorker(cl, p.round_days ?? []) || 'Unassigned',
    detail: cl => [visitJobLabel(cl), partBadge(cl)?.textContent, cl.blocked_reason ? [blockedBadgeText(cl), blockedNoteText(cl.blocked_reason, cl.blocked_note)].filter(Boolean).join(': ') : '', splitAccessWarning(cl.customer_address ?? '').warn, cl.customer_status === 'paused' ? 'Paused, check before going' : cl.customer_follow_up_on ? `Ask again ${shortDate(cl.customer_follow_up_on)}` : ''].filter(Boolean).join(' · '),
    payment: cl => cl.payment_status === 'paid' ? '✓ paid' : cl.payment_status === 'unpaid' ? `${currencySymbol()} ${paymentLabel(cl).text.toLowerCase()}` : 'payment unknown',
    filtered: !!(diarySearch || workerFilter || areaFilter),
  })
  const placeBar = picking ? el('div', {class:'diary-week-place-bar', role:'status'}, el('strong', {}, `Tap a day for ${pickedName}`), sheetButton('Cancel', cancelMoveSelection)) : null
  // Beside + Book a visit, the magnifier and ⋯ (tidy-up item 4; Liam, 20 Oct 2026, his drawing top-after.jpg). The
  // magnifier opens the search, All workers (not in a one-person round, 19 Oct 2026) and All areas under the dates, and
  // stays open while any of them is in use; ⋯ jumps to a date and moves this week.
  const findOpen = filtersOpen || !!(diarySearch || workerFilter || areaFilter)
  const find = el('button', {type:'button', class:`diary-icon-button diary-find-toggle${findOpen ? ' is-on' : ''}`, 'aria-expanded':String(findOpen), 'aria-controls':'diary-desk-find', 'aria-label':'Search and filters', title:'Search and filters'}, magnifier())
  find.addEventListener('click', () => {
    if (!diaryNavigationReady()) return
    filtersOpen = !findOpen; render(p, root)
    root.querySelector<HTMLElement>(filtersOpen ? '[aria-label="Search diary"]' : '.diary-find-toggle')?.focus({preventScroll:true})
  })
  const search = el('input', {type:'search',placeholder:'Search name, address or job…','aria-label':'Search diary'})
  search.value = diarySearch
  search.addEventListener('input',()=>{
    if (!diaryNavigationReady()) return
    diarySearch = search.value; const cursor = search.selectionStart
    render(p,root); const next = root.querySelector<HTMLInputElement>('[aria-label="Search diary"]'); next?.focus({preventScroll:true}); try { next?.setSelectionRange(cursor,cursor) } catch { /* Search selection differs by browser. */ }
  })
  const findBar = el('div', {class:'diary-phone-find', id:'diary-desk-find', role:'search', 'aria-label':'Find visits'}, search, el('div', {class:'diary-phone-find-row'}, ...(worksAlone() ? [] : [worker]), area))
  findBar.hidden = !findOpen
  void find
  const activeFilters = [diarySearch ? `Search: ${diarySearch}` : '',workerFilter ? `Worker: ${workerFilter === '__unassigned' ? 'Unassigned' : workerFilter}` : '',areaFilter ? `Area: ${areaFilter}` : ''].filter(Boolean)
  const filterTools = el('div', {class:'diary-filter-tools'})
  if (activeFilters.length) {
    const reset = el('button', {type:'button',class:'diary-clear-filters'},'Clear filters')
    reset.addEventListener('pointerdown',event=>{if(editing)event.preventDefault()})
    reset.addEventListener('mousedown',event=>{if(editing)event.preventDefault()})
    reset.addEventListener('click',()=>{if(!diaryNavigationReady())return; diarySearch = ''; workerFilter = ''; areaFilter = ''; filtersOpen = false; render(p,root); root.querySelector<HTMLElement>('.diary-phone-head .diary-more > summary')?.focus({preventScroll:true})})
    filterTools.append(el('span', {class:'diary-active-filters'},activeFilters.join(' · ')),reset)
  }
  heading.after(summary, viewsRow, findBar, ...(placeBar ? [placeBar] : []), strip, diaryColourKey(), ...(activeFilters.length ? [filterTools] : []), ...(weekRows ? [weekRows] : []), putHere)
  // Design B, one week not two (Liam, 4 Nov 2026: "weve effectively got two indicators on week ... B is the one"): the week's
  // name, arrows and figures move inside the days card, and the ⋯ sits beside + Book a visit, so the top line is the
  // view switch and the week shows once (https://claude.ai/artifact/QzPu9qQakxQvZnHf8SjeQ1).
  {
    const weekNav = heading.querySelector<HTMLElement>(':scope > .week-nav')
    const more = heading.querySelector<HTMLElement>(':scope > .diary-more')
    if (more) viewsRow.append(more)
    summary.before(viewsRow)
    if (weekNav) { const box = el('div', {class:'diary-strip-card'}); strip.before(box); box.append(weekNav, strip) }
    heading.classList.add('is-merged')
  }
  if (!dayView) usedDiaryWeek()
  // Needs you opens over the diary from its button; the box itself loads and fills here, out of sight.
  const attentionSlot = root.querySelector<HTMLElement>('.diary-attention-slot')
  setNeedsExtras(planningExtras(root, reviewCount(p)))
  if (attentionSlot) { attentionSlot.classList.add('diary-needs-you'); attentionSlot.hidden = true; root.append(attentionSlot) }
  syncDay()
  if (days && !dayView) days.hidden = true
  root.append(phoneWeekBar(dueCount, due))
  if (popDue) { popDue = false; popDueCount(root) }
  // "Message N" beside Waiting on (round 4): the next of those placed whose message was put away.
  const later = messageLaterChip()
  if (later) {
    const top = root.querySelector<HTMLElement>('.diary-due-bar .diary-due-top'); top?.querySelector('.diary-due-hint')?.remove(); top?.insertBefore(later, top.querySelector('.diary-due-waiting-slot'))
    // A message put away to send later is something on the bar: it shows even with nobody due (Sol's review).
    const whole = top?.closest<HTMLElement>('.diary-due-bar')
    if (whole) { whole.classList.remove('is-empty'); whole.hidden = false }
  }
  // A card tapped to pick (or let go) keeps the focus across the redraw, so a keyboard or screen reader carries on.
  if (focusDueKey) { root.querySelector<HTMLElement>(`.diary-due-chip[data-due-key="${focusDueKey}"]`)?.focus({preventScroll:true}); focusDueKey = null }
  // "Show me" from What's next: the visits held in a week glow on the bar, to be put on a day.
  if (placingGuide && guideOpensBar && !phoneSheet) openDueSheet('due')
  if (placingGuide) {
    const held = document.querySelectorAll<HTMLElement>('.diary-week-tray [data-week-pick^="visit:"], .diary-due-tiles [data-week-pick^="visit:"]')
    if (held.length) for (const chip of held) chip.classList.add('first-visit-glow')
    else placingGuide = false
  }
  // "Give them dates" (the import's finish page, the welcome): the list opens on First visit.
  if (takeNoDateGlow()) window.setTimeout(() => { if (!document.querySelector('dialog[open]')) openDueSheet('first') }, 300)
  guideOpensBar = false
  // A sheet that was open stays open with what is true now.
  if (phoneSheet?.kind === 'due') fillDueSheet()
  else if (phoneSheet?.kind === 'needs') fillNeedsSheet()
  else if (phoneSheet?.kind === 'waiting') fillWaitingSheet()
  else if (phoneSheet?.kind === 'pencil') fillPencilSheet(phonePencil)
  // Re-entering Week uses this phone's existing Due preference, including one saved
  // by Day's bar. Picking and other dialogs temporarily keep the dates unobstructed.
  if (!picking && !phoneSheet && dueBarOpen(phoneDueMemory().open) && !document.querySelector('dialog[open]') && !root.querySelector<HTMLElement>('.diary-week-bar')?.hidden) openDueSheet('due')
  syncPhoneWeekBar()
  if (phoneWeekActive() && phoneSheet?.sheet.dialog.dataset.size === 'small') phoneSheet.sheet.resize?.('small', false)
  // Needs you or Due tapped on the phone's Month: their list opens here, in the week.
  // Only straight after the tap (a week that never drew does not open it hours later), and never over a pop-up.
  if (phoneSheetOnArrive) {
    const { sheet, at } = phoneSheetOnArrive; phoneSheetOnArrive = null
    if (Date.now() - at < 8000 && !document.querySelector('dialog[open]')) { if (sheet === 'needs') openNeedsSheet(); else openDueSheet('due') }
  }
}

function reviewCount(p: SchedulePayload): number {
  return reviewVisits(p.overdue ?? [], customers, roundJobList, todayISO()).length
}

// The bar's cards, most behind first: visits already promised for this week but given no day lead, then the people due.
function barCards(due: PhoneDue, p: SchedulePayload): BarCard[] {
  const held = due.held.map((cl): BarCard => ({
    key: `visit:${cl.id}`, name: cl.customer_name ?? `#${cl.customer_id}`, line: 'this week, no day yet', late: false,
    price: cl.amount_pence !== null ? cash(cl.amount_pence) : '', pushed: 0, canPush: false,
    label: `${cl.customer_name ?? 'Visit'}, in the week of ${shortDate(mondayOf(cl.date))}, no day yet. Push it up onto a day, or tap it and then a day.`,
  }))
  return [...held, ...due.sets.due.map((c): BarCard => {
    const missed = missedCleanFor(c, p)
    const waited = c.follow_up_on && c.follow_up_on <= todayISO() && (!c.last_clean || c.follow_up_on > c.last_clean) ? c.follow_up_on : null
    const from = dueFrom(c, p, todayISO())
    const line = missed ? `was due ${shortDate(missed.date)}, not done` : waited ? `asked to wait until ${shortDate(waited)}` : from ? `due ${shortDate(from)}` : 'due'
    return {
      key: `due:${dueKey(c)}`, name: c.dueJob ? `${c.name} · ${c.dueJob.name}` : c.name, line,
      late: !waited && !!(missed || (from && from < todayISO())),
      price: duePrice(c, todayISO()) !== null ? cash(duePrice(c, todayISO())!) : '', pushed: c.due_pushes ?? 0, canPush: true,
      label: `${dueWho(c)}, ${line}. Push up onto a day, tap then tap a day, or pull down for next week.`,
    }
  })]
}

function phoneWeekMoney(visits: Clean[]): string {
  const counted = visits.filter(countsAsDayVisit)
  const f = diaryDayFacts(counted)
  // "£855+" on one line, the + saying some are unpriced (Liam, 4 Nov 2026: "Do all four"); Help says what it means.
  return !f.visits ? '' : counted.every(c => c.amount_pence == null) ? 'Unpriced' : `${cash(f.pence)}${f.unpriced ? '+' : ''}`
}
// The phone's Due tray, the same on Day and Week (Liam, 4 Nov 2026: "We need to unify day and week due", design B
// https://claude.ai/artifact/QzPu9qQakxQvZnHf8SjeQ1): the newer Week tray, its six squares and its two-line cards, on both.
// (The name is from when only Week had it.)
function phoneWeekActive(): boolean { return phoneNew() && diaryView() === 'week' }
let phoneWeekReturn: (() => void) | null = null
function phoneDueMemory(): { open: string; size: string } {
  const business = getMe()?.businessId ?? 'none'
  return { open: `roundly:due-bar-open:${business}`, size: `roundly:due-bar-size:${business}` }
}
function syncPhoneWeekBar(): void {
  const bar = document.querySelector<HTMLElement>('#screen .diary-week-bar')
  if (!bar) return
  const open = phoneSheet?.kind === 'due' && phoneSheet.sheet.dialog.open
  bar.classList.toggle('is-folded', !open)
  const fold = bar.querySelector<HTMLElement>('.diary-due-fold')
  if (fold) { fold.textContent = open ? 'Hide' : 'Show'; fold.setAttribute('aria-expanded', String(!!open)); fold.setAttribute('aria-label', `${open ? 'Hide' : 'Show'} the Due tray`) }
}
function phoneWeekBar(count: number, due: PhoneDue): HTMLElement {
  const bar = el('section', {class:'diary-due-bar diary-week-bar is-folded', 'aria-label':'Due'})
  const open = (): void => { if (diaryNavigationReady()) openDueSheet('due') }
  const toggle = (): void => {
    if (!diaryNavigationReady()) return
    if (phoneSheet?.kind === 'due') { rememberDueBarOpen(phoneDueMemory().open, false); closePhoneSheet() }
    else openDueSheet('due')
  }
  const handle = el('button', {type:'button', class:'diary-due-handle', 'aria-label':'Open the Due tray'}, el('span', {'aria-hidden':'true'}))
  // The closed handle is a lift too. Reserve its gesture before Safari starts
  // page scrolling; a second lift uses the small tray's existing resize handle.
  let lift: {id: number; y: number} | null = null
  let lifted = false
  // Pushed down out of the way (Liam, 4 Nov 2026: "i cant scroll the tab down and away", again after a redesign): a
  // swipe down on the folded tray leaves only its Due · N line, remembered on this phone; a tap or a swipe up on that
  // line brings the squares and cards back. Checked in scripts/diary-week-phone.test.mjs so a redesign cannot drop it.
  const tuckKey = `${phoneDueMemory().open}:tucked`
  const setTucked = (on: boolean): void => {
    rememberDueBarOpen(tuckKey, on); bar.classList.toggle('is-tucked', on)
    handle.setAttribute('aria-label', on ? 'Show the Due squares and cards' : 'Open the Due tray')
  }
  const tucked = (): boolean => bar.classList.contains('is-tucked')
  handle.addEventListener('click', () => { if (lifted) { lifted = false; return }; if (tucked()) setTucked(false); else open() })
  const show = el('button', {type:'button', class:'diary-due-fold'}, 'Show')
  show.addEventListener('click', () => { if (lifted) { lifted = false; return }; toggle() })
  show.setAttribute('aria-label', 'Show the Due tray')
  const top = el('div', {class:'diary-due-top'}, handle,
    el('div', {class:'diary-due-title'}, el('strong', {class:'diary-due-count'}, `Due · ${customers ? count : '…'}`)),
    el('span', {class:'diary-due-waiting-slot'}), show)
  // The lift works from anywhere on the bar, not only the small handle (Liam, 2 Nov 2026: "the due tab at the bottom
  // doesnt slide up"). A lift that starts on Show or Waiting on is still a lift; that button's tap is then let go.
  // The swipe works from the top line and the squares; the small cards keep their own sideways scroll and drag.
  bar.addEventListener('pointerdown', e => {
    if (e.button !== 0 || (e.target as Element | null)?.closest?.('.diary-due-tiles')) return
    lifted = false; lift = {id:e.pointerId, y:e.clientY}
    try { bar.setPointerCapture(e.pointerId) } catch { /* optional */ }
  })
  bar.addEventListener('pointerup', e => {
    if (!lift || e.pointerId !== lift.id) return
    const up = lift.y - e.clientY; lift = null
    if (Math.abs(up) < 24 || !diaryNavigationReady()) return
    lifted = true; swallowNextTap()
    if (up < 0) { if (!tucked()) setTucked(true); return }
    if (tucked()) { setTucked(false); return }
    openDueSheet('due'); phoneSheet?.sheet.resize?.('small')
  })
  bar.addEventListener('pointercancel', () => { lift = null })
  bar.append(top); showWaiting(bar, waitingCount(), openWaitingSheet)
  // Design B (Liam, 4 Nov 2026: "B"): folded, the tray shows its six squares, one tap opening that list, and a row of
  // small cards, the ones Day used to show side by side: name, price and where asking stands. Hold one and drag it onto
  // a day, or tap it then tap a day, as in the tray.
  if (customers && payload) {
    const p = payload
    const tabs: [DueTab, string, number][] = [
      ['due', 'Due', due.held.length + due.sets.due.length], ['new', 'New', due.enquiries.length], ['first', 'First visit', due.sets.firstVisit.length],
      ['next', 'Next week', due.sets.nextWeek.length], ['quiet', 'Quiet', due.sets.goneQuiet.length], ['nocycle', 'No cycle', due.noCycle.length],
    ]
    const cards = barCards(due, p)
    const late = cards.filter(c => c.late).length
    const squares = el('div', {class:'diary-due-squares-row', role:'group', 'aria-label':'The Due lists'})
    for (const [key, label, n] of tabs) {
      const ring = el('span', {class:'diary-sheet-ring', 'aria-hidden':'true'}, lineDrawing(DUE_TAB_DRAWINGS[key], 18), el('span', {class:'diary-sheet-count'}, key === 'new' && !leads ? '…' : String(n)))
      if (key === 'due' && late) ring.append(el('span', {class:'diary-sheet-late'}, `Late ${late}`))
      const b = el('button', {type:'button', class:'diary-due-square', 'aria-label':`Open ${label}, ${n}${key === 'due' && late ? `, ${late} late` : ''}`}, ring, el('span', {class:'diary-sheet-word'}, label))
      b.addEventListener('click', e => { e.stopPropagation(); if (diaryNavigationReady()) openDueSheet(key) })
      squares.append(b)
    }
    const row = el('div', {class:'diary-due-tiles', role:'list', 'aria-label':'Due, to put on a day'})
    for (const c of cards.slice(0, 12)) {
      const visit = c.key.startsWith('visit:') ? p.cleans.find(cl => cl.id === Number(c.key.slice(6))) : null
      const kind: 'visit' | 'due' = visit ? 'visit' : 'due', id = c.key.slice(c.key.indexOf(':') + 1)
      // Where asking stands for a visit held in the week (the heading says the week); for a customer due, when.
      const words = visit ? diaryWords(visit).text.split(' · ')[0] : c.line
      const tile = weekName(c.name, `${kind}:${id}`, () => pickPhoneWeek(kind, id), iso => placePhoneWeek(kind, id, iso))
      tile.classList.add('diary-due-tile'); if (c.late) tile.classList.add('is-late')
      tile.replaceChildren(el('span', {class:'diary-due-tile-top'}, el('b', {}, c.name), ...(c.price && !pricesHidden() ? [el('span', {}, c.price)] : [])), el('span', {class:'diary-due-tile-words'}, words))
      tile.setAttribute('aria-label', `${c.name}${c.price ? `, ${c.price}` : ''}, ${words}. Tap then tap a day, or hold and drag onto a day.`)
      row.append(el('div', {role:'listitem'}, tile))
    }
    bar.append(squares, ...(cards.length ? [row] : []))
  }
  if (dueBarOpen(tuckKey)) setTucked(true)
  if (!count && !due.enquiries.length && !due.sets.nextWeek.length && !due.sets.firstVisit.length && !due.sets.goneQuiet.length && !due.noCycle.length && customers && leads && needsReady && waitingCount() === 0) { bar.classList.add('is-empty'); bar.hidden = true }
  return bar
}
function pickPhoneWeek(kind: 'visit' | 'due' | 'enq', id: number | string): void {
  if (!diaryNavigationReady()) return
  const tab = phoneSheet?.kind === 'due' ? phoneSheet.tab : null
  const pencil = phoneSheet?.kind === 'pencil'
  phoneWeekReturn = () => {
    if (tab) openDueSheet(tab)
    else if (pencil && payload) openPencilSheet(pencilledRows(payload.cleans.filter(c => visible(c, payload!.round_days ?? []))))
    const key = `${kind}:${id}`
    document.querySelector<HTMLElement>(`[data-week-pick="${key}"]`)?.focus({preventScroll:true})
  }
  pickFromSheet(kind, id)
  document.querySelector<HTMLElement>('.diary-phone-week-view .diary-week-strip [data-due-drop]')?.focus({preventScroll:true})
}
function placePhoneWeek(kind: 'visit' | 'due' | 'enq', id: number | string, iso: string): void {
  if (!diaryNavigationReady()) return
  if (iso < todayISO()) { toast(GONE_DAY_WORDS); return }
  if (kind === 'visit') {
    const visit = payload?.cleans.find(c => c.id === Number(id))
    if (!visit || !mayMoveHere(visit)) { toast('This visit changed. Check it before moving.'); return }
  }
  closePhoneSheet(); phoneWeekReturn = null
  movingId = kind === 'visit' ? Number(id) : null
  movingDueId = kind === 'due' ? String(id) : null
  movingEnqId = kind === 'enq' ? Number(id) : null
  placePicked(iso)
}
// Whether the last thing done was a tap or click (true) or a key (false), so focus moves back only for the keyboard.
let pointerLast = false
if (typeof document !== 'undefined') {
  document.addEventListener('pointerdown', () => { pointerLast = true }, true)
  document.addEventListener('keydown', () => { pointerLast = false }, true)
}
function phoneBottomSheet(label: string, onClosed: () => void, tile: string): Sheet {
  const week = phoneWeekActive()
  const sheet = bottomSheet(label, () => {
    onClosed(); syncPhoneWeekBar()
    // Back to its tile for the keyboard only: after a tap the tile would keep a dark focus ring (Liam's photo, 4 Nov 2026).
    if (week && !pointerLast && !document.querySelector('dialog[open]')) document.querySelector<HTMLElement>(`#screen .diary-ptile[data-tile="${tile}"]`)?.focus({preventScroll:true})
  }, week, week && tile === 'due' ? phoneDueMemory() : undefined)
  if (week) {
    const small = el('button', {type:'button', 'data-week-resize-small':'', class:'diary-week-resize-small', tabindex:'-1', 'aria-hidden':'true'})
    small.addEventListener('click', () => sheet.resize?.('small', false)); sheet.dialog.append(small)
  }
  return sheet
}

// ---- the phone's sheets -----------------------------------------------------------------------------------------------
function closePhoneSheet(): void { const open = phoneSheet; phoneSheet = null; open?.sheet.close(); syncPhoneWeekBar() }
function openDueSheet(tab: DueTab): void {
  closePhoneSheet()
  const sheet = phoneBottomSheet('Due list', () => { if (phoneSheet?.sheet === sheet) phoneSheet = null }, 'due')
  phoneSheet = { kind: 'due', tab, sheet, drawn: null }
  syncPhoneWeekBar(); fillDueSheet()
}
function sheetButton(text: string, act: () => void, lemon = false): HTMLButtonElement {
  const b = el('button', {type:'button', class:lemon ? 'btn-primary' : 'btn-secondary'}, text)
  b.addEventListener('click', act)
  return b
}
// Out of the list and back to the diary, then do it (placing opens their message, which must not sit under the list).
const thenClose = (fn: () => void) => (): void => { closePhoneSheet(); fn() }
function pickFromSheet(kind: 'visit' | 'due' | 'enq', id: number | string): void {
  closePhoneSheet()
  movingId = kind === 'visit' ? Number(id) : null
  movingDueId = kind === 'due' ? String(id) : null
  movingEnqId = kind === 'enq' ? Number(id) : null
  const root = document.querySelector<HTMLElement>('#screen')
  if (payload && root) render(payload, root)
}
// A row of the list keeps its own controls (the name opens the customer, its ⋯, Message); a tap on the rest of it picks
// them, to tap a day next, as a tap on a bar card does.
function sheetRow(row: HTMLElement, pick: () => void, acts: HTMLElement[]): HTMLElement {
  row.draggable = false
  if (phoneWeekActive()) {
    const raw = row.dataset.pick ?? '', split = raw.indexOf(':')
    const kind = raw.startsWith('due:') ? 'due' : raw.startsWith('enq:') ? 'enq' : 'visit'
    const id = raw.slice(split + 1)
    const link = row.querySelector<HTMLElement>('.sched-clean-link')
    const name = link?.textContent?.trim() ?? 'Visit'
    const choose = (): void => pickPhoneWeek(kind, id)
    if (link) {
      const customerLink = el('a', {href:link.getAttribute('href') ?? '#/customers'}, 'Open their page')
      const button = weekName(name, `${kind}:${id}`, choose, iso => placePhoneWeek(kind, id, iso))
      link.replaceWith(button)
      const menu = row.querySelector<HTMLElement>('.row-menu-list')
      if (menu) menu.append(customerLink)
      if (kind === 'visit') {
        // Under "This week, no day yet" the card does not say it again (two-line card, 3 Nov 2026).
        row.querySelector('.badge-sheet-said.is-week')?.remove()
      }
    }
    row.removeAttribute('role'); row.removeAttribute('tabindex')
    if (!row.querySelector('.row-menu-list')) row.append(rowMenu(`More actions for ${name}`, () => {}))
    const menu = row.querySelector<HTMLElement>('.row-menu-list')
    // Move today's actual buttons, retaining their handlers, into today's existing menu.
    for (const action of [...row.querySelectorAll<HTMLElement>(':scope > .diary-due-message'), ...acts]) {
      if (menu) menu.append(action)
    }
    const wrap = el('div', {class:'diary-sheet-row diary-week-due-card'}, row)
    weekNameDrag(row, name, iso => placePhoneWeek(kind, id, iso), 'a, button, summary, input, select, .row-menu')
    row.addEventListener('click', (e) => {
      if ((e.target as Element)?.closest('a, button, summary, input, select, .row-menu')) return
      e.stopImmediatePropagation(); e.preventDefault(); choose()
    }, true)
    return wrap
  }
  row.addEventListener('click', (e) => {
    const t = e.target as Element
    if (['a', 'button', 'summary', 'input', 'select', '.row-menu'].some((s) => t.closest(s))) return
    e.stopImmediatePropagation(); e.preventDefault(); pick()
  }, true)
  return el('div', {class:'diary-sheet-row'}, row, el('div', {class:'diary-sheet-acts'}, ...acts))
}
const DUE_TAB_SHORT: Partial<Record<DueTab, string>> = { quiet: 'Quiet', nocycle: 'No cycle' }
const DUE_TAB_DRAWINGS: Record<DueTab, Drawing> = { due: 'list', new: 'personPlus', first: 'house', next: 'arrowRight', quiet: 'bubble', nocycle: 'time' }
function fillDueSheet(): void {
  const open = phoneSheet
  if (!open || open.kind !== 'due' || !phoneDue || !payload) return
  const due = phoneDue, p = payload, day = putDay()
  const tabs: [DueTab, string, number][] = [
    ['due', 'Due', due.held.length + due.sets.due.length], ['new', 'New', due.enquiries.length], ['first', 'First visit', due.sets.firstVisit.length],
    ['next', 'Next week', due.sets.nextWeek.length], ['quiet', 'Gone quiet', due.sets.goneQuiet.length], ['nocycle', 'No cycle set', due.noCycle.length],
  ]
  const strip = el('div', {class:'diary-sheet-tabs', role:'tablist', 'aria-label':'The Due list'})
  const late = phoneWeekActive() && customers ? barCards(due, p).filter(c => c.late).length : null
  for (const [key, label, n] of tabs.filter(([k, , n]) => phoneWeekActive() || k === 'due' || n > 0 || k === open.tab)) {
    const words = `${label} · ${phoneWeekActive() && (key === 'new' ? !leads : !customers) ? '…' : n}`
    const b = el('button', {type:'button', role:'tab', 'aria-selected':String(key === open.tab), class:key === open.tab ? 'is-on' : ''}, words)
    // Design C (Liam, 3 Nov 2026: "I like C"; https://claude.ai/artifact/6MZeS9Zw81TBB1G9RSAxpk): on the phone's week
    // the six lists are picture squares in one row, a drawing in a ring with the words under it, so the names start
    // straight under them. The red Late count sits on the Due ring; its results and action stay the same.
    // Design D (Liam, 3 Nov 2026: "reduce height by not having the icon words wrap over two lines", then "go with new d
    // design"): the number sits on the picture as a small badge, so the words fit on one line.
    if (phoneWeekActive()) {
      const count = phoneWeekActive() && (key === 'new' ? !leads : !customers) ? '…' : String(n)
      const ring = el('span', {class:'diary-sheet-ring', 'aria-hidden':'true'}, lineDrawing(DUE_TAB_DRAWINGS[key], 20), el('span', {class:'diary-sheet-count'}, count))
      if (key === 'due' && late) ring.append(el('span', {class:'diary-sheet-late'}, `Late ${late}`))
      b.classList.add('diary-sheet-square')
      b.replaceChildren(el('span', {class:'diary-sheet-word'}, DUE_TAB_SHORT[key] ?? label), ring)
      b.setAttribute('aria-label', key === 'due' && late ? `${words}, ${late} late` : words)
      if (key === 'due' && late) b.classList.add('has-late')
    } else if (key === 'due' && late) {
      b.classList.add('has-late')
      b.replaceChildren(el('span', {class:'diary-sheet-late'}, `Late ${late}`), el('span', {}, words))
      b.setAttribute('aria-label', `${words}, ${late} late`)
    }
    b.addEventListener('click', () => { open.tab = key; fillDueSheet(); open.sheet.head.querySelector<HTMLElement>('[aria-selected="true"]')?.focus({preventScroll:true}) })
    strip.append(b)
  }
  const keep = open.drawn === open.tab ? open.sheet.body.scrollTop : 0
  const rows: HTMLElement[] = []
  const intro = (text: string): void => { rows.push(el('p', {class:'diary-sheet-intro'}, text)) }
  let teach: ReturnType<typeof dueDragTeach> | null = null
  const put = (fn: () => void): HTMLButtonElement => sheetButton(`Put on ${dayLabel(day)}`, thenClose(fn), true)
  if (open.tab === 'due') {
    // Design E (3 Nov 2026): on the phone's week the words go; the first time, the drag is shown instead (due-drag-demo.ts).
    teach = phoneWeekActive() ? dueDragTeach('phone') : null
    if (teach !== 'demo' && teach !== 'none') intro(phoneWeekActive() ? 'Hold and drag a name onto a day, or tap it then tap a day. Late first. More actions in each card’s ⋯.' : 'Most behind first. Put them on a day, or swipe one left for next week: nothing is sent to them.')
    if (phoneWeekActive() && due.held.length) rows.push(el('h3', {class:'diary-week-held-title'}, 'This week, no day yet'))
    for (const cl of due.held) rows.push(sheetRow(trayRow(cl), () => pickFromSheet('visit', cl.id), [put(() => moveToDay(cl, day)), sheetButton('Pick a day', () => pickFromSheet('visit', cl.id))]))
    if (phoneWeekActive() && due.held.length && due.sets.due.length) rows.push(el('h3', {class:'diary-week-due-title'}, 'Due customers'))
    for (const c of due.sets.due) {
      const push = (): void => pushToNextWeek(c)
      rows.push(swipeToPush(sheetRow(dueRow(c, p), () => pickFromSheet('due', dueKey(c)), [put(() => placeDueOn(c, day, p)), sheetButton('Pick a day', () => pickFromSheet('due', dueKey(c))), sheetButton('Next week', push)]), push))
    }
    if (!due.held.length && !due.sets.due.length && (!phoneWeekActive() || customers)) rows.push(el('p', {class:'diary-sheet-empty'}, el('strong', {}, 'All clear for this week.'), due.sets.nextWeek.length ? ` ${due.sets.nextWeek.length} moved to next week.` : ' Everyone is placed.'))
  } else if (open.tab === 'new') {
    intro('Enquiries nobody has answered yet. Put one on a day to make them a customer and book their first visit.')
    for (const l of due.enquiries) rows.push(sheetRow(enquiryRow(l), () => pickFromSheet('enq', l.id), [put(() => placeEnquiry(l, day)), sheetButton('Pick a day', () => pickFromSheet('enq', l.id))]))
  } else if (open.tab === 'first') {
    intro('Never visited and nothing booked. Put them on a day or message them.')
    for (const c of due.sets.firstVisit) rows.push(sheetRow(dueRow(c, p), () => pickFromSheet('due', dueKey(c)), [put(() => placeDueOn(c, day, p)), sheetButton('Pick a day', () => pickFromSheet('due', dueKey(c)))]))
  } else if (open.tab === 'next') {
    intro('Out of Due until the day shown. Nothing was sent to them.')
    // The same cards as Due (hold and drag onto a day, or tap then tap a day), with Back into Due now as well.
    for (const c of due.sets.nextWeek) rows.push(sheetRow(dueRow(c, p), () => pickFromSheet('due', dueKey(c)), [put(() => placeDueOn(c, day, p)), sheetButton('Pick a day', () => pickFromSheet('due', dueKey(c))), sheetButton('Back into Due now', () => backIntoDue(c))]))
  } else if (open.tab === 'quiet') {
    intro('More than two cleans behind. Ask if they still want it, put them on a day, or take them off from their page.')
    for (const c of due.sets.goneQuiet) rows.push(sheetRow(dueRow(c, p), () => pickFromSheet('due', dueKey(c)), [
      sheetButton('Pick a day', () => pickFromSheet('due', dueKey(c)), true),
      sheetButton('Ask if they still want it', thenClose(() => openMessagesFor({ id: c.id, name: c.name }, 'customer'))),
      sheetButton('Take off', thenClose(() => { window.location.hash = `#/customer/${c.id}` })),
    ]))
  } else {
    intro('No cycle set, so not in Due. Roundly guessed one from their past visits: keep it in one tap and they come into Due when they are due.')
    for (const x of due.noCycle) rows.push(noCycleRow(x))
  }
  if (phoneWeekActive() && (open.tab === 'new' ? !leads : !customers)) {
    rows.push(el('p', {class:'diary-sheet-empty', role:'status'}, open.tab === 'new' ? 'Enquiries unavailable. Try again with signal.' : 'Due customers unavailable. Visits already held in this week are still shown.'))
    rows.push(sheetButton('Retry', () => void load()))
  }
  if (rows.length === 1 && open.tab !== 'due') rows.push(el('p', {class:'diary-sheet-empty'}, 'Nobody here now.'))
  if (phoneWeekActive()) for (const plain of rows.filter(r => r.classList.contains('diary-sheet-plain'))) {
    const actions = plain.querySelector<HTMLElement>('.diary-sheet-acts')
    if (!actions) continue
    plain.append(rowMenu(`More actions for ${plain.querySelector('strong, a')?.textContent ?? 'this customer'}`, list => { for (const action of [...actions.children]) list.append(action) }))
    actions.remove()
  }
  // Liam, 3 Nov 2026: "because of the filter pills i cant drag a customer into a day ... cant reach even one name": no
  // "Due · N" title over the lists (the picked square says it), the six squares in one row (design C above).
  open.sheet.head.replaceChildren(strip)
  // Waiting on N (replies and offered days) lives here now, not on the folded bar (Liam, 4 Nov 2026: "waiting on and
  // show need dropping"): one line under the squares while anyone is waiting.
  const waiting = waitingCount()
  if (waiting) {
    const w = el('button', {type:'button', class:'diary-tray-waiting', 'aria-label':`Waiting on ${waiting}: replies and offered days`}, `Waiting on ${waiting} ›`)
    w.addEventListener('click', () => openWaitingSheet())
    open.sheet.head.append(w)
  }
  open.sheet.body.replaceChildren(...rows)
  if (teach === 'demo') playDueDragDemo(open.sheet.body, 'phone')
  if (phoneWeekActive()) { open.sheet.body.setAttribute('role', 'tabpanel'); open.sheet.body.setAttribute('aria-label', tabs.find(t => t[0] === open.tab)?.[1] ?? 'Due') }
  open.sheet.body.scrollTop = keep
  open.drawn = open.tab
  strip.querySelector<HTMLElement>('.is-on')?.scrollIntoView?.({block:'nearest', inline:'nearest'})
}

// The nearest how-often to a guessed number of days ("every 8 weeks" for 54 days): ui.ts nearestCycleChoice.
const nearestCycle = nearestCycleChoice
// One tap keeps Roundly's guess; one more chooses another, or says they have no fixed cycle (Liam: "almost one or two
// clicks"). The same save as the customer page's Cycle, with Undo.
function noCycleRow(x: NoCycleEntry): HTMLElement {
  const c = x.customer
  const near = nearestCycle(x.guessDays)
  const save = (days: number | null, text: string | null, words: string): void => {
    void mutate({ label: `Cycle: ${c.name}`, method: 'PATCH', path: `/api/customers/${c.id}`, body: { version: c.version, cycle_days: days, cycle_text: text }, onConflict: () => void load() }).then((ack) => {
      if (!ack.ok && ack.status >= 400 && ack.status < 500) { alert4xx(ack); void load(); return }
      void load()
      undoPatch({ text: `${c.name}: ${words}`, label: `Undo cycle: ${c.name}`, path: `/api/customers/${c.id}`, ack, version: c.version, body: { cycle_days: c.cycle_days ?? null, cycle_text: c.cycle_text ?? null }, after: () => void load() })
    })
  }
  const other = el('select', {'aria-label':`Another cycle for ${c.name}`, class:'diary-sheet-cycle'})
  other.append(el('option', {value:''}, 'Another cycle…'))
  cycleOptions().forEach((o, i) => { if (o.days || (o.marker && o.marker !== 'TBC')) other.append(el('option', {value:String(i)}, o.label)) })
  other.addEventListener('change', () => {
    const o = cycleOptions()[Number(other.value)]
    if (!other.value || !o) return
    save(o.days, o.days ? null : o.marker ?? null, o.days ? `every ${o.label}` : o.label)
  })
  const acts: HTMLElement[] = []
  if (near) acts.push(sheetButton(`Set every ${near.label}`, () => save(near.days, null, `every ${near.label}`), true))
  acts.push(other)
  return el('div', {class:'diary-sheet-row diary-sheet-plain'},
    el('a', {href:`#/customer/${c.id}`, class:'name-link'}, c.name),
    el('span', {class:'muted'}, [c.address ? splitAccessWarning(c.address).addr : '', `last visit ${shortDate(c.last_clean!)}`].filter(Boolean).join(' · ')),
    el('span', {}, `Roundly's guess: about every ${Math.round(x.guessDays / 7)} weeks, so due ${shortDate(x.due)}`),
    el('div', {class:'diary-sheet-acts'}, ...acts))
}

// The phone's Pencilled (phone 4): the same two day-only groups as the computer's list, in a sheet from the bottom.
// One of the phone's three tiles (phone 4): its picture and number, its word, and a second line ("3 late", "8 to ask").
function phoneTileButton(key: string, drawing: TileDrawing, count: string, word: string, second: string, open: () => void): HTMLElement {
  const b = el('button', {type:'button', class:'diary-ptile', 'data-tile':key},
    // "1 late" / "5 to ask" beside the number, not a third line, so the tiles are shorter (Liam, 27 Oct 2026: "move the 6
    // like you said").
    // Design D on the phone too (Liam, 3 Nov 2026: "What about mobile tho?"): a picture square, the number as a badge on
    // the ring, the word under it and "1 late" / "5 to ask" under that, as on the computer and in the Due tray.
    el('span', {class:'diary-ptile-top'}, el('span', {class:`diary-wtile-ring is-${key}`, 'aria-hidden':'true'}, drawing === '!' ? '!' : lineDrawing(drawing, 18)), el('b', {}, count)),
    el('span', {class:'diary-ptile-word'}, word),
    ...(second ? [el('span', {class:'diary-ptile-second'}, second)] : []))
  b.addEventListener('click', () => { if (diaryNavigationReady()) open() })
  return b
}

// The phone's Month takes the same three tiles (phone 4, Month as Week; Liam, 26 Oct 2026). Pencilled is the month on
// show, from today on, and opens its list here; Needs you and Due are this week's (as on a computer's Month), so they
// open their lists in the week, where the Due bar and Needs you's own lines live.
let monthNeedsAsked = false
let phoneSheetOnArrive: { sheet: 'needs' | 'due'; at: number } | null = null
function monthPhoneTiles(mp: SchedulePayload, list: Customer[] | null): HTMLElement {
  const today = todayISO(), from = defaultFrom(today)
  const p = monthWeek && monthWeek.from === from ? monthWeek : null
  let dueCount = '…', late = 0
  if (p) {
    const people = list ?? customers
    const due: PhoneDue = {
      sets: dueGroups(p, people, roundJobList, today, (c) => askAgainLater(c)),
      held: p.cleans.filter((c) => isSheetWeek(c, p.from, p.to)),
      enquiries: freshEnquiries(),
      noCycle: noCycleSet(p, people, today, (c) => askAgainLater(c)),
    }
    dueCount = String(due.held.length + due.sets.due.length)
    late = barCards(due, p).filter(b => b.late).length
  }
  void mp
  const rows = pencilledRows(monthVisitsShown().filter(c => c.date >= today && !isContact(c)))
  const pen = countPencilled(rows.map(r => r.step))
  const inWeek = (sheet: 'needs' | 'due') => (): void => { phoneSheetOnArrive = { sheet, at: Date.now() }; setWeekMode('week'); showWeek() }
  // Opened straight into Month, Needs you reads its lines here, so its number comes in (Sonnet's check).
  if (!needsReady && !monthNeedsAsked) { monthNeedsAsked = true; setNeedsWatch(onNeedsLines); renderAttention(el('div', {class:'diary-attention-slot'})) }
  return el('div', {class:'diary-phone-tiles', role:'group', 'aria-label':'What needs you'},
    phoneTileButton('due', 'list', dueCount, 'Due', late ? `${late} late` : '', inWeek('due')),
    phoneTileButton('pencil', 'pencil', String(pen.all), 'Pencilled', pen.ask ? `${pen.ask} to ask` : '', () => openPencilSheet(rows)),
    phoneTileButton('needs', '!', needsTileCount(), 'Needs you', '', inWeek('needs')))
}

function openPencilSheet(rows: PencilRow[]): void {
  closePhoneSheet()
  const sheet = phoneBottomSheet('Pencilled', () => { if (phoneSheet?.sheet === sheet) phoneSheet = null }, 'pencil')
  phoneSheet = { kind: 'pencil', sheet }
  const list = deskPencilColumn(rows, () => { closePhoneSheet(); void load() })
  list.querySelector('.diary-drawer-close')?.remove()
  list.classList.remove('is-floating'); list.style.left = ''; list.style.top = ''
  list.querySelector('.diary-pencil-intro')?.replaceChildren(rows.length ? 'Day not agreed yet: ask them, or wait for their reply.' : diarySearch || workerFilter || areaFilter ? 'No pencilled visits match the search or filters.' : 'Nothing pencilled from today on: every visit day is agreed.')
  list.classList.add('diary-pencil-sheet')
  sheet.head.append(el('h3', {}, `Pencilled · ${rows.length}`))
  list.querySelector('.diary-pencil-head')?.remove()
  sheet.body.append(list)
}
function fillPencilSheet(rows: PencilRow[]): void {
  if (phoneSheet?.kind !== 'pencil') return
  const { sheet } = phoneSheet
  const list = deskPencilColumn(rows, () => { closePhoneSheet(); void load() })
  list.querySelector('.diary-drawer-close')?.remove(); list.querySelector('.diary-pencil-head')?.remove()
  list.classList.remove('is-floating'); list.style.left = ''; list.style.top = ''
  list.querySelector('.diary-pencil-intro')?.replaceChildren(rows.length ? 'Day not agreed yet: ask them, or wait for their reply.' : diarySearch || workerFilter || areaFilter ? 'No pencilled visits match the search or filters.' : 'Nothing pencilled from today on: every visit day is agreed.')
  list.classList.add('diary-pencil-sheet')
  sheet.head.querySelector('h3')?.replaceChildren(`Pencilled · ${rows.length}`)
  sheet.body.replaceChildren(list)
}
function openNeedsSheet(): void {
  closePhoneSheet()
  const sheet = phoneBottomSheet('Needs you', () => {
    // The box goes back where it loads, out of sight, for the next time.
    const slot = sheet.body.querySelector<HTMLElement>('.diary-attention-slot')
    const root = document.querySelector<HTMLElement>('#screen')
    // Only back into the phone diary; closed by leaving it (a name tapped), the box goes with the sheet.
    if (slot && root && root.querySelector(':scope > .diary-due-bar') && !root.querySelector('.diary-attention-slot')) { slot.hidden = true; root.append(slot) }
    if (phoneSheet?.sheet === sheet) phoneSheet = null
  }, 'needs')
  phoneSheet = { kind: 'needs', sheet }
  fillNeedsSheet()
}
function fillNeedsSheet(): void {
  if (phoneSheet?.kind !== 'needs') return
  const { sheet } = phoneSheet
  sheet.head.replaceChildren(el('h2', {class:'diary-sheet-title'}, 'Needs you'))
  const slot = document.querySelector<HTMLElement>('#screen .diary-attention-slot')
  if (slot) { slot.hidden = false; sheet.body.replaceChildren(slot) }
}
function openWaitingSheet(): void {
  closePhoneSheet()
  const sheet = bottomSheet('Waiting on', () => { if (phoneSheet?.sheet === sheet) phoneSheet = null })
  phoneSheet = { kind: 'waiting', sheet }
  fillWaitingSheet()
}
function fillWaitingSheet(): void {
  if (phoneSheet?.kind !== 'waiting') return
  const { sheet } = phoneSheet
  sheet.head.replaceChildren(el('h2', {class:'diary-sheet-title'}, 'Waiting on'))
  const parts: HTMLElement[] = [el('p', {class:'diary-sheet-intro'}, 'Waiting for a reply, and Dates offered, waiting: the same people as in Messages, which sends the next message.')]
  // Drawn as Needs you draws its lines, open: the same rows, buttons and words.
  for (const line of needsLines.filter(l => WAITING_KEYS.includes(l.key))) {
    const box = el('div', {class:'needs-panel diary-sheet-group-body'})
    line.fill(box)
    parts.push(el('section', {class:'needs-row needs-open diary-sheet-group'},
      el('h3', {class:'needs-line'}, meaningIcon('waiting', 'row'), el('span', {class:'needs-label'}, line.label), el('span', {class:'needs-count'}, String(line.count ?? '?'))),
      box))
  }
  if (parts.length === 1) parts.push(el('p', {class:'diary-sheet-empty'}, 'Nobody is waiting on a reply.'))
  sheet.body.replaceChildren(...parts)
}

// ---- the computer's Due column (round 3 of docs/plans/diary-due/PLAN.md) ------------------------------------------------
// Due down the left in Day, Week and Month, in place of the To place row: the same groups as the phone's Due list, as
// tabs. A card is dragged onto a date (or a week's day, or a month's date), or clicked and then a date clicked; its
// message opens as before. "Next week" on a card, or a card dropped on the space at the foot, takes them out of Due until
// Monday. The rows are the ones To place drew (their ⋯ keeps Not now, Put in a week and the rest).
let deskDueTab: DueTab = 'due'
let deskDueScroll = 0
// The tab belongs to the account it was chosen in: another account opens on Due (round 3 review).
let deskDueWho = ''
function deskDueFor(): void {
  const who = diaryPreferenceKey('selection')
  if (deskDueWho !== who) { deskDueWho = who; deskDueTab = 'due'; deskDueScroll = 0 }
}
// The card clicked in the column keeps the keyboard's place once the diary is drawn again (round 3 review).
let pickFocus: string | null = null
function notePick(row: HTMLElement): void { if (row.closest('.diary-due-col') && row.dataset.pick) pickFocus = row.dataset.pick }
function dueTabs(due: PhoneDue): [DueTab, string, number][] {
  return [
    ['due', 'Due', due.held.length + due.sets.due.length], ['new', 'New', due.enquiries.length], ['first', 'First visit', due.sets.firstVisit.length],
    ['next', 'Next week', due.sets.nextWeek.length], ['quiet', 'Gone quiet', due.sets.goneQuiet.length], ['nocycle', 'No cycle set', due.noCycle.length],
  ]
}
function deskDueColumn(p: SchedulePayload, due: PhoneDue, redraw: () => void): HTMLElement {
  deskDueFor()
  const tabs = dueTabs(due)
  // A tab emptied since (everyone placed) goes back to Due.
  if (deskDueTab !== 'due' && !(tabs.find(t => t[0] === deskDueTab)?.[2])) deskDueTab = 'due'
  const count = due.held.length + due.sets.due.length
  const head = el('div', {class:'diary-due-col-head'}, el('h2', {class:'diary-due-count'}, `Due · ${count}`), ...(messageLater.length ? [messageLaterChip()!] : []), el('span', {class:'diary-due-waiting-slot'}))
  showWaiting(head, waitingCount(), openWaitingSheet)
  // Design G (Liam, 3 Nov 2026: "it should be G consistent with mobile"): no hint line (the first time, the drag is shown
  // once, due-drag-demo.ts; reduced motion keeps the words); the six lists as the phone's picture squares, the number on
  // each picture, one line of words.
  const teach = dueDragTeach('desk')
  const hint = teach === 'text' ? el('p', {class:'diary-due-col-hint'}, 'Drag someone onto a day, or click them and then a day. Their message opens straight away.') : null
  const strip = el('div', {class:'diary-due-col-tabs diary-due-squares', role:'tablist', 'aria-label':'Due groups'})
  const late = customers ? barCards(due, p).filter(c => c.late).length : 0
  for (const [key, label, n] of tabs) {
    const b = el('button', {type:'button', role:'tab', 'aria-selected':String(key === deskDueTab), class:key === deskDueTab ? 'is-on' : '', 'aria-label':key === 'due' && late ? `${label} · ${n}, ${late} late` : `${label} · ${n}`, title:`${label} · ${n}`},
      el('span', {class:'diary-sheet-word'}, DUE_TAB_SHORT[key] ?? label),
      el('span', {class:'diary-sheet-ring', 'aria-hidden':'true'}, lineDrawing(DUE_TAB_DRAWINGS[key], 20), el('span', {class:'diary-sheet-count'}, String(n)), ...(key === 'due' && late ? [el('span', {class:'diary-sheet-late'}, `Late ${late}`)] : [])))
    b.addEventListener('click', () => { if (key === deskDueTab) return; deskDueTab = key; deskDueScroll = 0; redraw() })
    strip.append(b)
  }
  const list = el('div', {class:'diary-due-col-list', role:'tabpanel'})
  const small = (text: string, act: () => void, label?: string): HTMLButtonElement => {
    const b = el('button', {type:'button', class:'diary-due-col-act', ...(label ? {'aria-label':label} : {})}, text)
    b.addEventListener('click', (e) => { e.stopPropagation(); act() })
    return b
  }
  const card = (row: HTMLElement, acts: HTMLElement[] = []): HTMLElement => {
    row.classList.add('diary-due-col-card')
    if (acts.length) row.append(el('div', {class:'diary-due-col-acts'}, ...acts))
    // A "DO NOT BOOK …" line is one clipped line; a click (or Enter) opens it in full, and the pointer resting on it
    // shows it too (Liam, 12 Oct 2026: "should be clipped with an option to easily read it"). Never picks the card.
    const warn = row.querySelector<HTMLElement>('.access-warn')
    if (warn) {
      const words = warn.textContent ?? ''
      warn.title = words
      warn.tabIndex = 0
      warn.setAttribute('role', 'button')
      warn.setAttribute('aria-expanded', 'false')
      const flip = (e: Event): void => { e.preventDefault(); e.stopPropagation(); warn.setAttribute('aria-expanded', String(warn.classList.toggle('is-open'))) }
      warn.addEventListener('click', flip)
      warn.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') flip(e) })
    }
    return row
  }
  const intro = (text: string): void => { list.append(el('p', {class:'diary-due-col-intro'}, text)) }
  if (deskDueTab === 'due') {
    for (const cl of due.held) list.append(card(trayRow(cl)))
    for (const c of due.sets.due) list.append(card(dueRow(c, p), [small('Next week', () => pushToNextWeek(c), `Move ${dueWho(c)} to next week`)]))
    if (!count) list.append(el('div', {class:'diary-due-clear'}, el('span', {class:'diary-due-tick', 'aria-hidden':'true'}, '✓'),
      el('span', {}, el('strong', {}, 'All clear for this week.'), due.sets.nextWeek.length ? ` ${due.sets.nextWeek.length} moved to next week.` : ' Everyone is placed.')))
  } else if (deskDueTab === 'new') {
    intro('Enquiries nobody has answered yet. Put one on a day to make them a customer and book their first visit.')
    for (const l of due.enquiries) list.append(card(enquiryRow(l)))
  } else if (deskDueTab === 'first') {
    intro('Never visited and nothing booked.')
    for (const c of due.sets.firstVisit) list.append(card(dueRow(c, p)))
  } else if (deskDueTab === 'next') {
    intro('Out of Due until the day shown. Nothing was sent to them.')
    for (const c of due.sets.nextWeek) list.append(el('div', {class:'diary-due-col-card diary-due-col-plain'},
      el('strong', {}, c.dueJob ? `${c.name} · ${c.dueJob.name}` : c.name),
      el('span', {class:'muted'}, dueGroupLine('next', c, p)),
      el('div', {class:'diary-due-col-acts'}, small('Back into Due now', () => backIntoDue(c)))))
  } else if (deskDueTab === 'quiet') {
    intro('More than two cleans behind.')
    for (const c of due.sets.goneQuiet) list.append(card(dueRow(c, p), [
      small('Ask if they still want it', () => openMessagesFor({ id: c.id, name: c.name }, 'customer')),
      small('Take off', () => { window.location.hash = `#/customer/${c.id}` }),
    ]))
  } else {
    intro('No cycle set, so not in Due. Keep Roundly\'s guess and they come into Due when they are due.')
    for (const x of due.noCycle) list.append(noCycleRow(x))
  }
  list.scrollTop = deskDueScroll
  list.addEventListener('scroll', () => { deskDueScroll = list.scrollTop }, { passive: true })
  requestAnimationFrame(() => { if (list.isConnected && deskDueScroll) list.scrollTop = deskDueScroll })
  if (pickFocus) {
    const pick = pickFocus; pickFocus = null
    requestAnimationFrame(() => list.querySelector<HTMLElement>(`[data-pick="${pick}"]`)?.focus({ preventScroll: true }))
  }
  const col = el('aside', {class:'diary-due-col', 'aria-label':'Due'}, head, ...(hint ? [hint] : []), strip, list)
  if (teach === 'demo' && deskDueTab === 'due') playDueDragDemo(list, 'desk')
  // Due moves as Pencilled does (Liam, 26 Oct 2026: "due should also be draggable?").
  const mover = listMover(col, 'due', 'Due')
  head.prepend(mover.grip); head.querySelector('h2')?.after(mover.back)
  // The space at the foot: a customer due dropped here goes to next week.
  if (deskDueTab === 'due' && due.sets.due.length) {
    const later = el('div', {class:'diary-due-later', 'aria-hidden':'true'}, 'Drag here for next week')
    later.addEventListener('dragover', (e) => { if (!e.dataTransfer) return; e.preventDefault(); e.dataTransfer.dropEffect = 'move'; later.classList.add('is-over'); later.textContent = 'Let go: next week' })
    later.addEventListener('dragleave', () => { later.classList.remove('is-over'); later.textContent = 'Drag here for next week' })
    later.addEventListener('drop', (e) => {
      e.preventDefault(); later.classList.remove('is-over'); later.textContent = 'Drag here for next week'
      const data = e.dataTransfer?.getData('text/plain') ?? ''
      const c = data.startsWith('due:') ? due.sets.due.find(x => dueKey(x) === data.slice(4)) : undefined
      if (c) pushToNextWeek(c)
    })
    col.append(later)
  }
  return col
}
// Month on a computer (round 3): the Due column down the left, and every date of the month a place to drop someone. Due
// is this week's, as in Day and Week. In Month a card is dragged (a click picks for the week's dates, which Month has
// not got), or its ⋯ chooses a day.
// Read with the month, so Due is this week's whichever month is open and a change made in Month shows in it.
let monthWeek: SchedulePayload | null = null
async function loadMonthDue(): Promise<void> {
  const from = defaultFrom()
  const [w, l, j] = await Promise.all([
    api<SchedulePayload>(`/api/schedule?from=${from}&to=${addDaysISO(from, WINDOW_DAYS - 1)}`, 'schedule').catch(() => null),
    api<{ leads: Lead[] }>('/api/leads', 'leads').catch(() => null),
    loadRoundJobs(),
  ])
  monthWeek = w && w.from === from ? w : null
  if (l) leads = l.leads
  roundJobList = j
}
// Design B on a computer (Liam, 24 Oct 2026, https://claude.ai/artifact/GvAv9orrjczy2hBG43Dq6E): Due and Needs you are
// the first and last of the month's tiles. Due slides over the calendar from the left and tucks away once a drag passes
// its edge; someone in it is clicked and then a date clicked, as in Day and Week (Astra's final check: Month took drags
// only). Needs you slides in from the right with its own live lines (Astra: Month had none of its own).
let monthNeeds: { read: SchedulePayload; slot: HTMLElement } | null = null
function monthDueFrame(root: HTMLElement, mp: SchedulePayload, list: Customer[] | null): void {
  if (deskDueOpen && deskPencilOpen) deskPencilOpen = false
  if (!diaryDesk()) return
  monthAsk = mp
  const today = todayISO(), from = defaultFrom(today)
  // This week's own read; failing that, the month's (right while the month open is this one).
  const p: SchedulePayload = monthWeek && monthWeek.from === from ? monthWeek : { ...mp, from, to: addDaysISO(from, WINDOW_DAYS - 1) }
  const people = list ?? customers
  const due: PhoneDue = {
    sets: dueGroups(p, people, roundJobList, today, (c) => askAgainLater(c)),
    held: p.cleans.filter((c) => isSheetWeek(c, p.from, p.to)),
    enquiries: freshEnquiries(),
    noCycle: noCycleSet(p, people, today, (c) => askAgainLater(c)),
  }
  const findDue = (key: string): DueEntry | undefined => [...due.sets.due, ...due.sets.goneQuiet, ...due.sets.firstVisit].find((x) => dueKey(x) === key)
  // Someone picked who is no longer waiting (placed on another phone, a new read) is let go, never left as "Them picked".
  if (movingDueId !== null && !findDue(movingDueId)) movingDueId = null
  if (movingEnqId !== null && !due.enquiries.some(l => l.id === movingEnqId)) movingEnqId = null
  if (movingId !== null && !due.held.some(c => c.id === movingId)) movingId = null
  const picking = movingId !== null || movingDueId !== null || movingEnqId !== null
  const pickedName = movingDueId !== null ? findDue(movingDueId)?.name : movingEnqId !== null ? due.enquiries.find(l => l.id === movingEnqId)?.name : due.held.find(c => c.id === movingId)?.customer_name
  // Put whoever is picked on a date: a customer due is placed (their message opens), an enquiry becomes a customer, a
  // visit held in a week gets its day.
  const placeOn = (date: string): boolean => {
    const dueId = movingDueId, enqId = movingEnqId, cleanId = movingId
    movingId = null; movingDueId = null; movingEnqId = null
    if (dueId !== null) { const c = findDue(dueId); if (c) { placeDueOn(c, date, p); return true } }
    if (enqId !== null) { const l = due.enquiries.find(x => x.id === enqId); if (l) { placeEnquiry(l, date); return true } }
    if (cleanId !== null) { const cl = due.held.find(x => x.id === cleanId); if (cl) { moveToDay(cl, date); return true } }
    monthRedraw()
    return false
  }
  const col = deskDueColumn(p, due, () => monthRedraw())
  col.querySelector('.diary-due-col-hint')?.replaceChildren('Drag someone onto a date, or click them and then a date. Their message opens straight away. Drag past this edge for the dates under the list.')
  // A card clicked picks them for a date (the row's own handler draws the week, so the month answers here instead).
  col.addEventListener('click', (e) => {
    const t = e.target as Element
    const card = t.closest<HTMLElement>('.diary-due-col-card')
    if (!card || card.classList.contains('diary-due-col-plain') || ['a', 'button', 'summary', 'input', 'select', 'label', '.row-menu'].some((s) => t.closest(s))) return
    e.stopPropagation(); e.preventDefault()
    const pick = card.dataset.pick ?? ''
    movingId = null; movingDueId = null; movingEnqId = null
    if (pick.startsWith('due:')) movingDueId = pick.slice(4)
    else if (pick.startsWith('enq:')) movingEnqId = Number(pick.slice(4))
    else if (pick.startsWith('clean:')) movingId = Number(pick.slice(6))
    monthRedraw()
  }, true)
  col.addEventListener('keydown', (e) => {
    const card = (e.target as Element).closest<HTMLElement>('.diary-due-col-card')
    if (!card || e.target !== card || (e.key !== 'Enter' && e.key !== ' ')) return
    e.preventDefault(); e.stopPropagation(); card.click()
  }, true)

  // ---- the tiles: Due first, Needs you last ----
  const dueCount = due.held.length + due.sets.due.length
  const slot = (name: string): HTMLElement | null => root.querySelector<HTMLElement>(`.diary-month-tiles > [data-slot="${name}"]`)
  // Due, Pencilled and Needs you, as in Week and Day; Pencilled counts the month on show, from today on.
  // The month on show as Month draws it (its own dates, after search, Who and Area: month.ts monthVisitsShown).
  const monthPencil = pencilledRows(monthVisitsShown().filter(c => c.date >= today && !isContact(c)))
  slot('due')?.replaceWith(actionTiles(root, dueCount, barCards(due, p).filter(b => b.late).length, countPencilled(monthPencil.map(r => r.step)), () => monthRedraw()))

  // Needs you's own lines, live: past visits to review open in Day, where they are answered; dates offered list here.
  // Read again only when the month is (a new read), not on every redraw of it (a tab, a pick, a list opened).
  setNeedsWatch(onNeedsLines)
  const fresh = !monthNeeds || monthNeeds.read !== mp
  const needsYou = fresh ? el('div', {class:'diary-attention-slot diary-needs-you'}) : monthNeeds!.slot
  if (fresh) {
    const offers = offersList(people)
    const offered = offers.querySelectorAll('.diary-offer').length + Number(/(\d+) more/.exec(offers.textContent ?? '')?.[1] ?? 0)
    // Counted as Day and Week count it (render's overdue), against the month's own customer read: the week's read
    // carries the visits gone unanswered.
    const reviewN = monthWeek ? reviewVisits(monthWeek.overdue ?? [], people, roundJobList, today).length : 0
    setNeedsExtras(() => [
      { key: 'review', label: 'Past visits to review', count: reviewN, fill: into => {
        const go = el('button', {type:'button', class:'btn-primary'}, 'Answer them in Day')
        go.addEventListener('click', () => { setWeekMode('day'); showWeek(today); deskNeedsOpen = true })
        into.append(go)
      } },
      { key: 'offers', label: 'Dates offered, waiting', count: offered, fill: into => into.append(offers) },
    ])
    renderAttention(needsYou)
    monthNeeds = { read: mp, slot: needsYou }
  }

  // ---- the calendar on a stage the lists slide over ----
  const head = root.querySelector<HTMLElement>(':scope > .page-heading')
  if (!head) return
  const grid = root.querySelector<HTMLElement>(':scope > .month-grid')
  const stage = el('div', {class:'diary-week-stage diary-month-stage'})
  grid?.replaceWith(stage)
  if (grid) stage.append(grid)
  if (deskDueOpen && !picking) {
    col.classList.add('diary-due-drawer')
    const close = el('button', {type:'button', class:'diary-drawer-close', 'aria-label':'Close the Due list'}, el('span', {'aria-hidden':'true'}, '✕'))
    close.addEventListener('click', () => { deskDueOpen = false; monthRedraw(); root.querySelector<HTMLElement>('.diary-wtile[data-tile="due"]')?.focus({preventScroll:true}) })
    col.querySelector('.diary-due-col-head')?.append(close)
    stage.append(col)
    tuckOnDrag(col)
  }
  if (deskPencilOpen && !picking) {
    const pencilCol = deskPencilColumn(monthPencil, () => monthRedraw())
    stage.append(pencilCol)
    tuckOnDrag(pencilCol)
  }
  if (deskNeedsOpen && !picking && !deskDueOpen && !deskPencilOpen) {
    stage.append(deskNeedsDrawer(needsYou, () => { deskNeedsOpen = false; monthRedraw(); root.querySelector<HTMLElement>('.diary-wtile[data-tile="needs"]')?.focus({preventScroll:true}) }))
  } else {
    needsYou.hidden = true
    stage.append(needsYou)
  }
  // Someone picked: a line says so, with Cancel, and every date from today takes them (by click or by key).
  const moveBar = picking ? (() => {
    const cancel = el('button', {type:'button'}, 'Cancel'); cancel.addEventListener('click', () => cancelMoveSelection())
    return el('div', {class:'diary-move-bar', role:'status'}, el('span', {}, el('strong', {}, `${pickedName ?? 'Them'} picked: click a date for them`), ' · or drag them onto it.'), cancel)
  })() : null
  const laterChip = deskDueOpen && !picking ? null : messageLaterChip()
  const laterBar = laterChip ? el('div', {class:'diary-week-later'}, laterChip, el('span', {}, 'placed, message not sent yet')) : null
  if (moveBar) stage.before(moveBar)
  if (laterBar) stage.before(laterBar)
  const rest = [...root.children].filter((n) => n !== head) as HTMLElement[]
  head.after(el('div', {class:'diary-desk-frame diary-month-frame'}, el('div', {class:'diary-desk-main'}, ...rest)))
  for (const cell of root.querySelectorAll<HTMLElement>('.month-day[data-date]')) {
    const date = cell.dataset.date!
    acceptDueDrop(cell, date, due, p)
    if (!picking || date < today) continue
    cell.classList.add('is-target')
    // Ahead of the day's own click (which shows the day below): with someone picked, the date takes them.
    cell.addEventListener('click', (e) => { if (!(movingId !== null || movingDueId !== null || movingEnqId !== null)) return; e.stopPropagation(); e.preventDefault(); placeOn(date) }, true)
    cell.addEventListener('keydown', (e) => { if ((e.key === 'Enter' || e.key === ' ') && (movingId !== null || movingDueId !== null || movingEnqId !== null)) { e.stopPropagation(); e.preventDefault(); placeOn(date) } }, true)
  }
  bindWeekEscape()
}
// A date that takes someone dragged out of Due: a customer due is placed (their message opens), an enquiry becomes a
// customer, a visit held in a week gets its day. A day that has gone takes nobody.
function acceptDueDrop(target: HTMLElement, date: string, due: PhoneDue, p: SchedulePayload): void {
  target.addEventListener('dragover', (e) => {
    if (!e.dataTransfer || date < todayISO()) return
    e.preventDefault(); e.dataTransfer.dropEffect = 'move'; target.classList.add('drop-ready')
  })
  target.addEventListener('dragleave', () => target.classList.remove('drop-ready'))
  target.addEventListener('drop', (e) => {
    // Anything dropped on a date is the diary's: the browser never opens the dragged words as a page.
    e.preventDefault()
    const data = e.dataTransfer?.getData('text/plain') ?? ''
    target.classList.remove('drop-ready')
    if (data.startsWith('due:')) {
      const c = [...due.sets.due, ...due.sets.goneQuiet, ...due.sets.firstVisit].find((x) => dueKey(x) === data.slice(4))
      if (c) placeDueOn(c, date, p)
    } else if (data.startsWith('enq:')) {
      const l = due.enquiries.find((x) => x.id === Number(data.slice(4))); if (l) placeEnquiry(l, date)
    } else if (/^pencil:\d+$/.test(data)) {
      // A visit from the Pencilled list: Month's own visits (Sonnet's check, 26 Oct 2026: it never matched before).
      const cl = monthAsk?.cleans.find((x) => x.id === Number(data.slice(7))); if (cl) moveToDay(cl, date)
    } else if (/^\d+$/.test(data)) {
      // One held in a week.
      const cl = due.held.find((x) => x.id === Number(data)); if (cl) moveToDay(cl, date)
    }
  })
}

// "Give them dates" on a computer: the Due column opens on First visit.
function openDeskFirstVisit(): void {
  // The week's Due list is closed until asked for: opened here on First visit (Astra's final check, 24 Oct 2026).
  deskDueFor(); deskDueTab = 'first'; deskDueScroll = 0; deskDueOpen = true; deskPencilOpen = false; deskNeedsOpen = false
  const root = document.querySelector<HTMLElement>('#screen')
  if (payload && root && root.querySelector('.diary-due-col, .diary-week-frame, .diary-day-frame')) render(payload, root)
}

// "Give them a day" from What's next: the guide (the Due bar opened for it once) lasts until no visit is left without a
// day (Codex).
function showPlacingGuide(): void {
  if (!placingGuide) return
  if (!(payload?.cleans ?? []).some((c) => isSheetWeek(c, fromDate, addDaysISO(fromDate, WINDOW_DAYS - 1)))) placingGuide = false
}

// Week or Month (Liam 30 Sep 2026). The week is the diary everyone knows, so it is where the diary opens;
// Month is one tap away and this phone remembers the choice (docs/plans/month-view/).
const viewKey = (): string => diaryPreferenceKey('view')
// Held in memory too, so the switch works where the phone keeps nothing (a private window).
let viewNow: 'week' | 'month' | null = null
let viewIdentity = ''
function diaryView(): 'week' | 'month' {
  if (viewIdentity !== viewKey()) { viewIdentity = viewKey(); viewNow = null }
  if (viewNow) return viewNow
  try { viewNow = localStorage.getItem(viewKey()) === 'month' ? 'month' : 'week' } catch { viewNow = 'week' }
  return viewNow
}
function setDiaryView(v: 'week' | 'month'): void {
  viewIdentity = viewKey()
  viewNow = v
  try { localStorage.setItem(viewKey(), v) } catch { /* private window: remembered until the app closes */ }
}
function showMonth(): void {
  if (!diaryNavigationReady()) return
  dropDeskMap()
  setDiaryView('month')
  // A week read still on its way must not draw over the month (Astra, 30 Sep).
  requestSequence++
  // A pick from Day or Week ends here (round 3 review); Month has its own, from its Due list.
  movingId = null; movingDueId = null; movingEnqId = null
  // Another view arrives with its lists closed; Month opens on the month of the date Day or Week showed.
  deskDueOpen = false; deskNeedsOpen = false; deskWeekLens = null
  monthStart = diaryDesk() ? selectedDate : null
  insideDiary = true
  mountSchedule()
}
let monthStart: string | null = null
function showWeek(date?: string): void {
  setDiaryView('week')
  leaveMonth()
  // Leaving Month: Day or Week arrives with its lists closed and no tile lit, whichever it was before.
  deskDueOpen = false; deskNeedsOpen = false; deskWeekLens = null
  // A day picked in the month opens its own week, and the stale-window rule must not snap it back to this week.
  // Its worker and area filters are cleared too, so none of that day's jobs is hidden (Astra, 30 Sep).
  if (date) { fromDate = defaultFrom(date); holdWindow = true; workerFilter = ''; areaFilter = ''; diarySearch = ''; selectedDate = date; selectedIdentity = diaryPreferenceKey('selection') }
  insideDiary = true
  mountSchedule()
}
// Set by Month's way back and the switch to Month: the Diary is being redrawn from inside, not opened.
let insideDiary = false

export function mountSchedule(): void {
  dropDeskMap() // a map from an earlier visit to the Diary is never shown again
  resetDiaryColours() // no colour or tick animation for work finished while the Diary was closed
  orderFeedback = null
  // A link to a day ("#/schedule?from=2026-10-08": Money's days) opens the Diary on that day (Liam, 9 Oct 2026: "when
  // i click the date it doesnt take me to that date in the diary").
  // A visit still waiting is asked about once its card is drawn; any other visit to the Diary forgets the request.
  // "#/schedule?firstjob=1" (the start screen's "In a notebook or on my phone", 19 Oct 2026): the Diary with the first job open.
  if (/[?&]firstjob=1/.test(window.location.hash)) {
    history.replaceState(null, '', '#/schedule')
    void import('../first-job').then((m) => m.openFirstJob())
  }
  const notDone = /[?&]notdone=(\d+)/.exec(window.location.hash)?.[1]
  // Read the day too before the address is tidied (both reviewers: Owed's "Didn't happen" lost its day).
  const askedDay = /[?&]from=(\d{4}-\d{2}-\d{2})/.exec(window.location.hash)?.[1]
  askNotDone = null
  // A fresh Diary starts its Day done watch again: a job finished elsewhere meanwhile is not a moment here.
  diaryTodayStates = null
  if (notDone) {
    history.replaceState(null, '', '#/schedule')
    if (diaryView() === 'month') { setDiaryView('week'); leaveMonth() }
    askNotDone = Number(notDone)
    reviewOpen = true
  }
  if (askedDay) {
    history.replaceState(null, '', '#/schedule')
    if (diaryView() === 'month') { setDiaryView('week'); leaveMonth() }
    selectedDate = askedDay; selectedIdentity = diaryPreferenceKey('selection')
    fromDate = defaultFrom(askedDay)
    holdWindow = true
  }
  // Opening the Diary (Liam, 11 Oct 2026: "the diary should just open on the week tab because thats how you would want
  // to see your week and once you click a day it switches you to a day and today basically does ghag anyway"): Week,
  // whatever was on screen last time, on a phone and a computer (Liam, 20 Oct 2026: "Keep week i think"). A link to one
  // visit or day opens that day.
  // Back from a customer page or a day's map, the Diary is as it was left: its day, week and view (GPT-6.1's E06).
  const entering = !insideDiary
  insideDiary = false
  const asked = !!(askedDay || notDone || focusReq)
  const back = cameFrom === 'customer' || cameFrom === 'map'
  cameFrom = ''
  if (entering && (asked || !back)) {
    if (diaryView() === 'month') { setDiaryView('week'); leaveMonth() }
    setWeekMode(asked ? 'day' : 'week')
    // An ordinary arrival (another tab, or the app opening) chooses the day once; a link to a day or a visit wins (E07).
    choosing = !asked
  } else if (entering) choosing = false
  if (diaryView() === 'month') { endRowDrag(); mountMonth({ messageThem: messageThemLink, missedLink: (cl) => { const m = missedOf(cl); return m ? (date, version, before) => missedMessageLink(cl, date, m, version, before) : null }, customerOf, toWeek: showWeek, toMode: (mode, date) => { setWeekMode(mode); showWeek(date) }, search: () => diarySearch, setSearch: value => { diarySearch = value }, isEditing: () => editing, book: date => { if (customers && customers.length === 0) { void import('../first-job').then((m) => m.openFirstJob()); return } openBooking({date}) }, dayExtras: (date, rows, p) => {
      payload = p
      const workers = knownWorkers(p), roster = p.round_days ?? []
      const head = el('div', {class:'diary-selected-day-head'})
      const title = el('div', {class:'day-head'}, el('h3', {}, new Date(`${date}T12:00:00`).toLocaleDateString(screenLocale(), {weekday:'long',day:'numeric',month:'short'})))
      const map = dayMapButton(rows.filter(c => !isSuggestion(c)),date); if (map) title.append(map)
      const book = el('button', {type:'button'}, '+ Book here'); book.addEventListener('click', () => openBooking({date})); title.append(book)
      // No day chooser on Month's selected day in a one-person round (Liam, 19 Oct 2026).
      head.append(title, ...(worksAlone() ? [] : [el('div', {class:'diary-day-worker'}, el('span', {}, 'Out on this day'), rosterPicker(date, roster.find(r => r.date === date) ?? null, workers))]))
      const notes = el('div', {class:'day-notes'}); renderNotes(date,p.day_notes.filter(n => n.date === date),notes)
      const ledger = worksAlone() ? el('div', {class:'day-ledger'}) : null
      if (ledger) renderDayLedger(date,p.day_ledger.filter(l => l.date === date),ledger,{cleans:p.cleans,roster,workers,finished:finishedDays(p),isEditing:()=>editing,beginEdit:()=>{editing=true},afterEdit,reload:()=>monthOnDataChanged()})
      const entry = closeOutEntry(date, p.cleans, p.day_ledger, roster, p.day_crews ?? [], { setting: p.owner_pay, partners: p.pay_partners, takes: p.owner_takes, owners: p.owners })
      const footer = diaryDayFooter(notes,ledger)
      if (entry) footer.prepend(entry)
      return {head, footer}
    }, deskFrame: (root, mp, list) => monthDueFrame(root, mp, list), phoneTiles: (mp, list) => monthPhoneTiles(mp, list), deskLoad: () => loadMonthDue(), startDate: (() => { const d = monthStart ?? undefined; monthStart = null; return d })(), renderVisit: (cl, row, p, filtered) => {
      payload = p
      const day = orderDay(p.cleans.filter(c => c.date === cl.date && c.state !== 'cancelled' && !isContact(c) && !isUnplaced(c, p.from, p.to)), isSuggestion)
      renderClean(cl, row, undefined, day)
      jobLook(row)
      // On multi-job days the week view owns grouped house ordering.
      if (!filtered && canReorder(cl, isSuggestion) && new Set(day.map(c => c.customer_id)).size === day.length) appendOrderButtons(row, cl, day.filter(c => c.state === cl.state && bandOf(c, isSuggestion(c)) === bandOf(cl, isSuggestion(cl))), day, cl.date)
    } }); return }
  editing = false // module state must not survive navigation (kimi S-5)
  refreshPending = false
  movingId = null // a move selection is the same kind of state
  movingDueId = null // and so is the due-group booking selection
  movingEnqId = null // and so is the enquiry placement selection
  endRowDrag() // and so is a day row mid-drag: the screen it was on is going away
  resetStaleWindow()
  void load()
}

// Opening the diary must show today's work. A window left in the past — paged
// back deliberately, or simply overtaken by midnight — is snapped forward.
// A window paged FORWARD is left alone: that is someone planning next week,
// and it is still ahead of them.
function resetStaleWindow(): void {
  const today = todayISO()
  if (holdWindow) { holdWindow = false; mountedDay = today; return }
  // An ordinary visit: a focus request from an earlier one is over, and the owner's own choices come back.
  focusReq = null
  placingGuide = false
  if (restoreChoices) {
    ;({ workerFilter, areaFilter } = restoreChoices)
    restoreChoices = null
  }
  if (mountedDay !== today) { selectedDate = chosenDay = today; chosenAhead = null; selectedIdentity = diaryPreferenceKey('selection') }
  if (fromDate < defaultFrom(today) || mountedDay !== today) fromDate = defaultFrom(today)
  mountedDay = today
  // An ordinary arrival with the Diary's own choice chooses again, from this week (GPT-6.1's E06, E10). A day the person
  // picked, and the week it is in, stay (E1).
  if (choosing && (!selectedDate || selectedDate === chosenDay)) { fromDate = defaultFrom(today); chosenAhead = null }
  else choosing = false
}

export function scheduleOnDataChanged(): void {
  if (diaryView() === 'month') { monthOnDataChanged(); return }
  dataChanged()
}

// Coming back to the Diary (main.ts, come-back.ts): read again, quietly, unless something is being edited or dragged.
export function scheduleBusy(): boolean {
  return editing || document.body.classList.contains('diary-row-dragging')
}
export function scheduleComeBack(): void {
  if (scheduleBusy()) return
  if (diaryView() === 'month') { monthComeBack(); return }
  // Coming back to the app on a new calendar day chooses again: yesterday's day is never right in the morning (Sonnet's
  // E7). Any other return keeps the day, as saves, Undo, redraws, resizing and midnight passing on screen do (GPT-6.1's
  // E14; both as the lead settled them, 20 Oct 2026).
  if (mountedDay !== todayISO()) { choosing = true; resetStaleWindow() }
  quietNext = true
  void load()
}
